import type { components } from "./api.gen";
import { connectEventStream, type StreamHandlers } from "./stream";

// The generated module is types-only by design (§3), so this is where the
// hand-written half lives. We generate the nouns and write the verbs: every
// shape below is the spec's, and every request is ours.
export type Product = components["schemas"]["Product"];
export type ProductDraft = components["schemas"]["ProductDraft"];
export type ProductPage = components["schemas"]["ProductPage"];
export type ProductPatch = components["schemas"]["ProductPatch"];
export type ApiErrorBody = components["schemas"]["Error"];
export type Organization = components["schemas"]["Organization"];
export type OrgSettings = components["schemas"]["OrgSettings"];
export type OrgSettingsPatch = components["schemas"]["OrgSettingsPatch"];
export type OrgHoliday = components["schemas"]["OrgHoliday"];
export type CurrentOrganization = components["schemas"]["CurrentOrganization"];
export type OrgDataResetResult = components["schemas"]["OrgDataResetResult"];
export type Store = components["schemas"]["Store"];
export type StoreDraft = components["schemas"]["StoreDraft"];
export type StorePage = components["schemas"]["StorePage"];
export type StoreOnboarding = components["schemas"]["StoreOnboarding"];
export type StorePatch = components["schemas"]["StorePatch"];
export type StoreUpdate = components["schemas"]["StoreUpdate"];
export type StoreContact = components["schemas"]["StoreContact"];
export type StoreKycDocument = components["schemas"]["StoreKycDocument"];
export type StoreKycDecision = components["schemas"]["StoreKycDecision"];
export type StoreKycReview = components["schemas"]["StoreKycReview"];
export type StorePortalSetting = components["schemas"]["StorePortalSetting"];
export type StorePortalSettingDraft = components["schemas"]["StorePortalSettingDraft"];
export type StoreStatusChange = components["schemas"]["StoreStatusChange"];
export type StoreCatalogPage = components["schemas"]["StoreCatalogPage"];
export type CatalogItem = components["schemas"]["CatalogItem"];
export type CatalogSku = components["schemas"]["CatalogSku"];
export type SkuQuantities = components["schemas"]["SkuQuantities"];
export type StoreStockList = components["schemas"]["StoreStockList"];
export type RemovalOrder = components["schemas"]["RemovalOrder"];
export type RemovalOrderList = components["schemas"]["RemovalOrderList"];
export type RemovalOrderDraft = components["schemas"]["RemovalOrderDraft"];
export type RemovalAddress = components["schemas"]["RemovalAddress"];
export type RemovalFeeQuote = components["schemas"]["RemovalFeeQuote"];
export type StoreTransition = components["schemas"]["StoreTransition"];
export type StoreTransitionOptions = components["schemas"]["StoreTransitionOptions"];
export type StoreIntakeGate = components["schemas"]["StoreIntakeGate"];
export type Blocker = components["schemas"]["Blocker"];
export type ServiceDefinition = components["schemas"]["ServiceDefinition"];
export type SkuInboundList = components["schemas"]["SkuInboundList"];
export type ServiceDefinitionDraft = components["schemas"]["ServiceDefinitionDraft"];
export type ServiceDefinitionList = components["schemas"]["ServiceDefinitionList"];
export type StoreServiceRate = components["schemas"]["StoreServiceRate"];
export type StoreServiceRateDraft = components["schemas"]["StoreServiceRateDraft"];
export type StoreRateCard = components["schemas"]["StoreRateCard"];
export type PricingModel = components["schemas"]["PricingModel"];
export type StorageFee = components["schemas"]["StorageFee"];
export type StorageFeeDraft = components["schemas"]["StorageFeeDraft"];
export type StorageFeeDetail = components["schemas"]["StorageFeeDetail"];
export type StorageFeeRow = components["schemas"]["StorageFeeRow"];
export type StorageFeeList = components["schemas"]["StorageFeeList"];
export type StorageFeeResult = components["schemas"]["StorageFeeResult"];
export type StorageOccupancy = components["schemas"]["StorageOccupancy"];
export type StorageBill = components["schemas"]["StorageBill"];
export type StorageBillRow = components["schemas"]["StorageBillRow"];
export type StorageBillList = components["schemas"]["StorageBillList"];
export type StorageBillStatus = components["schemas"]["StorageBillStatus"];
export type StorageBillTotals = components["schemas"]["StorageBillTotals"];
export type FinanceStorageBillList = components["schemas"]["FinanceStorageBillList"];
export type StorageBillCreditRequest = components["schemas"]["StorageBillCreditRequest"];
export type StorageBillUnallocatedRequest = components["schemas"]["StorageBillUnallocatedRequest"];
export type StorageBillGenerateRequest = components["schemas"]["StorageBillGenerateRequest"];
export type StorageBillGenerateResult = components["schemas"]["StorageBillGenerateResult"];
export type StorageUnitKind = components["schemas"]["StorageUnitKind"];
export type StoreServicePlan = components["schemas"]["StoreServicePlan"];
export type StoreServicePlanDraft = components["schemas"]["StoreServicePlanDraft"];
export type FulfillmentPromise = components["schemas"]["FulfillmentPromise"];
export type ServiceCreditRule = components["schemas"]["ServiceCreditRule"];
export type RemittanceCadence = components["schemas"]["RemittanceCadence"];
export type PayoutMethod = components["schemas"]["PayoutMethod"];
export type ServiceCharge = components["schemas"]["ServiceCharge"];
export type ServiceChargePeriod = components["schemas"]["ServiceChargePeriod"];
export type ServiceChargeTotal = components["schemas"]["ServiceChargeTotal"];
export type StorePayoutAccount = components["schemas"]["StorePayoutAccount"];
export type StorePayoutAccountDraft = components["schemas"]["StorePayoutAccountDraft"];
export type StoreBillingBalance = components["schemas"]["StoreBillingBalance"];
export type StoreStatement = components["schemas"]["StoreStatement"];
export type StatementLine = components["schemas"]["StatementLine"];
export type StoreStatementDetail = components["schemas"]["StoreStatementDetail"];
export type StorePayout = components["schemas"]["StorePayout"];
export type CashoutRequest = components["schemas"]["CashoutRequest"];
export type CashoutRequestStatus = components["schemas"]["CashoutRequestStatus"];
export type CashoutRequestList = components["schemas"]["CashoutRequestList"];
export type CashoutRequestDraft = components["schemas"]["CashoutRequestDraft"];
export type CashoutQueue = components["schemas"]["CashoutQueue"];
export type CashoutQueueRow = components["schemas"]["CashoutQueueRow"];
export type CashoutSummary = components["schemas"]["CashoutSummary"];
export type CashoutAvailability = components["schemas"]["CashoutAvailability"];
export type CashoutRelease = components["schemas"]["CashoutRelease"];
export type PayoutAccountMethod = components["schemas"]["PayoutAccountMethod"];
export type PayoutAccountStatus = components["schemas"]["PayoutAccountStatus"];
export type StoreUser = components["schemas"]["StoreUser"];
export type StoreUserList = components["schemas"]["StoreUserList"];
export type StoreUserAccess = components["schemas"]["StoreUserAccess"];
export type StoreOwnerDraft = components["schemas"]["StoreOwnerDraft"];
export type StoreSubAccountDraft = components["schemas"]["StoreSubAccountDraft"];
export type StoreUserPatch = components["schemas"]["StoreUserPatch"];
export type StoreUserActivity = components["schemas"]["StoreUserActivity"];
export type StoreUserPasswordReset = components["schemas"]["StoreUserPasswordReset"];
export type StoreUserSessionsEnded = components["schemas"]["StoreUserSessionsEnded"];
export type StoreInvitation = components["schemas"]["StoreInvitation"];
export type StoreInvitationIssued = components["schemas"]["StoreInvitationIssued"];
export type StoreInvitationAccepted = components["schemas"]["StoreInvitationAccepted"];
export type StoreAccountKind = components["schemas"]["StoreAccountKind"];
export type StoreOrderScope = components["schemas"]["StoreOrderScope"];
export type StoreUserStatus = components["schemas"]["StoreUserStatus"];
export type StoreRoleTemplate = components["schemas"]["StoreRoleTemplate"];
export type StorePasswordMode = components["schemas"]["StorePasswordMode"];
export type StoreSectionMetadata = components["schemas"]["StoreSectionMetadata"];
export type StoreTemplateGrid = components["schemas"]["StoreTemplateGrid"];
export type Category = components["schemas"]["Category"];
export type CategoryNode = components["schemas"]["CategoryNode"];
export type CategoryTree = components["schemas"]["CategoryTree"];
export type CategoryDraft = components["schemas"]["CategoryDraft"];
export type CategoryPatch = components["schemas"]["CategoryPatch"];
export type CategoryRollup = components["schemas"]["CategoryRollup"];
export type CategoryNiche = components["schemas"]["CategoryNiche"];
export type CategoryLibraryNode = components["schemas"]["CategoryLibraryNode"];
export type CategoryLibraryImportResult = components["schemas"]["CategoryLibraryImportResult"];
export type CategoryLibraryPath = components["schemas"]["CategoryLibraryPath"];
export type CategoryLibraryPathResult = components["schemas"]["CategoryLibraryPathResult"];
export type HandlingFlag = components["schemas"]["HandlingFlag"];
export type Item = components["schemas"]["Item"];
export type ItemDetail = components["schemas"]["ItemDetail"];
export type ItemDraft = components["schemas"]["ItemDraft"];
export type ItemPatch = components["schemas"]["ItemPatch"];
export type ItemKind = components["schemas"]["ItemKind"];
export type ItemStatus = components["schemas"]["ItemStatus"];
export type OwnerType = components["schemas"]["OwnerType"];
export type Sku = components["schemas"]["Sku"];
export type SkuDraft = components["schemas"]["SkuDraft"];
export type SkuPatch = components["schemas"]["SkuPatch"];
export type SkuPage = components["schemas"]["SkuPage"];
export type SkuRow = components["schemas"]["SkuRow"];
export type SkuStatus = components["schemas"]["SkuStatus"];
export type SkuAlias = components["schemas"]["SkuAlias"];
export type SkuAliasDraft = components["schemas"]["SkuAliasDraft"];
export type CodeMatch = components["schemas"]["CodeMatch"];
export type CodeMatchList = components["schemas"]["CodeMatchList"];
export type LowStockPage = components["schemas"]["LowStockPage"];
export type LowStockRow = components["schemas"]["LowStockRow"];
export type LowStockFilter = components["schemas"]["LowStockFilter"];
export type LowStockState = components["schemas"]["LowStockState"];
export type LowStockStatus = components["schemas"]["LowStockStatus"];
export type ReorderPolicy = components["schemas"]["ReorderPolicy"];
export type ReorderPolicyDraft = components["schemas"]["ReorderPolicyDraft"];
export type ReorderPolicyPage = components["schemas"]["ReorderPolicyPage"];
export type AlertChannel = components["schemas"]["AlertChannel"];
export type PickFaceStatus = components["schemas"]["PickFaceStatus"];
export type PickFaceStatusPage = components["schemas"]["PickFaceStatusPage"];
export type PickFaceState = components["schemas"]["PickFaceState"];
export type PickFacePolicyDraft = components["schemas"]["PickFacePolicyDraft"];
export type ReplenishmentSuggestion = components["schemas"]["ReplenishmentSuggestion"];
export type ReplenishmentSuggestionPage = components["schemas"]["ReplenishmentSuggestionPage"];
export type ReplenishmentSuggestionState = components["schemas"]["ReplenishmentSuggestionState"];
export type ReplenishmentAccept = components["schemas"]["ReplenishmentAccept"];
export type ReorderRecommendation = components["schemas"]["ReorderRecommendation"];
export type ReorderRecommendationPage = components["schemas"]["ReorderRecommendationPage"];
export type LowStockReport = components["schemas"]["LowStockReport"];
export type SkuSelection = components["schemas"]["SkuSelection"];
export type SkuSelectionDraft = components["schemas"]["SkuSelectionDraft"];
export type SkuSelectionFilter = components["schemas"]["SkuSelectionFilter"];
export type BulkApproveRequest = components["schemas"]["BulkApproveRequest"];
export type BulkApproveResponse = components["schemas"]["BulkApproveResponse"];
export type VariantValue = components["schemas"]["VariantValue"];
export type VariationAxis = components["schemas"]["VariationAxis"];
export type VariationPreviewRequest = components["schemas"]["VariationPreviewRequest"];
export type VariationPreview = components["schemas"]["VariationPreview"];
export type ProposedVariant = components["schemas"]["ProposedVariant"];
export type VariantDraft = components["schemas"]["VariantDraft"];
export type VariationsCreateRequest = components["schemas"]["VariationsCreateRequest"];
export type VariationPreset = components["schemas"]["VariationPreset"];
export type VariationPresetList = components["schemas"]["VariationPresetList"];
export type VariationPresetDraft = components["schemas"]["VariationPresetDraft"];
export type StockFilter = components["schemas"]["StockFilter"];
export type ItemsFilter = components["schemas"]["ItemsFilter"];
export type Uom = components["schemas"]["Uom"];
export type StockLevel = components["schemas"]["StockLevel"];
export type StockLevelPage = components["schemas"]["StockLevelPage"];
export type SkuStockSummary = components["schemas"]["SkuStockSummary"];
export type SkuStockSummaryPage = components["schemas"]["SkuStockSummaryPage"];
export type StockDiscrepancy = components["schemas"]["StockDiscrepancy"];
export type StockDiscrepancyPage = components["schemas"]["StockDiscrepancyPage"];
export type StockMovement = components["schemas"]["StockMovement"];
export type StockMovementPage = components["schemas"]["StockMovementPage"];
export type StockState = components["schemas"]["StockState"];
export type MovementType = components["schemas"]["MovementType"];
export type ItemHistoryPage = components["schemas"]["ItemHistoryPage"];
export type ItemHistoryEntry = components["schemas"]["ItemHistoryEntry"];
export type ItemHistoryAction = components["schemas"]["ItemHistoryAction"];
export type ItemHistoryDocumentType = components["schemas"]["ItemHistoryDocumentType"];
export type ItemHistorySubject = components["schemas"]["ItemHistorySubject"];
/** A calendar or timeline window (EP15-S09): both days inclusive, and the active saved filter. */
export interface TaskWindowQuery {
	from: string;
	to: string;
	filterId?: string;
	signal?: AbortSignal;
}
/** The item-history screen's filters (EP02-S18), as the query string carries them. */
export interface ItemHistoryQuery {
	from?: string;
	to?: string;
	action?: Exclude<ItemHistoryAction, "other">;
	reason?: string;
	location?: string;
	actor?: string;
	document?: ItemHistoryDocumentType;
	state?: StockState;
	damagedOnly?: boolean;
	q?: string;
}
// EP02-S24: master boxes.
export type MasterBox = components["schemas"]["MasterBox"];
export type MasterBoxStatus = components["schemas"]["MasterBoxStatus"];
export type MasterBoxContentLine = components["schemas"]["MasterBoxContentLine"];
export type MasterBoxRow = components["schemas"]["MasterBoxRow"];
export type MasterBoxPage = components["schemas"]["MasterBoxPage"];
export type MasterBoxDetail = components["schemas"]["MasterBoxDetail"];
export type MasterBoxDraft = components["schemas"]["MasterBoxDraft"];
export type MasterBoxPatch = components["schemas"]["MasterBoxPatch"];
export type MasterBoxInstancePage = components["schemas"]["MasterBoxInstancePage"];
export type ContentDiscrepancy = components["schemas"]["ContentDiscrepancy"];
export type BoxUnitRow = components["schemas"]["BoxUnitRow"];
export type BoxSplitDraft = components["schemas"]["BoxSplitDraft"];
export type BoxPackDraft = components["schemas"]["BoxPackDraft"];
export type BoxMoveResult = components["schemas"]["BoxMoveResult"];
export type StockEditDirection = components["schemas"]["StockEditDirection"];
export type StockReasonDirection = components["schemas"]["StockReasonDirection"];
export type ApprovalPolicy = components["schemas"]["ApprovalPolicy"];
export type DamageResponsibility = components["schemas"]["DamageResponsibility"];
export type StockAdjustmentReason = components["schemas"]["StockAdjustmentReason"];
export type StockAdjustmentReasonList = components["schemas"]["StockAdjustmentReasonList"];
export type StockAdjustmentReasonDraft = components["schemas"]["StockAdjustmentReasonDraft"];
export type StockAdjustmentReasonPatch = components["schemas"]["StockAdjustmentReasonPatch"];
export type StockEditContext = components["schemas"]["StockEditContext"];
export type StockEditLeaf = components["schemas"]["StockEditLeaf"];
export type StockEditCurrentLevel = components["schemas"]["StockEditCurrentLevel"];
export type StockSplitRow = components["schemas"]["StockSplitRow"];
export type StockAdjustDraft = components["schemas"]["StockAdjustDraft"];
export type StockDamageDraft = components["schemas"]["StockDamageDraft"];
export type StockExceptionReport = components["schemas"]["StockExceptionReport"];
export type StockExceptionRow = components["schemas"]["StockExceptionRow"];
export type StockExceptionTotals = components["schemas"]["StockExceptionTotals"];
export type StockResolveDraft = components["schemas"]["StockResolveDraft"];
export type ExceptionState = components["schemas"]["ExceptionState"];
export type ExceptionAgeBucket = components["schemas"]["ExceptionAgeBucket"];
export type ExceptionResolution = components["schemas"]["ExceptionResolution"];
export type Reservation = components["schemas"]["Reservation"];
export type ReservationPage = components["schemas"]["ReservationPage"];
export type BinTask = components["schemas"]["BinTask"];
export type BinTaskPage = components["schemas"]["BinTaskPage"];
export type BinTaskDraft = components["schemas"]["BinTaskDraft"];
export type BinTaskType = components["schemas"]["BinTaskType"];
export type BinTaskState = components["schemas"]["BinTaskState"];
export type BinTaskStep = components["schemas"]["BinTaskStep"];
export type TrackingMode = components["schemas"]["TrackingMode"];
export type ItemTrackingDraft = components["schemas"]["ItemTrackingDraft"];
export type ItemTracking = components["schemas"]["ItemTracking"];
export type Lot = components["schemas"]["Lot"];
export type LotPage = components["schemas"]["LotPage"];
export type LotState = components["schemas"]["LotState"];
export type LotExposure = components["schemas"]["LotExposure"];
export type LotBalance = components["schemas"]["LotBalance"];
export type LotDisposal = components["schemas"]["LotDisposal"];
export type LotTrace = components["schemas"]["LotTrace"];
export type LotConsumer = components["schemas"]["LotConsumer"];
export type LotLocation = components["schemas"]["LotLocation"];
export type ExpiryReport = components["schemas"]["ExpiryReport"];
export type SerialNumber = components["schemas"]["SerialNumber"];
export type SerialNumberPage = components["schemas"]["SerialNumberPage"];
export type SerialState = components["schemas"]["SerialState"];
export type StockTake = components["schemas"]["StockTake"];
export type StockTakePage = components["schemas"]["StockTakePage"];
export type StockTakeDraft = components["schemas"]["StockTakeDraft"];
export type StockTakeScope = components["schemas"]["StockTakeScope"];
export type StockTakeType = components["schemas"]["StockTakeType"];
export type StockTakeStatus = components["schemas"]["StockTakeStatus"];
export type StockTakePreview = components["schemas"]["StockTakePreview"];
// ADJ-1016-8: the storage units a stock take in progress covers.
export type StockTakeActiveUnits = components["schemas"]["StockTakeActiveUnits"];
// ADJ-1016-8: a bulk adjustment's direction, `set` being Bulk update quantities.
export type BulkStockDirection = components["schemas"]["BulkStockDirection"];
export type StockTakeZonePreview = components["schemas"]["StockTakeZonePreview"];
export type StockTakeTask = components["schemas"]["StockTakeTask"];
export type StockTakeTaskStatus = components["schemas"]["StockTakeTaskStatus"];
export type StockTakeTaskDraft = components["schemas"]["StockTakeTaskDraft"];
export type StockTakeDetail = components["schemas"]["StockTakeDetail"];
export type StockTakeUnit = components["schemas"]["StockTakeUnit"];
export type StockTakeUnitState = components["schemas"]["StockTakeUnitState"];
export type StockTakeCountLine = components["schemas"]["StockTakeCountLine"];
export type StockTakeCountEntry = components["schemas"]["StockTakeCountEntry"];
export type StockTakeWalk = components["schemas"]["StockTakeWalk"];
export type StockTakeProgress = components["schemas"]["StockTakeProgress"];
export type StockTakeProgressCount = components["schemas"]["StockTakeProgressCount"];
export type SkuVerification = components["schemas"]["SkuVerification"];
export type StockTakeVarianceLine = components["schemas"]["StockTakeVarianceLine"];
export type StockTakeVarianceList = components["schemas"]["StockTakeVarianceList"];
export type StockTakeLineDecision = components["schemas"]["StockTakeLineDecision"];
export type StockTakeApproveRequest = components["schemas"]["StockTakeApproveRequest"];
export type StockTakeApproveResult = components["schemas"]["StockTakeApproveResult"];
export type StockTakeLog = components["schemas"]["StockTakeLog"];
export type StockTakeLogEntry = components["schemas"]["StockTakeLogEntry"];
export type VerificationAgeingReport = components["schemas"]["VerificationAgeingReport"];
export type VerificationAgeingRow = components["schemas"]["VerificationAgeingRow"];
export type VerificationAgeingBucket = components["schemas"]["VerificationAgeingBucket"];
/** A verification log's filters (EP02-S28); empty ones do not filter. */
export interface StockTakeLogFilter {
	type?: string;
	actor?: string;
	zone?: string;
}
export type ScanSubmission = components["schemas"]["ScanSubmission"];
export type ScanResult = components["schemas"]["ScanResult"];
export type ScanRefusal = components["schemas"]["ScanRefusal"];
export type ScanBatchItem = components["schemas"]["ScanBatchItem"];
export type ScanBatchOutcome = components["schemas"]["ScanBatchOutcome"];
export type ScanBatchResult = components["schemas"]["ScanBatchResult"];
export type ReservationStatus = components["schemas"]["ReservationStatus"];
export type Backorder = components["schemas"]["Backorder"];
export type BackorderPage = components["schemas"]["BackorderPage"];
export type BackorderStatus = components["schemas"]["BackorderStatus"];
export type AllocationPolicy = components["schemas"]["AllocationPolicy"];
export type AllocationPolicyDraft = components["schemas"]["AllocationPolicyDraft"];
export type ValuationMethod = components["schemas"]["ValuationMethod"];
export type Valuation = components["schemas"]["Valuation"];
export type ValuationLine = components["schemas"]["ValuationLine"];
export type ValuationPolicy = components["schemas"]["ValuationPolicy"];
export type ValuationPolicyDraft = components["schemas"]["ValuationPolicyDraft"];
export type ValuationSnapshot = components["schemas"]["ValuationSnapshot"];
export type ValuationSnapshotDraft = components["schemas"]["ValuationSnapshotDraft"];
export type ValuationSnapshotPage = components["schemas"]["ValuationSnapshotPage"];
export type ValuationComparison = components["schemas"]["ValuationComparison"];
export type ValuationDelta = components["schemas"]["ValuationDelta"];
export type StockAllocateDraft = components["schemas"]["StockAllocateDraft"];
export type StockAdjustResult = components["schemas"]["StockAdjustResult"];
export type StockClearResult = components["schemas"]["StockClearResult"];
export type StockClearItem = components["schemas"]["StockClearItem"];
export type MovementResult = components["schemas"]["MovementResult"];
export type ReceivingStatus = components["schemas"]["ReceivingStatus"];
export type ReceivingLineStatus = components["schemas"]["ReceivingLineStatus"];
export type ReceivingLine = components["schemas"]["ReceivingLine"];
export type ReceivingOrder = components["schemas"]["ReceivingOrder"];
export type ReceivingOrderPage = components["schemas"]["ReceivingOrderPage"];
export type ReceivingOrderDetail = components["schemas"]["ReceivingOrderDetail"];
export type ReceivingLineDraft = components["schemas"]["ReceivingLineDraft"];
export type ReceivingOrderDraft = components["schemas"]["ReceivingOrderDraft"];
export type ReceivingOrderPatch = components["schemas"]["ReceivingOrderPatch"];
export type ReceiptRowDraft = components["schemas"]["ReceiptRowDraft"];
export type ReceiptDraft = components["schemas"]["ReceiptDraft"];
export type Receipt = components["schemas"]["Receipt"];
export type ReceiptResult = components["schemas"]["ReceiptResult"];
export type OverReceiptDecision = components["schemas"]["OverReceiptDecision"];
export type OverReceiptResult = components["schemas"]["OverReceiptResult"];
export type PutawaySuggestion = components["schemas"]["PutawaySuggestion"];
export type PutawaySuggestions = components["schemas"]["PutawaySuggestions"];
export type PutawayDraft = components["schemas"]["PutawayDraft"];
export type TransferDraft = components["schemas"]["TransferDraft"];
export type TransferResult = components["schemas"]["TransferResult"];
export type MovementAdjustDraft = components["schemas"]["MovementAdjustDraft"];
export type Supplier = components["schemas"]["Supplier"];
export type SupplierPage = components["schemas"]["SupplierPage"];
export type SupplierDraft = components["schemas"]["SupplierDraft"];
export type SupplierPatch = components["schemas"]["SupplierPatch"];
export type PurchaseOrder = components["schemas"]["PurchaseOrder"];
export type SkuBundle = components["schemas"]["SkuBundle"];
export type SkuBundleList = components["schemas"]["SkuBundleList"];
export type WarehouseLink = components["schemas"]["WarehouseLink"];
export type WarehouseLinkList = components["schemas"]["WarehouseLinkList"];
export type WarehouseLinkRelation = components["schemas"]["WarehouseLinkRelation"];
export type Transfer = components["schemas"]["Transfer"];
export type TransferList = components["schemas"]["TransferList"];
export type TransferStatus = components["schemas"]["TransferStatus"];
export type TransferReceipt = components["schemas"]["TransferReceipt"];
export type WarehouseTransferDraft = components["schemas"]["WarehouseTransferDraft"];
export type RestockPlan = components["schemas"]["RestockPlan"];
export type WarehouseServicePrices = components["schemas"]["WarehouseServicePrices"];
export type WarehouseServiceCostDraft = components["schemas"]["WarehouseServiceCostDraft"];
export type StoreServiceSwitches = components["schemas"]["StoreServiceSwitches"];
export type StoreAccountCharges = components["schemas"]["StoreAccountCharges"];
export type StoreDiscountTier = components["schemas"]["StoreDiscountTier"];
export type RestockLine = components["schemas"]["RestockLine"];
export type RestockLevel = components["schemas"]["RestockLevel"];
export type SkuBundleDraft = components["schemas"]["SkuBundleDraft"];
export type SkuBundleAvailability = components["schemas"]["SkuBundleAvailability"];
export type CostAllocation = components["schemas"]["CostAllocation"];
export type CostAllocationLine = components["schemas"]["CostAllocationLine"];
export type PurchaseOrderPage = components["schemas"]["PurchaseOrderPage"];
export type PurchaseOrderStatus = components["schemas"]["PurchaseOrderStatus"];
export type PurchaseOrderLine = components["schemas"]["PurchaseOrderLine"];
export type PurchaseOrderLineKind = components["schemas"]["PurchaseOrderLineKind"];
export type PurchaseOrderLineDraft = components["schemas"]["PurchaseOrderLineDraft"];
export type PurchaseOrderDraft = components["schemas"]["PurchaseOrderDraft"];
export type PurchaseOrderPatch = components["schemas"]["PurchaseOrderPatch"];
export type PurchaseOrderReceiptDraft = components["schemas"]["PurchaseOrderReceiptDraft"];
export type PurchaseOrderEvent = components["schemas"]["PurchaseOrderEvent"];
export type PurchaseOrderEventPage = components["schemas"]["PurchaseOrderEventPage"];
// EP02-S22: sorting sessions and the variance decision.
export type SortingSession = components["schemas"]["SortingSession"];
// ADJ-1017-2: what a closed session's inbound services charged.
export type SortingSessionCharge = components["schemas"]["SortingSessionCharge"];
export type ChargePer = components["schemas"]["ChargePer"];
export type SortingSessionState = components["schemas"]["SortingSessionState"];
export type SortingLineProgress = components["schemas"]["SortingLineProgress"];
export type SortingSessionOpenDraft = components["schemas"]["SortingSessionOpenDraft"];
export type SortSplit = components["schemas"]["SortSplit"];
export type SortLineDraft = components["schemas"]["SortLineDraft"];
export type SortLineResult = components["schemas"]["SortLineResult"];
export type SortingEntry = components["schemas"]["SortingEntry"];
export type SortingEntryPage = components["schemas"]["SortingEntryPage"];
export type VarianceDecision = components["schemas"]["VarianceDecision"];
export type VarianceDecisionsDraft = components["schemas"]["VarianceDecisionsDraft"];
export type StockAllocateResult = components["schemas"]["StockAllocateResult"];
export type StockEditBatch = components["schemas"]["StockEditBatch"];
// EP02-S17: bulk edit, bulk allocation and the batch queue.
export type StockEditBatchStatus = components["schemas"]["StockEditBatchStatus"];
export type StockEditBatchOperation = components["schemas"]["StockEditBatchOperation"];
export type StockEditBatchDetail = components["schemas"]["StockEditBatchDetail"];
export type StockEditBatchPage = components["schemas"]["StockEditBatchPage"];
export type AllocationStrategy = components["schemas"]["AllocationStrategy"];
export type BulkStockDraft = components["schemas"]["BulkStockDraft"];
export type BulkStockLine = components["schemas"]["BulkStockLine"];
export type BulkStockPreview = components["schemas"]["BulkStockPreview"];
export type BulkStockRow = components["schemas"]["BulkStockRow"];
export type BulkStockRowOutcome = components["schemas"]["BulkStockRowOutcome"];
export type StoresSummary = components["schemas"]["StoresSummary"];
export type SecurityOverview = components["schemas"]["SecurityOverview"];
export type BlockedUser = components["schemas"]["BlockedUser"];
export type StepUpResult = components["schemas"]["StepUpResult"];
export type Me = components["schemas"]["Me"];
export type MeContext = components["schemas"]["MeContext"];
export type MeStore = components["schemas"]["MeStore"];
export type MePreferences = components["schemas"]["MePreferences"];
export type AdminDashboard = components["schemas"]["AdminDashboard"];
export type DashboardTile = components["schemas"]["DashboardTile"];
export type DashboardLayout = components["schemas"]["DashboardLayout"];
export type SavedView = components["schemas"]["SavedView"];
export type SavedViewDraft = components["schemas"]["SavedViewDraft"];
export type FlagSet = components["schemas"]["FlagSet"];
export type FeatureFlag = components["schemas"]["FeatureFlag"];
export type FlagInterface = components["schemas"]["FlagInterface"];
export type UploadRequest = components["schemas"]["UploadRequest"];
export type UploadTicket = components["schemas"]["UploadTicket"];
export type Attachment = components["schemas"]["Attachment"];
export type ImportType = components["schemas"]["ImportType"];
export type ImportColumn = components["schemas"]["ImportColumn"];
export type ImportJob = components["schemas"]["ImportJob"];
export type ImportRowResult = components["schemas"]["ImportRowResult"];
export type ImportResultList = components["schemas"]["ImportResultList"];
export type ImportMode = components["schemas"]["ImportCommit"]["mode"];
export type ApiKey = components["schemas"]["ApiKey"];
export type ApiKeyList = components["schemas"]["ApiKeyList"];
export type ApiKeyScope = components["schemas"]["ApiKeyScope"];
export type ApiKeyTenantType = components["schemas"]["ApiKeyTenantType"];
export type ApiKeyMode = components["schemas"]["ApiKeyMode"];
export type ApiKeyStatus = components["schemas"]["ApiKeyStatus"];
export type ApiRequestLog = components["schemas"]["ApiRequestLog"];
export type ApiRequestLogList = components["schemas"]["ApiRequestLogList"];
export type DeveloperOverview = components["schemas"]["DeveloperOverview"];
export type DocsPage = components["schemas"]["DocsPage"];
export type DocsPageVisibility = components["schemas"]["DocsPageVisibility"];
export type CreateDocsPageRequest = components["schemas"]["CreateDocsPageRequest"];
export type UpdateDocsPageRequest = components["schemas"]["UpdateDocsPageRequest"];
export type SandboxRequest = components["schemas"]["SandboxRequest"];
export type SandboxResponse = components["schemas"]["SandboxResponse"];
export type SandboxFixtures = components["schemas"]["SandboxFixtures"];

/** The Request Logs' filters (EP09-S22); `from`/`to` are RFC 3339. */
export interface ListRequestLogsQuery {
	requestId?: string;
	keyId?: string;
	tenantId?: string;
	/** An exact status (`422`) or a class (`4xx`). */
	status?: string;
	method?: string;
	path?: string;
	environment?: ApiKeyMode;
	errorCode?: string;
	traceId?: string;
	from?: string;
	to?: string;
	cursor?: string;
	limit?: number;
	signal?: AbortSignal;
}

/** A query string of the filters that are set; `signal` is not one. */
function requestLogParams(query: ListRequestLogsQuery & { format?: string }): string {
	const params = new URLSearchParams();
	for (const [key, value] of Object.entries(query)) {
		if (key !== "signal" && value !== undefined && value !== "") {
			params.set(key, String(value));
		}
	}
	return params.size === 0 ? "" : `?${params.toString()}`;
}
export type IssueApiKeyRequest = components["schemas"]["IssueApiKeyRequest"];
export type IssuedApiKey = components["schemas"]["IssuedApiKey"];
export type UpdateApiKeyRequest = components["schemas"]["UpdateApiKeyRequest"];
export type EndpointGroup = components["schemas"]["EndpointGroup"];
export type EndpointPolicyRow = components["schemas"]["EndpointPolicyRow"];
export type RatePolicy = components["schemas"]["RatePolicy"];
export type EndpointPolicyMatrix = components["schemas"]["EndpointPolicyMatrix"];
export type EndpointPolicyMatrixUpdate = components["schemas"]["EndpointPolicyMatrixUpdate"];
export type OrderCreationStatusRow = components["schemas"]["OrderCreationStatusRow"];
export type OrderCreationStatusSet = components["schemas"]["OrderCreationStatusSet"];
export type OrderCreationStatusUpdate = components["schemas"]["OrderCreationStatusUpdate"];
export type DeliveryFieldRow = components["schemas"]["DeliveryFieldRow"];
export type DeliveryFieldSet = components["schemas"]["DeliveryFieldSet"];
export type DeliveryFieldUpdate = components["schemas"]["DeliveryFieldUpdate"];
export type WebhookSubscription = components["schemas"]["WebhookSubscription"];
export type WebhookSubscriptionStatus = components["schemas"]["WebhookSubscriptionStatus"];
export type CreateWebhookSubscriptionRequest =
	components["schemas"]["CreateWebhookSubscriptionRequest"];
export type CreatedWebhookSubscription = components["schemas"]["CreatedWebhookSubscription"];
export type UpdateWebhookSubscriptionRequest =
	components["schemas"]["UpdateWebhookSubscriptionRequest"];
export type UpdatedWebhookSubscription = components["schemas"]["UpdatedWebhookSubscription"];
export type WebhookDelivery = components["schemas"]["WebhookDelivery"];
export type WebhookDeliveryStatus = components["schemas"]["WebhookDeliveryStatus"];
export type WebhookDeliveryList = components["schemas"]["WebhookDeliveryList"];
export type WebhookDeliveryDetail = components["schemas"]["WebhookDeliveryDetail"];
export type WebhookAttempt = components["schemas"]["WebhookAttempt"];
export type WebhookReplayJob = components["schemas"]["WebhookReplayJob"];
export type WebhookReplayProgress = components["schemas"]["WebhookReplayProgress"];
export type ReplayWebhookDeliveriesRequest =
	components["schemas"]["ReplayWebhookDeliveriesRequest"];

/** The delivery log's filters (EP09-S11); `from`/`to` are RFC 3339. */
export interface ListWebhookDeliveriesQuery {
	subscriptionId?: string;
	eventType?: string;
	status?: WebhookDeliveryStatus;
	eventId?: string;
	from?: string;
	to?: string;
	signal?: AbortSignal;
}

export type ChannelConnection = components["schemas"]["ChannelConnection"];
export type ChannelConnectionStatus = components["schemas"]["ChannelConnectionStatus"];
export type ChannelConnectionSettings = components["schemas"]["ChannelConnectionSettings"];
export type ChannelLocation = components["schemas"]["ChannelLocation"];
export type ConnectShopifyRequest = components["schemas"]["ConnectShopifyRequest"];
export type ConnectShopifyResponse = components["schemas"]["ConnectShopifyResponse"];
export type CreateWooConnectionRequest = components["schemas"]["CreateWooConnectionRequest"];
export type TestWooConnectionRequest = components["schemas"]["TestWooConnectionRequest"];
export type WooHealth = components["schemas"]["WooHealth"];
export type UpdateChannelConnectionRequest =
	components["schemas"]["UpdateChannelConnectionRequest"];

export interface ListChannelConnectionsQuery {
	storeId?: string;
	status?: ChannelConnectionStatus;
	signal?: AbortSignal;
}

export type SyncJob = components["schemas"]["SyncJob"];
export type SyncJobList = components["schemas"]["SyncJobList"];
export type SyncJobStatus = components["schemas"]["SyncJobStatus"];
export type SyncJobReportRow = components["schemas"]["SyncJobReportRow"];
export type StartSyncJobRequest = components["schemas"]["StartSyncJobRequest"];

export type DeadLetter = components["schemas"]["DeadLetter"];
export type DeadLetterPage = components["schemas"]["DeadLetterPage"];
export type DeadLetterSource = components["schemas"]["DeadLetterSource"];
export type DeadLetterStatus = components["schemas"]["DeadLetterStatus"];
export type DeadLetterBulkRetry = components["schemas"]["DeadLetterBulkRetry"];
export type RetryDeadLettersRequest = components["schemas"]["RetryDeadLettersRequest"];
export type ReconciliationKind = components["schemas"]["ReconciliationKind"];
export type ReconciliationStatus = components["schemas"]["ReconciliationStatus"];
export type ReconciliationRun = components["schemas"]["ReconciliationRun"];
export type Discrepancy = components["schemas"]["Discrepancy"];
export type StartReconciliationRequest = components["schemas"]["StartReconciliationRequest"];
export type ReliabilitySummary = components["schemas"]["ReliabilitySummary"];
export type ReliabilityHealthPoint = components["schemas"]["ReliabilityHealthPoint"];

/** The Reliability Center's dead-letter filters (EP09-S19). */
export interface ListReliabilityDeadLettersQuery {
	source?: DeadLetterSource;
	connectionId?: string;
	status?: DeadLetterStatus;
	olderThanHours?: number;
	cursor?: string;
	limit?: number;
	signal?: AbortSignal;
}

/** The Reliability Center's run filters. */
export interface ListReconciliationRunsQuery {
	connectionId?: string;
	kind?: ReconciliationKind;
	status?: ReconciliationStatus;
	signal?: AbortSignal;
}

export type InventoryBuffer = components["schemas"]["InventoryBuffer"];
export type InventoryBufferType = components["schemas"]["InventoryBufferType"];
export type InventoryPushStatus = components["schemas"]["InventoryPushStatus"];
export type InventorySync = components["schemas"]["InventorySync"];
export type InventorySyncPolicy = components["schemas"]["InventorySyncPolicy"];
export type InventorySyncRow = components["schemas"]["InventorySyncRow"];
export type UpdateInventorySyncPolicyRequest =
	components["schemas"]["UpdateInventorySyncPolicyRequest"];

export type ChannelItemMapping = components["schemas"]["ChannelItemMapping"];
export type ChannelItemMappingList = components["schemas"]["ChannelItemMappingList"];
export type ChannelItemMappingView = components["schemas"]["ChannelItemMappingView"];
export type ResolveChannelItemMappingRequest =
	components["schemas"]["ResolveChannelItemMappingRequest"];
export type EditChannelItemMappingRequest = components["schemas"]["EditChannelItemMappingRequest"];

export interface ListChannelItemMappingsQuery {
	connectionId?: string;
	storeId?: string;
	view?: ChannelItemMappingView;
	q?: string;
	signal?: AbortSignal;
}

export interface ListApiKeysQuery {
	tenantType?: ApiKeyTenantType;
	tenantId?: string;
	mode?: ApiKeyMode;
	status?: ApiKeyStatus;
	signal?: AbortSignal;
}
export type ScheduledJob = components["schemas"]["ScheduledJob"];
export type JobRun = components["schemas"]["JobRun"];
export type JobRunStatus = components["schemas"]["JobRunStatus"];
export type AdminFlag = components["schemas"]["AdminFlag"];
export type NotificationDefinition = components["schemas"]["NotificationDefinition"];
export type InboxNotification = components["schemas"]["InboxNotification"];
export type InboxNotificationList = components["schemas"]["InboxNotificationList"];
export type InboxSeverity = InboxNotification["severity"];

/** `GET /notifications`'s filters and page (EP12-S03). */
export interface InboxQuery {
	severity?: InboxSeverity;
	topic?: string;
	unread?: boolean;
	cursor?: string;
	limit?: number;
	signal?: AbortSignal;
}
export type NotificationChannel = components["schemas"]["NotificationChannel"];
export type NotificationPreferences = components["schemas"]["NotificationPreferences"];
export type NotificationPreferencesInput = components["schemas"]["NotificationPreferencesInput"];
export type NotificationPreferenceLevel = components["schemas"]["NotificationPreferenceLevel"];
export type AlertRules = components["schemas"]["AlertRules"];
export type AlertRule = components["schemas"]["AlertRule"];
export type AlertRuleKey = AlertRule["ruleKey"];
export type DigestPreview = components["schemas"]["DigestPreview"];
export type NotificationDefinitionPatch = components["schemas"]["NotificationDefinitionPatch"];
export type NotificationTestRequest = components["schemas"]["NotificationTestRequest"];
export type NotificationTestResult = components["schemas"]["NotificationTestResult"];
export type ChannelProvider = components["schemas"]["ChannelProvider"];
export type ChannelProviderInput = components["schemas"]["ChannelProviderInput"];
export type ChannelProviderRole = components["schemas"]["ChannelProviderRole"];
export type ChannelProviderName = components["schemas"]["ChannelProviderName"];
export type ChannelProviderMode = components["schemas"]["ChannelProviderMode"];
export type ChannelSettings = components["schemas"]["ChannelSettings"];
export type ChannelSettingsInput = components["schemas"]["ChannelSettingsInput"];
export type ProviderChannel = ChannelProvider["channel"];
export type WhatsAppTemplate = components["schemas"]["WhatsAppTemplate"];
export type NotificationTemplate = components["schemas"]["NotificationTemplate"];
export type NotificationTemplateCreate = components["schemas"]["NotificationTemplateCreate"];
export type NotificationTemplatePatch = components["schemas"]["NotificationTemplatePatch"];
export type NotificationTemplatePreviewRequest =
	components["schemas"]["NotificationTemplatePreviewRequest"];
export type NotificationTemplatePreview = components["schemas"]["NotificationTemplatePreview"];
export type NotificationTemplateWarning = components["schemas"]["NotificationTemplateWarning"];
export type NotificationLogEntry = components["schemas"]["NotificationLogEntry"];
export type NotificationLogPage = components["schemas"]["NotificationLogPage"];
export type NotificationAttempt = components["schemas"]["NotificationAttempt"];
export type NotificationMessageDetail = components["schemas"]["NotificationMessageDetail"];
export type ChannelHealth = components["schemas"]["ChannelHealth"];
export type Suppression = components["schemas"]["Suppression"];
/** The delivery log's filters (EP12-S17); `status` is comma-separated. */
export interface NotificationLogQuery {
	status?: string;
	channel?: string;
	eventType?: string;
	recipient?: string;
	orderId?: string;
	/** Matched exactly (ADJ-M03-11). */
	failureCode?: string;
	from?: string;
	to?: string;
	cursor?: string;
	limit?: string;
}
export type CustomerMessage = components["schemas"]["CustomerMessage"];
export type CustomerMessageTimeline = components["schemas"]["CustomerMessageTimeline"];
export type CustomerNotificationSettings = components["schemas"]["CustomerNotificationSettings"];
export type CustomerNotificationSettingsPatch =
	components["schemas"]["CustomerNotificationSettingsPatch"];
export type CustomerMessageSetting = components["schemas"]["CustomerMessageSetting"];
export type CustomerMessageStoreChoice = components["schemas"]["CustomerMessageStoreChoice"];
export type UserRecord = components["schemas"]["UserRecord"];
export type UserSummary = components["schemas"]["UserSummary"];
export type UserCounts = components["schemas"]["UserCounts"];
export type Membership = components["schemas"]["Membership"];
export type GrantMembership = components["schemas"]["GrantMembership"];
export type Invitation = components["schemas"]["Invitation"];
export type CreateInvitation = components["schemas"]["CreateInvitation"];
export type Session = components["schemas"]["Session"];
export type UserStatusChange = components["schemas"]["UserStatusChange"];
export type Role = components["schemas"]["Role"];
export type CreateRole = components["schemas"]["CreateRole"];
export type UpdateRole = components["schemas"]["UpdateRole"];
export type PermissionCatalog = components["schemas"]["PermissionCatalog"];
export type AuditEvent = components["schemas"]["AuditEvent"];
export type AuditChange = components["schemas"]["AuditChange"];
export type AuditFilter = components["schemas"]["AuditFilter"];
export type Team = components["schemas"]["Team"];
export type UpdateTeam = components["schemas"]["UpdateTeam"];
export type Impersonation = components["schemas"]["Impersonation"];
export type StartStoreImpersonation = components["schemas"]["StartStoreImpersonation"];
export type Warehouse = components["schemas"]["Warehouse"];
export type WarehouseDraft = components["schemas"]["WarehouseDraft"];
export type WarehousePatch = components["schemas"]["WarehousePatch"];
export type WarehousePage = components["schemas"]["WarehousePage"];
export type WarehouseRole = components["schemas"]["WarehouseRole"];
export type WarehouseService = components["schemas"]["WarehouseService"];
export type WarehouseServiceDraft = components["schemas"]["WarehouseServiceDraft"];
export type WarehouseServiceList = components["schemas"]["WarehouseServiceList"];
export type WarehouseServiceState = components["schemas"]["WarehouseServiceState"];
export type WarehouseServiceStateList = components["schemas"]["WarehouseServiceStateList"];
export type WarehouseRoleServices = components["schemas"]["WarehouseRoleServices"];
export type StoreRestockSettings = components["schemas"]["StoreRestockSettings"];
export type WarehouseRoleServicesList = components["schemas"]["WarehouseRoleServicesList"];
export type WarehouseServiceScope = components["schemas"]["WarehouseServiceScope"];
export type OperatingCompany = components["schemas"]["OperatingCompany"];
export type OperatingCompanyDraft = components["schemas"]["OperatingCompanyDraft"];
export type OperatingCompanyList = components["schemas"]["OperatingCompanyList"];
export type OperatingCompanyPatch = components["schemas"]["OperatingCompanyPatch"];
export type Province = components["schemas"]["Province"];
export type ProvinceList = components["schemas"]["ProvinceList"];
export type ProvinceDraft = components["schemas"]["ProvinceDraft"];
export type ProvincePatch = components["schemas"]["ProvincePatch"];
export type ProvinceUpdate = components["schemas"]["ProvinceUpdate"];
export type GeographySeedRequest = components["schemas"]["GeographySeedRequest"];
export type GeographySeedReport = components["schemas"]["GeographySeedReport"];
export type Department = components["schemas"]["Department"];
export type DepartmentNode = components["schemas"]["DepartmentNode"];
export type DepartmentList = components["schemas"]["DepartmentList"];
export type DepartmentDraft = components["schemas"]["DepartmentDraft"];
export type DepartmentPatch = components["schemas"]["DepartmentPatch"];
export type Position = components["schemas"]["Position"];
export type PositionNode = components["schemas"]["PositionNode"];
export type PositionList = components["schemas"]["PositionList"];
export type PositionDraft = components["schemas"]["PositionDraft"];
export type PositionPatch = components["schemas"]["PositionPatch"];
export type PayBasis = components["schemas"]["PayBasis"];
export type WorkSession = components["schemas"]["WorkSession"];
export type WorkSessionType = components["schemas"]["WorkSessionType"];
export type WorkSessionStatus = components["schemas"]["WorkSessionStatus"];
export type WorkSessionActivity = components["schemas"]["WorkSessionActivity"];
export type WorkSessionActivityDraft = components["schemas"]["WorkSessionActivityDraft"];
export type WorkSessionDetail = components["schemas"]["WorkSessionDetail"];
export type WorkSessionList = components["schemas"]["WorkSessionList"];
export type WorkSessionOpen = components["schemas"]["WorkSessionOpen"];
export type WorkSessionCancel = components["schemas"]["WorkSessionCancel"];
export type WorkSessionOwner = components["schemas"]["WorkSessionOwner"];
export type WorkSessionStats = components["schemas"]["WorkSessionStats"];
export type WorkSessionContinuation = components["schemas"]["WorkSessionContinuation"];
export type WorkSessionLog = components["schemas"]["WorkSessionLog"];
export type WorkSessionLogRow = components["schemas"]["WorkSessionLogRow"];
export type WorkSessionLogTotals = components["schemas"]["WorkSessionLogTotals"];
export type PackagingBreakdownLine = components["schemas"]["PackagingBreakdownLine"];
export type LinkedWorkSummary = components["schemas"]["LinkedWorkSummary"];
// EP05-S10: shift templates and the schedule board.
export type Shift = components["schemas"]["Shift"];
export type ShiftList = components["schemas"]["ShiftList"];
export type ShiftDraft = components["schemas"]["ShiftDraft"];
export type ShiftPatch = components["schemas"]["ShiftPatch"];
export type ShiftAssignment = components["schemas"]["ShiftAssignment"];
export type ShiftAssignmentStatus = components["schemas"]["ShiftAssignmentStatus"];
export type ShiftAssignmentBatch = components["schemas"]["ShiftAssignmentBatch"];
export type ShiftAssignmentBatchResult = components["schemas"]["ShiftAssignmentBatchResult"];
export type ShiftAssignmentFailure = components["schemas"]["ShiftAssignmentFailure"];
export type ShiftAssignmentPatch = components["schemas"]["ShiftAssignmentPatch"];
export type AttendanceRecord = components["schemas"]["AttendanceRecord"];
export type AttendanceDay = components["schemas"]["AttendanceDay"];
export type AttendanceRow = components["schemas"]["AttendanceRow"];
export type AttendanceStats = components["schemas"]["AttendanceStats"];
export type AttendanceClockRequest = components["schemas"]["AttendanceClockRequest"];
// EP05-S14: commission rules and the accruals they earn.
export type CommissionRule = components["schemas"]["CommissionRule"];
export type CommissionRuleDraft = components["schemas"]["CommissionRuleDraft"];
export type CommissionRuleList = components["schemas"]["CommissionRuleList"];
export type CommissionTrigger = components["schemas"]["CommissionTrigger"];
export type CommissionBasis = components["schemas"]["CommissionBasis"];
export type CommissionScopeType = components["schemas"]["CommissionScopeType"];
export type CommissionAccrual = components["schemas"]["CommissionAccrual"];
export type CommissionAccrualStatus = components["schemas"]["CommissionAccrualStatus"];
export type CommissionAccrualPage = components["schemas"]["CommissionAccrualPage"];
// EP05-S15: payroll runs, their lines and deductions.
export type PayrollRun = components["schemas"]["PayrollRun"];
export type PayrollRunDraft = components["schemas"]["PayrollRunDraft"];
export type PayrollRunDetail = components["schemas"]["PayrollRunDetail"];
export type PayrollRunList = components["schemas"]["PayrollRunList"];
export type PayrollRunKind = components["schemas"]["PayrollRunKind"];
export type PayrollRunStatus = components["schemas"]["PayrollRunStatus"];
export type PayrollItem = components["schemas"]["PayrollItem"];
export type PayrollItemList = components["schemas"]["PayrollItemList"];
// EP05-S16: a leaver still owed a final run.
export type PayrollFinalRun = components["schemas"]["PayrollFinalRun"];
export type PayrollItemNote = components["schemas"]["PayrollItemNote"];
export type PayrollDeduction = components["schemas"]["PayrollDeduction"];
export type PayrollDeductionDraft = components["schemas"]["PayrollDeductionDraft"];
export type PayrollDeductionType = components["schemas"]["PayrollDeductionType"];
export type PayrollCommissionLine = components["schemas"]["PayrollCommissionLine"];

// EP05-S13: performance records, the leaderboard and reviews.
export type PerformanceRecord = components["schemas"]["PerformanceRecord"];
export type PerformanceRecordPage = components["schemas"]["PerformanceRecordPage"];
export type PerformanceReview = components["schemas"]["PerformanceReview"];
export type PerformanceReviewDraft = components["schemas"]["PerformanceReviewDraft"];
export type PerformanceLeaderboard = components["schemas"]["PerformanceLeaderboard"];
export type PerformanceLeaderboardEntry = components["schemas"]["PerformanceLeaderboardEntry"];
export type PerformancePeriodType = components["schemas"]["PerformancePeriodType"];
export type PerformanceScope = components["schemas"]["PerformanceScope"];
export type PerformanceRecomputeRequest = components["schemas"]["PerformanceRecomputeRequest"];
export type PerformanceRecomputeResult = components["schemas"]["PerformanceRecomputeResult"];

/** `GET /performance`. `employeeId` repeats. */
export interface ListPerformanceQuery {
	periodType: PerformancePeriodType;
	from: string;
	to: string;
	employeeId?: string[];
	departmentId?: string;
	scope?: PerformanceScope;
	limit?: number;
	cursor?: string;
}

/** `GET /performance/leaderboard`. */
export interface PerformanceLeaderboardQuery {
	periodType: PerformancePeriodType;
	periodStart: string;
	scope?: PerformanceScope;
	departmentId?: string;
}

/** `GET /commission-accruals`. */
export interface ListCommissionAccrualsQuery {
	employeeId?: string;
	status?: CommissionAccrualStatus;
	limit?: number;
	cursor?: string;
	signal?: AbortSignal;
}
export type AttendanceCorrection = components["schemas"]["AttendanceCorrection"];
export type ShiftSchedule = components["schemas"]["ShiftSchedule"];
export type ShiftSchedulePerson = components["schemas"]["ShiftSchedulePerson"];
export type ShiftCoverage = components["schemas"]["ShiftCoverage"];
export type Employee = components["schemas"]["Employee"];
export type EmployeeDraft = components["schemas"]["EmployeeDraft"];
export type EmployeeDirectory = components["schemas"]["EmployeeDirectory"];
export type EmployeeDirectoryRow = components["schemas"]["EmployeeDirectoryRow"];
export type EmployeeCounts = components["schemas"]["EmployeeCounts"];
export type EmployeeSectionAccess = components["schemas"]["EmployeeSectionAccess"];
export type EmployeeSectionAccessCell = components["schemas"]["EmployeeSectionAccessCell"];
export type EmployeeSectionAccessReplace = components["schemas"]["EmployeeSectionAccessReplace"];
export type EmployeeAccountDraft = components["schemas"]["EmployeeAccountDraft"];
export type EmployeeAccountRole = components["schemas"]["EmployeeAccountRole"];
export type EmployeeAccountRoleList = components["schemas"]["EmployeeAccountRoleList"];
export type EmployeeUsernameAvailability = components["schemas"]["EmployeeUsernameAvailability"];
export type EmployeeInvitation = components["schemas"]["EmployeeInvitation"];
export type EmployeeAccountProblem = components["schemas"]["EmployeeAccountProblem"];
export type EmployeePasswordReset = components["schemas"]["EmployeePasswordReset"];
export type RoleDefaultGrid = components["schemas"]["RoleDefaultGrid"];
export type RoleDefaultGridList = components["schemas"]["RoleDefaultGridList"];
export type RoleDefaultGridReplace = components["schemas"]["RoleDefaultGridReplace"];
export type RoleDefaultGridSaved = components["schemas"]["RoleDefaultGridSaved"];
export type EmploymentType = components["schemas"]["EmploymentType"];
export type EmploymentStatus = components["schemas"]["EmploymentStatus"];
export type EmployeePatch = components["schemas"]["EmployeePatch"];
export type EmployeeSalary = components["schemas"]["EmployeeSalary"];
export type EmployeeSalaryDraft = components["schemas"]["EmployeeSalaryDraft"];
export type EmployeeStatusChange = components["schemas"]["EmployeeStatusChange"];
export type EmployeeAssignment = components["schemas"]["EmployeeAssignment"];
export type EmployeeAssignResult = components["schemas"]["EmployeeAssignResult"];
export type PendingAssignment = components["schemas"]["PendingAssignment"];
export type LedgerAccount = components["schemas"]["LedgerAccount"];
export type LedgerBalance = components["schemas"]["LedgerBalance"];
export type LedgerAccountDetail = components["schemas"]["LedgerAccountDetail"];
export type LedgerAccountPage = components["schemas"]["LedgerAccountPage"];
export type LedgerEntry = components["schemas"]["LedgerEntry"];
export type LedgerEntryPage = components["schemas"]["LedgerEntryPage"];
export type LedgerPartyType = components["schemas"]["LedgerPartyType"];
export type LedgerPosition = components["schemas"]["LedgerPosition"];
export type LedgerPositionList = components["schemas"]["LedgerPositionList"];
export type DeliveryCompany = components["schemas"]["DeliveryCompany"];
export type DeliveryCompanyList = components["schemas"]["DeliveryCompanyList"];
export type DeliveryCompanyDraft = components["schemas"]["DeliveryCompanyDraft"];
export type DeliveryCompanyPatch = components["schemas"]["DeliveryCompanyPatch"];
export type DeliveryWindow = components["schemas"]["DeliveryWindow"];
export type DeliveryCompanyStatusChange = components["schemas"]["DeliveryCompanyStatusChange"];
export type DeliveryCompanyTransition = components["schemas"]["DeliveryCompanyTransition"];
export type DeliveryDriver = components["schemas"]["DeliveryDriver"];
export type DeliveryDriverList = components["schemas"]["DeliveryDriverList"];
// EP10-S15: the Driver App's sync and the device registry.
export type DriverShipment = components["schemas"]["DriverShipment"];
export type DriverRun = components["schemas"]["DriverRun"];
// ADJ-1022-8b: the Driver App's History tab, online only.
export type DriverShipmentHistory = components["schemas"]["DriverShipmentHistory"];

/** `GET /delivery/me/shipments/history`: the days a stop finished on, org-local, both inclusive. */
export interface DriverHistoryQuery {
	kind?: "shipment" | "pickup";
	status?: string;
	from?: string;
	to?: string;
	cursor?: string;
	limit?: number;
	signal?: AbortSignal;
}
// EP10-S17: the partial-delivery picker's lines and price.
export type DriverShipmentLine = components["schemas"]["DriverShipmentLine"];
export type AcceptedLine = components["schemas"]["AcceptedLine"];
export type CollectibleQuote = components["schemas"]["CollectibleQuote"];
// EP10-S18: the recipient's one-time code and the proof methods.
export type OtpStatus = components["schemas"]["OtpStatus"];
export type PodMethod = components["schemas"]["PodMethod"];
export type SyncPullRequest = components["schemas"]["SyncPullRequest"];
export type SyncPullResult = components["schemas"]["SyncPullResult"];
export type SyncMutationInput = components["schemas"]["SyncMutationInput"];
export type SyncMutationResult = components["schemas"]["SyncMutationResult"];
export type SyncPushResult = components["schemas"]["SyncPushResult"];
export type SyncConflict = components["schemas"]["SyncConflict"];
/** A driver's acknowledgment of an alert (EP12-S15). */
export type AlertAck = components["schemas"]["AlertAck"];
export type AlertAckList = components["schemas"]["AlertAckList"];
export type AlertAckBoard = components["schemas"]["AlertAckBoard"];
export type CarrierDeadLetter = components["schemas"]["CarrierDeadLetter"];
export type CarrierDeadLetterList = components["schemas"]["CarrierDeadLetterList"];
export type SyncConflictList = components["schemas"]["SyncConflictList"];
export type SyncConflictResolve = components["schemas"]["SyncConflictResolve"];
export type DeviceRegistration = components["schemas"]["DeviceRegistration"];
export type DeviceRegistrationDraft = components["schemas"]["DeviceRegistrationDraft"];
// EP10-S22: the live stream and presence.
export type PresenceHeartbeat = components["schemas"]["PresenceHeartbeat"];
export type Presence = components["schemas"]["Presence"];
export type PresenceList = components["schemas"]["PresenceList"];
export type DeliveryDriverDraft = components["schemas"]["DeliveryDriverDraft"];
export type DeliveryDriverPatch = components["schemas"]["DeliveryDriverPatch"];
/** A driver's own delivery fee under one company (ADJ-1022-6). */
export type DriverFee = components["schemas"]["DriverFee"];
export type DriverCompanyLink = components["schemas"]["DriverCompanyLink"];
export type CodHandling = components["schemas"]["CodHandling"];
export type DeliveryVehicle = components["schemas"]["DeliveryVehicle"];
export type DeliveryVehicleList = components["schemas"]["DeliveryVehicleList"];
export type DeliveryVehicleDraft = components["schemas"]["DeliveryVehicleDraft"];
export type DeliveryVehiclePatch = components["schemas"]["DeliveryVehiclePatch"];
export type DriverShift = components["schemas"]["DriverShift"];
export type DriverShiftList = components["schemas"]["DriverShiftList"];
export type DriverShiftDraft = components["schemas"]["DriverShiftDraft"];
export type Shipment = components["schemas"]["Shipment"];
export type ShipmentStatus = components["schemas"]["ShipmentStatus"];
export type ShipmentEvent = components["schemas"]["ShipmentEvent"];
export type ShipmentDetail = components["schemas"]["ShipmentDetail"];
export type ShipmentList = components["schemas"]["ShipmentList"];
export type ShipmentSummary = components["schemas"]["ShipmentSummary"];
export type ShipmentTransition = components["schemas"]["ShipmentTransition"];
export type ShipmentRateLine = components["schemas"]["ShipmentRateLine"];
export type ShipmentAssign = components["schemas"]["ShipmentAssign"];
export type ShipmentAssignDriver = components["schemas"]["ShipmentAssignDriver"];
export type ShipmentBulkAssign = components["schemas"]["ShipmentBulkAssign"];
export type ShipmentBulkAssignResult = components["schemas"]["ShipmentBulkAssignResult"];
export type ShipmentBulkFailure = components["schemas"]["ShipmentBulkFailure"];
export type ShipmentProof = components["schemas"]["ShipmentProof"];
export type DeliveryAttempt = components["schemas"]["DeliveryAttempt"];
export type DeliveryFailureReason = components["schemas"]["DeliveryFailureReason"];
export type PodRecord = components["schemas"]["PodRecord"];
export type PodFile = components["schemas"]["PodFile"];
export type ShipmentGeo = components["schemas"]["ShipmentGeo"];
export type ShipmentPinRequest = components["schemas"]["ShipmentPinRequest"];
export type ShipmentWindowPatch = components["schemas"]["ShipmentWindowPatch"];
export type ShipmentPromisedDate = components["schemas"]["ShipmentPromisedDate"];
export type DeliveryTimeReport = components["schemas"]["DeliveryTimeReport"];
export type DeliveryTimeRow = components["schemas"]["DeliveryTimeRow"];

/** The time-to-deliver report's filters (EP03-S14): tenant days, both inclusive. */
export interface DeliveryTimeQuery {
	from: string;
	to: string;
	companyId?: string;
	provinceId?: string;
}
export type ShipmentInsurancePatch = components["schemas"]["ShipmentInsurancePatch"];
export type ShipmentTrackingLink = components["schemas"]["ShipmentTrackingLink"];
/** Where a shipment's map pin stands, the table's pin filter (EP03-S22). */
export type ShipmentPinState = "confirmed" | "geocoded" | "unconfirmed" | "pending";
export type ShipmentReschedule = components["schemas"]["ShipmentReschedule"];
export type ShipmentRto = components["schemas"]["ShipmentRto"];
export type ShipmentLost = components["schemas"]["ShipmentLost"];
export type Manifest = components["schemas"]["Manifest"];
export type ManifestStatus = components["schemas"]["ManifestStatus"];
export type ManifestOutcome = components["schemas"]["ManifestOutcome"];
export type ManifestOutcomeValue = components["schemas"]["ManifestOutcomeValue"];
export type ManifestList = components["schemas"]["ManifestList"];
export type ManifestDetail = components["schemas"]["ManifestDetail"];
export type ManifestCreate = components["schemas"]["ManifestCreate"];
export type ManifestPlan = components["schemas"]["ManifestPlan"];
export type ShipmentWaybill = components["schemas"]["ShipmentWaybill"];
export type PickupRequest = components["schemas"]["PickupRequest"];
// EP10-S14: the store's returns, recalls, shipments and proof of delivery.
export type PickupFeePreview = components["schemas"]["PickupFeePreview"];
export type PortalReturnTab = components["schemas"]["PortalReturnTab"];
export type PortalReturnCase = components["schemas"]["PortalReturnCase"];
export type PortalReturnList = components["schemas"]["PortalReturnList"];
export type PortalReturnCaseDetail = components["schemas"]["PortalReturnCaseDetail"];
export type PortalReturnRequest = components["schemas"]["PortalReturnRequest"];
export type PortalReturnRequestResult = components["schemas"]["PortalReturnRequestResult"];
export type PortalShipment = components["schemas"]["PortalShipment"];
export type PortalShipmentList = components["schemas"]["PortalShipmentList"];
export type PortalPod = components["schemas"]["PortalPod"];
export type PortalFile = components["schemas"]["PortalFile"];
// EP10-S12: store tickets and claims.
export type StoreTicket = components["schemas"]["StoreTicket"];
export type StoreTicketType = components["schemas"]["StoreTicketType"];
export type StoreTicketStatus = components["schemas"]["StoreTicketStatus"];
export type StoreTicketBucket = components["schemas"]["StoreTicketBucket"];
export type StoreTicketLinkKind = components["schemas"]["StoreTicketLinkKind"];
export type StoreTicketMessage = components["schemas"]["StoreTicketMessage"];
export type StoreTicketDetail = components["schemas"]["StoreTicketDetail"];
export type StoreTicketList = components["schemas"]["StoreTicketList"];
export type StoreTicketDraft = components["schemas"]["StoreTicketDraft"];
export type StoreTicketReply = components["schemas"]["StoreTicketReply"];
export type StoreTicketOperatorReply = components["schemas"]["StoreTicketOperatorReply"];
export type StoreTicketClaimDecisionInput = components["schemas"]["StoreTicketClaimDecisionInput"];
/** A tickets page's filters: the tab, and on the desk one merchant. */
export interface StoreTicketQuery {
	bucket?: StoreTicketBucket;
	storeId?: string;
	cursor?: string;
	limit?: number;
}
export type PickupRequestStatus = components["schemas"]["PickupRequestStatus"];
export type PickupRequestList = components["schemas"]["PickupRequestList"];
export type PickupRequestDraft = components["schemas"]["PickupRequestDraft"];
export type PickupRequestPatch = components["schemas"]["PickupRequestPatch"];
export type PickupType = components["schemas"]["PickupType"];
export type PickupWindow = components["schemas"]["PickupWindow"];
export type PickupOrigin = components["schemas"]["PickupOrigin"];

/** The pickup queue's filters (EP03-S21). */
export interface PickupListQuery {
	status?: PickupRequestStatus;
	storeId?: string;
	cursor?: string;
	limit?: number;
}

/** The manifests list's filters (EP03-S15). */
export interface ManifestListQuery {
	status?: ManifestStatus;
	companyId?: string;
	cursor?: string;
	limit?: number;
}
export type DispatchOrder = components["schemas"]["DispatchOrder"];
export type DispatchOrderStatus = components["schemas"]["DispatchOrderStatus"];
export type DispatchOrderDetail = components["schemas"]["DispatchOrderDetail"];
export type DispatchOrderList = components["schemas"]["DispatchOrderList"];
export type DispatchBoardColumn = components["schemas"]["DispatchBoardColumn"];
export type DispatchOrderWrite = components["schemas"]["DispatchOrderWrite"];
export type DispatchOrderApprove = components["schemas"]["DispatchOrderApprove"];
export type DispatchOrderHandover = components["schemas"]["DispatchOrderHandover"];
export type DispatchPick = components["schemas"]["DispatchPick"];
export type DispatchLine = components["schemas"]["DispatchLine"];
export type DispatchLog = components["schemas"]["DispatchLog"];
export type DispatchDocumentKind = components["schemas"]["DispatchDocumentKind"];
export type DispatchDocumentList = components["schemas"]["DispatchDocumentList"];

/** The dispatch list's filters (EP07-S23). */
export interface DispatchOrderListQuery {
	status?: DispatchOrderStatus;
	/** `board` answers `columns`, every status with its count (EP07-S24). */
	view?: "list" | "board";
	warehouseId?: string;
	storeId?: string;
	cursor?: string;
	limit?: number;
}
export type DeliveryExceptionKind = components["schemas"]["DeliveryExceptionKind"];
export type DeliveryExceptionPage = components["schemas"]["DeliveryExceptionPage"];

/** The exceptions queue's tab and filters (EP03-S18). */
export interface DeliveryExceptionQuery {
	kind: DeliveryExceptionKind;
	reason?: string;
	companyId?: string;
	cursor?: string;
	limit?: number;
}

/** Delivery's COD Collections filters (EP03-S19): Finance's plus store, carrier and delivery window. */
export interface DeliveryCodCollectionsQuery {
	status?: CodCollectionStatus;
	driverId?: string;
	companyId?: string;
	storeId?: string;
	tenderCurrency?: CodTenderCurrency;
	from?: string;
	to?: string;
	cursor?: string;
	limit?: number;
}

/** Delivery's handover queue (EP03-S20): `open` is every handover not yet counted. */
export interface DeliveryCodHandoversQuery {
	status?: "open" | "disputed" | "closed";
	cursor?: string;
	limit?: number;
}

/** The shipments board's filters (EP03-S12); `status` is comma-separated. */
export interface ShipmentListQuery {
	status?: string;
	companyId?: string;
	storeId?: string;
	driverId?: string;
	provinceId?: string;
	createdFrom?: string;
	createdTo?: string;
	cod?: boolean;
	slaBreached?: boolean;
	pinUnconfirmed?: boolean;
	/** EP03-S22's Window and Pin state filters. */
	deliveryWindow?: DeliveryWindow;
	pinState?: ShipmentPinState;
	/** EP12-S13: rated by the customer at most this, 1–5. */
	maxRating?: number;
	cursor?: string;
	limit?: number;
}
export type CarrierContact = components["schemas"]["CarrierContact"];
export type CarrierBankDetails = components["schemas"]["CarrierBankDetails"];
export type CarrierOperatingModel = components["schemas"]["CarrierOperatingModel"];
export type CarrierOperatingModelPatch = components["schemas"]["CarrierOperatingModelPatch"];
export type CarrierServiceLevel = components["schemas"]["CarrierServiceLevel"];
export type CarrierProvinceCapacity = components["schemas"]["CarrierProvinceCapacity"];
export type CarrierProvinceLoad = components["schemas"]["CarrierProvinceLoad"];
export type DeliveryCompanyCapacity = components["schemas"]["DeliveryCompanyCapacity"];
export type DeliveryCompanyStore = components["schemas"]["DeliveryCompanyStore"];
export type DeliveryCompanyStoreList = components["schemas"]["DeliveryCompanyStoreList"];
export type DeliveryCompanyStoreDraft = components["schemas"]["DeliveryCompanyStoreDraft"];
export type DeliveryCompanyStorePatch = components["schemas"]["DeliveryCompanyStorePatch"];
export type StoreDeliveryCompany = components["schemas"]["StoreDeliveryCompany"];
export type StoreDeliveryCompanyList = components["schemas"]["StoreDeliveryCompanyList"];
export type DeliveryAssignmentRule = components["schemas"]["DeliveryAssignmentRule"];
export type DeliveryAssignmentRuleSet = components["schemas"]["DeliveryAssignmentRuleSet"];
export type DeliveryAssignmentRuleDraft = components["schemas"]["DeliveryAssignmentRuleDraft"];
export type DeliveryAssignmentRuleSetDraft =
	components["schemas"]["DeliveryAssignmentRuleSetDraft"];
export type DeliveryAssignmentResolveRequest =
	components["schemas"]["DeliveryAssignmentResolveRequest"];
export type DeliveryAssignmentResolution = components["schemas"]["DeliveryAssignmentResolution"];
export type DeliveryAssignmentSkip = components["schemas"]["DeliveryAssignmentSkip"];
export type DeliveryRate = components["schemas"]["DeliveryRate"];
export type DeliveryRateList = components["schemas"]["DeliveryRateList"];
export type DeliveryRateDraft = components["schemas"]["DeliveryRateDraft"];
export type DeliveryRatePatch = components["schemas"]["DeliveryRatePatch"];
export type DeliveryRateCreated = components["schemas"]["DeliveryRateCreated"];
export type DeliveryRateLevel = components["schemas"]["DeliveryRateLevel"];
export type DeliveryRateMoney = components["schemas"]["DeliveryRateMoney"];
export type DeliveryQuoteRequest = components["schemas"]["DeliveryQuoteRequest"];
export type DeliveryQuote = components["schemas"]["DeliveryQuote"];
export type DeliveryQuoteLine = components["schemas"]["DeliveryQuoteLine"];
export type RateCard = components["schemas"]["RateCard"];
export type RateCardList = components["schemas"]["RateCardList"];
export type RateCardCreate = components["schemas"]["RateCardCreate"];
export type RateCardPatch = components["schemas"]["RateCardPatch"];
export type RateCardRules = components["schemas"]["RateCardRules"];
export type RateCardTier = components["schemas"]["RateCardTier"];
export type RateCardSurcharge = components["schemas"]["RateCardSurcharge"];
export type RateCardIssue = components["schemas"]["RateCardIssue"];
export type RateCardScope = components["schemas"]["RateCardScope"];
export type ShipmentPatch = components["schemas"]["ShipmentPatch"];
export type EffectiveDeliveryRateList = components["schemas"]["EffectiveDeliveryRateList"];
export type EffectiveDeliveryRate = components["schemas"]["EffectiveDeliveryRate"];
export type StoreDeliveryRateCompany = components["schemas"]["StoreDeliveryRateCompany"];
export type StoreDeliveryRateList = components["schemas"]["StoreDeliveryRateList"];
export type StoreDeliveryCoverage = components["schemas"]["StoreDeliveryCoverage"];
export type OrphanedDeliveryRate = components["schemas"]["OrphanedDeliveryRate"];
export type NegativeMarginLine = components["schemas"]["NegativeMarginLine"];
export type NegativeMarginReport = components["schemas"]["NegativeMarginReport"];
export type DeliveryRatesGrid = components["schemas"]["DeliveryRatesGrid"];
export type DeliveryRatesGridGroup = components["schemas"]["DeliveryRatesGridGroup"];
export type DeliveryRatesGridProvince = components["schemas"]["DeliveryRatesGridProvince"];
export type DeliveryRatesGridCity = components["schemas"]["DeliveryRatesGridCity"];
export type DeliveryRatesGridCell = components["schemas"]["DeliveryRatesGridCell"];
export type StoreDeliveryPriceList = components["schemas"]["StoreDeliveryPriceList"];
export type City = components["schemas"]["City"];
export type CityList = components["schemas"]["CityList"];
export type CityDraft = components["schemas"]["CityDraft"];
export type CityPatch = components["schemas"]["CityPatch"];
export type CityFee = components["schemas"]["CityFee"];
export type LocationType = components["schemas"]["LocationType"];
export type LocationTypeList = components["schemas"]["LocationTypeList"];
export type LocationTypeDraft = components["schemas"]["LocationTypeDraft"];
export type LocationTypePatch = components["schemas"]["LocationTypePatch"];
export type StorageLocation = components["schemas"]["Location"];
export type LocationDraft = components["schemas"]["LocationDraft"];
export type LocationPatch = components["schemas"]["LocationPatch"];
export type LocationsCreated = components["schemas"]["LocationsCreated"];
export type LocationTreeNode = components["schemas"]["LocationNode"];
export type LocationTreeResponse = components["schemas"]["LocationTree"];
export type LocationMoveResult = components["schemas"]["LocationMoveResult"];
export type LocationContents = components["schemas"]["LocationContents"];
export type LocationLabel = components["schemas"]["LocationLabel"];
export type LocationNodeKind = components["schemas"]["LocationNodeKind"];
export type LocationUnitKind = components["schemas"]["LocationUnitKind"];
export type LocationStatus = components["schemas"]["LocationStatus"];
export type EntityPostings = components["schemas"]["EntityPostings"];
export type JournalPosting = components["schemas"]["JournalPosting"];
export type Journal = components["schemas"]["Journal"];
export type JournalDraft = components["schemas"]["JournalDraft"];
export type JournalLegDraft = components["schemas"]["JournalLegDraft"];
export type JournalReversal = components["schemas"]["JournalReversal"];
export type JournalStatus = components["schemas"]["JournalStatus"];
export type JournalPage = components["schemas"]["JournalPage"];
export type JournalDetail = components["schemas"]["JournalDetail"];
export type PostedJournal = components["schemas"]["PostedJournal"];
export type LedgerDirection = components["schemas"]["LedgerDirection"];
export type LedgerPositionTotal = components["schemas"]["LedgerPositionTotal"];
export type PostingRule = components["schemas"]["PostingRule"];
export type PostingRuleList = components["schemas"]["PostingRuleList"];
export type EconomicEvent = components["schemas"]["EconomicEvent"];
export type EconomicEventPage = components["schemas"]["EconomicEventPage"];
export type EconomicEventStatus = components["schemas"]["EconomicEventStatus"];
export type Cashout = components["schemas"]["Cashout"];
export type CashoutLine = components["schemas"]["CashoutLine"];
export type CashoutList = components["schemas"]["CashoutList"];
export type CashoutStatus = components["schemas"]["CashoutStatus"];
export type CashoutDraft = components["schemas"]["CashoutDraft"];
export type CashoutEligibleOrders = components["schemas"]["CashoutEligibleOrders"];
// EP04-S08: the remittance settings and the store's "Cash out now".
export type PayoutCurrency = components["schemas"]["PayoutCurrency"];
export type RemittanceSettings = components["schemas"]["RemittanceSettings"];
export type RemittanceSettingsDraft = components["schemas"]["RemittanceSettingsDraft"];
export type ExpressCashoutQuote = components["schemas"]["ExpressCashoutQuote"];
export type PortalMoney = components["schemas"]["PortalMoney"];
export type PortalFinanceSummary = components["schemas"]["PortalFinanceSummary"];
export type PortalFinanceBalance = components["schemas"]["PortalFinanceBalance"];
export type PortalSummary = components["schemas"]["PortalSummary"];
export type PortalSummaryTile = components["schemas"]["PortalSummaryTile"];
export type PortalActivity = components["schemas"]["PortalActivity"];
/** A store dashboard's Sales & Revenue block: every one but the store ranking (EP10-S13). */
export type PortalSalesBlock = Exclude<SalesBlock, "top-stores">;
/** `GET /portal/dashboards/sales_revenue`: the header's store, forced. */
export interface PortalSalesQuery {
	from: string;
	to: string;
	provinceId?: string;
	cityId?: string;
	limit?: number;
	signal?: AbortSignal;
}
export type PortalStatement = components["schemas"]["PortalStatement"];
export type PortalStatementList = components["schemas"]["PortalStatementList"];
export type PortalStatementDetail = components["schemas"]["PortalStatementDetail"];
export type PortalLedgerEntry = components["schemas"]["PortalLedgerEntry"];
export type PortalCashoutRequestList = components["schemas"]["PortalCashoutRequestList"];
export type PortalLedgerDispute = components["schemas"]["PortalLedgerDispute"];
export type PortalLedgerDisputeResult = components["schemas"]["PortalLedgerDisputeResult"];
export type StatementLineDisputeReason = components["schemas"]["StatementLineDisputeReason"];
export type StorePayoutList = components["schemas"]["StorePayoutList"];
export type StoreDeliveryPrice = components["schemas"]["StoreDeliveryPrice"];
export type PayoutRun = components["schemas"]["PayoutRun"];
export type PayoutRunList = components["schemas"]["PayoutRunList"];
export type PayoutRunStatus = components["schemas"]["PayoutRunStatus"];
export type PayoutRunDraft = components["schemas"]["PayoutRunDraft"];
export type PayoutRunItem = components["schemas"]["PayoutRunItem"];
export type PayoutRunItemList = components["schemas"]["PayoutRunItemList"];
export type PayoutRunItemEntries = components["schemas"]["PayoutRunItemEntries"];
export type SettlementRun = components["schemas"]["SettlementRun"];
export type SettlementRunList = components["schemas"]["SettlementRunList"];
export type SettlementRunStatus = components["schemas"]["SettlementRunStatus"];
export type SettlementRunDraft = components["schemas"]["SettlementRunDraft"];
export type SettlementLine = components["schemas"]["SettlementLine"];
export type SettlementLineList = components["schemas"]["SettlementLineList"];
export type SettlementLineAction = components["schemas"]["SettlementLineAction"];
export type SettlementLineResult = components["schemas"]["SettlementLineResult"];
export type SettlementTransition = components["schemas"]["SettlementTransition"];
export type CarrierBalance = components["schemas"]["CarrierBalance"];
export type Adjustment = components["schemas"]["Adjustment"];
export type AdjustmentList = components["schemas"]["AdjustmentList"];
export type AdjustmentDraft = components["schemas"]["AdjustmentDraft"];
export type AdjustmentPreview = components["schemas"]["AdjustmentPreview"];
export type AdjustmentPartyKind = components["schemas"]["AdjustmentPartyKind"];
export type AdjustmentType = components["schemas"]["AdjustmentType"];
export type AdjustmentStatus = components["schemas"]["AdjustmentStatus"];
export type AdjustmentReason = components["schemas"]["AdjustmentReason"];
export type AdjustmentRefKind = components["schemas"]["AdjustmentRefKind"];
export type RecurringCost = components["schemas"]["RecurringCost"];
export type RecurringCostList = components["schemas"]["RecurringCostList"];
export type RecurringCostDraft = components["schemas"]["RecurringCostDraft"];
export type RecurringCostPatch = components["schemas"]["RecurringCostPatch"];
export type RecurringCostCategory = components["schemas"]["RecurringCostCategory"];
export type SalaryGap = components["schemas"]["SalaryGap"];
export type SalarySyncResult = components["schemas"]["SalarySyncResult"];
export type OneTimeCost = components["schemas"]["OneTimeCost"];
export type OneTimeCostList = components["schemas"]["OneTimeCostList"];
export type OneTimeCostDraft = components["schemas"]["OneTimeCostDraft"];
export type OneTimeCostPatch = components["schemas"]["OneTimeCostPatch"];
export type OneTimeCostCategory = components["schemas"]["OneTimeCostCategory"];
export type InternalStatus = components["schemas"]["InternalStatus"];
export type InternalStatusRow = components["schemas"]["InternalStatusRow"];
export type InternalStatusLine = components["schemas"]["InternalStatusLine"];
export type InternalProfitLines = components["schemas"]["InternalProfitLines"];
export type InternalStatusItem = components["schemas"]["InternalStatusItem"];
export type InternalStatusItemList = components["schemas"]["InternalStatusItemList"];
export type ProfitPeriod = components["schemas"]["ProfitPeriod"];
export type ProfitPeriodList = components["schemas"]["ProfitPeriodList"];
export type ProfitPeriodClose = components["schemas"]["ProfitPeriodClose"];
export type ReportType = components["schemas"]["ReportType"];
export type ReportFigures = components["schemas"]["ReportFigures"];
export type ReportSnapshot = components["schemas"]["ReportSnapshot"];
export type ReportSnapshotList = components["schemas"]["ReportSnapshotList"];
export type PnlRow = components["schemas"]["PnlRow"];
export type PnlReport = components["schemas"]["PnlReport"];
export type CarrierMarginRow = components["schemas"]["CarrierMarginRow"];
export type CarrierMarginReport = components["schemas"]["CarrierMarginReport"];
export type AgingRow = components["schemas"]["AgingRow"];
export type AgingReport = components["schemas"]["AgingReport"];
export type CodPositionReport = components["schemas"]["CodPositionReport"];
export type ReportEntry = components["schemas"]["ReportEntry"];
export type ReportEntryList = components["schemas"]["ReportEntryList"];
export type ReportTable = components["schemas"]["ReportTable"];
export type PartyStatement = components["schemas"]["PartyStatement"];
export type ReportParams = components["schemas"]["ReportParams"];
export type ExportJob = components["schemas"]["ExportJob"];
export type ExportJobList = components["schemas"]["ExportJobList"];
export type ExportJobRequest = components["schemas"]["ExportJobRequest"];
export type PayoutPartyKind = components["schemas"]["PayoutPartyKind"];
export type DriverEarning = components["schemas"]["DriverEarning"];
export type DriverEarningTotals = components["schemas"]["DriverEarningTotals"];
export type DriverEarningList = components["schemas"]["DriverEarningList"];
export type DriverEarningsSummary = components["schemas"]["DriverEarningsSummary"];
export type DriverShortfall = components["schemas"]["DriverShortfall"];
export type DriverShortfallList = components["schemas"]["DriverShortfallList"];
export type DriverShortfallStatus = components["schemas"]["DriverShortfallStatus"];
export type PayoutItemResultRequest = components["schemas"]["PayoutItemResultRequest"];
export type BillingStatement = components["schemas"]["BillingStatement"];
export type BillingStatementList = components["schemas"]["BillingStatementList"];
export type BillingStatementLines = components["schemas"]["BillingStatementLines"];
export type StatementStatus = components["schemas"]["StatementStatus"];
export type StatementGenerateRequest = components["schemas"]["StatementGenerateRequest"];
export type StatementGenerateResult = components["schemas"]["StatementGenerateResult"];
export type Invoice = components["schemas"]["Invoice"];
export type InvoiceList = components["schemas"]["InvoiceList"];
export type InvoiceLineType = components["schemas"]["InvoiceLineType"];
export type CreditNote = components["schemas"]["CreditNote"];
export type CreditNoteList = components["schemas"]["CreditNoteList"];
export type CreditNoteRequest = components["schemas"]["CreditNoteRequest"];
export type CreditNoteReason = components["schemas"]["CreditNoteReason"];
export type FeeSchedule = components["schemas"]["FeeSchedule"];
export type FeeScheduleList = components["schemas"]["FeeScheduleList"];
export type FeeScheduleDraft = components["schemas"]["FeeScheduleDraft"];
export type FeeScheduleCloseRequest = components["schemas"]["FeeScheduleCloseRequest"];
export type FeeMatrix = components["schemas"]["FeeMatrix"];
export type FeeMatrixRow = components["schemas"]["FeeMatrixRow"];
export type FeeServiceType = components["schemas"]["FeeServiceType"];
export type FeeBasis = components["schemas"]["FeeBasis"];
export type FeePriceSource = components["schemas"]["FeePriceSource"];
export type TaxRule = components["schemas"]["TaxRule"];
export type TaxRuleList = components["schemas"]["TaxRuleList"];
export type TaxRuleDraft = components["schemas"]["TaxRuleDraft"];
export type TaxMode = components["schemas"]["TaxMode"];
export type FxRate = components["schemas"]["FxRate"];
export type FxRatePublication = components["schemas"]["FxRatePublication"];
export type CodCollection = components["schemas"]["CodCollection"];
export type DriverWallet = components["schemas"]["DriverWallet"];
export type CodShortfallReason = components["schemas"]["CodShortfallReason"];
export type CodCollectionList = components["schemas"]["CodCollectionList"];
export type CodCollectionStatus = components["schemas"]["CodCollectionStatus"];
export type CodCustody = components["schemas"]["CodCustody"];
export type CodTenderCurrency = components["schemas"]["CodTenderCurrency"];
export type CodCash = components["schemas"]["CodCash"];
export type CodTender = components["schemas"]["CodTender"];
export type CodTenderOptions = components["schemas"]["CodTenderOptions"];
export type CodSummary = components["schemas"]["CodSummary"];
export type CodAgingBucket = components["schemas"]["CodAgingBucket"];
export type CodHandover = components["schemas"]["CodHandover"];
export type CodHandoverStatus = components["schemas"]["CodHandoverStatus"];
export type CodHandoverOpened = components["schemas"]["CodHandoverOpened"];
export type CodHandoverDetail = components["schemas"]["CodHandoverDetail"];
export type CodHandoverConfirm = components["schemas"]["CodHandoverConfirm"];
export type CodHandoverCount = components["schemas"]["CodHandoverCount"];
export type CodHandoverList = components["schemas"]["CodHandoverList"];
export type CodBatchCreate = components["schemas"]["CodBatchCreate"];
export type CodPerCurrencyCount = components["schemas"]["CodPerCurrencyCount"];
export type CodDeposit = components["schemas"]["CodDeposit"];
export type CodAging = components["schemas"]["CodAging"];
export type CodAgingHolder = components["schemas"]["CodAgingHolder"];
export type CodDiscrepancy = components["schemas"]["CodDiscrepancy"];
export type CodDiscrepancyKind = components["schemas"]["CodDiscrepancyKind"];
export type CodDiscrepancyList = components["schemas"]["CodDiscrepancyList"];
export type CodDiscrepancyResolve = components["schemas"]["CodDiscrepancyResolve"];
export type CodResolution = components["schemas"]["CodResolution"];
export type CodResolutionOption = components["schemas"]["CodResolutionOption"];

/** The discrepancy queue's filters (EP04-S05). */
export interface ListCodDiscrepanciesQuery {
	resolution?: "open" | CodResolution;
	kind?: CodDiscrepancyKind;
	cursor?: string;
	limit?: number;
}

/** The COD collections table's filters (EP04-S04). */
export interface ListCodCollectionsQuery {
	status?: CodCollectionStatus;
	driverId?: string;
	custody?: CodCustody;
	tenderCurrency?: CodTenderCurrency;
	cursor?: string;
	limit?: number;
}
export type TaxAppliesTo = components["schemas"]["TaxAppliesTo"];
export type PriceRequest = components["schemas"]["PriceRequest"];
export type PriceResult = components["schemas"]["PriceResult"];
export type PriceLine = components["schemas"]["PriceLine"];
export type Zone = components["schemas"]["Zone"];
export type ZoneList = components["schemas"]["ZoneList"];
export type ZoneNodeSummary = components["schemas"]["ZoneNodeSummary"];
export type ZoneRow = components["schemas"]["ZoneRow"];
export type ZoneDraft = components["schemas"]["ZoneDraft"];
export type ZonePatch = components["schemas"]["ZonePatch"];
export type ZoneUsage = components["schemas"]["ZoneUsage"];
export type ZoneViewName = components["schemas"]["ZoneView"];
export type ZoneDesign = components["schemas"]["ZoneDesign"];
export type ZoneArea = components["schemas"]["ZoneArea"];
export type ZoneAreaDraft = components["schemas"]["ZoneAreaDraft"];
export type ZoneDesignRow = components["schemas"]["ZoneDesignRow"];
export type ZoneRowDraft = components["schemas"]["ZoneRowDraft"];
export type ZoneRowList = components["schemas"]["ZoneRowList"];
export type ZoneRowGenerated = components["schemas"]["ZoneRowGenerated"];
export type ZoneCapacity = components["schemas"]["ZoneCapacity"];
export type CapacityEstimate = components["schemas"]["CapacityEstimate"];
export type StorageUnitTemplate = components["schemas"]["StorageUnitTemplate"];
export type StorageUnitTemplateDraft = components["schemas"]["StorageUnitTemplateDraft"];
export type StorageUnitTemplateSkuRule = components["schemas"]["StorageUnitTemplateSkuRule"];
export type StorageUnitTemplateSkuRuleResult =
	components["schemas"]["StorageUnitTemplateSkuRuleResult"];
export type StorageUnitTemplateList = components["schemas"]["StorageUnitTemplateList"];
export type ZoneTemplate = components["schemas"]["ZoneTemplate"];
export type ZoneTemplateArea = components["schemas"]["ZoneTemplateArea"];
export type ZoneTemplateList = components["schemas"]["ZoneTemplateList"];
export type ZoneTemplateDraft = components["schemas"]["ZoneTemplateDraft"];
export type ZoneTemplateApply = components["schemas"]["ZoneTemplateApply"];
export type ZoneTemplateApplied = components["schemas"]["ZoneTemplateApplied"];
export type ZoneLayout = components["schemas"]["ZoneLayout"];
export type ZoneLayoutUnit = components["schemas"]["ZoneLayoutUnit"];
export type ZoneLayoutNode = components["schemas"]["ZoneLayoutNode"];
export type ZoneLayoutMode = components["schemas"]["ZoneLayoutMode"];
export type ZoneOccupancyBand = components["schemas"]["ZoneOccupancyBand"];
export type ZoneMixedSkuBand = components["schemas"]["ZoneMixedSkuBand"];
/** What an exported zone map is coloured by. */
export type ZoneMapLegend = "occupancy" | "mixed_sku" | "stock_take";
export type HandlingEquipment = components["schemas"]["HandlingEquipment"];
export type AisleSuggestion = components["schemas"]["AisleSuggestion"];
export type HandlingEquipmentList = components["schemas"]["HandlingEquipmentList"];
export type UnitKindDef = components["schemas"]["UnitKindDef"];
export type DimensionPolicy = components["schemas"]["DimensionPolicy"];
export type CurrencyList = components["schemas"]["CurrencyList"];
export type AcceptedCurrency = components["schemas"]["AcceptedCurrency"];
export type CurrencyRate = components["schemas"]["CurrencyRate"];
export type CurrencyRateList = components["schemas"]["CurrencyRateList"];
export type StoreDimensionRule = components["schemas"]["StoreDimensionRule"];
export type UnitKindList = components["schemas"]["UnitKindList"];
export type CustomUnitRate = components["schemas"]["CustomUnitRate"];
export type BinUnitRate = components["schemas"]["BinUnitRate"];
export type HandlingEquipmentDraft = components["schemas"]["HandlingEquipmentDraft"];
export type CityDeleteAllRequest = components["schemas"]["CityDeleteAllRequest"];
export type CityDeleteAllResult = components["schemas"]["CityDeleteAllResult"];
export type PackagingMaterial = components["schemas"]["PackagingMaterial"];
export type PackagingMaterialDraft = components["schemas"]["PackagingMaterialDraft"];
export type PackagingMaterialPatch = components["schemas"]["PackagingMaterialPatch"];
export type PackagingMaterialPage = components["schemas"]["PackagingMaterialPage"];
export type PackagingMaterialArchiveResult =
	components["schemas"]["PackagingMaterialArchiveResult"];
export type PackagingMaterialType = components["schemas"]["PackagingMaterialType"];
export type PackagingUom = components["schemas"]["PackagingUom"];
export type PackagingOwnership = components["schemas"]["PackagingOwnership"];
export type PackagingCostEntry = components["schemas"]["PackagingCostEntry"];
export type PackagingCostHistory = components["schemas"]["PackagingCostHistory"];

/** The filters `GET /packaging/materials` accepts (EP06-S01). */
export interface ListPackagingMaterialsQuery {
	limit?: number;
	cursor?: string;
	/** One material type. */
	type?: string;
	/** `active`, `archived` or `all` (the default). */
	status?: string;
	/** `operator` or `store_consigned`. */
	ownership?: string;
	/** Case-insensitive match on the code or either name. */
	q?: string;
	signal?: AbortSignal;
}

export type PackageType = components["schemas"]["PackageType"];
export type PackageTypeDraft = components["schemas"]["PackageTypeDraft"];
export type PackageTypePatch = components["schemas"]["PackageTypePatch"];
export type PackageTypePage = components["schemas"]["PackageTypePage"];
export type PackageTypeFiller = components["schemas"]["PackageTypeFiller"];
export type PackageTypeBomLine = components["schemas"]["PackageTypeBomLine"];
export type PackageTypeStore = components["schemas"]["PackageTypeStore"];
export type PackageTypeStoreList = components["schemas"]["PackageTypeStoreList"];
export type PackageTypeStorePut = components["schemas"]["PackageTypeStorePut"];
export type PackagingOption = components["schemas"]["PackagingOption"];
export type PackagingOptions = components["schemas"]["PackagingOptions"];
export type StorePackageTypeDraft = components["schemas"]["StorePackageTypeDraft"];
export type StorePackageTypePatch = components["schemas"]["StorePackageTypePatch"];
export type StoreBagSupplyPut = components["schemas"]["StoreBagSupplyPut"];
export type PackagingRule = components["schemas"]["PackagingRule"];
export type PackagingRuleList = components["schemas"]["PackagingRuleList"];
export type PackagingRuleDraft = components["schemas"]["PackagingRuleDraft"];
export type PackagingRuleReorder = components["schemas"]["PackagingRuleReorder"];
export type PackageSelectRequest = components["schemas"]["PackageSelectRequest"];
export type PackageSelection = components["schemas"]["PackageSelection"];
export type PackagingPriceUnit = components["schemas"]["PackagingPriceUnit"];
export type PackagingStockRow = components["schemas"]["PackagingStockRow"];
export type PackagingStockPage = components["schemas"]["PackagingStockPage"];
export type PackagingStockPolicyPut = components["schemas"]["PackagingStockPolicyPut"];
export type PackagingStockMovement = components["schemas"]["PackagingStockMovement"];
export type PackagingStockMovementDraft = components["schemas"]["PackagingStockMovementDraft"];
export type PackagingStockMovementPage = components["schemas"]["PackagingStockMovementPage"];
export type PackagingStockMovementResult = components["schemas"]["PackagingStockMovementResult"];
export type PackagingReplenishment = components["schemas"]["PackagingReplenishment"];
export type PackagingReplenishmentPage = components["schemas"]["PackagingReplenishmentPage"];
export type PackagingReplenishmentOrder = components["schemas"]["PackagingReplenishmentOrder"];

/** The filters `GET /packaging/stock/movements` accepts (EP06-S08). */
export interface ListPackagingStockMovementsQuery {
	limit?: number;
	cursor?: string;
	/** One material's ledger; empty for every material. */
	materialId?: string;
	/** `receipt`, `consumption`, `adjustment`, `write_off`, `transfer` or `all`. */
	type?: string;
	signal?: AbortSignal;
}
export type PackagingConsumption = components["schemas"]["PackagingConsumption"];
export type PackagingConsumptionPage = components["schemas"]["PackagingConsumptionPage"];
export type PackagingConsumptionLine = components["schemas"]["PackagingConsumptionLine"];
export type PackagingBagCharge = components["schemas"]["PackagingBagCharge"];
export type PackagingBagAdjustment = components["schemas"]["PackagingBagAdjustment"];
export type OrderPackaging = components["schemas"]["OrderPackaging"];
export type OrderBagAdjustmentPut = components["schemas"]["OrderBagAdjustmentPut"];
/** Cancelling a set of an order's items (EP08-S04). */
export type OrderCancelLines = components["schemas"]["OrderCancelLines"];
export type OrderCancelLine = components["schemas"]["OrderCancelLine"];
export type OrderCancelLinesResult = components["schemas"]["OrderCancelLinesResult"];
export type OrderCancelConsequence = components["schemas"]["OrderCancelConsequence"];

/** The intake contract every channel's order arrives through (EP07-S03). */
export type OrderDraft = components["schemas"]["OrderDraft"];
export type OrderDraftLine = components["schemas"]["OrderDraftLine"];
export type OrderDraftCombinedPackage = components["schemas"]["OrderDraftCombinedPackage"];
/** ADJ-1022-3: the combinable type boxes, the service mode and the cards' answers. */
export type OrderCard = components["schemas"]["OrderCard"];
export type OrderServiceMode = components["schemas"]["OrderServiceMode"];
export type OrderHandoff = components["schemas"]["OrderHandoff"];
export type OrderExpectedReturn = components["schemas"]["OrderExpectedReturn"];
export type OrderExpectedReturnDraft = components["schemas"]["OrderExpectedReturnDraft"];
export type PickupWarehouse = components["schemas"]["PickupWarehouse"];
export type PortalOrderOptions = components["schemas"]["PortalOrderOptions"];
export type OrderIntakeResult = components["schemas"]["OrderIntakeResult"];
export type OrderCatalogSku = components["schemas"]["OrderCatalogSku"];
export type OrderCatalogSkuPage = components["schemas"]["OrderCatalogSkuPage"];

export type ReturnCase = components["schemas"]["ReturnCase"];
export type ReturnCaseDetail = components["schemas"]["ReturnCaseDetail"];
export type ReturnCaseLine = components["schemas"]["ReturnCaseLine"];
export type ReturnCasePage = components["schemas"]["ReturnCasePage"];
export type ReturnCaseDraft = components["schemas"]["ReturnCaseDraft"];
/** The scan (EP08-S03): what a code resolved to, and what the screen does next. */
export type ReturnScanRequest = components["schemas"]["ReturnScanRequest"];
export type ReturnScanContext = components["schemas"]["ReturnScanContext"];
export type ReturnScanMatch = components["schemas"]["ReturnScanMatch"];
export type ReturnScanKind = components["schemas"]["ReturnScanKind"];
export type ReturnScanAction = components["schemas"]["ReturnScanAction"];
export type ReturnScanOrder = components["schemas"]["ReturnScanOrder"];
export type ReturnableOrderLine = components["schemas"]["ReturnableOrderLine"];
export type ReturnCasePatch = components["schemas"]["ReturnCasePatch"];
/** Receipt (EP08-S05). */
export type ReturnBulkReceiveResult = components["schemas"]["ReturnBulkReceiveResult"];
export type ReturnUnexpectedDraft = components["schemas"]["ReturnUnexpectedDraft"];
/** Assignment (EP08-S09). */
export type ReturnAssign = components["schemas"]["ReturnAssign"];
export type ReturnSlot = components["schemas"]["ReturnSlot"];
export type ReturnBulkAssign = components["schemas"]["ReturnBulkAssign"];
export type ReturnBulkAssignResult = components["schemas"]["ReturnBulkAssignResult"];
/** Inspection (EP08-S06). */
export type ReturnInspect = components["schemas"]["ReturnInspect"];
export type ReturnLineInspection = components["schemas"]["ReturnLineInspection"];
export type ReturnResolveDiscrepancy = components["schemas"]["ReturnResolveDiscrepancy"];
export type ReturnReconcile = components["schemas"]["ReturnReconcile"];
export type ReturnInspection = components["schemas"]["ReturnInspection"];
export type ReturnInspectionList = components["schemas"]["ReturnInspectionList"];
/** Disposition (EP08-S07). */
export type ReturnDispose = components["schemas"]["ReturnDispose"];
export type ReturnDispositionKind = components["schemas"]["ReturnDispositionKind"];
export type ReturnDispositionList = components["schemas"]["ReturnDispositionList"];
export type ReturnPolicy = components["schemas"]["ReturnPolicy"];
/** Refunds and store credit (EP08-S11). */
export type Refund = components["schemas"]["Refund"];
export type RefundDraft = components["schemas"]["RefundDraft"];
export type RefundList = components["schemas"]["RefundList"];
export type RefundReason = components["schemas"]["RefundReason"];
export type RefundLiability = components["schemas"]["RefundLiability"];
export type RefundStatus = components["schemas"]["RefundStatus"];
/** Exchanges and the case's finance summary (EP08-S12). */
export type ReturnExchangeDraft = components["schemas"]["ReturnExchangeDraft"];
export type ReturnExchange = components["schemas"]["ReturnExchange"];
export type ReturnCaseFinance = components["schemas"]["ReturnCaseFinance"];
export type ReturnFinanceRow = components["schemas"]["ReturnFinanceRow"];
export type ReturnReplacementLine = components["schemas"]["ReturnReplacementLine"];
/** Batch add-back (EP08-S08). */
export type ReturnRestockRow = components["schemas"]["ReturnRestockRow"];
export type ReturnRestockPreview = components["schemas"]["ReturnRestockPreview"];
export type ReturnRestockBatch = components["schemas"]["ReturnRestockBatch"];
export type ReturnRestockBatchResult = components["schemas"]["ReturnRestockBatchResult"];
export type ReturnRestockLocation = components["schemas"]["ReturnRestockLocation"];
export type ReturnRestockFee = components["schemas"]["ReturnRestockFee"];
export type ReturnRestockPreviewRequest = components["schemas"]["ReturnRestockPreviewRequest"];
/** Return sessions (EP08-S10). */
export type ReturnSession = components["schemas"]["ReturnSession"];
export type ReturnSessionStatus = components["schemas"]["ReturnSessionStatus"];
export type ReturnSessionAssignment = components["schemas"]["ReturnSessionAssignment"];
export type ReturnSessionDetail = components["schemas"]["ReturnSessionDetail"];
export type ReturnSessionList = components["schemas"]["ReturnSessionList"];
export type ReturnPipeline = components["schemas"]["ReturnPipeline"];
export type ReturnBoard = components["schemas"]["ReturnBoard"];
export type ReturnBoardColumn = components["schemas"]["ReturnBoardColumn"];
export type ReturnStage = components["schemas"]["ReturnStage"];
export type ReturnType = components["schemas"]["ReturnType"];
export type ReturnOrigin = components["schemas"]["ReturnOrigin"];
export type ReturnReason = components["schemas"]["ReturnReason"];
export type ReturnInspectionStatus = components["schemas"]["ReturnInspectionStatus"];
export type ReturnDamageGrade = components["schemas"]["ReturnDamageGrade"];

/** The filters `GET /returns` accepts (EP08-S01). */
export interface ListReturnCasesQuery {
	limit?: number;
	cursor?: string;
	stage?: ReturnStage;
	storeId?: string;
	returnType?: ReturnType;
	origin?: ReturnOrigin;
	inspectionStatus?: ReturnInspectionStatus;
	damageGrade?: ReturnDamageGrade;
	inspectAssignee?: string;
	restockAssignee?: string;
	sessionId?: string;
	/** Prefix of a case, order or channel number, a customer's name, or a phone. At least two characters. */
	q?: string;
	/** Inclusive lower bound on `createdAt`, RFC 3339. */
	createdFrom?: string;
	/** Exclusive upper bound on `createdAt`, RFC 3339. */
	createdTo?: string;
	/** Inclusive lower bound on `receivedAt`, RFC 3339. */
	receivedFrom?: string;
	/** Exclusive upper bound on `receivedAt`, RFC 3339. */
	receivedTo?: string;
	signal?: AbortSignal;
}
// EP07-S01: the order and its seventeen statuses.
export type Order = components["schemas"]["Order"];
export type OrderLine = components["schemas"]["OrderLine"];
export type OrderCombinedPackage = components["schemas"]["OrderCombinedPackage"];
export type OrderStatus = components["schemas"]["OrderStatus"];
export type OrderSecondaryStatus = components["schemas"]["OrderSecondaryStatus"];
export type OrderCancellationStage = components["schemas"]["OrderCancellationStage"];
export type OrderChannel = components["schemas"]["OrderChannel"];
export type OrderEvent = components["schemas"]["OrderEvent"];
export type OrderTransition = components["schemas"]["OrderTransition"];
// ADJ-1016-2: the org owner's Update status.
export type OrderStatusOverride = components["schemas"]["OrderStatusOverride"];
export type OrderStatusEvent = components["schemas"]["OrderStatusEvent"];
export type OrderStatusEventPage = components["schemas"]["OrderStatusEventPage"];
// EP07-S07: the Order Log's five tabs.
export type OrderLogName = components["schemas"]["OrderLogName"];
export type OrderLogEntry = components["schemas"]["OrderLogEntry"];
export type OrderLogPage = components["schemas"]["OrderLogPage"];
export type OrderLogCounts = components["schemas"]["OrderLogCounts"];
// EP07-S14: the guard table, the hold and the withdrawal.
export type OrderPatch = components["schemas"]["OrderPatch"];
export type OrderEditableField = components["schemas"]["OrderEditableField"];
export type OrderEditBlocked = components["schemas"]["OrderEditBlocked"];
export type OrderHold = components["schemas"]["OrderHold"];
export type OrderContact = components["schemas"]["OrderContact"];
export type OrderContactStatus = components["schemas"]["OrderContactStatus"];
export type Handover = components["schemas"]["Handover"];
export type HandoverDetail = components["schemas"]["HandoverDetail"];
export type HandoverOrder = components["schemas"]["HandoverOrder"];
export type HandoverOpen = components["schemas"]["HandoverOpen"];
export type HandoverScan = components["schemas"]["HandoverScan"];
export type HandoverClose = components["schemas"]["HandoverClose"];
export type HandoverAckMethod = components["schemas"]["HandoverAckMethod"];
export type OrderCancel = components["schemas"]["OrderCancel"];
export type OrderBulkResult = components["schemas"]["OrderBulkResult"];
export type OrderBulkRejection = components["schemas"]["OrderBulkRejection"];
export type OrderBulkStatus = components["schemas"]["OrderBulkStatus"];
export type OrderBulkStatusOverride = components["schemas"]["OrderBulkStatusOverride"];
export type OrderBulkUnchanged = components["schemas"]["OrderBulkUnchanged"];
export type OrderBulkContact = components["schemas"]["OrderBulkContact"];
export type OrderBulkReschedule = components["schemas"]["OrderBulkReschedule"];
export type OrderBulkAssign = components["schemas"]["OrderBulkAssign"];
export type OrderBulkAssignDriver = components["schemas"]["OrderBulkAssignDriver"];
export type OrderBulkArchive = components["schemas"]["OrderBulkArchive"];
export type OrderBulkHold = components["schemas"]["OrderBulkHold"];
export type OrderBulkApiVisibility = components["schemas"]["OrderBulkApiVisibility"];
// EP07-S25: the External Import queue and the intake log.
export type ExternalImportRow = components["schemas"]["ExternalImportRow"];
export type ExternalImportPage = components["schemas"]["ExternalImportPage"];
export type ExternalImportPayload = components["schemas"]["ExternalImportPayload"];
export type ExternalImportLine = components["schemas"]["ExternalImportLine"];
export type ExternalImportStatus = components["schemas"]["ExternalImportStatus"];
export type ExternalImportReport = components["schemas"]["ExternalImportReport"];
export type ExternalImportOutcome = components["schemas"]["ExternalImportOutcome"];
export type ExternalImportFix = components["schemas"]["ExternalImportFix"];
export type IntakeRecordRow = components["schemas"]["IntakeRecordRow"];
export type IntakeRecordPage = components["schemas"]["IntakeRecordPage"];
export type IntakeOutcome = components["schemas"]["IntakeOutcome"];
export type OrderAutoContactStamp = components["schemas"]["OrderAutoContactStamp"];
export type OrderContactNote = components["schemas"]["OrderContactNote"];
// EP07-S08: allocation at pending, Missing Stock and the re-source.
export type OrderAllocationResult = components["schemas"]["OrderAllocationResult"];
export type OrderAllocationLine = components["schemas"]["OrderAllocationLine"];
export type OrderAllocationPanel = components["schemas"]["OrderAllocationPanel"];
export type OrderAllocationRow = components["schemas"]["OrderAllocationRow"];
// EP07-S09: the fulfillment session — the walk the warehouse is opened for.
export type FulfillmentSession = components["schemas"]["FulfillmentSession"];
export type FulfillmentSessionDetail = components["schemas"]["FulfillmentSessionDetail"];
export type FulfillmentSessionPage = components["schemas"]["FulfillmentSessionPage"];
export type FulfillmentSessionOpen = components["schemas"]["FulfillmentSessionOpen"];
export type FulfillmentSessionCancel = components["schemas"]["FulfillmentSessionCancel"];
export type FulfillmentSessionReassign = components["schemas"]["FulfillmentSessionReassign"];
export type FulfillmentScan = components["schemas"]["FulfillmentScan"];
export type FulfillmentScanResult = components["schemas"]["FulfillmentScanResult"];
/** ADJ-1022-5: carts of numbered boxes, and the box scan of a session By cart. */
export type FulfillmentCart = components["schemas"]["FulfillmentCart"];
export type FulfillmentCartList = components["schemas"]["FulfillmentCartList"];
export type FulfillmentCartDraft = components["schemas"]["FulfillmentCartDraft"];
export type FulfillmentPlaceItem = components["schemas"]["FulfillmentPlaceItem"];
export type FulfillmentPlacement = components["schemas"]["FulfillmentPlacement"];
export type PickPlacement = components["schemas"]["PickPlacement"];
export type FulfillmentShortPick = components["schemas"]["FulfillmentShortPick"];
export type FulfillmentShortPickResult = components["schemas"]["FulfillmentShortPickResult"];
export type FulfillmentPutBack = components["schemas"]["FulfillmentPutBack"];
export type FulfillmentOrderScan = components["schemas"]["FulfillmentOrderScan"];
export type FulfillmentPackResult = components["schemas"]["FulfillmentPackResult"];
export type FulfillmentFinishResult = components["schemas"]["FulfillmentFinishResult"];
export type FulfillmentSessionOrder = components["schemas"]["FulfillmentSessionOrder"];
export type FulfillmentWeigh = components["schemas"]["FulfillmentWeigh"];
export type FulfillmentWeighResult = components["schemas"]["FulfillmentWeighResult"];
export type FulfillmentWeightVerdict = components["schemas"]["FulfillmentWeightVerdict"];
export type FulfillmentPackPhotoResult = components["schemas"]["FulfillmentPackPhotoResult"];
export type PackWeightRefusal = components["schemas"]["PackWeightRefusal"];
export type PackPhoto = components["schemas"]["PackPhoto"];
export type PackStationSettings = components["schemas"]["PackStationSettings"];
export type FulfillmentReadiness = components["schemas"]["FulfillmentReadiness"];
export type FulfillmentOrderReadiness = components["schemas"]["FulfillmentOrderReadiness"];
export type FulfillmentBlockedReason = components["schemas"]["FulfillmentBlockedReason"];
export type PickRow = components["schemas"]["PickRow"];
export type PickLocation = components["schemas"]["PickLocation"];
export type PickPlace = components["schemas"]["PickPlace"];
export type PickOrderShare = components["schemas"]["PickOrderShare"];
export type FulfillmentSessionLine = components["schemas"]["FulfillmentSessionLine"];
export type LabelLocale = components["schemas"]["LabelLocale"];
export type PickPlaceList = components["schemas"]["PickPlaceList"];
export type AllocationSplit = components["schemas"]["AllocationSplit"];
export type AllocationShelf = components["schemas"]["AllocationShelf"];
export type AllocationAlternatives = components["schemas"]["AllocationAlternatives"];
export type AllocationResource = components["schemas"]["AllocationResource"];
export type MissingStockOrder = components["schemas"]["MissingStockOrder"];
export type MissingStockLine = components["schemas"]["MissingStockLine"];
export type MissingStockPage = components["schemas"]["MissingStockPage"];
// EP10-S04: the Store Portal's Missing Stock drawer.
export type PortalShortLinesEdit = components["schemas"]["PortalShortLinesEdit"];
export type PortalShortLinesResult = components["schemas"]["PortalShortLinesResult"];
// EP07-S04: the Orders page.
export type OrderListTab = components["schemas"]["OrderListTab"];
export type OrderRow = components["schemas"]["OrderRow"];
export type OrderRowCosting = components["schemas"]["OrderRowCosting"];
/** Order costing (EP07-S19). */
export type OrderCosting = components["schemas"]["OrderCosting"];
export type CostComponent = components["schemas"]["CostComponent"];
export type CostAdjustment = components["schemas"]["CostAdjustment"];
export type CostAdjustmentDraft = components["schemas"]["CostAdjustmentDraft"];
export type CostAdjustmentReason = components["schemas"]["CostAdjustmentReason"];
export type OrderCharges = components["schemas"]["OrderCharges"];
export type CostingSummary = components["schemas"]["CostingSummary"];
export type CostingSummaryRow = components["schemas"]["CostingSummaryRow"];
export type CostingLossOrder = components["schemas"]["CostingLossOrder"];

/** `GET /costing/summary` (EP07-S19): `from` inclusive, `to` exclusive. */
export interface CostingSummaryQuery {
	from: string;
	to: string;
	storeId?: string;
	deliveryCompanyId?: string;
	provinceId?: string;
	groupBy?: "store" | "delivery_company" | "province";
	lossOnly?: boolean;
	signal?: AbortSignal;
}
export type OrderListPage = components["schemas"]["OrderListPage"];
export type OrderScanMatch = components["schemas"]["OrderScanMatch"];

/** The filters `GET /orders` accepts (EP07-S04). The rest are EP07-S05's. */
export interface ListOrdersQuery {
	limit?: number;
	cursor?: string;
	/** `active` (the default) or `archived`. */
	tab?: OrderListTab;
	/** Order number, custom id, customer name, email or phone — a prefix match. */
	q?: string;
	/** One or more of the seventeen statuses, comma-separated. */
	status?: string;
	storeId?: string;
	/** An employee id, or `unassigned`. */
	assigneeEmployeeId?: string;
	/** The ticked rows, comma-separated, at most 500 — what `selectionTotalMinor` sums. */
	selectedIds?: string;
	/** Sum every matching order instead of `selectedIds`, capped at 5,000. */
	selectAllMatching?: boolean;
	/** `-createdAt` (the default), `createdAt`, or `fulfillBy` (most urgent first, EP07-S22). */
	sort?: string;
	/** Open orders at this point against their promise (EP07-S22). */
	promiseState?: OrderPromiseState;
	signal?: AbortSignal;
}

// EP10-S03: the Store Portal's orders.
export type PortalOrderTab = components["schemas"]["PortalOrderTab"];
export type PortalOrderLogTab = components["schemas"]["PortalOrderLogTab"];
export type PortalOrderRow = components["schemas"]["PortalOrderRow"];
export type PortalOrderListPage = components["schemas"]["PortalOrderListPage"];
export type PortalOrder = components["schemas"]["PortalOrder"];
// EP10-S05: the Store Portal's New Order form and the pending-order actions.
export type PortalOrderDraft = components["schemas"]["PortalOrderDraft"];
export type PortalOrderPatch = components["schemas"]["PortalOrderPatch"];
export type PortalOrderCancel = components["schemas"]["PortalOrderCancel"];
export type PortalOrderIntakeResult = components["schemas"]["PortalOrderIntakeResult"];
export type PortalCity = components["schemas"]["PortalCity"];
export type PortalCityPage = components["schemas"]["PortalCityPage"];
// EP10-S11: the portal's Settings.
export type PortalSettings = components["schemas"]["PortalSettings"];
export type PortalSettingsUpdate = components["schemas"]["PortalSettingsUpdate"];
export type PortalAutoImport = components["schemas"]["PortalAutoImport"];
export type PortalStoreProfile = components["schemas"]["PortalStoreProfile"];
// EP10-S06: the portal's Inventory.
export type PortalStockRow = components["schemas"]["PortalStockRow"];
export type PortalStockPage = components["schemas"]["PortalStockPage"];
export type PortalLowStockPage = components["schemas"]["PortalLowStockPage"];
export type PortalReceivingRow = components["schemas"]["PortalReceivingRow"];
export type PortalReceivingPage = components["schemas"]["PortalReceivingPage"];
export type PortalReorderRow = components["schemas"]["PortalReorderRow"];
export type PortalReorderPage = components["schemas"]["PortalReorderPage"];
export type PortalReorderAccept = components["schemas"]["PortalReorderAccept"];
export type PortalReorderDismissReason = components["schemas"]["PortalReorderDismissReason"];
export type PortalReorderDecision = components["schemas"]["PortalReorderDecision"];
// EP10-S07: the portal's Catalog.
export type PortalCatalogImage = components["schemas"]["PortalCatalogImage"];
export type PortalSkuChannel = components["schemas"]["PortalSkuChannel"];
export type PortalCatalogSku = components["schemas"]["PortalCatalogSku"];
export type PortalCatalogItem = components["schemas"]["PortalCatalogItem"];
export type PortalCatalogPage = components["schemas"]["PortalCatalogPage"];
export type PortalCatalogSkuInput = components["schemas"]["PortalCatalogSkuInput"];
export type PortalCatalogItemInput = components["schemas"]["PortalCatalogItemInput"];
export type PortalChannel = components["schemas"]["PortalChannel"];
export type PortalChannelList = components["schemas"]["PortalChannelList"];

export interface ListPortalOrdersQuery {
	limit?: number;
	cursor?: string;
	/** `existing` (the default), `website` or `archived`. */
	tab?: PortalOrderTab;
	q?: string;
	/** One or more of the seventeen statuses, comma-separated. */
	status?: string;
	/** `-createdAt` (the default) or `createdAt`. */
	sort?: string;
	/** The filter drawer's values, by query parameter (`type`, `urgency`, `createdFrom`, …). */
	filters?: Record<string, string>;
	signal?: AbortSignal;
}
// EP07-S22: the fulfillment-promise clock.
export type OrderPromiseState = components["schemas"]["OrderPromiseState"];
export type OrderPromiseCounts = components["schemas"]["OrderPromiseCounts"];
export type OrderPromiseSummary = components["schemas"]["OrderPromiseSummary"];

// EP07-S02: the customer record, its COD rollup and its risk ladder.
export type Customer = components["schemas"]["Customer"];
export type CustomerPage = components["schemas"]["CustomerPage"];
export type CustomerDetail = components["schemas"]["CustomerDetail"];
export type CustomerPatch = components["schemas"]["CustomerPatch"];
export type CustomerPhone = components["schemas"]["CustomerPhone"];
export type CustomerAddress = components["schemas"]["CustomerAddress"];
export type CustomerAddressInput = components["schemas"]["CustomerAddressInput"];
export type CustomerConsent = components["schemas"]["CustomerConsent"];
export type CustomerConsentChannel = components["schemas"]["CustomerConsentChannel"];
export type CustomerOrderSummary = components["schemas"]["CustomerOrderSummary"];
export type CustomerRiskLevel = components["schemas"]["CustomerRiskLevel"];
export type CustomerRiskUpdate = components["schemas"]["CustomerRiskUpdate"];
export type CustomerRiskEvent = components["schemas"]["CustomerRiskEvent"];
export type CustomerRiskEventPage = components["schemas"]["CustomerRiskEventPage"];
export type CustomerMerge = components["schemas"]["CustomerMerge"];
export type CustomerMergeResult = components["schemas"]["CustomerMergeResult"];

/** The filters `GET /customers` accepts (EP07-S02). */
export interface ListCustomersQuery {
	limit?: number;
	cursor?: string;
	/** One risk level — the All / Watch / High / Blocked pills. */
	risk?: CustomerRiskLevel;
	/** Prefix of a display name or a run of phone digits. At least two characters. */
	q?: string;
	signal?: AbortSignal;
}

export type PackagingReversalReason = components["schemas"]["PackagingReversalReason"];
export type PackagingConsumptionReverse = components["schemas"]["PackagingConsumptionReverse"];
export type PackagingConsumptionReversal = components["schemas"]["PackagingConsumptionReversal"];

/** The filters `GET /packaging/consumptions` accepts (EP06-S05). */
export interface ListPackagingConsumptionsQuery {
	limit?: number;
	cursor?: string;
	orderId?: string;
	storeId?: string;
	packageTypeId?: string;
	/** `recorded`, `reversed`, `reversal` or `all`. */
	status?: string;
	/** Inclusive lower bound on `createdAt`, RFC 3339. */
	from?: string;
	/** Exclusive upper bound on `createdAt`, RFC 3339. */
	to?: string;
	signal?: AbortSignal;
}

export type PackagingPricingModel = components["schemas"]["PackagingPricingModel"];
export type StorePackagingPrice = components["schemas"]["StorePackagingPrice"];
export type StorePackagingPriceDraft = components["schemas"]["StorePackagingPriceDraft"];
export type StorePackagingPriceList = components["schemas"]["StorePackagingPriceList"];
export type PackagingCharge = components["schemas"]["PackagingCharge"];
export type PackagingChargePage = components["schemas"]["PackagingChargePage"];
export type PackagingChargeRerate = components["schemas"]["PackagingChargeRerate"];
export type PackagingMarginRow = components["schemas"]["PackagingMarginRow"];
export type PackagingMarginReport = components["schemas"]["PackagingMarginReport"];
export type PackagingOverview = components["schemas"]["PackagingOverview"];
export type PackagingTypeUtilization = components["schemas"]["PackagingTypeUtilization"];

/** The filters `GET /packaging/charges` accepts (EP06-S07). */
export interface ListPackagingChargesQuery {
	limit?: number;
	cursor?: string;
	storeId?: string;
	/** `posted`, `voided`, `missing_rate` or `all`. */
	status?: string;
	/** Inclusive lower bound on `occurredAt`, RFC 3339. */
	from?: string;
	/** Exclusive upper bound on `occurredAt`, RFC 3339. */
	to?: string;
	signal?: AbortSignal;
}

/** `GET /packaging/margin-report` (EP06-S07): `from` inclusive, `to` exclusive. */
export interface PackagingMarginReportQuery {
	from: string;
	to: string;
	groupBy?: "store" | "package_type";
	signal?: AbortSignal;
}

/** `GET /packaging/overview` (EP06-S10): UTC days, both inclusive. */
export interface PackagingOverviewQuery {
	from: string;
	to: string;
	signal?: AbortSignal;
}

export type MetricSeries = components["schemas"]["MetricSeries"];
export type MetricPoint = components["schemas"]["MetricPoint"];
export type MetricDims = components["schemas"]["MetricDims"];

/** `GET /analytics/metrics/live` (EP13-S01): today's counters. */
export interface LiveMetricQuery extends MetricDims {
	metricKey: string;
	/** Comma-separated: `date` and dimension names. */
	groupBy?: string;
	currency?: string;
	signal?: AbortSignal;
}

/** `GET /analytics/metrics` (EP13-S01): org-local days, both inclusive, at most 400. */
export interface MetricQuery extends LiveMetricQuery {
	from: string;
	to: string;
}

export type SalesBreakdown = components["schemas"]["SalesBreakdown"];
export type SalesRow = components["schemas"]["SalesRow"];
export type SalesBlock = SalesBreakdown["block"];

/** `GET /analytics/sales/{block}` (EP13-S10): org-local days, both inclusive. */
export interface SalesQuery {
	from: string;
	to: string;
	storeId?: string;
	channel?: string;
	provinceId?: string;
	cityId?: string;
	/** The top lists' length; 10 by default, at most 50. */
	limit?: number;
	signal?: AbortSignal;
}

export type CustomersBreakdown = components["schemas"]["CustomersBreakdown"];
export type CustomersRow = components["schemas"]["CustomersRow"];
export type CustomersBlock = CustomersBreakdown["block"];
export type ReturnsInspections = components["schemas"]["ReturnsInspections"];

export type StorePerformanceList = components["schemas"]["StorePerformanceList"];
export type StorePerformanceRow = components["schemas"]["StorePerformanceRow"];
export type StoreScorecard = components["schemas"]["StoreScorecard"];
export type StoreStorage = components["schemas"]["StoreStorage"];
export type StoreStorageKind = components["schemas"]["StoreStorageKind"];
export type StoreTrend = components["schemas"]["StoreTrend"];
export type StoreTrendDay = components["schemas"]["StoreTrendDay"];
export type StoreHealth = NonNullable<StorePerformanceRow["health"]>;
/** `GET /analytics/stores`, one store's scorecard and trend (EP13-S11), and the portal's `/portal/scorecard`. */
export interface StorePerformanceQuery {
	from: string;
	to: string;
	/** The ranking only: one lifecycle state; every store but prospects without it. */
	status?: "prospect" | "active" | "suspended" | "closed";
	signal?: AbortSignal;
}

/** `GET /analytics/customers/{block}` and `/analytics/returns/inspections` (EP13-S16). */
export interface CustomersQuery {
	from: string;
	to: string;
	storeId?: string;
	provinceId?: string;
	cityId?: string;
	reasonCode?: string;
	/** On `return-reasons`, split each reason by store too. */
	byStore?: boolean;
	signal?: AbortSignal;
}

export type DeliveryKpiLane = components["schemas"]["DeliveryKpiLane"];
export type DeliveryKpiTimeToDeliver = components["schemas"]["DeliveryKpiTimeToDeliver"];
export type DeliveryKpiOdd = components["schemas"]["DeliveryKpiOdd"];
export type DeliveryKpiOddDay = components["schemas"]["DeliveryKpiOddDay"];
export type DeliveryKpiDriver = components["schemas"]["DeliveryKpiDriver"];
export type DeliveryKpiDriverDay = components["schemas"]["DeliveryKpiDriverDay"];
export type DeliveryKpiDrivers = components["schemas"]["DeliveryKpiDrivers"];
export type DeliveryKpiReason = components["schemas"]["DeliveryKpiReason"];
export type DeliveryKpiExceptionStat = components["schemas"]["DeliveryKpiExceptionStat"];
export type DeliveryKpiExceptionWeek = components["schemas"]["DeliveryKpiExceptionWeek"];
export type DeliveryKpiExceptions = components["schemas"]["DeliveryKpiExceptions"];

export type DeliveryCodSummary = components["schemas"]["DeliveryCodSummary"];
export type DeliveryCodGeoRow = components["schemas"]["DeliveryCodGeoRow"];
export type DeliveryCodProvince = components["schemas"]["DeliveryCodProvince"];
export type DeliveryCodGeography = components["schemas"]["DeliveryCodGeography"];
export type DeliveryCodCarrier = components["schemas"]["DeliveryCodCarrier"];
export type DeliveryCodCarriers = components["schemas"]["DeliveryCodCarriers"];
export type DeliveryCodDay = components["schemas"]["DeliveryCodDay"];
export type DeliveryCodCash = components["schemas"]["DeliveryCodCash"];
export type DeliveryCodUnpricedLane = components["schemas"]["DeliveryCodUnpricedLane"];
export type DeliveryCodUnpricedLanes = components["schemas"]["DeliveryCodUnpricedLanes"];

/**
 * The Delivery KPIs reads (EP13-S08) and the Delivery & COD dashboard's
 * (EP13-S09), by their path's last segment.
 */
export interface DeliveryKpiResults {
	"time-to-deliver": DeliveryKpiTimeToDeliver;
	odd: DeliveryKpiOdd;
	drivers: DeliveryKpiDrivers;
	exceptions: DeliveryKpiExceptions;
	summary: DeliveryCodSummary;
	geography: DeliveryCodGeography;
	carriers: DeliveryCodCarriers;
	cod: DeliveryCodCash;
	"unpriced-lanes": DeliveryCodUnpricedLanes;
}
export type DeliveryKpiRead = keyof DeliveryKpiResults;

/** `GET /analytics/delivery/{read}` (EP13-S08): org-local days, both inclusive. */
export interface DeliveryKpiQuery {
	from: string;
	to: string;
	companyId?: string;
	provinceId?: string;
	cityId?: string;
	storeId?: string;
	driverId?: string;
	/** The carrier panel's currency (EP13-S09); USD when absent. */
	currency?: string;
	signal?: AbortSignal;
}

export type FulfillmentCounts = components["schemas"]["FulfillmentCounts"];
export type FulfillmentFee = components["schemas"]["FulfillmentFee"];
export type FulfillmentThroughput = components["schemas"]["FulfillmentThroughput"];
export type FulfillmentCycleStat = components["schemas"]["FulfillmentCycleStat"];
export type FulfillmentCycleTimes = components["schemas"]["FulfillmentCycleTimes"];
export type FulfillmentSlaStat = components["schemas"]["FulfillmentSlaStat"];
export type FulfillmentSla = components["schemas"]["FulfillmentSla"];
export type FulfillmentBacklogStage = components["schemas"]["FulfillmentBacklogStage"];
export type FulfillmentBacklog = components["schemas"]["FulfillmentBacklog"];
export type FulfillmentProductivityRow = components["schemas"]["FulfillmentProductivityRow"];
export type FulfillmentProductivity = components["schemas"]["FulfillmentProductivity"];

/** The Fulfillment & Warehouse Ops reads (EP13-S07), by their path's last segment. */
export interface FulfillmentResults {
	throughput: FulfillmentThroughput;
	"cycle-times": FulfillmentCycleTimes;
	sla: FulfillmentSla;
	backlog: FulfillmentBacklog;
	productivity: FulfillmentProductivity;
}
export type FulfillmentRead = keyof FulfillmentResults;

/** `GET /analytics/fulfillment/{read}` (EP13-S07); `backlog` takes no range. */
export interface FulfillmentQuery {
	from?: string;
	to?: string;
	storeId?: string;
	orderType?: string;
	signal?: AbortSignal;
}

export type WorkforcePackageLine = components["schemas"]["WorkforcePackageLine"];
export type WorkforceTotals = components["schemas"]["WorkforceTotals"];
export type WorkforceOverview = components["schemas"]["WorkforceOverview"];
export type WorkforceEmployeeRow = components["schemas"]["WorkforceEmployeeRow"];
export type WorkforceEmployees = components["schemas"]["WorkforceEmployees"];
export type WorkforceDayRow = components["schemas"]["WorkforceDayRow"];
export type WorkforceDaily = components["schemas"]["WorkforceDaily"];
export type WorkforcePackaging = components["schemas"]["WorkforcePackaging"];
export type WorkforceCharts = components["schemas"]["WorkforceCharts"];

/** The employee performance reads (EP13-S06), by their path's last segment. */
export interface WorkforceResults {
	overview: WorkforceOverview;
	employees: WorkforceEmployees;
	daily: WorkforceDaily;
	packaging: WorkforcePackaging;
	charts: WorkforceCharts;
}
export type WorkforceRead = keyof WorkforceResults;

/**
 * `GET /analytics/workforce/{read}` (EP13-S06). The lists are comma-separated;
 * pickup-design orders are left out unless `pickupDesign` is `include`.
 */
export interface WorkforceQuery {
	from: string;
	to: string;
	employeeId?: string;
	orderStatus?: string;
	orderType?: string;
	pickupDesign?: "exclude" | "include";
	mode?: "split" | "unified";
	signal?: AbortSignal;
}

export type FinanceFigures = components["schemas"]["FinanceFigures"];
export type FinanceSummary = components["schemas"]["FinanceSummary"];
export type FinanceTrend = components["schemas"]["FinanceTrend"];
export type FinanceCodHop = components["schemas"]["FinanceCodHop"];
export type FinanceCodPanel = components["schemas"]["FinanceCodPanel"];
export type FinanceCodWaterfall = components["schemas"]["FinanceCodWaterfall"];
export type FinancePartyType = components["schemas"]["FinancePartyType"];
export type FinancePartyBalance = components["schemas"]["FinancePartyBalance"];
export type FinanceBalances = components["schemas"]["FinanceBalances"];
export type FinanceForecast = components["schemas"]["FinanceForecast"];
export type FinanceForecastRow = components["schemas"]["FinanceForecastRow"];

export type ExecutiveOverview = components["schemas"]["ExecutiveOverview"];
export type ExecutiveTile = components["schemas"]["ExecutiveTile"];
export type ExecutiveKpiKey = components["schemas"]["ExecutiveKpiKey"];
export type ExecutiveHealth = components["schemas"]["ExecutiveHealth"];
export type KpiTarget = components["schemas"]["KpiTarget"];
export type KpiTargetList = components["schemas"]["KpiTargetList"];
export type KpiTargetInput = components["schemas"]["KpiTargetInput"];

export type AnalyticsExport = components["schemas"]["AnalyticsExport"];
export type AnalyticsExportList = components["schemas"]["AnalyticsExportList"];
export type AnalyticsExportRequest = components["schemas"]["AnalyticsExportRequest"];
export type AnalyticsExportDownload = components["schemas"]["AnalyticsExportDownload"];
export type AnalyticsSchedule = components["schemas"]["AnalyticsSchedule"];
export type AnalyticsScheduleList = components["schemas"]["AnalyticsScheduleList"];
export type AnalyticsScheduleInput = components["schemas"]["AnalyticsScheduleInput"];
export type AlertMetricKey = components["schemas"]["AlertMetricKey"];

/** `GET /analytics/executive` (EP13-S17): a month (`2026-09`) or a quarter (`2026-Q3`). */
export interface ExecutiveQuery {
	period?: string;
	signal?: AbortSignal;
}

/** `GET /analytics/finance/{summary,trend,cod-waterfall}` (EP13-S12): org-local days, both inclusive. */
export interface FinanceRangeQuery {
	from: string;
	to: string;
	currency?: string;
	signal?: AbortSignal;
}

/** `GET /analytics/finance/{balances,forecast}` (EP13-S12). */
export interface FinancePartyQuery {
	partyType?: FinancePartyType;
	currency?: string;
	signal?: AbortSignal;
}

export type FinanceStatementRow = components["schemas"]["FinanceStatementRow"];
export type FinanceStatementReport = components["schemas"]["FinanceStatementReport"];
export type FinanceMarginGrouping = components["schemas"]["FinanceMarginGrouping"];
export type FinanceMarginFigures = components["schemas"]["FinanceMarginFigures"];
export type FinanceMarginRow = components["schemas"]["FinanceMarginRow"];
export type FinanceMarginReport = components["schemas"]["FinanceMarginReport"];
export type FinanceCodPositionHop = components["schemas"]["FinanceCodPositionHop"];
export type FinanceCodPositionRow = components["schemas"]["FinanceCodPositionRow"];
export type FinanceCodPositionReport = components["schemas"]["FinanceCodPositionReport"];
export type FinancePayoutItemRow = components["schemas"]["FinancePayoutItemRow"];
export type FinancePayoutRunRow = components["schemas"]["FinancePayoutRunRow"];
export type FinancePayoutRunReport = components["schemas"]["FinancePayoutRunReport"];
export type FinanceReportEntry = components["schemas"]["FinanceReportEntry"];
export type FinanceReportEntries = components["schemas"]["FinanceReportEntries"];

/** `GET /analytics/reports/finance/*` (EP13-S13): org-local days, both inclusive. */
export interface FinanceReportQuery {
	from: string;
	to: string;
	currency?: string;
	storeId?: string;
	companyId?: string;
	partyType?: FinancePartyType;
	partyId?: string;
	signal?: AbortSignal;
}

/** The margin report's query: the report's, and how to group it. */
export interface FinanceMarginQuery extends FinanceReportQuery {
	groupBy: FinanceMarginGrouping;
}

export type AggregateRebuild = components["schemas"]["AggregateRebuild"];
export type AggregateRebuildList = components["schemas"]["AggregateRebuildList"];
export type DriftFinding = components["schemas"]["DriftFinding"];
export type RequestAnalyticsRebuild = components["schemas"]["RequestAnalyticsRebuild"];
export type AnalyticsReconciliation = components["schemas"]["AnalyticsReconciliation"];
export type MetricDefinition = components["schemas"]["MetricDefinition"];
export type MetricDefinitionList = components["schemas"]["MetricDefinitionList"];
export type AnalyticsDashboard = components["schemas"]["AnalyticsDashboard"];
export type AnalyticsDashboardList = components["schemas"]["AnalyticsDashboardList"];

export type Project = components["schemas"]["Project"];
export type ProjectList = components["schemas"]["ProjectList"];
export type ProjectDraft = components["schemas"]["ProjectDraft"];
export type ProjectPatch = components["schemas"]["ProjectPatch"];
export type ProjectRole = components["schemas"]["ProjectRole"];
export type ProjectKeyPrefixAvailability = components["schemas"]["ProjectKeyPrefixAvailability"];
export type DashboardAmount = components["schemas"]["DashboardAmount"];
export type InventoryHealthSummary = components["schemas"]["InventoryHealthSummary"];
export type InventoryOccupancy = components["schemas"]["InventoryOccupancy"];
export type InventoryOccupancyKind = components["schemas"]["InventoryOccupancyKind"];
export type InventoryOccupancyNode = components["schemas"]["InventoryOccupancyNode"];
export type InventoryOccupancyTrendPoint = components["schemas"]["InventoryOccupancyTrendPoint"];
export type InventoryAging = components["schemas"]["InventoryAging"];
export type InventoryAgingBucket = components["schemas"]["InventoryAgingBucket"];
export type InventoryDeadStock = components["schemas"]["InventoryDeadStock"];
export type InventoryDeadStockItem = components["schemas"]["InventoryDeadStockItem"];
export type InventoryTurnover = components["schemas"]["InventoryTurnover"];
export type InventoryTurnoverReport = components["schemas"]["InventoryTurnoverReport"];

/** The Inventory Health reads (EP13-S14): a snapshot day (the newest when absent) and a store. */
export interface InventoryHealthQuery {
	date?: string;
	storeId?: string;
	signal?: AbortSignal;
}

/** `GET /analytics/inventory/occupancy`: a node to drill into; the organisation when absent. */
export interface InventoryOccupancyQuery {
	date?: string;
	nodeId?: string;
	signal?: AbortSignal;
}

/** `GET /analytics/inventory/dead-stock`: only dead or only slow; both when absent. */
export interface InventoryDeadStockQuery extends InventoryHealthQuery {
	status?: "dead" | "slow";
}
export type ProjectMember = components["schemas"]["ProjectMember"];
export type ProjectMemberList = components["schemas"]["ProjectMemberList"];
export type ProjectMemberDraft = components["schemas"]["ProjectMemberDraft"];
export type Task = components["schemas"]["Task"];
export type TaskList = components["schemas"]["TaskList"];
export type TaskDraft = components["schemas"]["TaskDraft"];
export type TaskPatch = components["schemas"]["TaskPatch"];
export type TaskStatusCategory = components["schemas"]["TaskStatusCategory"];
export type TaskType = components["schemas"]["TaskType"];
export type TaskPriority = components["schemas"]["TaskPriority"];
export type TaskActivity = components["schemas"]["TaskActivity"];
export type TaskActivityList = components["schemas"]["TaskActivityList"];
export type TaskComment = components["schemas"]["TaskComment"];
export type TaskCommentList = components["schemas"]["TaskCommentList"];
export type TaskCommentDraft = components["schemas"]["TaskCommentDraft"];
export type TaskCommentEdit = components["schemas"]["TaskCommentEdit"];
export type TaskLabel = components["schemas"]["TaskLabel"];
export type TaskLabelList = components["schemas"]["TaskLabelList"];
export type TaskLabelDraft = components["schemas"]["TaskLabelDraft"];
export type TaskWorkflow = components["schemas"]["TaskWorkflow"];
export type TaskRef = components["schemas"]["TaskRef"];
export type TaskChecklistItem = components["schemas"]["TaskChecklistItem"];
export type TaskChecklistWrite = components["schemas"]["TaskChecklistWrite"];
export type TaskLinkKind = components["schemas"]["TaskLinkKind"];
export type TaskEntityLink = components["schemas"]["TaskEntityLink"];
export type TaskLinkDraft = components["schemas"]["TaskLinkDraft"];
export type TaskDependency = components["schemas"]["TaskDependency"];
export type TaskDependencyDraft = components["schemas"]["TaskDependencyDraft"];
export type TaskDependencyEdge = components["schemas"]["TaskDependencyEdge"];
export type TaskAttachment = components["schemas"]["TaskAttachment"];
export type Milestone = components["schemas"]["Milestone"];
export type MilestoneList = components["schemas"]["MilestoneList"];
export type MilestoneDraft = components["schemas"]["MilestoneDraft"];
export type MilestonePatch = components["schemas"]["MilestonePatch"];
export type MilestoneState = components["schemas"]["MilestoneState"];
export type Release = components["schemas"]["Release"];
export type ReleaseList = components["schemas"]["ReleaseList"];
export type ReleaseDraft = components["schemas"]["ReleaseDraft"];
export type ReleasePatch = components["schemas"]["ReleasePatch"];
export type ReleaseState = components["schemas"]["ReleaseState"];
export type ReleaseShip = components["schemas"]["ReleaseShip"];
export type ShipDecision = components["schemas"]["ShipDecision"];
export type PlanProgress = components["schemas"]["PlanProgress"];
export type Roadmap = components["schemas"]["Roadmap"];
export type RoadmapLane = components["schemas"]["RoadmapLane"];
export type Idea = components["schemas"]["Idea"];
export type IdeaList = components["schemas"]["IdeaList"];
export type IdeaDraft = components["schemas"]["IdeaDraft"];
export type IdeaPatch = components["schemas"]["IdeaPatch"];
export type IdeaPromotion = components["schemas"]["IdeaPromotion"];
export type IdeaState = components["schemas"]["IdeaState"];
export type IdeaSource = components["schemas"]["IdeaSource"];
export type IdeaImpact = components["schemas"]["IdeaImpact"];
export type IdeaComment = components["schemas"]["IdeaComment"];
export type IdeaCommentList = components["schemas"]["IdeaCommentList"];
export type IdeaIntakeList = components["schemas"]["IdeaIntakeList"];
export type IdeaIntakeProject = components["schemas"]["IdeaIntakeProject"];
export type TaskTemplate = components["schemas"]["TaskTemplate"];
export type TaskTemplateList = components["schemas"]["TaskTemplateList"];
export type TaskTemplateDraft = components["schemas"]["TaskTemplateDraft"];
export type TaskTemplatePatch = components["schemas"]["TaskTemplatePatch"];
export type TaskTemplateInstance = components["schemas"]["TaskTemplateInstance"];
export type TaskSubtaskBlueprint = components["schemas"]["TaskSubtaskBlueprint"];
export type RecurringRule = components["schemas"]["RecurringRule"];
export type RecurringRuleList = components["schemas"]["RecurringRuleList"];
export type RecurringRuleDraft = components["schemas"]["RecurringRuleDraft"];
export type RecurringRulePatch = components["schemas"]["RecurringRulePatch"];
export type RecurringSchedule = components["schemas"]["RecurringSchedule"];
export type RecurringPreset = components["schemas"]["RecurringPreset"];
export type RecurringWeekday = components["schemas"]["RecurringWeekday"];
export type RecurringOnOpenPrevious = components["schemas"]["RecurringOnOpenPrevious"];
export type TaskCalendar = components["schemas"]["TaskCalendar"];
export type TaskTimeline = components["schemas"]["TaskTimeline"];
export type TaskTimelineEdge = components["schemas"]["TaskTimelineEdge"];
export type WorkTask = components["schemas"]["WorkTask"];
export type MyWork = components["schemas"]["MyWork"];
export type TimeLog = components["schemas"]["TimeLog"];
export type TimeLogDraft = components["schemas"]["TimeLogDraft"];
export type TimeLogPatch = components["schemas"]["TimeLogPatch"];
export type TimeLogList = components["schemas"]["TimeLogList"];
export type Workload = components["schemas"]["Workload"];
export type WorkloadRow = components["schemas"]["WorkloadRow"];
export type WorkloadTask = components["schemas"]["WorkloadTask"];

/** The filters `GET /timelogs` accepts (EP15-S10): one scope, and a window without a task. */
export interface TimeLogsQuery {
	taskKey?: string;
	projectId?: string;
	employeeId?: string;
	from?: string;
	to?: string;
	signal?: AbortSignal;
}

/** `GET /workload` (EP15-S10): a window, optionally one project and one person. */
export interface WorkloadQuery {
	from: string;
	to: string;
	projectId?: string;
	employeeId?: string;
	signal?: AbortSignal;
}
export type Board = components["schemas"]["Board"];
export type BoardList = components["schemas"]["BoardList"];
export type BoardColumn = components["schemas"]["BoardColumn"];
export type BoardColumnInput = components["schemas"]["BoardColumnInput"];
export type BoardPatch = components["schemas"]["BoardPatch"];
export type BoardFilter = components["schemas"]["BoardFilter"];
export type BoardSwimlane = components["schemas"]["BoardSwimlane"];
export type BoardCard = components["schemas"]["BoardCard"];
export type BoardCards = components["schemas"]["BoardCards"];
export type BoardMove = components["schemas"]["BoardMove"];
export type BoardMoveResult = components["schemas"]["BoardMoveResult"];
export type Sprint = components["schemas"]["Sprint"];
export type SprintState = components["schemas"]["SprintState"];
export type SprintList = components["schemas"]["SprintList"];
export type SprintDraft = components["schemas"]["SprintDraft"];
export type SprintPatch = components["schemas"]["SprintPatch"];
export type SprintCompletion = components["schemas"]["SprintCompletion"];
export type SprintCompleted = components["schemas"]["SprintCompleted"];
// EP15-S12: automations.
export type Automation = components["schemas"]["Automation"];
export type AutomationDraft = components["schemas"]["AutomationDraft"];
export type AutomationPatch = components["schemas"]["AutomationPatch"];
export type AutomationTrigger = components["schemas"]["AutomationTrigger"];
export type AutomationTriggerConfig = components["schemas"]["AutomationTriggerConfig"];
export type AutomationCondition = components["schemas"]["AutomationCondition"];
export type AutomationAction = components["schemas"]["AutomationAction"];
export type AutomationList = components["schemas"]["AutomationList"];
export type AutomationRun = components["schemas"]["AutomationRun"];
export type AutomationRunResult = components["schemas"]["AutomationRunResult"];
export type AutomationRunList = components["schemas"]["AutomationRunList"];
export type AutomationDryRun = components["schemas"]["AutomationDryRun"];
export type ProjectBacklog = components["schemas"]["ProjectBacklog"];
export type BacklogSprint = components["schemas"]["BacklogSprint"];
export type BacklogReorder = components["schemas"]["BacklogReorder"];
export type BacklogReorderResult = components["schemas"]["BacklogReorderResult"];
export type ProjectVelocity = components["schemas"]["ProjectVelocity"];
export type BurnPoint = components["schemas"]["BurnPoint"];
export type Burndown = components["schemas"]["Burndown"];
export type Throughput = components["schemas"]["Throughput"];
export type ThroughputWeek = components["schemas"]["ThroughputWeek"];
export type DurationStat = components["schemas"]["DurationStat"];
export type LabelCycleTime = components["schemas"]["LabelCycleTime"];
export type CycleTime = components["schemas"]["CycleTime"];
export type OverdueSummary = components["schemas"]["OverdueSummary"];
export type WipColumn = components["schemas"]["WipColumn"];
export type WipSummary = components["schemas"]["WipSummary"];
export type MetricsRecomputed = components["schemas"]["MetricsRecomputed"];
export type SprintTaskItem = components["schemas"]["SprintTaskItem"];
export type StandupPerson = components["schemas"]["StandupPerson"];
export type Standup = components["schemas"]["Standup"];
export type SprintReport = components["schemas"]["SprintReport"];
export type TaskLabelPatch = components["schemas"]["TaskLabelPatch"];
export type TaskQuery = components["schemas"]["TaskQuery"];
export type TaskGroupBy = components["schemas"]["TaskGroupBy"];
export type TaskSortBy = components["schemas"]["TaskSortBy"];
export type TaskSearch = components["schemas"]["TaskSearch"];
export type TaskGroup = components["schemas"]["TaskGroup"];
export type TaskSearchPage = components["schemas"]["TaskSearchPage"];
export type TaskBulkEdit = components["schemas"]["TaskBulkEdit"];
export type TaskBulkRow = components["schemas"]["TaskBulkRow"];
export type TaskBulkResult = components["schemas"]["TaskBulkResult"];
export type TaskFilter = components["schemas"]["TaskFilter"];
export type TaskFilterList = components["schemas"]["TaskFilterList"];
export type TaskFilterDraft = components["schemas"]["TaskFilterDraft"];
export type TaskFilterPatch = components["schemas"]["TaskFilterPatch"];
export type TaskViewMode = components["schemas"]["TaskViewMode"];

/** The filters `GET /projects/{id}/tasks` accepts (EP15-S03); they combine. */
export interface ProjectTasksQuery {
	status?: string;
	statusCategory?: TaskStatusCategory;
	assigneeEmployeeId?: string;
	labelId?: string;
	signal?: AbortSignal;
}

export type InventorySohRow = components["schemas"]["InventorySohRow"];
export type InventorySohPage = components["schemas"]["InventorySohPage"];
export type InventoryAgingRow = components["schemas"]["InventoryAgingRow"];
export type InventoryAgingReport = components["schemas"]["InventoryAgingReport"];
export type InventoryValuationRow = components["schemas"]["InventoryValuationRow"];
export type InventoryValuationReport = components["schemas"]["InventoryValuationReport"];
export type InventoryMovementRow = components["schemas"]["InventoryMovementRow"];
export type InventoryMovementReference = components["schemas"]["InventoryMovementReference"];
export type InventoryMovementReport = components["schemas"]["InventoryMovementReport"];

/** The inventory report hub's shared filters (EP13-S15): a store, one sku code, a page. */
export interface InventoryReportQuery {
	storeId?: string;
	sku?: string;
	limit?: number;
	cursor?: string;
	signal?: AbortSignal;
}

/** `GET /analytics/reports/inventory/soh`: per sku, or per leaf under a warehouse or a node. */
export interface InventorySohQuery extends InventoryReportQuery {
	warehouseId?: string;
	locationId?: string;
}

/** Aging and valuation: a snapshot day, the newest when absent. */
export interface InventorySnapshotReportQuery extends InventoryReportQuery {
	date?: string;
}

/** `GET /analytics/reports/inventory/movements`: org-local days, at most 93. */
export interface InventoryMovementsReportQuery extends InventoryReportQuery {
	from?: string;
	to?: string;
	type?: string;
}

/** The filters `GET /packaging/package-types` accepts (EP06-S02). */
export interface ListPackageTypesQuery {
	limit?: number;
	cursor?: string;
	/** `active`, `archived` or `all` (the default). */
	status?: string;
	/** Case-insensitive match on the code or either name. */
	q?: string;
	signal?: AbortSignal;
}

/**
 * A front end somebody can actually be browsing from.
 *
 * `all` is in the wire enum because a stored row can speak for every interface,
 * but nobody evaluates *for* it — asking the server for "all"'s flags is a 400.
 * Excluding it here turns that into a type error at the call site.
 */
export type EvaluableInterface = Exclude<FlagInterface, "all">;

/**
 * A file the server produced, already in memory.
 *
 * The filename comes from the response rather than being built here: the server
 * decides what an export is called — it knows the date and the type — and two
 * places naming the same file is two places to change when one of them moves.
 */
export interface DownloadedFile {
	blob: Blob;
	filename: string;
}

/**
 * Saves a downloaded file the way a browser does.
 *
 * The object URL is revoked on the next frame rather than immediately: a
 * revoked URL is a cancelled download in Safari, and leaving it alive is a leak
 * that lasts until the tab closes.
 */
export function saveFile(file: DownloadedFile): void {
	const url = URL.createObjectURL(file.blob);
	const link = document.createElement("a");
	link.href = url;
	link.download = file.filename;
	document.body.append(link);
	link.click();
	link.remove();
	setTimeout(() => URL.revokeObjectURL(url), 0);
}

/** The frame the last {@link printFile} printed from, kept until the next. */
let printFrame: { frame: HTMLIFrameElement; url: string } | null = null;

/**
 * Opens a downloaded document in the browser's print dialog, as Ctrl+P does.
 *
 * A hidden frame loads the file and prints itself. The frame stays until the
 * next print, because removing it while the dialog is open cancels the print.
 * A browser that refuses to print a frame opens the document in a tab instead.
 *
 * ponytail: Safari may print an empty page from the frame; open a tab there if
 * Safari ever runs the warehouse.
 */
export function printFile(file: DownloadedFile): void {
	if (printFrame !== null) {
		printFrame.frame.remove();
		URL.revokeObjectURL(printFrame.url);
	}
	const url = URL.createObjectURL(file.blob);
	const frame = document.createElement("iframe");
	// Not display:none: a hidden-by-display frame never loads a PDF viewer.
	frame.style.cssText =
		"position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden";
	frame.title = file.filename;
	frame.onload = () => {
		try {
			frame.contentWindow?.focus();
			frame.contentWindow?.print();
		} catch {
			window.open(url, "_blank");
		}
	};
	frame.src = url;
	document.body.append(frame);
	printFrame = { frame, url };
}

/** Reads the filename out of a Content-Disposition, falling back to a plain one. */
function filenameFrom(disposition: string | null): string {
	const match = disposition?.match(/filename="([^"]+)"/);
	return match?.[1] ?? "download";
}

/** A non-2xx response, carrying the error shape the spec promises. */
export class ApiError extends Error {
	readonly status: number;
	readonly code: string;
	readonly field: string | null;
	/**
	 * The permission the caller was missing, for a `permission_denied`.
	 *
	 * It is the same value as {@link field}, surfaced under a name that says
	 * what it is: on a 403 the field is not a form input to highlight but a
	 * permission string to quote to an administrator, and reading
	 * `error.field` at that call site invites exactly the wrong handling.
	 */
	readonly permission: string | null;
	/**
	 * The records standing in the way, when the refusal names them — the
	 * package types that still use a material somebody is archiving. Empty
	 * for every other refusal.
	 */
	readonly blocking: Blocker[];
	/**
	 * The refusal's whole body, for the ones that carry more than a code.
	 *
	 * Some refusals are a code and a message; a few are a code, a message and
	 * the thing the caller has to act on — the fields a patch was blocked by,
	 * whether a manager could override this scan, the lanes a handover close
	 * could not price. Typing each of those onto this class would be a list
	 * that grows with every story and is read by one screen each, so the body
	 * is kept as it arrived and the screen that knows the shape reads it.
	 */
	readonly details: Record<string, unknown>;

	constructor(status: number, body: ApiErrorBody) {
		super(body.message);
		this.name = "ApiError";
		this.status = status;
		this.code = body.code;
		this.field = body.field ?? null;
		this.permission = body.code === "permission_denied" ? (body.field ?? null) : null;
		this.blocking = body.blocking ?? [];
		this.details = body as unknown as Record<string, unknown>;
	}
}

/**
 * Which of the three clients is calling (EP10-S01): the Admin Console, the
 * Store Portal or the Driver App. Sent on every request as
 * `X-Khazzin-Interface` — `/me/context` included — and recorded on every audit
 * row the request produces.
 */
export type Interface = "admin" | "store" | "driver";

export interface ClientOptions {
	/**
	 * Where the API lives. The default is a same-origin relative path on
	 * purpose: in production the load balancer serves the UI and the API from
	 * one origin (§13), and in development Vite proxies /api to the local
	 * service. Neither case involves CORS, and neither should learn to.
	 */
	baseUrl?: string;
	/** Supplies the WorkOS access token, or null when nobody is signed in. */
	accessToken: () => Promise<string | null>;
	/**
	 * The locale to ask the server to answer in, sent as `Accept-Language`.
	 *
	 * A getter rather than a value because the client is memoised per token and
	 * the locale can change under it — somebody switching to Arabic must not
	 * have to reload for the next validation message to come back translated.
	 * Omitted entirely when absent, which lets the server apply its own default
	 * rather than being told `undefined`.
	 */
	locale?: () => string | null;
	/**
	 * Which client this is. Defaults to the Admin Console, so the console's
	 * requests are byte-for-byte what they were before the other two apps
	 * existed.
	 */
	interface?: Interface;
	/**
	 * The Store Portal's active store, sent as `X-Store-Id` on every request
	 * (EP10-S02). A getter, read per request, so a store switch changes the
	 * next call without rebuilding the client; null sends nothing.
	 */
	storeId?: () => string | null;
	/** This build's version, sent as `X-App-Version` (the Driver App's, EP10-S23). */
	appVersion?: string;
	/**
	 * Called when any answer is 426 `upgrade_required`: the server will not take
	 * commands from this build. The Driver App shows its upgrade screen.
	 */
	onUpgradeRequired?: () => void;
}

/** Per-request options every mutating call accepts. */
export interface RequestOptions {
	/**
	 * The idempotency key for a retryable mutation.
	 *
	 * The server stores the response against it, so a retry after a timeout
	 * returns the first answer rather than creating a second order. It is an
	 * option rather than something generated here because only the caller knows
	 * what "the same request" means: a submit button that is pressed twice is
	 * one operation, and two separate drafts saved a minute apart are two.
	 */
	idempotencyKey?: string;
	/** Aborts the request. TanStack Query passes its own. */
	signal?: AbortSignal;
}

export interface StoreCatalogQuery {
	limit?: number;
	cursor?: string;
	signal?: AbortSignal;
}

export interface ListStoresQuery {
	limit?: number;
	cursor?: string;
	/** A prefix of the store name, case-insensitively, or a store id exactly. */
	q?: string;
	/** `prospect`, `active`, `suspended`, `closed` or `all` (the default). */
	status?: string;
	/** `pending`, `verified`, `rejected` or `all` (the default). */
	kyc?: string;
	signal?: AbortSignal;
}

export interface ListWarehousesQuery {
	limit?: number;
	cursor?: string;
	/** `draft`, `active`, `suspended`, `retired` or `all` (the default). */
	status?: string;
	/** One warehouse role. */
	role?: string;
	/** EP-03's city id. */
	cityId?: string;
	/** One operating company. */
	companyId?: string;
	signal?: AbortSignal;
}

export interface ListProvincesQuery {
	/** ISO 3166-1 alpha-2. Absent means every country. */
	countryCode?: string;
	/** Only the provinces a new record may reference. */
	activeOnly?: boolean;
	signal?: AbortSignal;
}

/** One read of the schedule board (EP05-S10): `from` and `to` inclusive, 31 days at most. */
export interface ListShiftAssignmentsQuery {
	from: string;
	to: string;
	departmentId?: string;
	employeeId?: string;
	signal?: AbortSignal;
}

/** Narrowing the positions list (EP05-S01). */
export interface ListPositionsQuery {
	/** One department. Absent means every position of the organisation. */
	departmentId?: string;
	signal?: AbortSignal;
}

/**
 * The Active Sessions list (EP05-S08). `scope: "all"` and `employeeId` are
 * honoured only for a holder of `sessions.read_all`; anybody else gets their
 * own session and `scope: "mine"` in the answer.
 */
export interface ListWorkSessionsQuery {
	scope?: "mine" | "all";
	/** `open` (both open states, the default), `active` or `paused`. */
	status?: "open" | "active" | "paused";
	type?: WorkSessionType;
	employeeId?: string;
	/** Adds the four tiles (null for anybody without `sessions.read_all`). */
	stats?: boolean;
	signal?: AbortSignal;
}

/**
 * The Session Log (EP05-S09): a window of org-local dates, both inclusive.
 * `employeeIds` is honoured only for a holder of `sessions.read_all`.
 */
export interface WorkSessionLogQuery {
	from: string;
	to: string;
	employeeIds?: string[];
	type?: WorkSessionType;
	cursor?: string;
	limit?: number;
	signal?: AbortSignal;
}

/** Narrowing the employee directory (EP05-S02). */
export interface ListEmployeesQuery {
	limit?: number;
	cursor?: string;
	/** A name prefix, or an exact code, `@handle`, email or phone. */
	q?: string;
	/** One lifecycle state, or `all`. Absent means `active`. */
	employmentStatus?: EmploymentStatus | "all";
	departmentId?: string;
	/** Only employees currently in this position (ADJ-M03-11). */
	positionId?: string;
	roleKey?: string;
	employmentType?: EmploymentType;
	signal?: AbortSignal;
}

/** Narrowing the Companies list. */
export interface ListDeliveryCompaniesQuery {
	limit?: number;
	cursor?: string;
	/** One lifecycle state. Absent means every one. */
	status?: DeliveryCompany["status"];
	/** `true` for our own fleets, `false` for external carriers, absent for both. */
	isInHouse?: boolean;
	/**
	 * A province code the carrier covers.
	 *
	 * Re-checked on the page by the server rather than served by an index, so a
	 * filtered page can come back shorter than `limit` while more rows match.
	 * Keep paging until `nextCursor` is absent.
	 */
	province?: string;
	signal?: AbortSignal;
}

export interface ListCitiesQuery {
	limit?: number;
	cursor?: string;
	/** Case-insensitive prefix of the city name. A prefix, not a substring. */
	q?: string;
	/** Narrow to one province. Absent means every one. */
	provinceId?: string;
	/** `true` (the server's default) for live cities, `false` for deleted ones. */
	isActive?: boolean;
	signal?: AbortSignal;
}

/**
 * Narrowing the chart of accounts.
 *
 * `partyId` without `partyType` is a 400 rather than a wildcard: driver
 * `drv_7` and store `sto_7` are different parties, and matching on the id
 * alone would be a cross-party read waiting for an id collision.
 */
export interface ListLedgerAccountsQuery {
	limit?: number;
	cursor?: string;
	partyType?: LedgerPartyType;
	partyId?: string;
	accountCode?: string;
	/** `active` or `closed`. Omitted means both. */
	status?: string;
	/**
	 * The chart's search box: a case-folded prefix of the party's name, the
	 * chart code or the account's name.
	 *
	 * It filters the page the server returned rather than the chart, so a page
	 * can come back short and an empty page can still carry a cursor.
	 */
	q?: string;
	signal?: AbortSignal;
}

export interface ListLedgerEntriesQuery {
	limit?: number;
	cursor?: string;
	signal?: AbortSignal;
}

export interface ListLedgerBalancesQuery {
	partyType?: LedgerPartyType;
	partyId?: string;
	signal?: AbortSignal;
}

/**
 * Which journals to list.
 *
 * `status` is what separates the four-eyes queue from the book: without it the
 * journals still waiting for approval sort behind every posted one, because
 * they carry no posting instant at all.
 */
export interface ListJournalEntriesQuery {
	limit?: number;
	cursor?: string;
	status?: JournalStatus;
	signal?: AbortSignal;
}

export interface ListEconomicEventsQuery {
	limit?: number;
	cursor?: string;
	status?: EconomicEventStatus;
	sourceKind?: string;
	sourceId?: string;
	signal?: AbortSignal;
}

/**
 * Which fee schedule versions to list.
 *
 * `tenantOnly` and an absent `storeId` are different questions: the first asks
 * for the default chain, the second for every scope. An empty `storeId` is a
 * value in its own right here — it is what a tenant default carries — so the
 * flag is what distinguishes them.
 */
export interface ListFeeSchedulesQuery {
	storeId?: string;
	tenantOnly?: boolean;
	serviceType?: FeeServiceType;
	/** Only meaningful with `serviceType`; the server refuses it alone. */
	basis?: FeeBasis;
	signal?: AbortSignal;
}

/** A page of cashouts (EP04-S06). */
/** A page of cashout requests (EP01-S17), across stores or for one. */
export interface ListCashoutRequestsQuery {
	status?: CashoutRequestStatus;
	/** The queue only (ADJ-M03-9): one store's requests. */
	storeId?: string;
	cursor?: string;
	limit?: number;
	signal?: AbortSignal;
}

export interface ListCashoutsQuery {
	storeId?: string;
	status?: CashoutStatus;
	cursor?: string;
	limit?: number;
	signal?: AbortSignal;
}

/** A page of store statements (EP04-S15). */
export interface ListStatementsQuery {
	storeId?: string;
	status?: StatementStatus;
	/** The period's first day, at or after this `YYYY-MM-DD` (ADJ-M03-9). */
	periodFrom?: string;
	/** The period's first day, at or before this `YYYY-MM-DD`. */
	periodTo?: string;
	cursor?: string;
	limit?: number;
	signal?: AbortSignal;
}

/** A page of payout runs (EP04-S09). */
export interface ListPayoutRunsQuery {
	status?: PayoutRunStatus;
	cursor?: string;
	limit?: number;
	signal?: AbortSignal;
}

/** In-house driver earnings (EP04-S11): a driver's, a fleet's or a run's, in a day window. */
export interface ListDriverEarningsQuery {
	driverId?: string;
	companyId?: string;
	runId?: string;
	/** `YYYY-MM-DD`, inclusive. */
	from?: string;
	to?: string;
	signal?: AbortSignal;
}

/** A page of driver shortfalls (EP04-S11). */
export interface ListDriverShortfallsQuery {
	status?: DriverShortfallStatus;
	driverId?: string;
	cursor?: string;
	limit?: number;
	signal?: AbortSignal;
}

/** A page of adjustments (EP04-S14). `type` and `auto` are filtered on the page. */
export interface ListAdjustmentsQuery {
	status?: AdjustmentStatus;
	partyKind?: AdjustmentPartyKind;
	partyId?: string;
	type?: AdjustmentType;
	auto?: boolean;
	cursor?: string;
	limit?: number;
	signal?: AbortSignal;
}

/** A page of carrier settlement runs (EP04-S10). */
/** A report's filters (EP04-S16). A whole closed month reads its snapshot. */
export interface ReportQuery {
	periodStart?: string;
	periodEnd?: string;
	currency?: string;
	storeId?: string;
	snapshotId?: string;
	groupBy?: "store" | "order";
	orderId?: string;
	signal?: AbortSignal;
}

export interface ListSettlementRunsQuery {
	status?: SettlementRunStatus;
	deliveryCompanyId?: string;
	cursor?: string;
	limit?: number;
	signal?: AbortSignal;
}

export interface FeeMatrixQuery {
	storeId?: string;
	/** RFC 3339. Absent means now; a past instant is how an old charge is checked. */
	at?: string;
	signal?: AbortSignal;
}

export interface ListProductsQuery {
	limit?: number;
	cursor?: string;
	/** A prefix matched against the SKU or the name, case-insensitively. */
	q?: string;
	/** `active` (the default), `archived` or `all`. */
	status?: string;
	/** `updated_desc` (the default) or `sku_asc`. */
	sort?: string;
	signal?: AbortSignal;
}

export interface Client {
	listProducts(query?: ListProductsQuery): Promise<ProductPage>;

	/**
	 * A page of physical sites, ordered by code.
	 *
	 * `role` and `cityId` are re-checked by the server in memory rather than
	 * served by an index, so a filtered page can come back shorter than its
	 * limit. It never repeats a row and never skips one.
	 */
	listWarehouses(query?: ListWarehousesQuery): Promise<WarehousePage>;
	getWarehouse(warehouseId: string, options?: RequestOptions): Promise<Warehouse>;
	/** Registers a site as a draft. Activation is a separate decision. */
	createWarehouse(draft: WarehouseDraft): Promise<Warehouse>;
	/**
	 * Changes some of a site's fields.
	 *
	 * `version` is what the caller last read, sent as `If-Match`. A required
	 * argument rather than an optional one: the server refuses the write
	 * without it, and a signature that let it be omitted would make that a
	 * runtime surprise instead of a compile error.
	 */
	updateWarehouse(warehouseId: string, patch: WarehousePatch, version: number): Promise<Warehouse>;
	/**
	 * Every service link on a site, active or not, ordered by code.
	 *
	 * Not the availability gate: a link scoped to two stores appears here with
	 * its scope so somebody can read the rule. What may be *selected* on a
	 * document is `listAvailableWarehouseServices`.
	 */
	listWarehouseServices(
		warehouseId: string,
		options?: RequestOptions,
	): Promise<WarehouseServiceList>;
	/**
	 * The services this site performs for a given store and SKU.
	 *
	 * With neither, the answer is the links that apply to everything — narrower
	 * than "all of them" on purpose, because a store-scoped service shown
	 * without its store is one somebody will try to select for the wrong
	 * merchant.
	 */
	listAvailableWarehouseServices(
		warehouseId: string,
		scope?: { storeId?: string; skuId?: string },
		options?: RequestOptions,
	): Promise<WarehouseServiceList>;
	/**
	 * Every catalogued service as this site stands with it: whether its roles
	 * call for it, whether it is offered, and the link overriding that default.
	 */
	listWarehouseServiceStates(
		warehouseId: string,
		options?: RequestOptions,
	): Promise<WarehouseServiceStateList>;
	/** How a store reorders from its supplier: static or demand (owner note 6). */
	getStoreRestockSettings(storeId: string, options?: RequestOptions): Promise<StoreRestockSettings>;
	putStoreRestockSettings(
		storeId: string,
		settings: StoreRestockSettings,
	): Promise<StoreRestockSettings>;
	/** Every warehouse role and the services it switches on (owner note 3). */
	listWarehouseRoles(options?: RequestOptions): Promise<WarehouseRoleServicesList>;
	/** Names a custom role, or replaces the services it switches on. */
	setWarehouseRole(name: string, serviceCodes: string[]): Promise<WarehouseRoleServices>;
	/** Deletes a custom role, softly (owner note 15, 2026-10-16). */
	deleteWarehouseRole(name: string): Promise<void>;
	/**
	 * Attaches a service to a site, or replaces the terms it is offered on.
	 *
	 * An upsert on `(warehouse, serviceCode)`: a site either performs a service
	 * or it does not, so there is no separate create and update to choose
	 * between, and the whole statement travels rather than a patch.
	 */
	offerWarehouseService(
		warehouseId: string,
		draft: WarehouseServiceDraft,
	): Promise<WarehouseService>;
	/**
	 * Stops a site offering a service.
	 *
	 * The server deactivates rather than removes when recorded work already
	 * names the service, and answers 204 either way; re-read the list to see
	 * which happened.
	 */
	withdrawWarehouseService(warehouseId: string, warehouseServiceId: string): Promise<void>;
	/** The legal entities the tenant's sites trade under, default first. */
	listOperatingCompanies(options?: RequestOptions): Promise<OperatingCompanyList>;
	createOperatingCompany(draft: OperatingCompanyDraft): Promise<OperatingCompany>;
	/**
	 * Renames a company, corrects its registration, or makes it the default.
	 * `isDefault` only promotes; `version` is sent as `If-Match`.
	 */
	updateOperatingCompany(
		companyId: string,
		patch: OperatingCompanyPatch,
		version: number,
	): Promise<OperatingCompany>;

	/** A page of merchant clients, newest first. */
	listStores(query?: ListStoresQuery): Promise<StorePage>;
	getStore(storeId: string, options?: RequestOptions): Promise<Store>;
	/**
	 * Registers a merchant client as a prospect.
	 *
	 * Answers with everything the submission created — the store, its contacts,
	 * its document references — and any warnings, rather than the store alone: a
	 * duplicate name does not stop the create and the screen has to say so, and
	 * a signature that returned only the store would leave nowhere to put that.
	 */
	createStore(draft: StoreDraft): Promise<StoreOnboarding>;
	/**
	 * Changes some of a merchant's profile.
	 *
	 * `version` is optional here and required on almost every other write, which
	 * is `00` §9's choice for this record: it is edited by one person at a time
	 * from a screen that shows the whole thing, and a client that sends the
	 * version it read gets the stronger guarantee without every integration
	 * having to read first.
	 */
	patchStore(storeId: string, patch: StorePatch, version?: number): Promise<StoreUpdate>;
	/** The people at this merchant, primary first. */
	listStoreContacts(storeId: string, options?: RequestOptions): Promise<StoreContact[]>;
	/** The KYC files registered for this merchant. */
	listStoreKycDocuments(storeId: string, options?: RequestOptions): Promise<StoreKycDocument[]>;
	/**
	 * Records a reviewer's decision on one document.
	 *
	 * Answers with the store as well, because the header chip has to flip in the
	 * same round trip the decision was made in.
	 */
	decideStoreKycDocument(
		storeId: string,
		documentId: string,
		decision: StoreKycDecision,
	): Promise<StoreKycReview>;
	/** How the portal behaves for this merchant. */
	getStorePortalSettings(storeId: string, options?: RequestOptions): Promise<StorePortalSetting>;
	/** Sets it. A PUT: the screen shows both toggles and always sends both. */
	putStorePortalSettings(
		storeId: string,
		draft: StorePortalSettingDraft,
	): Promise<StorePortalSetting>;
	/**
	 * Deletes a store for an administrator (ADJ-M02-1): closed and hidden from
	 * every list, the record kept. Refused, with `blocking`, by whatever
	 * would refuse its closure.
	 */
	deleteStore(storeId: string): Promise<void>;
	/** Deletes a warehouse — a Super Admin's soft delete (bug list, line 7). */
	deleteWarehouse(warehouseId: string): Promise<void>;
	/** A warehouse's links, each as what the other site is to it (bug list, line 8). */
	listWarehouseLinks(warehouseId: string, options?: RequestOptions): Promise<WarehouseLinkList>;
	/** Links another warehouse to this one as `relation`, or changes the link. */
	linkWarehouses(
		warehouseId: string,
		otherWarehouseId: string,
		relation: WarehouseLinkRelation,
	): Promise<WarehouseLink>;
	unlinkWarehouses(warehouseId: string, otherWarehouseId: string): Promise<void>;
	/** A warehouse's transfers, in and out, newest first (bug list, line 8). */
	listTransfers(
		query: { warehouseId: string; status?: TransferStatus },
		options?: RequestOptions,
	): Promise<TransferList>;
	createTransfer(draft: WarehouseTransferDraft): Promise<Transfer>;
	getTransfer(transferId: string, options?: RequestOptions): Promise<Transfer>;
	/** Ships a draft; `version` is sent as `If-Match`. */
	shipTransfer(transferId: string, version: number): Promise<Transfer>;
	receiveTransfer(transferId: string, receipt: TransferReceipt, version: number): Promise<Transfer>;
	cancelTransfer(transferId: string, version: number): Promise<Transfer>;
	/** A branch's restock list from its hub (bug list, line 8). */
	getRestockPlan(warehouseId: string, options?: RequestOptions): Promise<RestockPlan>;
	setRestockLevel(
		warehouseId: string,
		skuId: string,
		min: number,
		max: number,
	): Promise<RestockLevel>;
	removeRestockLevel(warehouseId: string, skuId: string): Promise<void>;
	/** Drafts a transfer from the hub for the suggestions; `skuIds` narrows it. */
	draftRestockTransfer(warehouseId: string, skuIds?: string[]): Promise<Transfer>;
	/**
	 * Activates, suspends, reactivates or closes a merchant.
	 *
	 * `idempotencyKey` is required by the server. A required argument rather
	 * than an optional one: a double-tapped Activate would tell EP-07 twice that
	 * a store started trading, and a signature that let the key be omitted would
	 * make that a runtime surprise instead of a compile error.
	 */
	changeStoreStatus(
		storeId: string,
		change: StoreStatusChange,
		idempotencyKey: string,
	): Promise<StoreTransition>;
	/** Which moves this merchant can make, and what is stopping the rest. */
	getStoreTransitions(storeId: string, options?: RequestOptions): Promise<StoreTransitionOptions>;
	/** Whether this merchant may send in new work. */
	getStoreIntakeGate(storeId: string, options?: RequestOptions): Promise<StoreIntakeGate>;
	/** The tenant's catalogue of chargeable services, seeded on the first read. */
	listServiceDefinitions(options?: RequestOptions): Promise<ServiceDefinition[]>;
	/** Adds a tenant's own service; its code comes from the name unless given. */
	defineService(draft: ServiceDefinitionDraft): Promise<ServiceDefinition>;
	/** Deletes a tenant's own service, softly (owner note 15, 2026-10-16). */
	deleteServiceDefinition(code: string): Promise<void>;
	/** The tenant's global prices (owner note 13, 2026-10-16). */
	getGlobalServicePrices(options?: RequestOptions): Promise<WarehouseServicePrices>;
	/** Sets a global price from a date. */
	scheduleGlobalServicePrice(draft: StoreServiceRateDraft): Promise<StoreServiceRate>;
	/** Sets the global storage fee from a date. */
	setGlobalStorageFee(fee: StorageFeeDraft): Promise<StorageFee>;
	/** One service's global price history, with who set each version. */
	listGlobalServicePriceVersions(
		code: string,
		options?: RequestOptions,
	): Promise<StoreServiceRate[]>;
	/** One service's price history at a warehouse, or with `costs` its cost history. */
	listWarehouseServicePriceVersions(
		warehouseId: string,
		code: string,
		costs: boolean,
		options?: RequestOptions,
	): Promise<StoreServiceRate[]>;
	/** Sets what a service costs a warehouse per unit from a date (owner note 16). */
	scheduleWarehouseServiceCost(
		warehouseId: string,
		draft: WarehouseServiceCostDraft,
	): Promise<StoreServiceRate>;
	/**
	 * What this merchant is charged, and what it is not charged for.
	 *
	 * `at` resolves as of an instant other than now — the question a support
	 * conversation actually asks is "what was this priced at on the 3rd".
	 */
	listStoreServiceRates(
		storeId: string,
		at?: string,
		options?: RequestOptions,
	): Promise<StoreRateCard[]>;
	/** One service's whole version history, superseded rows included. */
	listStoreServiceRateVersions(
		storeId: string,
		code: string,
		options?: RequestOptions,
	): Promise<StoreServiceRate[]>;
	/** Appends a version to a service's chain. Never edits and never deletes. */
	scheduleStoreServiceRate(
		storeId: string,
		draft: StoreServiceRateDraft,
	): Promise<StoreServiceRate>;
	/**
	 * Returns a service to the store's home warehouse price from a date (call
	 * note 9): the store's own version in force then closes, later ones are
	 * superseded. Absent date means the store's today.
	 */
	endStoreServiceRate(storeId: string, code: string, effectiveFrom?: string): Promise<void>;
	/** Every merchant's storage price, occupancy and month to date. */
	listStorageFees(
		query?: { q?: string; cursor?: string; limit?: number },
		options?: RequestOptions,
	): Promise<StorageFeeList>;
	/**
	 * One merchant's storage price, its chain and what it occupies.
	 *
	 * 404 when nobody has priced this merchant. Not an empty shape: a screen
	 * showing $0.00 says they agreed free storage.
	 */
	getStorageFee(storeId: string, options?: RequestOptions): Promise<StorageFeeDetail>;
	/**
	 * Schedules a storage fee version, writing it through to the STORAGE rate.
	 *
	 * Both chains move in one transaction, and the answer carries both so the
	 * screen can show the pairing held rather than fetching the rate card.
	 */
	setStorageFee(storeId: string, draft: StorageFeeDraft): Promise<StorageFeeResult>;
	/** What this merchant occupies right now, by leaf unit kind. */
	getStorageOccupancy(storeId: string, options?: RequestOptions): Promise<StorageOccupancy>;
	/** One month's storage bills across the stores (EP01-S19). */
	listStorageBills(month: string, options?: RequestOptions): Promise<StorageBillList>;
	/** One store's storage bills, newest month first. */
	listStoreStorageBills(storeId: string, options?: RequestOptions): Promise<StorageBillList>;
	/** Generates and posts a closed month's bills; one store, or every store. */
	generateStorageBills(body: StorageBillGenerateRequest): Promise<StorageBillGenerateResult>;
	/** A storage bill as a PDF or CSV. */
	downloadStorageBill(billId: string, format: "pdf" | "csv"): Promise<DownloadedFile>;
	/**
	 * Finance's storage bills (EP04-S12): one month's, or one store's, by
	 * status, with each currency's totals over what the filters keep.
	 */
	listFinanceStorageBills(query: {
		month?: string;
		storeId?: string;
		status?: StorageBillStatus;
		signal?: AbortSignal;
	}): Promise<FinanceStorageBillList>;
	/** A credit note against a storage bill; the bill turns `credited`. */
	creditStorageBill(
		billId: string,
		body: StorageBillCreditRequest,
		idempotencyKey: string,
	): Promise<CreditNote>;
	/** What a storage bill charges for its Unallocated units (ADJ-1017-1), once. */
	decideStorageBillUnallocated(
		billId: string,
		body: StorageBillUnallocatedRequest,
		idempotencyKey: string,
	): Promise<StorageBill>;
	/**
	 * A month of what this merchant has actually been charged.
	 *
	 * The totals in the envelope cover the whole month, not the rows returned:
	 * a footer that summed its page would show a period total that changes as
	 * somebody scrolls.
	 */
	listStoreCharges(
		storeId: string,
		query?: { month?: string; service?: string },
		options?: RequestOptions,
	): Promise<ServiceChargePeriod>;
	/**
	 * The terms this merchant is served on.
	 *
	 * Never 404s: a store nobody has configured answers with the platform's
	 * defaults and `set: false`, so this client does not carry a second copy of
	 * them. `pendingAt` asks what an order going pending at that instant would
	 * be due — the server's own answer, so the promise is computed once.
	 */
	getStoreServicePlan(
		storeId: string,
		pendingAt?: string,
		options?: RequestOptions,
	): Promise<StoreServicePlan>;
	/**
	 * Replaces them.
	 *
	 * `version` is required, not optional as on `patchStore`: the record is
	 * shared between everybody who can price this merchant, and `0` is a real
	 * precondition meaning "nobody has saved one yet".
	 */
	putStoreServicePlan(
		storeId: string,
		draft: StoreServicePlanDraft,
		version: number,
	): Promise<StoreServicePlan>;
	/**
	 * Where this merchant can be paid, the destination money goes to first.
	 *
	 * Every account number in the response is a masking, and there is no
	 * parameter, header or companion call that returns the clear one — not for
	 * any permission. The full number is read in-process by the payout run.
	 */
	listStorePayoutAccounts(storeId: string, options?: RequestOptions): Promise<StorePayoutAccount[]>;
	/**
	 * Proposes a destination for somebody else to approve.
	 *
	 * The key is required rather than optional: a double-submitted drawer
	 * would spend two of the merchant's five destinations on one bank account,
	 * and a signature that let it be omitted would make that a runtime surprise
	 * instead of a compile error.
	 */
	proposeStorePayoutAccount(
		storeId: string,
		draft: StorePayoutAccountDraft,
		idempotencyKey: string,
	): Promise<StorePayoutAccount>;
	/** Verifies a destination, as somebody other than the person who typed it. */
	approveStorePayoutAccount(accountId: string): Promise<StorePayoutAccount>;
	/** Takes a destination out of use. Promotes nothing in its place. */
	disableStorePayoutAccount(accountId: string): Promise<StorePayoutAccount>;
	/** The Billing tab's tiles: the live balance, its direction and the next payout day. */
	getStoreBillingBalance(storeId: string, options?: RequestOptions): Promise<StoreBillingBalance>;
	/** The store's issued statements, newest period first. */
	listStoreStatements(storeId: string, options?: RequestOptions): Promise<StoreStatement[]>;
	/** One statement with its lines. */
	getStoreStatement(statementId: string, options?: RequestOptions): Promise<StoreStatementDetail>;
	/** A short-lived link to the statement's PDF. */
	getStoreStatementDocument(statementId: string): Promise<{ url: string }>;
	/** What was paid to the store, newest first. */
	listStorePayouts(storeId: string, options?: RequestOptions): Promise<StorePayout[]>;
	/** Flags a statement line (by its ledger entry) with a note. */
	disputeStatementLine(entryId: string, note: string): Promise<StatementLine>;
	/** The cross-store cashout review queue, with its four tiles (EP01-S17). */
	listCashoutQueue(query?: ListCashoutRequestsQuery): Promise<CashoutQueue>;
	/** One store's cashout requests, newest first. */
	listStoreCashoutRequests(
		storeId: string,
		query?: ListCashoutRequestsQuery,
	): Promise<CashoutRequestList>;
	/** What the store may request now, with the breakdown. */
	getStoreCashoutAvailability(
		storeId: string,
		options?: RequestOptions,
	): Promise<CashoutAvailability>;
	/**
	 * A merchant asks to be paid (the Store Portal, EP-10). The key is required:
	 * a double-tapped Request would otherwise reserve the balance twice.
	 */
	createCashoutRequest(
		storeId: string,
		draft: CashoutRequestDraft,
		idempotencyKey: string,
	): Promise<CashoutRequest>;
	/**
	 * Approves or rejects a requested cashout; a rejection needs a reason of at
	 * least ten characters. Approval generates the request's Cashout (EP04-S07),
	 * so the key is required: a replay answers the first approval.
	 */
	decideCashoutRequest(
		requestId: string,
		decision: "approve" | "reject",
		reason: string | undefined,
		idempotencyKey: string,
	): Promise<CashoutRequest>;
	/** Withdraws an open request that has not been released. */
	cancelCashoutRequest(requestId: string, reason?: string): Promise<CashoutRequest>;
	/** Hands every approved request to the Cashout Engine. */
	releaseCashoutRequests(): Promise<CashoutRelease>;
	/**
	 * The merchant's portal accounts, each with its effective thirteen-section
	 * grid.
	 *
	 * `access` is what the server will enforce, not what the account's template
	 * implies: the store's own status is already clamped onto it. The screen
	 * renders from this and never from a template name it holds locally, so a
	 * client that tampered with a role would change nothing it can see.
	 */
	listStoreUsers(storeId: string, options?: RequestOptions): Promise<StoreUser[]>;
	/**
	 * One page of a merchant's catalogue: items, their variants, the dimensions
	 * receiving depends on, and the live quantities.
	 *
	 * Nothing here is writable. A variant's `quantities` is **absent** rather
	 * than zero when nothing can answer for it — a catalogue rendering `0 on
	 * hand` for a full shelf is worse than one that says it does not know.
	 */
	listStoreCatalog(storeId: string, query?: StoreCatalogQuery): Promise<StoreCatalogPage>;
	/** The same quantities on their own, for a refresh without the items. */
	listStoreStock(storeId: string, query?: StoreCatalogQuery): Promise<StoreStockList>;
	/** A store's removal and disposal orders, newest first (EP01-S20). */
	listStoreRemovalOrders(storeId: string, query?: StoreCatalogQuery): Promise<RemovalOrderList>;
	/** What a removal of so many units would be charged now, priced by the server. */
	quoteStoreRemovalFee(storeId: string, units: number): Promise<RemovalFeeQuote>;
	/** Drafts a removal. Charges nothing and moves nothing. */
	createStoreRemovalOrder(storeId: string, draft: RemovalOrderDraft): Promise<RemovalOrder>;
	/** Confirms a draft: charges the REMOVAL fee and creates the dispatch. */
	confirmRemovalOrder(removalId: string): Promise<RemovalOrder>;
	/** Cancels a draft, or a confirmed removal nobody has started picking. */
	cancelRemovalOrder(removalId: string): Promise<RemovalOrder>;
	/**
	 * Gives a store its first portal account.
	 *
	 * There is no password in the draft and none in the response. Both
	 * `passwordMode` values mean the identity provider sends a link.
	 */
	createStoreOwner(storeId: string, draft: StoreOwnerDraft): Promise<StoreUser>;
	/**
	 * Sends an invited account's invitation to a new address (call note 12):
	 * the old one is withdrawn, and the answer is the account invited anew.
	 */
	changeStoreUserEmail(
		storeId: string,
		storeUserId: string,
		change: { email: string; phoneE164?: string },
	): Promise<StoreUser>;
	/** One account's effective grid, with each cell's provenance. */
	getStoreUserAccess(
		storeId: string,
		storeUserId: string,
		options?: RequestOptions,
	): Promise<StoreUserAccess>;
	/**
	 * The thirteen section keys and the six template grids, from the server.
	 *
	 * The client keeps a mirror of this so a grid can be drawn before any
	 * account has loaded; a test asserts the two are equal, which is the only
	 * thing that stops the mirror becoming a second specification.
	 */
	getStoreSectionMetadata(options?: RequestOptions): Promise<StoreSectionMetadata>;
	/**
	 * Adds a sub-account (EP01-S14). `409` carries `sub_account_limit`,
	 * `above_own_level` or `mfa_required`, the last two with the grid row as
	 * `field` (`access.<section>`).
	 */
	createStoreSubAccount(storeId: string, draft: StoreSubAccountDraft): Promise<StoreUser>;
	/**
	 * Replaces one account's thirteen cells; absent sections are none. With the
	 * `version` the editor read, a save over somebody else's is `409
	 * version_conflict` (EP10-S10).
	 */
	replaceStoreUserAccess(
		storeId: string,
		storeUserId: string,
		access: Record<string, components["schemas"]["AccessLevel"]>,
		version?: number,
	): Promise<StoreUser>;
	/** The team with the store's sub-account limit, for the portal's "n of max" (EP10-S10). */
	getStoreTeam(storeId: string, options?: RequestOptions): Promise<StoreUserList>;
	/** Renames, changes the order scope, or re-applies a template. */
	updateStoreUser(storeId: string, storeUserId: string, patch: StoreUserPatch): Promise<StoreUser>;
	/** Suspend, reactivate or revoke: the account comes back. */
	storeUserLifecycle(
		storeId: string,
		storeUserId: string,
		action: "suspend" | "reactivate" | "revoke",
	): Promise<StoreUser>;
	/** Signs the account out everywhere. */
	endStoreUserSessions(storeId: string, storeUserId: string): Promise<StoreUserSessionsEnded>;
	/** Emails a set-password link. Never returns a password. */
	resetStoreUserPassword(storeId: string, storeUserId: string): Promise<StoreUserPasswordReset>;
	/** Promotes a sub-account to owner; an operator passes a break-glass reason. */
	transferStoreOwnership(storeId: string, storeUserId: string, reason?: string): Promise<StoreUser>;
	/** The account's activity trail, newest first. */
	getStoreUserActivity(storeId: string, storeUserId: string): Promise<StoreUserActivity>;
	/** The store's outstanding invitations, pending or expired (EP01-S15). */
	listStoreInvitations(storeId: string, options?: RequestOptions): Promise<StoreInvitation[]>;
	/**
	 * Invites a teammate. `finance = write` is not refused here; acceptance holds
	 * it at read without a second factor. `acceptToken` is in this response only.
	 */
	inviteStoreUser(storeId: string, draft: StoreSubAccountDraft): Promise<StoreInvitationIssued>;
	/** Resends with a new token and seven more days; the old link stops working. */
	resendStoreInvitation(storeId: string, invitationId: string): Promise<StoreInvitationIssued>;
	/** Withdraws an invitation; the invited account is revoked. */
	revokeStoreInvitation(storeId: string, invitationId: string): Promise<StoreUser>;
	/** Redeems a token for the signed-in caller; a spent one is `410`. */
	acceptStoreInvitation(token: string): Promise<StoreInvitationAccepted>;
	/** The counts behind the list's chips and tiles. */
	getStoresSummary(options?: RequestOptions): Promise<StoresSummary>;

	/**
	 * The chart of accounts.
	 *
	 * A store-scoped caller gets its own stores' wallets and nothing else — not
	 * another store's, and not the platform's revenue accounts. The narrowing is
	 * the server's; there is no parameter for it here, deliberately.
	 */
	listLedgerAccounts(query?: ListLedgerAccountsQuery): Promise<LedgerAccountPage>;
	/**
	 * One account with its running balance.
	 *
	 * The balance is the stored total, written in the same transaction as the
	 * legs that moved it — not a sum computed for this request.
	 */
	getLedgerAccount(accountId: string, options?: RequestOptions): Promise<LedgerAccountDetail>;
	/** An account's posted legs, newest first: what makes a balance explainable. */
	listLedgerAccountEntries(
		accountId: string,
		query?: ListLedgerEntriesQuery,
	): Promise<LedgerEntryPage>;
	/** What each party is owed and what each owes, per currency. */
	listLedgerBalances(query?: ListLedgerBalancesQuery): Promise<LedgerPositionList>;
	getProduct(id: string, options?: RequestOptions): Promise<Product>;
	createProduct(draft: ProductDraft, options?: RequestOptions): Promise<Product>;
	/**
	 * Changes some of a product's fields.
	 *
	 * `version` is what the caller last read, sent as `If-Match`. A required
	 * argument rather than an optional one: the server refuses the write
	 * without it, and a signature that let it be omitted would make that a
	 * runtime surprise instead of a compile error.
	 */
	patchProduct(id: string, patch: ProductPatch, version: number): Promise<Product>;
	/** Takes a product out of circulation. Idempotent, and never a delete. */
	archiveProduct(id: string): Promise<Product>;
	/** Puts it back. */
	unarchiveProduct(id: string): Promise<Product>;
	/**
	 * The caller's own organisation. There is no parameter for which one: the
	 * server reads it from the token's org_id claim, and asking for another is
	 * not something this API can express.
	 */
	getCurrentOrganization(): Promise<CurrentOrganization>;
	/**
	 * Changes the caller's own organisation's settings.
	 *
	 * `version` is what the caller last read — from `/me/context`'s
	 * `org.settingsVersion`, or the `ETag` on `GET /orgs/current` — and it is a
	 * required argument rather than an optional one on purpose. The server
	 * refuses the write without it, and a signature that let it be omitted
	 * would make that a runtime surprise instead of a compile error.
	 */
	patchOrgSettings(
		patch: OrgSettingsPatch,
		version: number,
		options?: RequestOptions,
	): Promise<CurrentOrganization>;

	/**
	 * The Security screen's read model: the settings, the step-up catalogue,
	 * and who the MFA policy is currently stopping.
	 */
	getSecurityOverview(options?: RequestOptions): Promise<SecurityOverview>;

	/**
	 * Records that this session has just proved a second factor, with the
	 * six-digit code from the caller's authenticator app. The server verifies
	 * it with the identity provider (ADJ-M03-10).
	 *
	 * Takes the session id rather than reading it from the token, because the
	 * server checks that the two match: a request naming somebody else's
	 * session is refused rather than quietly redirected to the caller's own.
	 */
	confirmStepUp(sessionId: string, code: string): Promise<StepUpResult>;

	/** Signs every other session in the organisation out. */
	revokeAllOrgSessions(): Promise<{ revoked: number }>;
	/**
	 * Clear data (ADJ-1017-5): the org owner's wipe of the organisation's
	 * inventory, warehouses, orders and the money tied to them. `confirm` is
	 * the organisation's name, typed; anything else is `422
	 * confirmation_mismatch`, anybody but the owner `403 owner_only`.
	 */
	resetOrgData(confirm: string): Promise<OrgDataResetResult>;
	/**
	 * Who the caller is, what they may do, and which sections they can see.
	 *
	 * One call rather than several: the shell needs all of it before it can
	 * draw anything, and a handful of parallel requests would each pay the
	 * same resolution cost on the server.
	 */
	getMeContext(options?: RequestOptions): Promise<MeContext>;
	/**
	 * The operator home screen, in one call.
	 *
	 * One request for the tiles, the bell and the attention list, because the
	 * screen cannot draw without all three and three calls would be three sets
	 * of spinners landing at different moments. A tile that failed comes back
	 * inside a `200` with its own error — the response is the screen, not one
	 * number.
	 */
	getAdminDashboard(options?: RequestOptions): Promise<AdminDashboard>;
	/**
	 * Saves the caller's own dashboard arrangement.
	 *
	 * The whole ordered list, not a diff: a dashboard is a small ordered thing,
	 * and a patch of an order is a vocabulary nobody needs.
	 */
	putDashboardLayout(layout: DashboardLayout): Promise<DashboardLayout>;
	/** Goes back to the default, by deleting the row rather than storing it. */
	resetDashboardLayout(): Promise<void>;

	/** A page of users, each with the memberships they hold. */
	listUsers(query?: {
		limit?: number;
		cursor?: string | null;
		status?: string;
		interface?: string;
		q?: string;
		signal?: AbortSignal;
	}): Promise<{ items: UserRecord[]; counts: UserCounts; nextCursor?: string }>;
	/** One person, with every membership they have ever held. */
	getUser(id: string): Promise<UserRecord>;
	/** Gives somebody a role at a scope. */
	grantMembership(grant: GrantMembership): Promise<Membership>;
	/** Takes a membership away. Revoking a revoked one is not an error. */
	revokeMembership(id: string): Promise<void>;

	listInvitations(): Promise<{ items: Invitation[] }>;

	createInvitation(invitation: CreateInvitation): Promise<Invitation>;

	resendInvitation(id: string): Promise<Invitation>;

	revokeInvitation(id: string): Promise<Invitation>;

	listSessions(userId: string): Promise<{ items: Session[] }>;

	revokeSession(sessionId: string): Promise<void>;

	revokeAllSessions(userId: string): Promise<void>;

	logout(): Promise<void>;

	suspendUser(userId: string): Promise<UserStatusChange>;

	reactivateUser(userId: string): Promise<UserStatusChange>;

	listRoles(status?: string): Promise<{ items: Role[]; catalogVersion: number }>;

	listPermissions(): Promise<PermissionCatalog>;

	createRole(role: CreateRole): Promise<Role>;

	updateRole(roleKey: string, patch: UpdateRole, force?: boolean): Promise<Role>;

	listAuditEvents(
		query: Record<string, string>,
	): Promise<{ items: AuditEvent[]; nextCursor?: string }>;

	getAuditEvent(id: string): Promise<AuditEvent>;

	exportAuditEvents(
		filter: AuditFilter,
		format: "csv" | "json",
	): Promise<{ blob: Blob; filename: string }>;

	listTeams(status?: string): Promise<{ items: Team[] }>;

	createTeam(name: string): Promise<Team>;

	updateTeam(teamId: string, patch: UpdateTeam): Promise<Team>;

	listImpersonations(): Promise<{ items: Impersonation[] }>;

	startImpersonation(request: {
		targetUserId: string;
		storeId: string;
		reason: string;
	}): Promise<Impersonation>;

	endImpersonation(id: string): Promise<void>;

	/** A store's open Login as Store sessions (EP01-S16). */
	listStoreImpersonations(storeId: string): Promise<{ items: Impersonation[] }>;
	/** Login as Store: the token is in this response and never again. */
	startStoreImpersonation(
		storeId: string,
		request: StartStoreImpersonation,
	): Promise<Impersonation>;
	/** Ends a store's session now; any holder of the permission may. */
	endStoreImpersonation(storeId: string, id: string): Promise<void>;

	/** The public API keys, metadata only (EP09-S03). */
	listApiKeys(query?: ListApiKeysQuery): Promise<ApiKey[]>;
	/** Issues a key. The secret is in this response and never again. */
	issueApiKey(draft: IssueApiKeyRequest): Promise<IssuedApiKey>;
	/** Edits a key's label or expiry; `expiresAt: null` removes the expiry. */
	updateApiKey(keyId: string, patch: UpdateApiKeyRequest): Promise<ApiKey>;
	revokeApiKey(keyId: string): Promise<ApiKey>;

	/** The endpoint policy matrix and rate policies (EP09-S21). */
	getEndpointPolicies(options?: RequestOptions): Promise<EndpointPolicyMatrix>;
	/** Replaces the whole matrix; a row left out is deleted. */
	saveEndpointPolicies(update: EndpointPolicyMatrixUpdate): Promise<EndpointPolicyMatrix>;
	/** One scope's (`org` or a store id) order creation statuses. */
	getOrderCreationStatuses(
		scope: string,
		options?: RequestOptions,
	): Promise<OrderCreationStatusSet>;
	saveOrderCreationStatuses(update: OrderCreationStatusUpdate): Promise<OrderCreationStatusSet>;
	/** The org's (`org`) or one carrier key's editable fields. */
	getDeliveryEditableFields(subject: string, options?: RequestOptions): Promise<DeliveryFieldSet>;
	saveDeliveryEditableFields(update: DeliveryFieldUpdate): Promise<DeliveryFieldSet>;

	/** The public API request logs, newest first (EP09-S22). */
	listRequestLogs(query?: ListRequestLogsQuery): Promise<ApiRequestLogList>;
	/** One call by `X-Request-Id`, with its redacted excerpts. */
	getRequestLog(requestId: string, options?: RequestOptions): Promise<ApiRequestLog>;
	/** The same filters as an XLSX; 422 `export_too_large` past 50,000 rows. */
	exportRequestLogs(query?: ListRequestLogsQuery): Promise<DownloadedFile>;

	/** The Developer landing page's numbers, cached 60 s (EP09-S20). */
	getDeveloperOverview(options?: RequestOptions): Promise<DeveloperOverview>;
	/** The Docs Builder's pages in sidebar order; a store user gets only published outward ones. */
	listDocsPages(options?: RequestOptions): Promise<DocsPage[]>;
	/** Adds a draft page; `409 slug_exists` when the slug is taken. */
	createDocsPage(draft: CreateDocsPageRequest): Promise<DocsPage>;
	/** Edits, publishes (`action: "publish"`), unpublishes or reorders a page. */
	updateDocsPage(slug: string, patch: UpdateDocsPageRequest): Promise<DocsPage>;
	/** The public API's OpenAPI document, served at `/api/v1/openapi.json`. */
	getPublicApiSpec(options?: RequestOptions): Promise<unknown>;
	/** Sends one public API call as a test key (EP09-S23); any public status comes back as data. */
	sendSandboxRequest(req: SandboxRequest): Promise<SandboxResponse>;
	/** The test data a test key reads. */
	getSandboxFixtures(keyId: string, options?: RequestOptions): Promise<SandboxFixtures>;

	/** The outbound webhook subscriptions, newest first (EP09-S10). */
	listWebhookSubscriptions(options?: RequestOptions): Promise<WebhookSubscription[]>;
	/** Subscribes an endpoint. The signing secret is in this response only. */
	createWebhookSubscription(
		draft: CreateWebhookSubscriptionRequest,
	): Promise<CreatedWebhookSubscription>;
	/** Pause, resume, edit, or rotate the secret (returned once). */
	updateWebhookSubscription(
		id: string,
		patch: UpdateWebhookSubscriptionRequest,
	): Promise<UpdatedWebhookSubscription>;
	deleteWebhookSubscription(id: string): Promise<void>;
	/** Sends a signed ping now; answers its delivery. */
	testWebhookSubscription(id: string): Promise<WebhookDelivery>;
	/** The delivery log, newest first, with how many matched (EP09-S11). */
	listWebhookDeliveries(query?: ListWebhookDeliveriesQuery): Promise<WebhookDeliveryList>;
	/** One delivery with its attempts and the envelope it sends. */
	getWebhookDelivery(id: string, options?: RequestOptions): Promise<WebhookDeliveryDetail>;
	/** Sends a delivery again now with `Khazzin-Replay: true`; 409 `event_expired` after 30 days. */
	replayWebhookDelivery(id: string): Promise<WebhookDelivery>;
	/** Queues the dead deliveries a filter selects for the sender job. */
	replayDeadWebhookDeliveries(body: ReplayWebhookDeliveriesRequest): Promise<WebhookReplayJob>;
	/** A bulk replay's progress. */
	getWebhookReplayJob(jobId: string, options?: RequestOptions): Promise<WebhookReplayProgress>;

	/** The sales-channel connections, newest first (EP09-S12). */
	listChannelConnections(query?: ListChannelConnectionsQuery): Promise<ChannelConnection[]>;
	getChannelConnection(id: string, options?: RequestOptions): Promise<ChannelConnection>;
	/** Starts a Shopify connect; the browser goes to `consentUrl` next. */
	connectShopify(body: ConnectShopifyRequest): Promise<ConnectShopifyResponse>;
	/** Connects a WooCommerce site with its REST keys: active at once (EP09-S14). */
	connectWoo(body: CreateWooConnectionRequest): Promise<ChannelConnection>;
	/** "Test connection": each check against the site, nothing stored. */
	testWooConnection(body: TestWooConnectionRequest): Promise<WooHealth>;
	/** A WooCommerce connection's health, checked now. */
	getWooHealth(id: string, options?: RequestOptions): Promise<WooHealth>;
	/** Pause, resume, or edit the settings. */
	updateChannelConnection(
		id: string,
		patch: UpdateChannelConnectionRequest,
	): Promise<ChannelConnection>;
	/** Disconnect: terminal. */
	revokeChannelConnection(id: string): Promise<ChannelConnection>;
	reregisterChannelWebhooks(id: string): Promise<ChannelConnection>;
	listChannelLocations(id: string, options?: RequestOptions): Promise<ChannelLocation[]>;
	/** A connection's sync jobs, newest first, and whether a dry run succeeded (EP09-S16). */
	listSyncJobs(connectionId: string, options?: RequestOptions): Promise<SyncJobList>;
	/** Starts a sync job; the job comes back as its first page left it. */
	startSyncJob(body: StartSyncJobRequest): Promise<SyncJob>;
	/** One job with its report preview and download link. */
	getSyncJob(id: string, options?: RequestOptions): Promise<SyncJob>;
	/** The SKU Mappings screen's rows and tab counts (EP09-S17). */
	listChannelItemMappings(query?: ListChannelItemMappingsQuery): Promise<ChannelItemMappingList>;
	/** Map to an existing sku, allocate a new one, or archive a conflicting variant. */
	resolveChannelItemMapping(
		id: string,
		body: ResolveChannelItemMappingRequest,
	): Promise<ChannelItemMapping>;
	/** Remap, archive, or keep the internal sku over a drift. */
	editChannelItemMapping(
		id: string,
		body: EditChannelItemMappingRequest,
	): Promise<ChannelItemMapping>;
	/** Approve the mapped sku through the item master's approve. */
	approveChannelItemMappingSku(id: string): Promise<ChannelItemMapping>;
	/** The code "Allocate new SKU" would issue now. */
	getNextChannelItemMappingSku(id: string, options?: RequestOptions): Promise<{ sku: string }>;
	/** A connection's inventory sync-back: its policy and every mapped sku (EP09-S18). */
	getInventorySync(
		connectionId: string,
		query?: { status?: InventoryPushStatus; signal?: AbortSignal },
	): Promise<InventorySync>;
	/** Turn sync-back on or off, set the buffer or the full-sync interval. */
	updateInventorySyncPolicy(
		connectionId: string,
		body: UpdateInventorySyncPolicyRequest,
	): Promise<InventorySyncPolicy>;
	/** Turn sync-back off; the channel keeps its quantities. */
	pauseInventorySync(connectionId: string): Promise<InventorySyncPolicy>;
	/** Push every mapped, approved sku now. */
	runInventoryFullSync(connectionId: string): Promise<{ skus: number }>;
	/** Set one sku's buffer on the connection, or clear it with `null`. */
	setInventorySkuBuffer(
		connectionId: string,
		skuId: string,
		buffer: InventoryBuffer | null,
	): Promise<InventorySyncRow>;

	/** The integration workers' dead letters, newest first (EP09-S19). */
	listReliabilityDeadLetters(query?: ListReliabilityDeadLettersQuery): Promise<DeadLetterPage>;
	getReliabilityDeadLetter(id: string, options?: RequestOptions): Promise<DeadLetter>;
	/** Sends a dead letter back through the worker that failed. */
	retryReliabilityDeadLetter(id: string): Promise<DeadLetter>;
	/** Closes a dead letter with a reason of at least 10 characters. */
	discardReliabilityDeadLetter(id: string, reason: string): Promise<DeadLetter>;
	/** Retries up to 100 open dead letters a filter selects. */
	retryReliabilityDeadLetters(body: RetryDeadLettersRequest): Promise<DeadLetterBulkRetry>;
	listReconciliationRuns(query?: ListReconciliationRunsQuery): Promise<ReconciliationRun[]>;
	getReconciliationRun(id: string, options?: RequestOptions): Promise<ReconciliationRun>;
	/** "Run now": one reconciliation, finished in the request. */
	startReconciliationRun(body: StartReconciliationRequest): Promise<ReconciliationRun>;
	getReliabilitySummary(options?: RequestOptions): Promise<ReliabilitySummary>;

	/** Every scheduled job, with its schedule and how its last run went. */
	listJobs(options?: RequestOptions): Promise<ScheduledJob[]>;
	/** A page of one job's runs, newest first. */
	listJobRuns(
		name: string,
		params?: { cursor?: string; limit?: number },
	): Promise<{ items: JobRun[]; nextCursor?: string }>;
	/** Pauses or resumes a job. `version` is the job's ETag. */
	setJobPaused(
		name: string,
		paused: boolean,
		reason: string,
		version: number,
	): Promise<ScheduledJob>;
	/** Runs a job now, attributed to the caller. */
	runJobNow(name: string, idempotencyKey: string): Promise<JobRun>;

	/** Every staged feature, with the deploy's default and this tenant's row. */
	listAdminFlags(options?: RequestOptions): Promise<AdminFlag[]>;

	/** My in-app inbox, newest first (EP12-S03). */
	listNotifications(query?: InboxQuery): Promise<InboxNotificationList>;
	/** How many of my inbox rows are unread: the bell's badge. */
	getUnreadNotificationCount(options?: RequestOptions): Promise<number>;
	/** Marks some of my notifications read, or all of them; idempotent. */
	markNotificationsRead(body: { ids: string[] } | { all: true }): Promise<number>;

	/** The notification catalog, with this tenant's changes applied (EP12-S01). */
	listNotificationDefinitions(options?: RequestOptions): Promise<NotificationDefinition[]>;
	/** Changes a definition's channels or turns it on or off for this tenant. */
	updateNotificationDefinition(
		id: string,
		patch: NotificationDefinitionPatch,
	): Promise<NotificationDefinition>;
	/**
	 * Renders a definition's sample and queues it to the caller or an address
	 * (EP12-S02). A template that cannot be sent is a 400 with its code:
	 * `undeclared_variable`, `invalid_template`, `too_long`.
	 */
	sendTestNotification(request: NotificationTestRequest): Promise<NotificationTestResult>;
	/** The provider configured on each channel, primary and fallback (EP12-S04). */
	listChannelProviders(options?: RequestOptions): Promise<ChannelProvider[]>;
	/** The organisation's channel switches: SMS enabled, off by default (ADJ-B02-2). */
	getChannelSettings(options?: RequestOptions): Promise<ChannelSettings>;
	/** Turns SMS on or off for the organisation (ADJ-B02-2). */
	putChannelSettings(input: ChannelSettingsInput): Promise<ChannelSettings>;
	/**
	 * An order's customer messages, newest first, and how its customer is
	 * reached (EP12-S09); another store's order is a 404.
	 */
	listOrderCustomerMessages(
		orderId: string,
		options?: RequestOptions,
	): Promise<CustomerMessageTimeline>;
	/**
	 * Effective notification preferences at a scope (EP12-S16): the caller's
	 * own without `scopeRef`; `storeId` adds that store's defaults to a
	 * person's view.
	 */
	getNotificationPreferences(
		query?: { scopeRef?: string; storeId?: string },
		options?: RequestOptions,
	): Promise<NotificationPreferences>;
	/** Replaces one scope's preferences; answers the effective matrix. */
	putNotificationPreferences(input: NotificationPreferencesInput): Promise<NotificationPreferences>;
	/** The store-alert tunables in effect at `org` or `store:<id>` (EP12-S14). */
	getAlertRules(scopeRef?: string, options?: RequestOptions): Promise<AlertRules>;
	/** Overrides one tunable; `valueJson: null` inherits again. Answers the scope's rules. */
	putAlertRule(
		ruleKey: AlertRuleKey,
		scopeRef: string,
		valueJson: string | null,
	): Promise<AlertRules>;
	/** What a store's next daily digest would list. */
	previewDigest(storeId: string): Promise<DigestPreview>;
	/** The portal's own store's alert settings (EP12-S14). */
	getPortalAlertRules(options?: RequestOptions): Promise<AlertRules>;
	/** Overrides one of the portal store's alert settings. */
	putPortalAlertRule(ruleKey: AlertRuleKey, valueJson: string | null): Promise<AlertRules>;
	/** What the portal store's next daily digest would list. */
	previewPortalDigest(): Promise<DigestPreview>;
	/** The customer messages' switches, window and sender; with a store, its own choices (EP12-S09). */
	getCustomerNotificationSettings(
		storeId?: string,
		options?: RequestOptions,
	): Promise<CustomerNotificationSettings>;
	/** Changes the organisation's or a store's customer messages; answers the settings as they now are. */
	updateCustomerNotificationSettings(
		patch: CustomerNotificationSettingsPatch,
	): Promise<CustomerNotificationSettings>;
	/** Creates or replaces a channel's primary or fallback provider. */
	putChannelProvider(
		channel: ProviderChannel,
		input: ChannelProviderInput,
	): Promise<ChannelProvider>;
	/**
	 * Sends one verification message through a config (to `address`, else the
	 * caller) and returns the config with `lastVerifyResult`.
	 */
	verifyChannelProvider(
		channel: ProviderChannel,
		role: ChannelProviderRole,
		address?: string,
	): Promise<ChannelProvider>;
	/**
	 * A definition's WhatsApp variant in each locale, with the body Meta
	 * reviews and Meta's verdict (EP12-S05).
	 */
	listWhatsAppTemplates(
		definitionId: string,
		options?: RequestOptions,
	): Promise<WhatsAppTemplate[]>;
	/** The delivery log, newest first; addresses masked (EP12-S17). */
	listNotificationMessages(
		query: NotificationLogQuery,
		options?: RequestOptions,
	): Promise<NotificationLogPage>;
	/** One message with its attempts and the exact rendered body. */
	getNotificationMessage(id: string, options?: RequestOptions): Promise<NotificationMessageDetail>;
	/** Sends a failed or dead message again; `409 not_resendable` otherwise. */
	resendNotificationMessage(id: string): Promise<NotificationLogEntry>;
	/** Sent, delivered and failed per channel over the last hour and day, and the circuit. */
	getChannelHealth(options?: RequestOptions): Promise<ChannelHealth[]>;
	/** The suppression list, searched by address. */
	listSuppressions(
		query: { channel?: string; q?: string },
		options?: RequestOptions,
	): Promise<Suppression[]>;
	/** Removes an address from the suppression list. */
	removeSuppression(id: string): Promise<void>;
	/** Ends a shipment's public tracking link; its next message carries a new one. */
	revokeTrackingToken(shipmentId: string): Promise<void>;
	/** Sends a WhatsApp template to Meta for approval; answers with its verdict so far. */
	submitWhatsAppTemplate(templateId: string): Promise<WhatsAppTemplate>;
	/** A definition's templates: the platform seeds, then this tenant's drafts and versions (EP12-S08). */
	listNotificationTemplates(
		definitionId: string,
		options?: RequestOptions,
	): Promise<NotificationTemplate[]>;
	/** Starts a draft from a seed or a version. */
	createNotificationTemplate(input: NotificationTemplateCreate): Promise<NotificationTemplate>;
	/** Saves a draft's text; anything but a draft is 409 `immutable`. */
	updateNotificationTemplate(
		templateId: string,
		patch: NotificationTemplatePatch,
	): Promise<NotificationTemplate>;
	/** Discards a draft. */
	discardNotificationTemplate(templateId: string): Promise<void>;
	/** Publishes a draft as the next version. */
	publishNotificationTemplate(templateId: string): Promise<NotificationTemplate>;
	/** Retires a published version; messages fall back to the seed. */
	archiveNotificationTemplate(templateId: string): Promise<NotificationTemplate>;
	/** Renders a template, or unsaved text over it, with the sample. */
	previewNotificationTemplate(
		templateId: string,
		request: NotificationTemplatePreviewRequest,
		options?: RequestOptions,
	): Promise<NotificationTemplatePreview>;
	/** A template's history, newest first, down to the seed. */
	listNotificationTemplateVersions(
		templateId: string,
		options?: RequestOptions,
	): Promise<NotificationTemplate[]>;
	/**
	 * Turns a staged feature on or off for this organisation.
	 *
	 * The reason is required and the version is the row's — `0` when the tenant
	 * has never set this flag, which is a precondition a client can legitimately
	 * assert and which still fails if somebody else set one first.
	 */
	setFlag(
		key: string,
		enabled: boolean,
		reason: string,
		version: number,
	): Promise<components["schemas"]["FeatureFlag"]>;

	/** Reserves an attachment and returns the form to post the file to. */
	beginUpload(request: UploadRequest): Promise<UploadTicket>;
	/** Confirms the upload; the server checks the bytes are what they claimed. */
	completeUpload(id: string): Promise<Attachment>;
	/** A fresh form for an attachment still pending; 409 `attachment_ready` once it landed (EP10-S18). */
	renewUpload(id: string): Promise<UploadTicket>;
	/** A short-lived link to a ready attachment, under its purpose's own gate (ADJ-R01-12). */
	getAttachmentDownload(id: string, options?: RequestOptions): Promise<{ url: string }>;
	/** What this caller may import, and the columns each type takes. */
	listImportTypes(options?: RequestOptions): Promise<ImportType[]>;
	/**
	 * Validates an uploaded file and writes nothing.
	 *
	 * The idempotency key is required: a double-submitted upload would leave
	 * two jobs over one file, with no way to tell which one is about to be
	 * committed.
	 */
	createImport(
		type: string,
		attachmentId: string,
		idempotencyKey: string,
		/** The importer's per-run choices, by the names `ImportType.options` lists (EP02-S11). */
		options?: Record<string, string>,
	): Promise<ImportJob>;
	/** One import job, with the first page of its row verdicts. */
	getImport(id: string): Promise<ImportJob>;
	/** A page of the row verdicts, optionally only the ones worth fixing. */
	listImportResults(
		id: string,
		params?: { errorsOnly?: boolean; cursor?: string; limit?: number },
	): Promise<ImportResultList>;
	/** Writes the rows the mode allows. `version` is the job's ETag. */
	commitImport(id: string, mode: ImportMode, version: number): Promise<ImportJob>;
	/** The empty file with the right columns and one example row. */
	downloadImportTemplate(type: string, format?: "csv" | "xlsx"): Promise<DownloadedFile>;
	/** The list, under the filters the screen is showing, as a spreadsheet. */
	downloadExport(
		type: string,
		filters?: URLSearchParams,
		format?: "csv" | "xlsx",
	): Promise<DownloadedFile>;
	/** The stores half of the context, for the portal that needs only that. */
	/** The three top-level types every storage tree hangs from. */
	listLocationTypes(options?: RequestOptions): Promise<LocationTypeList>;
	createLocationType(draft: LocationTypeDraft): Promise<LocationType>;
	renameLocationType(
		typeId: string,
		patch: LocationTypePatch,
		version: number,
	): Promise<LocationType>;
	deleteLocationType(typeId: string): Promise<void>;
	/**
	 * One site's storage tree, or one subtree of it.
	 *
	 * `depth` bounds how far down the answer goes. A node whose children were
	 * not included says so with `hasChildren`, which is what lets the tree draw
	 * a chevron for a branch it has not fetched.
	 */
	getLocationTree(query: {
		warehouseId?: string;
		rootId?: string;
		depth?: number;
		signal?: AbortSignal;
	}): Promise<LocationTreeResponse>;
	/**
	 * Adds one node, or a row of them from a pattern.
	 *
	 * A pattern fills gaps rather than refusing: a code a sibling already holds
	 * comes back in `skipped` and the rest are created.
	 */
	createLocations(draft: LocationDraft): Promise<LocationsCreated>;
	/** Reads one node by its id, or by the path code printed on its label. */
	getLocation(ref: string, options?: RequestOptions): Promise<StorageLocation>;
	updateLocation(
		locationId: string,
		patch: LocationPatch,
		version: number,
	): Promise<StorageLocation>;
	/**
	 * Re-parents a node and everything under it.
	 *
	 * The descendants' addresses are re-derived before this resolves, and the
	 * result says how many moved — so a screen can tell somebody what happened
	 * rather than leave them guessing when the labels went wrong.
	 */
	moveLocation(locationId: string, parentId: string, version: number): Promise<LocationMoveResult>;
	/** What a storage unit holds. `available` is false until EP02-S12 ships. */
	getLocationContents(locationId: string, options?: RequestOptions): Promise<LocationContents>;
	getLocationLabel(locationId: string, options?: RequestOptions): Promise<LocationLabel>;

	getMeStores(options?: RequestOptions): Promise<{ stores: MeStore[] }>;
	/** The store `X-Store-Id` names, as the caller holds it; 404 when not theirs (EP10-S02). */
	getPortalScope(options?: RequestOptions): Promise<MeStore>;
	/** The dashboard's tiles the grid shows, and the activity feed (EP10-S13). */
	getPortalSummary(options?: RequestOptions): Promise<PortalSummary>;
	/** One Sales & Revenue block for the header's store (EP10-S13). */
	getPortalSales(block: PortalSalesBlock, query: PortalSalesQuery): Promise<SalesBreakdown>;
	/** The header's store's scorecard, portal-safe (EP13-S11). */
	getPortalScorecard(query: StorePerformanceQuery): Promise<StoreScorecard>;
	/** The header's store's orders and fulfillment rate per day (EP13-S11). */
	getPortalScorecardTrend(query: StorePerformanceQuery): Promise<StoreTrend>;
	/** The header's store's scorecard as a file (EP13-S11). */
	downloadPortalScorecard(
		query: { from: string; to: string },
		format?: "csv" | "xlsx",
	): Promise<DownloadedFile>;
	/** The store's Existing, Website or Archived orders (EP10-S03). */
	listPortalOrders(query?: ListPortalOrdersQuery): Promise<PortalOrderListPage>;
	/** One of the store's orders with its lines; another store's is a 404. */
	getPortalOrder(orderId: string, options?: RequestOptions): Promise<PortalOrder>;
	/** The messages the store's customer was sent for one of its orders (EP12-S09). */
	listPortalOrderCustomerMessages(
		orderId: string,
		options?: RequestOptions,
	): Promise<CustomerMessageTimeline>;
	/** One of the store's orders' pack photo, with a link signed for five minutes (EP07-S21). */
	getPortalOrderPackPhoto(orderId: string, options?: RequestOptions): Promise<PackPhoto>;
	/** One of an order's logs as the store reads it, newest first. */
	getPortalOrderLog(
		orderId: string,
		tab: PortalOrderLogTab,
		query?: { cursor?: string; limit?: number; signal?: AbortSignal },
	): Promise<OrderLogPage>;
	/** The tab the store is looking at, as a spreadsheet. */
	downloadPortalOrders(filters?: URLSearchParams, format?: "csv" | "xlsx"): Promise<DownloadedFile>;
	/** The active store's External Import queue: waiting rows, or the ones it imported (EP10-S04). */
	listPortalExternalImports(query?: {
		status?: "pending_review" | "imported";
		limit?: number;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<ExternalImportPage>;
	/** Import Selected, per row. `idempotencyKey` is required: a double-click replays. */
	importPortalExternalOrders(ids: string[], idempotencyKey: string): Promise<ExternalImportReport>;
	/** Delete Selected, per row. */
	deletePortalExternalImports(ids: string[]): Promise<ExternalImportReport>;
	/** The circle revert, while the imported order is still `pending`. */
	revertPortalExternalImport(importId: string): Promise<ExternalImportRow>;
	/** Cut a waiting order's short lines so it can release. */
	editPortalShortLines(
		orderId: string,
		body: PortalShortLinesEdit,
		version: number,
	): Promise<PortalShortLinesResult>;
	/**
	 * Key in an order for the active store (EP10-S05). The answer carries the
	 * server's totals, which the confirmation shows. `idempotencyKey` is one per
	 * opening of the form, so a double tap replays the first order.
	 */
	createPortalOrder(
		draft: PortalOrderDraft,
		idempotencyKey: string,
	): Promise<PortalOrderIntakeResult>;
	/** Correct a `pending` order's customer, delivery or payment; `version` travels as `If-Match`. */
	editPortalOrder(orderId: string, patch: PortalOrderPatch, version: number): Promise<PortalOrder>;
	/** The circle: pull a `pending` order back out of the warehouse. */
	withdrawPortalOrder(orderId: string): Promise<PortalOrder>;
	/** Send a withdrawn order back as corrected — a new `pending` order, once. */
	resubmitPortalOrder(
		orderId: string,
		draft: PortalOrderDraft,
		idempotencyKey: string,
	): Promise<PortalOrderIntakeResult>;
	/** Cancel a `pending` order; `version` travels as `If-Match`. */
	cancelPortalOrder(
		orderId: string,
		body: PortalOrderCancel,
		version: number,
	): Promise<PortalOrder>;
	/** The form's SKU picker, over the active store's catalogue. */
	searchPortalCatalogSkus(query?: {
		q?: string;
		limit?: number;
		signal?: AbortSignal;
	}): Promise<OrderCatalogSkuPage>;
	/** The form's City picker; each city names its province. */
	searchPortalCities(q: string, options?: RequestOptions): Promise<PortalCityPage>;
	/** The package types offered to the active store, at its price. */
	getPortalPackagingTypes(options?: RequestOptions): Promise<PackagingOptions>;
	/** The form's store default service and pickup warehouses, customer-pickup sites first (ADJ-1022-3). */
	getPortalOrderOptions(options?: RequestOptions): Promise<PortalOrderOptions>;
	/** The active store's skus with on hand, reserved, available and the alert (EP10-S06). */
	listPortalStock(query?: {
		q?: string;
		cursor?: string;
		limit?: number;
		signal?: AbortSignal;
	}): Promise<PortalStockPage>;
	/** The active store's skus in a `low` or `critical` state, with the counts. */
	listPortalLowStock(query?: {
		cursor?: string;
		limit?: number;
		signal?: AbortSignal;
	}): Promise<PortalLowStockPage>;
	/** The active store's ASNs, newest first. */
	listPortalReceiving(query?: {
		cursor?: string;
		limit?: number;
		signal?: AbortSignal;
	}): Promise<PortalReceivingPage>;
	/** The active store's lots, earliest expiry first, read only (ADJ-R01-12). */
	listPortalLots(query?: {
		state?: LotState;
		expiringBefore?: string;
		cursor?: string;
		limit?: number;
		signal?: AbortSignal;
	}): Promise<LotPage>;
	/** What to reorder: EP-02's rows on the store's own target days. */
	listPortalReorderSuggestions(options?: RequestOptions): Promise<PortalReorderPage>;
	/** Accept a row into an ASN; a row's id is its sku's. */
	acceptPortalReorderSuggestion(
		id: string,
		body: PortalReorderAccept,
	): Promise<PortalReorderDecision>;
	/** Dismiss a row with a reason. */
	dismissPortalReorderSuggestion(
		id: string,
		reason: PortalReorderDismissReason,
	): Promise<PortalReorderDecision>;
	/** The store's target days on hand; at least 7 (`target_days_too_low`). */
	putPortalReorderTargetDays(targetDays: number): Promise<{ targetDays: number }>;
	/** The active store's items with their skus, photos and channel rows (EP10-S07). */
	listPortalCatalogItems(query?: {
		cursor?: string;
		limit?: number;
		signal?: AbortSignal;
	}): Promise<PortalCatalogPage>;
	/** Create an item; a clashing code is `409 sku_code_taken` on `skus[i].code`. */
	createPortalCatalogItem(body: PortalCatalogItemInput): Promise<PortalCatalogItem>;
	/** Edit an item: rows with a `skuId` are edited, rows without one added. */
	updatePortalCatalogItem(itemId: string, body: PortalCatalogItemInput): Promise<PortalCatalogItem>;
	/** Approve a sku the store's channel imported. */
	approvePortalCatalogSku(skuId: string): Promise<PortalCatalogSku>;
	/** The sku's default package type; null clears it (`package_type_not_offered`). */
	putPortalSkuPackagingDefault(
		skuId: string,
		packageTypeId: string | null,
	): Promise<PortalCatalogSku>;
	/** The active store's channel connections and their health. */
	listPortalChannels(options?: RequestOptions): Promise<PortalChannelList>;
	/** The store's profile and Order flow switches (EP10-S11); `version` is the ETag. */
	getPortalSettings(options?: RequestOptions): Promise<PortalSettings>;
	/** Set the Order flow switches; `version` travels as `If-Match`. */
	putPortalSettings(body: PortalSettingsUpdate, version: number): Promise<PortalSettings>;
	/** The store's own API keys, newest first. */
	listPortalApiKeys(options?: RequestOptions): Promise<ApiKey[]>;
	/** A live key for the store; the secret is in this answer only. */
	createPortalApiKey(label: string): Promise<IssuedApiKey>;
	/** Revoke one of the store's keys; the next call with it is 401. */
	revokePortalApiKey(keyId: string): Promise<ApiKey>;
	/**
	 * Replaces the caller's own preferences.
	 *
	 * A PUT, and the only one in the contract. It is a full replace because that
	 * is what the settings form sends — every select, every time — and because
	 * there is exactly one row per person. The server takes the tenant and the
	 * user from the token, so there is nothing here to say whose they are.
	 */
	putPreferences(preferences: MePreferences, options?: RequestOptions): Promise<MePreferences>;
	/**
	 * The flags in force for the caller's organisation.
	 *
	 * `/me/context` already carries the console's set, so this exists for the
	 * refresh after a flag is changed, and for the two interfaces that do not
	 * load the console's shell.
	 */
	getFlags(iface?: EvaluableInterface, options?: RequestOptions): Promise<FlagSet>;
	/**
	 * The caller's own saved views for one list.
	 *
	 * Private to whoever made them, which is why there is no user parameter:
	 * the server takes the owner from the token, and a parameter would be a
	 * thing a client could get wrong about somebody else's bookmarks.
	 */
	listSavedViews(screenKey: string, options?: RequestOptions): Promise<SavedView[]>;
	createSavedView(draft: SavedViewDraft, options?: RequestOptions): Promise<SavedView>;
	deleteSavedView(id: string): Promise<void>;

	/**
	 * The provinces of the caller's organisation, ordered by code.
	 *
	 * No cursor: a country has tens of provinces and the rail shows all of
	 * them. `activeOnly` asks for the ones a new record may reference, which is
	 * what a picker wants and what the list screen does not.
	 */
	listProvinces(query?: ListProvincesQuery): Promise<ProvinceList>;
	createProvince(draft: ProvinceDraft): Promise<Province>;
	/**
	 * Changes a province's name, base fee, SLA or active flag.
	 *
	 * `version` is what the caller last read, sent as `If-Match`. A required
	 * argument rather than an optional one: the server refuses the write
	 * without it, and a signature that let it be omitted would make that a
	 * runtime surprise instead of a compile error.
	 */
	updateProvince(
		provinceId: string,
		patch: ProvincePatch,
		version: number,
	): Promise<ProvinceUpdate>;
	/**
	 * Creates a country's built-in province set, or reports what it would.
	 *
	 * Idempotent by code, so the dialog can dry-run and then commit without a
	 * key of its own, and a double click costs nothing.
	 */
	seedGeography(request: GeographySeedRequest): Promise<GeographySeedReport>;
	/**
	 * The caller's own open work session, zero or one, with the server's clock
	 * (EP05-S07). `employeeId` is null when the account has no employee record.
	 */
	listMyWorkSessions(options?: RequestOptions): Promise<WorkSessionList>;
	/**
	 * Open a work session for the caller. A second one while the first is
	 * active or paused is `409 session_already_open` with the open session in
	 * `blocking`.
	 */
	openWorkSession(body: WorkSessionOpen): Promise<WorkSessionDetail>;
	/** One session with its rollups and activities. */
	getWorkSession(sessionId: string, options?: RequestOptions): Promise<WorkSessionDetail>;
	pauseWorkSession(sessionId: string): Promise<WorkSessionDetail>;
	resumeWorkSession(sessionId: string): Promise<WorkSessionDetail>;
	/** Close takes no fields: the closing time is the server's. */
	closeWorkSession(sessionId: string): Promise<WorkSessionDetail>;
	/**
	 * The Active Sessions panel (EP05-S08): the caller's own session, or every
	 * open session for a manager, with owners, linked summaries and tiles.
	 */
	listWorkSessions(query?: ListWorkSessionsQuery): Promise<WorkSessionList>;
	/**
	 * Cancel a session with a reason: the linked Fulfillment / Return session
	 * is undone and the activities come back `voided` (EP05-S08).
	 */
	cancelWorkSession(sessionId: string, body: WorkSessionCancel): Promise<WorkSessionDetail>;
	/** A manager takes over another's session; the answer names the linked session. */
	continueWorkSession(sessionId: string): Promise<WorkSessionDetail>;
	/**
	 * The Session Log (EP05-S09): ended sessions of a window, newest close
	 * first, with the totals and packaging breakdown of the whole filter.
	 */
	listWorkSessionLog(query: WorkSessionLogQuery): Promise<WorkSessionLog>;
	/** The same filters as an XLSX workbook (`session-log_{from}_{to}.xlsx`). */
	exportWorkSessionLog(
		query: Omit<WorkSessionLogQuery, "cursor" | "limit" | "signal">,
	): Promise<DownloadedFile>;
	/**
	 * Credit an order prepared, a return processed or an inspection. `409
	 * session_not_active` on a paused or closed session, `409
	 * duplicate_activity` for the same subject twice without `repack`.
	 */
	recordWorkSessionActivity(
		sessionId: string,
		draft: WorkSessionActivityDraft,
	): Promise<WorkSessionDetail>;
	/**
	 * Every department, flat and in tree order, with depth and counts
	 * (EP05-S01). The screen builds the tree from `parentDepartmentId`.
	 */
	listDepartments(options?: RequestOptions): Promise<DepartmentList>;
	createDepartment(draft: DepartmentDraft): Promise<Department>;
	/** Edit, move, disable or re-enable. An empty string clears a reference. */
	updateDepartment(departmentId: string, patch: DepartmentPatch): Promise<Department>;
	/** One department's positions, or the organisation's, with holder counts. */
	listPositions(query?: ListPositionsQuery): Promise<PositionList>;
	createPosition(draft: PositionDraft): Promise<Position>;
	updatePosition(positionId: string, patch: PositionPatch): Promise<Position>;
	/** Every shift template, active first (EP05-S10). */
	listShifts(options?: RequestOptions): Promise<ShiftList>;
	createShift(draft: ShiftDraft): Promise<Shift>;
	/** Edit, disable or re-enable a template. `version` travels as `If-Match`. */
	updateShift(shiftId: string, patch: ShiftPatch, version: number): Promise<Shift>;
	/** The board for a range of dates: templates, rows, people and coverage. */
	listShiftAssignments(query: ListShiftAssignmentsQuery): Promise<ShiftSchedule>;
	/**
	 * Every employee on the shift on every date. Partial success: the rows
	 * written and each pair that was not, with its code.
	 */
	createShiftAssignments(batch: ShiftAssignmentBatch): Promise<ShiftAssignmentBatchResult>;
	/** Cancel an assignment or change its note. `version` travels as `If-Match`. */
	updateShiftAssignment(
		assignmentId: string,
		patch: ShiftAssignmentPatch,
		version: number,
	): Promise<ShiftAssignment>;
	/** One day's attendance, with the five tiles when `stats` is true (EP05-S11). */
	getAttendanceDay(query: {
		date: string;
		stats?: boolean;
		signal?: AbortSignal;
	}): Promise<AttendanceDay>;
	/**
	 * Clock in — oneself, or someone else as a supervisor. The key is required:
	 * a retry is served the first answer, not `409 already_clocked_in`.
	 */
	clockIn(body: AttendanceClockRequest, idempotencyKey: string): Promise<AttendanceRecord>;
	/** Clock out, closing the open record. */
	clockOut(body: AttendanceClockRequest, idempotencyKey: string): Promise<AttendanceRecord>;
	/** Correct a record or approve its overtime. `version` travels as `If-Match`. */
	correctAttendance(
		attendanceId: string,
		correction: AttendanceCorrection,
		version: number,
	): Promise<AttendanceRecord>;
	/** Every commission rule of the organisation, active first (EP05-S14). */
	listCommissionRules(options?: RequestOptions): Promise<CommissionRuleList>;
	createCommissionRule(draft: CommissionRuleDraft): Promise<CommissionRule>;
	/** Replace a rule. `version` travels as `If-Match`. */
	updateCommissionRule(
		ruleId: string,
		draft: CommissionRuleDraft,
		version: number,
	): Promise<CommissionRule>;
	/** Accruals, newest first — everyone's for a payslip reader, else one's own. */
	listCommissionAccruals(query?: ListCommissionAccrualsQuery): Promise<CommissionAccrualPage>;
	/** Performance records, newest period first (EP05-S13). */
	listPerformance(
		query: ListPerformanceQuery,
		options?: RequestOptions,
	): Promise<PerformanceRecordPage>;
	/** One period's employees ranked by units per hour. */
	getPerformanceLeaderboard(
		query: PerformanceLeaderboardQuery,
		options?: RequestOptions,
	): Promise<PerformanceLeaderboard>;
	/** Attach a rating and notes; the caller is the reviewer. */
	reviewPerformance(
		performanceId: string,
		draft: PerformanceReviewDraft,
	): Promise<PerformanceRecord>;
	/** Re-fold one period now. */
	recomputePerformance(body: PerformanceRecomputeRequest): Promise<PerformanceRecomputeResult>;
	/** Payroll runs, newest period first (EP05-S15). */
	listPayrollRuns(
		query?: { status?: PayrollRunStatus },
		options?: RequestOptions,
	): Promise<PayrollRunList>;
	/** Open a draft run for a period and compute its lines. */
	createPayrollRun(draft: PayrollRunDraft): Promise<PayrollRunDetail>;
	getPayrollRun(runId: string, options?: RequestOptions): Promise<PayrollRunDetail>;
	/** Re-derive a draft's lines, keeping its deductions. */
	recomputePayrollRun(runId: string): Promise<PayrollRunDetail>;
	addPayrollDeduction(runId: string, draft: PayrollDeductionDraft): Promise<PayrollRunDetail>;
	removePayrollDeduction(runId: string, deductionId: string): Promise<PayrollRunDetail>;
	/** Send a draft for approval. `version` travels as `If-Match`. */
	submitPayrollRun(runId: string, version: number): Promise<PayrollRunDetail>;
	/** Approve a run awaiting approval and post it (EP05-S16). */
	approvePayrollRun(runId: string): Promise<PayrollRunDetail>;
	/** Send a run awaiting approval back to draft with a reason. */
	rejectPayrollRun(runId: string, reason: string): Promise<PayrollRunDetail>;
	/** Pay slips — one employee's for a payslip reader, else one's own. */
	listPayrollItems(
		query?: { employeeId?: string },
		options?: RequestOptions,
	): Promise<PayrollItemList>;
	/**
	 * A page of the employee directory with the organisation-wide counts per
	 * status (EP05-S02). Contact is masked unless the caller is HR or the
	 * person themselves.
	 */
	listEmployees(query?: ListEmployeesQuery): Promise<EmployeeDirectory>;
	/**
	 * A new employee, active and without an account. `idempotencyKey` is
	 * required by the server: a double-submitted drawer would otherwise hire
	 * the same person twice under two codes.
	 */
	createEmployee(draft: EmployeeDraft, idempotencyKey: string): Promise<Employee>;
	/**
	 * One employee with the names beside the ids (EP05-S03). The four personal
	 * fields are absent unless the caller is HR or the person themselves.
	 */
	getEmployee(employeeId: string, options?: RequestOptions): Promise<Employee>;
	/** A profile edit. `version` is what the caller last read, sent as `If-Match`. */
	updateEmployee(employeeId: string, patch: EmployeePatch, version: number): Promise<Employee>;
	/**
	 * The salary on the record (EP05-S12). `404 salary_not_set` when nobody
	 * has set one — a different thing from zero.
	 */
	getEmployeeSalary(employeeId: string, options?: RequestOptions): Promise<EmployeeSalary>;
	/** Set the salary; `version` is the employee's, sent as `If-Match`. */
	setEmployeeSalary(
		employeeId: string,
		draft: EmployeeSalaryDraft,
		version: number,
	): Promise<Employee>;
	/** Place on leave, reactivate or terminate. */
	changeEmployeeStatus(employeeId: string, change: EmployeeStatusChange): Promise<Employee>;
	/** Move to another department and position, now or from a date. */
	assignEmployee(employeeId: string, assignment: EmployeeAssignment): Promise<EmployeeAssignResult>;
	/**
	 * One employee's effective section grid: every Admin section with its
	 * level, where it comes from and the role default (EP05-S04).
	 */
	getEmployeeSectionAccess(
		employeeId: string,
		options?: RequestOptions,
	): Promise<EmployeeSectionAccess>;
	/**
	 * Replace an employee's whole grid — every Admin section is required. Org
	 * owner only, and a step-up action: the first call may answer `403
	 * step_up_required`.
	 */
	replaceEmployeeSectionAccess(
		employeeId: string,
		body: EmployeeSectionAccessReplace,
	): Promise<EmployeeSectionAccess>;
	/**
	 * The roles an employee's login can be given, each with its default grid
	 * and whether this caller may grant it (EP05-S05).
	 */
	listEmployeeAccountRoles(options?: RequestOptions): Promise<EmployeeAccountRoleList>;
	/** Whether a handle is free — advisory; the create claims it for real. */
	checkEmployeeUsername(
		username: string,
		options?: RequestOptions,
	): Promise<EmployeeUsernameAvailability>;
	/** Give an existing employee a login: an Identity invitation (EP05-S05). */
	createEmployeeAccount(employeeId: string, draft: EmployeeAccountDraft): Promise<Employee>;
	/** Change the role of an employee's login. */
	changeEmployeeAccountRole(employeeId: string, roleKey: string): Promise<Employee>;
	/** Ask WorkOS to email a reset link. No password passes through here. */
	resetEmployeePassword(employeeId: string): Promise<EmployeePasswordReset>;
	/** Deactivate an employee's login: memberships paused, sessions ended. */
	suspendEmployeeAccount(employeeId: string): Promise<Employee>;
	/** Restore a deactivated login. */
	reactivateEmployeeAccount(employeeId: string): Promise<Employee>;
	/** Link an existing login to an employee, or let go of one with null. */
	linkEmployeeUser(employeeId: string, userId: string | null): Promise<Employee>;
	/**
	 * Every Admin role's default section grid, with its holders and their
	 * overrides (EP05-S06, Manage Roles).
	 */
	listRoleSectionDefaults(options?: RequestOptions): Promise<RoleDefaultGridList>;
	/**
	 * Replace a role's default grid — every Admin section is required. Org
	 * owner only, and a step-up action: the first call may answer `403
	 * step_up_required`.
	 */
	replaceRoleSectionDefaults(
		roleKey: string,
		body: RoleDefaultGridReplace,
	): Promise<RoleDefaultGridSaved>;
	/**
	 * Cities, searched by name prefix and paged by cursor.
	 *
	 * `provinceId` narrows to one province, and the server serves the two
	 * cases from two different indexes — which is why this is one call with a
	 * filter rather than two methods.
	 *
	 * `isActive` defaults to `true` on the server. Passing `false` is how the
	 * screen shows what a delete took out; there is no "both", because a
	 * tenant has hundreds of cities and a mixed first page is not a view
	 * anybody asked for.
	 */
	listCities(query?: ListCitiesQuery): Promise<CityList>;
	/** One city by id, deleted or not, for naming it (ADJ-M03-5). */
	getCity(cityId: string, options?: RequestOptions): Promise<City>;
	/**
	 * The delivery companies, ordered by the folded name and paged by cursor.
	 *
	 * `activeStores` and `codOutstanding` come back `null` until EP03-S06 and
	 * EP03-S19 exist to answer them, and the screen renders a dash: a zero would
	 * be a claim about the business.
	 */
	listDeliveryCompanies(query?: ListDeliveryCompaniesQuery): Promise<DeliveryCompanyList>;
	getDeliveryCompany(companyId: string, options?: RequestOptions): Promise<DeliveryCompany>;
	createDeliveryCompany(draft: DeliveryCompanyDraft): Promise<DeliveryCompany>;
	/**
	 * Changes a carrier's profile, coverage, capabilities, settlement or
	 * contacts.
	 *
	 * `version` is what the caller last read, sent as `If-Match`. A required
	 * argument rather than an optional one: the server refuses the write
	 * without it, and a signature that let it be omitted would make that a
	 * runtime surprise instead of a compile error.
	 */
	updateDeliveryCompany(
		companyId: string,
		patch: DeliveryCompanyPatch,
		version: number,
	): Promise<DeliveryCompany>;
	/**
	 * Moves a carrier between lifecycle states.
	 *
	 * One method for the three actions, because they differ only in which path
	 * they post to and the screen picks that from the same table it draws its
	 * buttons from. `reason` is required on suspend and archive.
	 */
	changeDeliveryCompanyStatus(
		companyId: string,
		action: "activate" | "suspend" | "archive",
		body?: DeliveryCompanyStatusChange,
	): Promise<DeliveryCompanyTransition>;
	/**
	 * Sets a carrier's service levels, cutoff, pickup days, capacity, COD
	 * limits and label format.
	 *
	 * Its own operation rather than more fields on the profile patch, because
	 * the two are edited from different tabs at different times: one patch for
	 * both would make an operations lead's cutoff change collide with whoever
	 * is filling in the bank details.
	 *
	 * `version` is what the caller last read, sent as `If-Match`.
	 */
	updateDeliveryCompanyOperatingModel(
		companyId: string,
		patch: CarrierOperatingModelPatch,
		version: number,
	): Promise<DeliveryCompany>;
	/**
	 * Drivers, vehicles and shifts (EP03-S16). The driver list is unpaged —
	 * a fleet is tens of drivers and the KPI tiles count all of them.
	 * `version` on the patches is sent as `If-Match`.
	 */
	listDeliveryDrivers(query?: {
		companyId?: string;
		signal?: AbortSignal;
	}): Promise<DeliveryDriverList>;
	getDeliveryDriver(driverId: string, options?: RequestOptions): Promise<DeliveryDriver>;
	createDeliveryDriver(draft: DeliveryDriverDraft): Promise<DeliveryDriver>;
	updateDeliveryDriver(
		driverId: string,
		patch: DeliveryDriverPatch,
		version: number,
	): Promise<DeliveryDriver>;
	/** `reason` is required on suspend and offboard. */
	changeDeliveryDriverStatus(
		driverId: string,
		action: "suspend" | "reactivate" | "offboard",
		reason?: string,
	): Promise<DeliveryDriver>;
	/** The shipments board and table (EP03-S12). */
	listShipments(query?: ShipmentListQuery & { signal?: AbortSignal }): Promise<ShipmentList>;
	getShipment(shipmentId: string, options?: RequestOptions): Promise<ShipmentDetail>;
	getShipmentSummary(options?: RequestOptions): Promise<ShipmentSummary>;
	/** Idempotent by `eventKey`; the order moves with it. */
	transitionShipment(shipmentId: string, body: ShipmentTransition): Promise<Shipment>;
	cancelShipment(shipmentId: string, reason: string): Promise<Shipment>;
	/** Confirm the carrier and freeze its quote (EP03-S13). */
	assignShipment(shipmentId: string, body: ShipmentAssign): Promise<Shipment>;
	/** Give the shipment a driver of its carrier (EP03-S13). */
	assignShipmentDriver(shipmentId: string, body: ShipmentAssignDriver): Promise<Shipment>;
	/** Each shipment on its own; partial success is the normal answer. The key is required. */
	bulkAssignShipments(
		body: ShipmentBulkAssign,
		idempotencyKey: string,
	): Promise<ShipmentBulkAssignResult>;
	/** Attempts and proof of delivery, files signed for five minutes (EP03-S17). */
	getShipmentProof(shipmentId: string, options?: RequestOptions): Promise<ShipmentProof>;
	/** Place, confirm or geocode the destination pin (EP03-S17). */
	setShipmentPin(shipmentId: string, body: ShipmentPinRequest): Promise<Shipment>;
	/** The delivery window and its day, until the parcel is out (EP03-S22). */
	setShipmentWindow(shipmentId: string, body: ShipmentWindowPatch): Promise<Shipment>;
	/** A dispatcher's promised date, with a reason (EP03-S14). */
	setShipmentPromisedDate(shipmentId: string, body: ShipmentPromisedDate): Promise<Shipment>;
	/** Pickup-to-delivery median, p90 and on-time rate per carrier per province (EP03-S14). */
	getTimeToDeliver(
		query: DeliveryTimeQuery & { signal?: AbortSignal },
	): Promise<DeliveryTimeReport>;
	/** The declared value and insured flag, before the quote is frozen (EP03-S22). */
	setShipmentInsurance(shipmentId: string, body: ShipmentInsurancePatch): Promise<Shipment>;
	/** The customer's tracking link, made the first time it is asked for (EP03-S22). */
	shipmentTrackingLink(shipmentId: string): Promise<ShipmentTrackingLink>;
	/** A shipment's COD collection (EP03-S19); 404 before delivery or when prepaid. */
	getShipmentCod(shipmentId: string, options?: RequestOptions): Promise<CodCollection>;
	/** The calling driver's cash in hand and open collections (EP03-S19; the Driver App's Cash tab, EP10-S19). */
	getMyDriverWallet(options?: RequestOptions): Promise<DriverWallet>;
	/** The calling driver's finished deliveries or pickups, newest first (ADJ-1022-8b). */
	listMyDriverShipmentHistory(query: DriverHistoryQuery): Promise<DriverShipmentHistory>;
	/** The currencies a driver may take today, with their rates (COD phase 2a). */
	getMyCodTenderOptions(options?: RequestOptions): Promise<CodTenderOptions>;
	/** The calling driver's last 20 handovers, newest first (EP10-S20). */
	listMyCodHandovers(options?: RequestOptions): Promise<CodHandoverList>;
	/** One of the calling driver's handovers, polled while its QR is shown (EP10-S20). */
	getMyCodHandover(handoverId: string, options?: RequestOptions): Promise<CodHandover>;
	/** Delivery's COD collections, a store user's own stores only (EP03-S19). */
	listDeliveryCodCollections(
		query?: DeliveryCodCollectionsQuery & { signal?: AbortSignal },
	): Promise<CodCollectionList>;
	/** A batch of a driver's collections for the desk (EP03-S20); idempotent by `clientEventKey`. */
	initiateCodBatch(body: CodBatchCreate): Promise<CodHandover>;
	/** Delivery's handover queue, newest first (EP03-S20). */
	listDeliveryCodHandovers(
		query?: DeliveryCodHandoversQuery & { signal?: AbortSignal },
	): Promise<CodHandoverList>;
	/** Counts a handover's dollars and lira at Delivery's desk (EP03-S20). */
	confirmDeliveryCodHandover(
		handoverId: string,
		body: CodPerCurrencyCount,
		idempotencyKey: string,
	): Promise<CodHandover>;
	/** Records a closed handover's bank deposit (EP03-S20). */
	depositCodHandover(handoverId: string, body: CodDeposit): Promise<CodHandover>;
	/** Cash still held, by holder and age band, with the desk's tiles (EP03-S20). */
	getDeliveryCodAging(options?: RequestOptions): Promise<CodAging>;
	/** Agree a new date; the order moves with it (EP03-S18). */
	rescheduleShipment(shipmentId: string, body: ShipmentReschedule): Promise<Shipment>;
	/** Return to origin; EP-08 opens the Return case (EP03-S18). */
	sendShipmentBack(shipmentId: string, body: ShipmentRto): Promise<Shipment>;
	/** Declare lost, with its liability (EP03-S18). */
	declareShipmentLost(shipmentId: string, body: ShipmentLost): Promise<Shipment>;
	/** Carrier pickup manifests, newest first (EP03-S15). */
	listManifests(query?: ManifestListQuery & { signal?: AbortSignal }): Promise<ManifestList>;
	getManifest(manifestId: string, options?: RequestOptions): Promise<ManifestDetail>;
	/** The carrier's next pickup day, what the builder proposes. */
	planManifest(
		companyId: string,
		driverId?: string,
		options?: RequestOptions,
	): Promise<ManifestPlan>;
	/** Build a manifest; every shipment must be ready and the carrier's, or none go on it. */
	createManifest(body: ManifestCreate): Promise<Manifest>;
	/** The carrier's pickup: every shipment picked up, or none. */
	confirmManifest(manifestId: string): Promise<Manifest>;
	/** The end-of-day handover: one outcome per shipment. */
	reconcileManifest(manifestId: string, outcomes: ManifestOutcome[]): Promise<Manifest>;
	cancelManifest(manifestId: string): Promise<Manifest>;
	/** The A4 manifest with barcodes and signature boxes. */
	printManifest(manifestId: string): Promise<DownloadedFile>;
	/** The shipment's 4×6 waybill (EP03-S15). */
	printShipmentWaybill(shipmentId: string): Promise<DownloadedFile>;
	/** The pickup queue with counts per status (EP03-S21). */
	listPickupRequests(
		query?: PickupListQuery & { signal?: AbortSignal },
	): Promise<PickupRequestList>;
	/** Request a pickup on behalf of a store. */
	createPickupRequest(body: PickupRequestDraft): Promise<PickupRequest>;
	/** Edit a requested pickup; `version` is the one read. */
	patchPickupRequest(
		pickupId: string,
		body: PickupRequestPatch,
		version: number,
	): Promise<PickupRequest>;
	schedulePickupRequest(
		pickupId: string,
		body: { date: string; window: PickupWindow },
	): Promise<PickupRequest>;
	/** Give a scheduled pickup to a driver who covers its province. */
	assignPickupDriver(pickupId: string, driverId: string): Promise<PickupRequest>;
	cancelPickupRequest(pickupId: string, reason?: string): Promise<PickupRequest>;
	/** The collected goods arrived at the warehouse. */
	receivePickupRequest(pickupId: string): Promise<PickupRequest>;
	/** The active store's own pickups (EP03-S21). */
	listPortalPickupRequests(
		query?: Omit<PickupListQuery, "storeId"> & { signal?: AbortSignal },
	): Promise<PickupRequestList>;
	createPortalPickupRequest(body: PickupRequestDraft): Promise<PickupRequest>;
	patchPortalPickupRequest(
		pickupId: string,
		body: PickupRequestPatch,
		version: number,
	): Promise<PickupRequest>;
	cancelPortalPickupRequest(pickupId: string, reason?: string): Promise<PickupRequest>;
	/** One pickup priced under the store's plan on a day, not recorded (EP10-S14). */
	getPortalPickupFeePreview(date?: string, options?: RequestOptions): Promise<PickupFeePreview>;
	/** The store's return cases, one tab, with every tab's count (EP10-S14). */
	listPortalReturns(query?: {
		tab?: PortalReturnTab;
		cursor?: string;
		limit?: number;
		signal?: AbortSignal;
	}): Promise<PortalReturnList>;
	getPortalReturn(returnId: string, options?: RequestOptions): Promise<PortalReturnCaseDetail>;
	/** Request a return, recall a parcel, or approve a return to origin (EP10-S14). */
	requestPortalReturn(body: PortalReturnRequest): Promise<PortalReturnRequestResult>;
	listPortalOrderShipments(orderId: string, options?: RequestOptions): Promise<PortalShipmentList>;
	/** What the store is billed for one of its orders: revenue lines only (ADJ-R01-12). */
	getPortalOrderCharges(orderId: string, options?: RequestOptions): Promise<OrderCharges>;
	getPortalShipmentPod(shipmentId: string, options?: RequestOptions): Promise<PortalPod>;
	/** The active store's tickets and claims, one tab at a time (EP10-S12). */
	listPortalTickets(
		query?: Omit<StoreTicketQuery, "storeId"> & { signal?: AbortSignal },
	): Promise<StoreTicketList>;
	openPortalTicket(body: StoreTicketDraft): Promise<StoreTicketDetail>;
	getPortalTicket(ticketId: string, options?: RequestOptions): Promise<StoreTicketDetail>;
	replyPortalTicket(ticketId: string, body: StoreTicketReply): Promise<StoreTicketDetail>;
	/** Every store's tickets, soonest SLA first — the console's desk (EP10-S12). */
	listStoreTickets(query?: StoreTicketQuery & { signal?: AbortSignal }): Promise<StoreTicketList>;
	getStoreTicket(ticketId: string, options?: RequestOptions): Promise<StoreTicketDetail>;
	replyStoreTicket(ticketId: string, body: StoreTicketOperatorReply): Promise<StoreTicketDetail>;
	setStoreTicketStatus(ticketId: string, status: StoreTicketStatus): Promise<StoreTicketDetail>;
	decideStoreTicketClaim(
		ticketId: string,
		body: StoreTicketClaimDecisionInput,
	): Promise<StoreTicketDetail>;
	/** Dispatch orders, newest first (EP07-S23). */
	listDispatchOrders(
		query?: DispatchOrderListQuery & { signal?: AbortSignal },
	): Promise<DispatchOrderList>;
	getDispatchOrder(dispatchId: string, options?: RequestOptions): Promise<DispatchOrderDetail>;
	/** Raise a dispatch; a store user's is filed as a request. */
	createDispatchOrder(body: DispatchOrderWrite): Promise<DispatchOrderDetail>;
	/** Replace the document while draft or submitted; `version` travels as `If-Match`. */
	updateDispatchOrder(
		dispatchId: string,
		body: DispatchOrderWrite,
		version: number,
	): Promise<DispatchOrderDetail>;
	/** A lifecycle step that takes no body. */
	moveDispatchOrder(
		dispatchId: string,
		step: "submit" | "allocate" | "stage" | "complete",
	): Promise<DispatchOrderDetail>;
	approveDispatchOrder(
		dispatchId: string,
		body: DispatchOrderApprove,
	): Promise<DispatchOrderDetail>;
	/** Scanned boxes and units onto the load. */
	pickDispatchOrder(dispatchId: string, picks: DispatchPick[]): Promise<DispatchOrderDetail>;
	/** Confirm the departure and the handover. */
	dispatchDispatchOrder(
		dispatchId: string,
		body: DispatchOrderHandover,
	): Promise<DispatchOrderDetail>;
	cancelDispatchOrder(dispatchId: string, reason?: string): Promise<DispatchOrderDetail>;
	listDispatchDocuments(
		dispatchId: string,
		options?: RequestOptions,
	): Promise<DispatchDocumentList>;
	/** One document as an A4 PDF. */
	printDispatchDocument(dispatchId: string, kind: DispatchDocumentKind): Promise<DownloadedFile>;
	getDispatchLog(dispatchId: string, options?: RequestOptions): Promise<DispatchLog>;
	/** The status log as CSV. */
	exportDispatchLog(dispatchId: string): Promise<DownloadedFile>;
	/** One tab of the exceptions queue and every tab's count (EP03-S18). */
	listDeliveryExceptions(
		query: DeliveryExceptionQuery & { signal?: AbortSignal },
	): Promise<DeliveryExceptionPage>;
	listDeliveryVehicles(options?: RequestOptions): Promise<DeliveryVehicleList>;
	createDeliveryVehicle(draft: DeliveryVehicleDraft): Promise<DeliveryVehicle>;
	updateDeliveryVehicle(
		vehicleId: string,
		patch: DeliveryVehiclePatch,
		version: number,
	): Promise<DeliveryVehicle>;
	listDeliveryShifts(query: {
		from: string;
		to: string;
		driverId?: string;
		signal?: AbortSignal;
	}): Promise<DriverShiftList>;
	planDeliveryShift(draft: DriverShiftDraft): Promise<DriverShift>;
	/**
	 * How much of a carrier's day is already spoken for, province by province.
	 *
	 * `used` and `remaining` come back `null` until EP03-S13 counts
	 * assignments, and the bar renders a dash: a running total nothing updates
	 * is the number that stops being believed. `reached` is never null, because
	 * auto-assignment gates on it and a gate has to hear "nothing in the way"
	 * rather than a guess.
	 *
	 * `date` defaults to today in the tenant's own timezone, which the response
	 * names.
	 */
	getDeliveryCompanyCapacity(
		companyId: string,
		query?: { date?: string; signal?: AbortSignal },
	): Promise<DeliveryCompanyCapacity>;
	/**
	 * The stores assigned to a carrier, with the provinces each may be given.
	 *
	 * `allowedProvinces` is `null` for a store that never restricted itself,
	 * and that null means *all of the carrier's coverage* rather than none:
	 * `effectiveProvinces` is that resolution already done, and it is what a
	 * gate reads. `coverageProvinces` travels with the page so the Add store
	 * drawer can draw its options without a second fetch.
	 */
	listDeliveryCompanyStores(
		companyId: string,
		query?: { limit?: number; cursor?: string; signal?: AbortSignal },
	): Promise<DeliveryCompanyStoreList>;
	/** Puts a store under a carrier, optionally restricting its provinces. */
	assignDeliveryCompanyStore(
		companyId: string,
		draft: DeliveryCompanyStoreDraft,
	): Promise<DeliveryCompanyStore>;
	/**
	 * Changes a store's allowed provinces, or turns the assignment off.
	 *
	 * No version: the row has two editable fields set from one drawer by one
	 * person, and the server asks for no precondition.
	 */
	updateDeliveryCompanyStore(
		companyId: string,
		storeId: string,
		patch: DeliveryCompanyStorePatch,
	): Promise<DeliveryCompanyStore>;
	/** The carriers one store is under, with the provinces each may be given. */
	listStoreDeliveryCompanies(
		storeId: string,
		options?: RequestOptions,
	): Promise<StoreDeliveryCompanyList>;
	/** A store's auto-assignment rules (EP03-S11). An unsaved store is an empty set at version 0. */
	getDeliveryAssignmentRules(
		storeId: string,
		options?: RequestOptions,
	): Promise<DeliveryAssignmentRuleSet>;
	/**
	 * Replace a store's whole rule set. A refused row comes back as a 422 whose
	 * `field` is `rules[i].companyId`, `rules[i].provinceId` or `rules[i].cityId`.
	 */
	replaceDeliveryAssignmentRules(
		storeId: string,
		draft: DeliveryAssignmentRuleSetDraft,
	): Promise<DeliveryAssignmentRuleSet>;
	/** Which carrier an order to this destination would get, and every carrier skipped on the way. */
	resolveDeliveryAssignment(
		body: DeliveryAssignmentResolveRequest,
	): Promise<DeliveryAssignmentResolution>;
	/**
	 * Delivery rate rows for a carrier or a merchant, newest effective first.
	 *
	 * `storeId` asks two questions: the literal `"default"` returns the rows
	 * with no merchant on them, a store id returns that merchant's, and leaving
	 * it off returns every scope. An empty string cannot ask the second, which
	 * is why the literal exists rather than a magic empty value.
	 *
	 * `isActive` filters the switch and `asOf` filters the window. They are two
	 * filters because a row turned off keeps its dates.
	 */
	listDeliveryRates(query?: {
		companyId?: string;
		storeId?: string;
		provinceId?: string;
		cityId?: string;
		isActive?: boolean;
		asOf?: string;
		signal?: AbortSignal;
	}): Promise<DeliveryRateList>;
	/**
	 * Records a company default or a client override for one lane.
	 *
	 * An overlap is `409 rate_overlap` carrying the conflicting row in
	 * `blocking`; resubmitting with `autoClosePrevious` closes the standing row
	 * at the new row's start, in the same transaction. The response carries
	 * both, so the screen can say what it ended rather than leaving somebody to
	 * reload and work out why the old price disappeared.
	 */
	createDeliveryRate(draft: DeliveryRateDraft): Promise<DeliveryRateCreated>;
	/**
	 * Edits a rate that has not taken effect yet.
	 *
	 * A live row is `409 rate_not_editable`: it has priced shipments, and
	 * editing it would restate what somebody was already charged. No version —
	 * the row two people could collide on is the live one, and that cannot be
	 * edited at all.
	 */
	updateDeliveryRate(rateId: string, patch: DeliveryRatePatch): Promise<DeliveryRate>;
	/** Sets a live rate's end date. Exclusive, and never in the past. */
	endDeliveryRate(rateId: string, effectiveTo?: string): Promise<DeliveryRate>;
	/**
	 * Resolves one lane through the five levels and prices it (EP03-S08).
	 *
	 * A read that writes nothing, which is why it carries no audit action. It is
	 * a POST because the request is a lane, a date and the inputs a rate card is
	 * evaluated against, rather than a query string.
	 *
	 * Nothing matching is `unpriced: true` with a **200** and the geography base
	 * fee as `suggestedRevenue` — a suggestion for the operator, never a price.
	 * A caller creating a shipment maps `unpriced` to `422 rate_not_assigned`.
	 */
	quoteDeliveryLane(body: DeliveryQuoteRequest): Promise<DeliveryQuote>;
	/** Rate cards (EP03-S24): the tenant's cards, each with its history and issues. */
	listRateCards(options?: RequestOptions): Promise<RateCardList>;
	getRateCard(cardId: string, options?: RequestOptions): Promise<RateCard>;
	createRateCard(body: RateCardCreate): Promise<RateCard>;
	/** Edits the working copy; quotes read the published version until the next publish. */
	updateRateCard(cardId: string, patch: RateCardPatch): Promise<RateCard>;
	/** Freezes the working copy as the next version; `422 rate_card_invalid` lists its issues. */
	publishRateCard(cardId: string): Promise<RateCard>;
	archiveRateCard(cardId: string): Promise<RateCard>;
	/** Records a parcel's weight and volume before assignment (EP03-S24). */
	patchShipment(shipmentId: string, patch: ShipmentPatch): Promise<Shipment>;
	/** Every province and city one merchant has under one carrier, resolved. */
	listEffectiveDeliveryRates(
		storeId: string,
		query: { companyId: string; asOf?: string; signal?: AbortSignal },
	): Promise<EffectiveDeliveryRateList>;
	/**
	 * One merchant's served lanes under each of its carriers, resolved, with
	 * the carrier take and the margin (EP01-S10) — the Stores tab's table.
	 */
	listStoreDeliveryRates(
		storeId: string,
		query?: { companyId?: string; asOf?: string; signal?: AbortSignal },
	): Promise<StoreDeliveryRateList>;
	/** The served lanes nothing prices, and the store's rows for places it no longer serves. */
	getStoreDeliveryCoverage(
		storeId: string,
		query?: { asOf?: string; signal?: AbortSignal },
	): Promise<StoreDeliveryCoverage>;
	/**
	 * Every lane whose effective resolution loses money (EP03-S10).
	 *
	 * The walk's own margin, never a subtraction of the row's two numbers, and
	 * each row listed once on the lane it sits on. The spreadsheet form is
	 * `downloadExport("delivery_rates_negative_margin", filters)`.
	 */
	listNegativeMarginDeliveryRates(query?: {
		companyId?: string;
		storeId?: string;
		provinceId?: string;
		asOf?: string;
		signal?: AbortSignal;
	}): Promise<NegativeMarginReport>;
	/**
	 * One carrier's rates arranged by store, province and city, every cell
	 * resolved through the same walk the quote runs (EP03-S09). `storeId` is
	 * the literal `default` for the carrier's own group, a store id for that
	 * store's, or absent for every group.
	 */
	getDeliveryRatesGrid(
		companyId: string,
		query?: { storeId?: string; asOf?: string; signal?: AbortSignal },
	): Promise<DeliveryRatesGrid>;
	/**
	 * A merchant's own delivery prices. No carrier cost, no margin, no level:
	 * `03/02` §5, and a contract test on both the schema and the JSON.
	 */
	listStoreDeliveryPrices(query?: {
		storeId?: string;
		companyId?: string;
		asOf?: string;
		signal?: AbortSignal;
	}): Promise<StoreDeliveryPriceList>;
	createCity(provinceId: string, draft: CityDraft): Promise<City>;
	/**
	 * Changes a city's name, code, fee override or active flag.
	 *
	 * `version` is what the caller last read, sent as `If-Match`. A required
	 * argument rather than an optional one: the server refuses the write
	 * without it, and a signature that let it be omitted would make that a
	 * runtime surprise instead of a compile error.
	 */
	updateCity(cityId: string, patch: CityPatch, version: number): Promise<City>;
	/**
	 * Deletes a city without removing it.
	 *
	 * No version, because there is nothing to lose a race with: the call is
	 * idempotent and every outcome is the same row, inactive. Answers with the
	 * city so the screen can re-render the status chip it has just been given.
	 */
	deleteCity(cityId: string): Promise<City>;
	/**
	 * Every journal one entity produced, legs included, in one call.
	 *
	 * A delivered COD shipment returns three: the client price billed to the
	 * store, the carrier take owed to the delivery company, and the COD
	 * collected on the store's behalf.
	 *
	 * A store-scoped caller gets less, and the server decides how much: a
	 * journal with no leg on one of their own wallets does not come back at
	 * all, and one that does comes back with only the legs they may see. So a
	 * journal can legitimately arrive with one leg of the two it has, and the
	 * panel must render that rather than treating it as malformed.
	 */
	listEntityPostings(
		sourceKind: string,
		sourceId: string,
		options?: RequestOptions,
	): Promise<EntityPostings>;

	/**
	 * A page of journal headers, and — with `status=pending_approval` — the
	 * four-eyes queue.
	 */
	listJournalEntries(query?: ListJournalEntriesQuery): Promise<JournalPage>;
	/**
	 * One journal with its legs and the accounts they name.
	 *
	 * The hop between an entry and what caused it. A reversal appears here as
	 * two journals pointing at each other, never as one journal that changed:
	 * the original keeps `reversedByJournalId` and the mirror carries
	 * `reversesJournalId`.
	 */
	getJournalEntry(journalId: string, options?: RequestOptions): Promise<JournalDetail>;
	/**
	 * Posts a manual balanced journal.
	 *
	 * `idempotencyKey` is required by the server, and required here for the
	 * same reason every other mutation's is: a signature that let it be
	 * omitted would make a double-submitted form two journals.
	 */
	postJournalEntry(draft: JournalDraft, idempotencyKey: string): Promise<PostedJournal>;
	/** Approves a journal somebody else raised above the threshold. */
	approveJournalEntry(journalId: string, options?: RequestOptions): Promise<Journal>;
	/**
	 * Posts the mirror of a journal.
	 *
	 * Returns the **new** journal, not the old one. A correction is a second
	 * journal here exactly as it is in the book, and a caller that replaced the
	 * original with this answer would be rendering an edit.
	 */
	reverseJournalEntry(
		journalId: string,
		body: JournalReversal,
		options?: RequestOptions,
	): Promise<Journal>;
	/** The posting rulebook: the effective catalogue, or one type's versions. */
	listPostingRules(eventType?: string, options?: RequestOptions): Promise<PostingRuleList>;
	/** The posting inbox, filtered by status. */
	listEconomicEvents(query?: ListEconomicEventsQuery): Promise<EconomicEventPage>;
	/** Re-runs a recorded event against the current rulebook. */
	repostEconomicEvent(eventId: string, options?: RequestOptions): Promise<EconomicEvent>;

	/** A store's orders that can go into a cashout now, with their deductions (EP04-S06). */
	listCashoutEligibleOrders(
		storeId: string,
		options?: RequestOptions,
	): Promise<CashoutEligibleOrders>;
	/** Cashouts, newest first. */
	listCashouts(query?: ListCashoutsQuery): Promise<CashoutList>;
	/** One cashout with its orders and totals. */
	getCashout(cashoutId: string, options?: RequestOptions): Promise<Cashout>;
	/**
	 * Generates a cashout for selected orders of one store. The key is
	 * required: a double-clicked Generate replays the first cashout.
	 */
	generateCashout(body: CashoutDraft, idempotencyKey: string): Promise<Cashout>;
	/** Cancels a generated cashout; its orders go back to ready for cashout. */
	cancelCashout(cashoutId: string, reason: string, idempotencyKey: string): Promise<Cashout>;
	/** The cashout as a PDF or CSV bill. */
	downloadCashoutDocument(cashoutId: string, format: "pdf" | "csv"): Promise<DownloadedFile>;
	/** How and when a store is paid (EP04-S08); the ETag is the plan's version. */
	getRemittanceSettings(storeId: string, options?: RequestOptions): Promise<RemittanceSettings>;
	/** Replaces a store's five remittance fields; `version` is the plan's, `0` when unsaved. */
	putRemittanceSettings(
		storeId: string,
		draft: RemittanceSettingsDraft,
		version: number,
	): Promise<RemittanceSettings>;
	/** What "Cash out now" would pay the portal's store (EP04-S08). */
	getPortalExpressCashoutQuote(options?: RequestOptions): Promise<ExpressCashoutQuote>;
	/** Cashes out every ready order of the portal's store now, for the express fee. */
	createPortalExpressCashout(idempotencyKey: string): Promise<Cashout>;

	/** The portal's Finance totals for a period, `YYYY-MM-DD` both ends (EP10-S08). */
	getPortalFinanceSummary(
		query: { from: string; to: string },
		options?: RequestOptions,
	): Promise<PortalFinanceSummary>;
	/** The balance card: live balance, available to request, next payout day. */
	getPortalFinanceBalance(options?: RequestOptions): Promise<PortalFinanceBalance>;
	/** The portal store's cashouts, newest first. */
	listPortalCashouts(query?: {
		cursor?: string;
		limit?: number;
		signal?: AbortSignal;
	}): Promise<CashoutList>;
	/** A cashout's PDF, the Admin Console's copy. */
	downloadPortalCashoutDocument(cashoutId: string): Promise<DownloadedFile>;
	/** The open period's provisional statement and every issued one. */
	listPortalStatements(options?: RequestOptions): Promise<PortalStatementList>;
	/** One statement with its lines; `500 statement_unbalanced` when it does not add up. */
	getPortalFinanceStatement(
		statementId: string,
		options?: RequestOptions,
	): Promise<PortalStatementDetail>;
	/** An issued statement's stored PDF. */
	downloadPortalStatementDocument(statementId: string): Promise<DownloadedFile>;
	/** The store wallet's ledger entry behind a statement line. */
	getPortalLedgerEntry(entryId: string, options?: RequestOptions): Promise<PortalLedgerEntry>;
	/** What was paid to the portal's store. */
	listPortalPayouts(options?: RequestOptions): Promise<StorePayoutList>;
	/** The read-only storage fee card; 404 when the store is unpriced. */
	getPortalStorageFee(options?: RequestOptions): Promise<StorageFeeRow>;
	/** The portal store's cashout requests and where they pay (EP10-S09). */
	listPortalCashoutRequests(query?: {
		cursor?: string;
		limit?: number;
		signal?: AbortSignal;
	}): Promise<PortalCashoutRequestList>;
	/**
	 * Requests a cashout, behind the MFA gate. The key is required: a
	 * double-tapped Request would otherwise reserve the balance twice.
	 */
	createPortalCashoutRequest(amountMinor: number, idempotencyKey: string): Promise<CashoutRequest>;
	/** Cancels the store's open request, releasing its reservation. */
	cancelPortalCashoutRequest(requestId: string): Promise<CashoutRequest>;
	/** Disputes a statement line, opening its billing_dispute ticket. */
	disputePortalLedgerEntry(
		entryId: string,
		body: PortalLedgerDispute,
	): Promise<PortalLedgerDisputeResult>;
	/** The portal store's client delivery prices, no carrier take (EP10-S08). */
	listPortalDeliveryRates(options?: RequestOptions): Promise<StoreDeliveryPriceList>;

	/** Payout runs, newest first (EP04-S09). */
	listPayoutRuns(query?: ListPayoutRunsQuery): Promise<PayoutRunList>;
	getPayoutRun(runId: string, options?: RequestOptions): Promise<PayoutRun>;
	createPayoutRun(body: PayoutRunDraft, idempotencyKey: string): Promise<PayoutRun>;
	/**
	 * One run-level write — compute, approve, export or cancel. Every one
	 * takes a key: a retried approval must answer the first, not 409.
	 */
	transitionPayoutRun(
		runId: string,
		action: "compute" | "approve" | "export" | "cancel",
		idempotencyKey: string,
	): Promise<PayoutRun>;
	listPayoutRunItems(runId: string, options?: RequestOptions): Promise<PayoutRunItemList>;
	/** The ledger entries one item netted. */
	listPayoutRunItemEntries(
		runId: string,
		itemId: string,
		options?: RequestOptions,
	): Promise<PayoutRunItemEntries>;
	holdPayoutRunItem(
		runId: string,
		itemId: string,
		body: { hold: boolean; reason?: string },
		idempotencyKey: string,
	): Promise<PayoutRunItem>;
	recordPayoutRunItemResult(
		runId: string,
		itemId: string,
		body: PayoutItemResultRequest,
		idempotencyKey: string,
	): Promise<PayoutRunItem>;
	/** The stored payment file, byte for byte what was hashed. */
	downloadPayoutRunExport(runId: string): Promise<DownloadedFile>;

	/** Carrier settlement runs, newest period first (EP04-S10). */
	listSettlementRuns(query?: ListSettlementRunsQuery): Promise<SettlementRunList>;
	getSettlementRun(runId: string, options?: RequestOptions): Promise<SettlementRun>;
	/** Drafts a carrier's run; an overlapping draft comes back re-assembled. */
	createSettlementRun(body: SettlementRunDraft, idempotencyKey: string): Promise<SettlementRun>;
	listSettlementLines(runId: string, options?: RequestOptions): Promise<SettlementLineList>;
	/** Every disputed line across runs. */
	listSettlementDisputes(options?: RequestOptions): Promise<SettlementLineList>;
	actOnSettlementLine(
		runId: string,
		lineId: string,
		body: SettlementLineAction,
		idempotencyKey: string,
	): Promise<SettlementLineResult>;
	transitionSettlementRun(
		runId: string,
		body: SettlementTransition,
		idempotencyKey: string,
	): Promise<SettlementRun>;
	/** The carrier's statement as a PDF or CSV. */
	downloadSettlementStatement(runId: string, format: "pdf" | "csv"): Promise<DownloadedFile>;
	/** A carrier's live balances and its last run (the company profile's panel). */
	getCarrierBalance(companyId: string, options?: RequestOptions): Promise<CarrierBalance>;

	/** Adjustments, newest first (EP04-S14). */
	listAdjustments(query?: ListAdjustmentsQuery): Promise<AdjustmentList>;
	getAdjustment(adjustmentId: string, options?: RequestOptions): Promise<Adjustment>;
	/** The party's balance before and after the adjustment posts. */
	previewAdjustment(adjustmentId: string, options?: RequestOptions): Promise<AdjustmentPreview>;
	/** Drafts an adjustment; `submit` sends it for approval at once. */
	createAdjustment(body: AdjustmentDraft, idempotencyKey: string): Promise<Adjustment>;
	submitAdjustment(adjustmentId: string, idempotencyKey: string): Promise<Adjustment>;
	/** Approves and posts. The creator is `403 self_approval`. */
	approveAdjustment(adjustmentId: string, idempotencyKey: string): Promise<Adjustment>;
	rejectAdjustment(adjustmentId: string, note: string, idempotencyKey: string): Promise<Adjustment>;
	/** Internal Finance's recurring costs, salaries first, and the missing-salary warning (EP04-S17). */
	listRecurringCosts(options?: RequestOptions): Promise<RecurringCostList>;
	createRecurringCost(body: RecurringCostDraft, idempotencyKey: string): Promise<RecurringCost>;
	/** A new amount from `effectiveDate` answers the new version row; a salary row is `409`. */
	updateRecurringCost(recurringCostId: string, patch: RecurringCostPatch): Promise<RecurringCost>;
	/** Projects the salaries Employees holds that the costs do not. */
	syncInternalSalaries(): Promise<SalarySyncResult>;
	listOneTimeCosts(query?: {
		from?: string;
		to?: string;
		signal?: AbortSignal;
	}): Promise<OneTimeCostList>;
	createOneTimeCost(body: OneTimeCostDraft, idempotencyKey: string): Promise<OneTimeCost>;
	updateOneTimeCost(oneTimeCostId: string, patch: OneTimeCostPatch): Promise<OneTimeCost>;
	/** A short-lived link to the cost's receipt. */
	getOneTimeCostAttachment(oneTimeCostId: string): Promise<{ url: string }>;
	/** Internal Finance's profit for any range, one row per month (EP04-S18). */
	getInternalStatus(
		query: { from: string; to: string },
		options?: RequestOptions,
	): Promise<InternalStatus>;
	/** The twelve months of a year and their total. */
	getInternalStatusMonthly(year: number, options?: RequestOptions): Promise<InternalStatus>;
	/** The documents behind one line of the status. */
	listInternalStatusItems(
		query: { from: string; to: string; line: InternalStatusLine },
		options?: RequestOptions,
	): Promise<InternalStatusItemList>;
	/** A month's closed versions, newest first. */
	listProfitPeriodVersions(periodId: string, options?: RequestOptions): Promise<ProfitPeriodList>;
	/** Close a month that has ended, or re-check a closed one. */
	closeProfitPeriod(periodId: string): Promise<ProfitPeriodClose>;
	/** Internal Finance as CSV or XLSX: the status, the recurring or the one-time costs. */
	exportInternalFinance(query: {
		view: "status" | "recurring" | "one_time";
		from?: string;
		to?: string;
		format: "csv" | "xlsx";
	}): Promise<DownloadedFile>;
	/** P&L by store or by order (EP04-S16). */
	getPnlReport(query: ReportQuery): Promise<PnlReport>;
	/** Delivery margin by carrier, province and city. */
	getCarrierMarginReport(query: ReportQuery): Promise<CarrierMarginReport>;
	/** Unsettled party balances by age, live. */
	getAgingReport(options?: RequestOptions): Promise<AgingReport>;
	/** The entries behind a P&L row. */
	listReportEntries(query: ReportQuery): Promise<ReportEntryList>;
	/** A closed month's snapshot versions, newest first. */
	listReportSnapshots(periodStart?: string, options?: RequestOptions): Promise<ReportSnapshotList>;
	/** A party's statement of record as PDF or CSV. */
	downloadPartyStatement(
		kind: string,
		partyId: string,
		query: { periodStart: string; periodEnd: string; accountId?: string },
		format: "pdf" | "csv",
	): Promise<DownloadedFile>;
	/** Queue a report export. */
	createExportJob(body: ExportJobRequest): Promise<ExportJob>;
	/** The caller's own export jobs. */
	listExportJobs(options?: RequestOptions): Promise<ExportJobList>;
	getExportJob(jobId: string, options?: RequestOptions): Promise<ExportJob>;
	/** A finished export's file, for 24 hours. */
	downloadExportJob(jobId: string): Promise<DownloadedFile>;

	/** In-house driver earnings and their per-driver totals (EP04-S11). */
	listDriverEarnings(query?: ListDriverEarningsQuery): Promise<DriverEarningList>;
	/** A driver's unpaid earnings and open shortfall — a driver reads only their own. */
	getDriverEarningsSummary(
		driverId: string,
		options?: RequestOptions,
	): Promise<DriverEarningsSummary>;
	listDriverShortfalls(query?: ListDriverShortfallsQuery): Promise<DriverShortfallList>;
	/** Writes off what is left of a shortfall (the owner's `finance.write_off.approve`). */
	writeOffDriverShortfall(
		shortfallId: string,
		reason: string,
		idempotencyKey: string,
	): Promise<DriverShortfall>;

	/** Store statements, latest period first (EP04-S15). */
	listStatements(query?: ListStatementsQuery): Promise<BillingStatementList>;
	getStatement(statementId: string, options?: RequestOptions): Promise<BillingStatement>;
	/** A draft's lines as the ledger has them now; a finalized one's as issued. */
	listStatementLines(
		statementId: string,
		options?: RequestOptions & { cursor?: string; limit?: number },
	): Promise<BillingStatementLines>;
	/** Drafts the period's statements; idempotent per store, period and currency. */
	generateStatements(
		body: StatementGenerateRequest,
		idempotencyKey: string,
	): Promise<StatementGenerateResult>;
	/** Finalize (bill, issue, invoice) or approve one statement. */
	transitionStatement(
		statementId: string,
		action: "finalize" | "approve",
		idempotencyKey: string,
	): Promise<BillingStatement>;
	/** The statement's lines as a CSV. */
	downloadStatementCSV(statementId: string): Promise<DownloadedFile>;
	/** Finance's dispute queue: every open line dispute. */
	listStatementDisputes(options?: RequestOptions): Promise<BillingStatementLines>;
	resolveStatementDispute(
		entryId: string,
		note: string,
		idempotencyKey: string,
	): Promise<StatementLine>;
	listInvoices(query?: {
		storeId?: string;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<InvoiceList>;
	getInvoice(invoiceId: string, options?: RequestOptions): Promise<Invoice>;
	downloadInvoicePDF(invoiceId: string): Promise<DownloadedFile>;
	issueCreditNote(
		invoiceId: string,
		body: CreditNoteRequest,
		idempotencyKey: string,
	): Promise<CreditNote>;
	listCreditNotes(options?: RequestOptions): Promise<CreditNoteList>;

	/** Fee schedule versions, newest effective first. */
	listFeeSchedules(query?: ListFeeSchedulesQuery): Promise<FeeScheduleList>;
	/**
	 * Adds a version to a chain.
	 *
	 * Never closes anything: an overlap is a 409 on `effectiveFrom`, and
	 * {@link ApiClient.closeFeeSchedule} is the deliberate act that makes room.
	 */
	createFeeSchedule(body: FeeScheduleDraft, options?: RequestOptions): Promise<FeeSchedule>;
	/** Sets a live version's exclusive end. */
	closeFeeSchedule(
		scheduleId: string,
		body: FeeScheduleCloseRequest,
		options?: RequestOptions,
	): Promise<FeeSchedule>;
	/** What every priced service and basis resolves to, and by which level. */
	getFeeMatrix(query?: FeeMatrixQuery): Promise<FeeMatrix>;
	/** The tax rules, newest effective first. */
	listTaxRules(options?: RequestOptions): Promise<TaxRuleList>;
	/** Defines a tax rule. Rules are created and never edited. */
	createTaxRule(body: TaxRuleDraft, options?: RequestOptions): Promise<TaxRule>;
	/**
	 * What one billable event costs on the day it happened.
	 *
	 * Resolved at `eventDate`, never at now, and the tax comes back as its own
	 * amount — see `lines`, whose fee leg carries the net.
	 */
	priceBillableEvent(body: PriceRequest, options?: RequestOptions): Promise<PriceResult>;

	/** One day's USD→LBP rate; 404 while unpublished (EP04-S04). */
	getFxRate(date: string, options?: RequestOptions): Promise<FxRate>;
	/**
	 * Publishes or corrects a day's rate, and stamps it onto that day's
	 * waiting LBP collections. A rate cash was converted at is `409
	 * fx_rate_in_use`.
	 */
	publishFxRate(date: string, lbpPerUsd: number): Promise<FxRatePublication>;
	listCodCollections(
		query?: ListCodCollectionsQuery,
		options?: RequestOptions,
	): Promise<CodCollectionList>;
	getCodCollection(collectionId: string, options?: RequestOptions): Promise<CodCollection>;
	getCodSummary(options?: RequestOptions): Promise<CodSummary>;
	/**
	 * Starts or refreshes one driver's handover. The answer carries the
	 * six-digit code to show the driver — once; it is never stored.
	 */
	openCodHandover(driverId: string, idempotencyKey: string): Promise<CodHandoverOpened>;
	getCodHandover(handoverId: string, options?: RequestOptions): Promise<CodHandoverDetail>;
	/** The driver's code (Driver App) or a signature the desk records. */
	confirmCodHandover(handoverId: string, body: CodHandoverConfirm): Promise<CodHandover>;
	/** Counts both drawers and decides the handover: closed, or disputed. */
	countCodHandover(
		handoverId: string,
		body: CodHandoverCount,
		idempotencyKey: string,
	): Promise<CodHandover>;
	/** The discrepancy queue (EP04-S05): open by default, newest first. */
	listCodDiscrepancies(
		query?: ListCodDiscrepanciesQuery,
		options?: RequestOptions,
	): Promise<CodDiscrepancyList>;
	/**
	 * Settles a discrepancy and posts its journal. A write-off needs the
	 * owner's `finance.write_off.approve`; a resolution the kind does not
	 * offer is `422 resolution_not_allowed`.
	 */
	resolveCodDiscrepancy(
		discrepancyId: string,
		body: CodDiscrepancyResolve,
	): Promise<CodDiscrepancy>;

	/**
	 * The zones of one site, in one of three views.
	 *
	 * `warehouseId` is required: zones belong to one site, and a tree somebody
	 * adds shelves to cannot be the union of several. All three views come from
	 * one read, so `zones` is always populated and the view only decides whether
	 * `rows` or `tree` comes with it.
	 */
	listZones(query: {
		warehouseId: string;
		view?: ZoneViewName;
		usage?: ZoneUsage;
		signal?: AbortSignal;
	}): Promise<ZoneList>;
	/** Add Zone: a name, a capacity and some notes. The code is derived. */
	createZone(draft: ZoneDraft): Promise<Zone>;
	/**
	 * One store's whole category tree, parents before children.
	 *
	 * `itemCount` is absent rather than zero on every row until EP02-S08's Item
	 * kind exists — "no items" and "we cannot tell you" are different sentences.
	 */
	listCategories(storeId: string, options?: RequestOptions): Promise<CategoryTree>;
	/** Adds a level. At most three deep; a sibling name is unique per parent. */
	createCategory(draft: CategoryDraft): Promise<Category>;
	/** Renames it, reflags it, or archives it. */
	patchCategory(categoryId: string, patch: CategoryPatch): Promise<Category>;
	/** Moves it, with everything under it. */
	reparentCategory(categoryId: string, parentId: string): Promise<Category>;
	/** What it contains, itself and everything under it. */
	getCategoryRollup(categoryId: string, options?: RequestOptions): Promise<CategoryRollup>;
	/** The standard niches, names only. */
	listCategoryNiches(options?: RequestOptions): Promise<CategoryNiche[]>;
	/** One niche with its branches, for the library browser's preview. */
	getCategoryNiche(niche: string, options?: RequestOptions): Promise<CategoryNiche>;
	/** Creates ordinary categories from library branches, skipping what exists. */
	importCategoryLibrary(body: {
		storeId: string;
		niche: string;
		branches: string[];
		parentId?: string;
	}): Promise<CategoryLibraryImportResult>;
	/** Every library category with its full path, for the item form's search (ADJ-M03-2). */
	listCategoryLibraryPaths(options?: RequestOptions): Promise<CategoryLibraryPath[]>;
	/** Makes one library path exist in a store's tree, atomically, and returns it. */
	ensureCategoryLibraryPath(body: {
		storeId: string;
		ref: string;
	}): Promise<CategoryLibraryPathResult>;
	/**
	 * Creates an item and its first sku codes (EP02-S08).
	 *
	 * A sku sent with no `skuCode` is given `{STORE_CODE}-{SERIES}-{n}` from the
	 * store's own counter and becomes the Default; sending no `skus` at all
	 * produces exactly one that way.
	 */
	createItem(draft: ItemDraft, options?: RequestOptions): Promise<ItemDetail>;
	/** One item with its skus and their external aliases. */
	getItem(itemId: string, options?: RequestOptions): Promise<ItemDetail>;
	/** Renames it, files it under a category, changes its owner or archives it. */
	patchItem(itemId: string, patch: ItemPatch): Promise<Item>;
	/** Adds a sku code, typed or scanned. `isDefault` demotes the incumbent. */
	addSku(itemId: string, draft: SkuDraft): Promise<Sku>;
	/** The Items query: one row per sku, carrying its item's fields. */
	listSkus(query: {
		storeId?: string;
		itemId?: string;
		status?: string;
		/** Item name, sku code or barcode. Not a category name or an alias. */
		q?: string;
		/** A node at any level; the filter takes its descendants with it. */
		categoryId?: string;
		stock?: StockFilter;
		item?: ItemsFilter;
		limit?: number;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<SkuPage>;
	/**
	 * The Low Stock page and the Items banner (EP02-S31): every sku in a `low`
	 * or `critical` state, critical first, then scarcest first, with the
	 * scope's counts. A store user must pass its own `storeId`.
	 */
	listLowStock(query: {
		storeId?: string;
		state?: LowStockFilter;
		limit?: number;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<LowStockPage>;
	/** Sets a sku's minimum and answers its re-evaluated low-stock state. */
	putSkuMinStock(skuId: string, minStockThreshold: number): Promise<LowStockStatus>;
	/** EP02-S30: a store's reorder policies, by sku code. */
	listReorderPolicies(query: {
		storeId?: string;
		limit?: number;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<ReorderPolicyPage>;
	/** Upserts a sku's reorder policy; the sku is evaluated at once. */
	putReorderPolicy(skuId: string, draft: ReorderPolicyDraft): Promise<ReorderPolicy>;
	/** The Internal restock queue: pick faces with their live state. */
	listPickFacePolicies(query: {
		warehouseId?: string;
		limit?: number;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<PickFaceStatusPage>;
	/** One pick face; 404 when the location is not one. */
	getPickFacePolicy(locationId: string, options?: RequestOptions): Promise<PickFaceStatus>;
	/** Makes a storage unit a pick face for one sku. */
	putPickFacePolicy(locationId: string, draft: PickFacePolicyDraft): Promise<PickFaceStatus>;
	/** Inbound suggestions, newest first. */
	listReplenishmentSuggestions(query: {
		storeId?: string;
		state?: ReplenishmentSuggestionState;
		limit?: number;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<ReplenishmentSuggestionPage>;
	/** Accepts an open suggestion into a pre-filled ASN. */
	acceptReplenishmentSuggestion(
		id: string,
		body: ReplenishmentAccept,
	): Promise<ReplenishmentSuggestion>;
	/** Dismisses an open suggestion with a reason. */
	dismissReplenishmentSuggestion(id: string, reason: string): Promise<ReplenishmentSuggestion>;
	/** CR-019's what to reorder: the store's 60 days against its target days. */
	getReorderRecommendations(query: {
		storeId: string;
		targetDays?: number;
		signal?: AbortSignal;
	}): Promise<ReorderRecommendationPage>;
	/** The org-wide low-stock heat view. */
	getLowStockReport(options?: RequestOptions): Promise<LowStockReport>;
	/**
	 * Snapshots a cross-page selection.
	 *
	 * The filter, not the ids: "select all 39,989 matching" cannot travel in a
	 * body, and ids captured here go stale the moment somebody else edits a row.
	 */
	createSkuSelection(draft: SkuSelectionDraft): Promise<SkuSelection>;
	/** Approves every pending sku in the set, reporting each row. */
	bulkApproveSkus(request: BulkApproveRequest): Promise<BulkApproveResponse>;
	/**
	 * Resolves a sku code, a barcode or an external alias.
	 *
	 * A code shared by two stores answers `409 code_ambiguous` unless `storeId`
	 * narrows it — handing back an arbitrary merchant's goods for a scan is the
	 * failure the index exists to prevent.
	 */
	lookupSku(code: string, storeId?: string, options?: RequestOptions): Promise<CodeMatch>;
	/**
	 * Every sku a code names (ADJ-1022-7): two sellers may share a barcode, and
	 * a screen with no seller in hand asks which. Each carries `storeName`
	 * when there is more than one. Empty when nothing matches.
	 */
	lookupSkuMatches(
		code: string,
		storeId?: string,
		options?: RequestOptions,
	): Promise<CodeMatchList>;
	/** Changes a sku's codes, cost, threshold, images or status. */
	patchSku(skuId: string, patch: SkuPatch): Promise<Sku>;
	/** Retires a sku. Refused while anything is on hand. */
	archiveSku(skuId: string): Promise<Sku>;
	/**
	 * Deletes a sku for an administrator (ADJ-M02-1): archived and hidden from
	 * every list, the record kept. Refused while anything is on hand.
	 */
	deleteSku(skuId: string): Promise<void>;
	/** Links an external identifier. Unique per (org, source). */
	linkSkuAlias(skuId: string, draft: SkuAliasDraft): Promise<SkuAlias>;
	/** Unlinks one, freeing the code for another sku. */
	unlinkSkuAlias(skuId: string, aliasId: string): Promise<void>;
	/** Approves one pending channel sku (EP02-S10). Idempotent. */
	approveSku(skuId: string): Promise<Sku>;
	/** The cartesian product of up to three axes, with proposed codes. Writes nothing. */
	previewVariations(request: VariationPreviewRequest): Promise<VariationPreview>;
	/** Creates the pruned rows as draft skus, in one transaction. */
	createVariations(itemId: string, request: VariationsCreateRequest): Promise<ItemDetail>;
	/** The standard variation sets, and one store's saved ones. */
	listVariationPresets(storeId?: string, options?: RequestOptions): Promise<VariationPresetList>;
	/** Saves an axis set as a preset for a store. */
	createVariationPreset(draft: VariationPresetDraft): Promise<VariationPreset>;
	/** Deletes a store's saved preset. */
	deleteVariationPreset(presetId: string): Promise<void>;
	/**
	 * The stock explorer (EP02-S12): one row per sku, location and state.
	 *
	 * A level whose quantity has reached zero is not returned — an emptied shelf
	 * is history, and a hundred zero rows would bury the ones with stock in
	 * them. A page can also come back shorter than `limit` with a `nextCursor`
	 * still set, because state and box are filtered after the read.
	 */
	listStockLevels(query: {
		skuId?: string;
		boxId?: string;
		locationId?: string;
		storeId?: string;
		warehouseId?: string;
		state?: StockState;
		limit?: number;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<StockLevelPage>;
	/** Per-SKU totals with `available` derived, never stored. */
	listStockSummary(query: {
		storeId?: string;
		limit?: number;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<SkuStockSummaryPage>;
	/** Where the nightly reconciliation found the ledger and a level disagreeing. */
	listStockDiscrepancies(query: {
		limit?: number;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<StockDiscrepancyPage>;
	/** The movement ledger, newest first. Append-only: there is no edit. */
	listMovements(query: {
		skuId?: string;
		boxId?: string;
		refType?: string;
		refId?: string;
		type?: MovementType;
		actorId?: string;
		storeId?: string;
		warehouseId?: string;
		from?: string;
		to?: string;
		limit?: number;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<StockMovementPage>;
	/**
	 * One SKU's or master box's item history (EP02-S18), newest first. The
	 * filters are the history screen's; a page can be short with a cursor.
	 */
	listItemHistory(
		subject: { kind: "sku" | "box"; id: string },
		query: ItemHistoryQuery & { limit?: number; cursor?: string; signal?: AbortSignal },
	): Promise<ItemHistoryPage>;
	/** The same filtered history as a file. Needs `inventory.history.export`. */
	exportItemHistory(
		subject: { kind: "sku" | "box"; id: string },
		query: ItemHistoryQuery,
		format: "csv" | "xlsx" | "pdf",
	): Promise<DownloadedFile>;
	/** EP02-S24: the Master Boxes list, in box-code order. */
	listMasterBoxes(query: {
		storeId?: string;
		status?: MasterBoxStatus;
		q?: string;
		limit?: number;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<MasterBoxPage>;
	/** One box with its contents resolved, its stock and its discrepancies. */
	getMasterBox(boxId: string, options?: RequestOptions): Promise<MasterBoxDetail>;
	createMasterBox(draft: MasterBoxDraft): Promise<MasterBox>;
	/** The version is the box's; a stale one is a 409. */
	updateMasterBox(boxId: string, patch: MasterBoxPatch, version: number): Promise<MasterBox>;
	replaceMasterBoxContents(
		boxId: string,
		contents: MasterBoxContentLine[],
		version: number,
	): Promise<MasterBox>;
	/** The 4×6 carton label (Code128 + QR), as a PDF. */
	getMasterBoxLabel(boxId: string): Promise<DownloadedFile>;
	listMasterBoxInstances(boxId: string, options?: RequestOptions): Promise<MasterBoxInstancePage>;
	/** Opens N boxes into unit stock, in one linked set. */
	splitMasterBoxes(draft: BoxSplitDraft, idempotencyKey: string): Promise<BoxMoveResult>;
	/** Packs unit stock into N boxes, in one linked set. */
	packMasterBoxes(draft: BoxPackDraft, idempotencyKey: string): Promise<BoxMoveResult>;
	/**
	 * The closed catalogue of reasons a quantity may be edited (EP02-S16).
	 *
	 * A tenant that has catalogued nothing is served the seed rather than an
	 * empty list, and the system-only rows — `order_pick` — are behind
	 * `includeUnselectable`, because a person choosing one would be recording a
	 * fulfilment that never happened.
	 */
	listStockAdjustmentReasons(query?: {
		direction?: StockEditDirection;
		includeUnselectable?: boolean;
		signal?: AbortSignal;
	}): Promise<StockAdjustmentReasonList>;
	/** Catalogues a reason of this tenant's own. Needs `inventory.reason.write`. */
	createStockAdjustmentReason(draft: StockAdjustmentReasonDraft): Promise<StockAdjustmentReason>;
	/**
	 * Changes the mutable half of one: the label, the requirements, the policy
	 * and the two switches. Not the code, the direction or the target state.
	 */
	updateStockAdjustmentReason(
		reasonCode: string,
		patch: StockAdjustmentReasonPatch,
	): Promise<StockAdjustmentReason>;
	/** The reservations board, newest first (EP02-S19). */
	listReservations(query: {
		status?: ReservationStatus;
		storeId?: string;
		skuId?: string;
		orderId?: string;
		limit?: number;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<ReservationPage>;
	/** Returns a reservation's units to available. */
	releaseReservation(id: string): Promise<Reservation>;
	/**
	 * The backorder queue, oldest first, each row ranked under its store's
	 * policy. The rank is derived on read and never stored.
	 */
	listBackorders(query: {
		status?: BackorderStatus;
		storeId?: string;
		skuId?: string;
		orderId?: string;
		limit?: number;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<BackorderPage>;
	/** Bumps a backorder to the front of its queue. Needs `inventory.reservation.manage`. */
	prioritizeBackorder(id: string): Promise<Backorder>;
	/**
	 * The bin-task queue (`active: true`, by priority) or the supervisor board
	 * (every state, newest change first) (EP02-S20).
	 */
	listBinTasks(query: {
		active?: boolean;
		warehouseId?: string;
		limit?: number;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<BinTaskPage>;
	getBinTask(id: string, options?: RequestOptions): Promise<BinTask>;
	/** A supervisor's task. Needs `inventory.stock.adjust`; a pick is refused. */
	createBinTask(draft: BinTaskDraft): Promise<BinTask>;
	/** Claims a task, or renews the caller's 60-second lease — the heartbeat. */
	claimBinTask(id: string): Promise<BinTask>;
	/**
	 * One scan step. A refusal is an `ApiError` (422) whose `details` carry
	 * `expectedLocationId` and `hint` for a `wrong_location`.
	 */
	scanBinTask(id: string, scan: ScanSubmission): Promise<ScanResult>;
	shortBinTask(id: string, body: { reason: string; qty?: number }): Promise<BinTask>;
	skipBinTask(id: string, reason: string): Promise<BinTask>;
	/** The offline queue, replayed per task in device-time order. */
	replayScanEvents(scans: ScanBatchItem[]): Promise<ScanBatchResult>;
	/**
	 * An item's lot, expiry or serial tracking, set on every sku at once
	 * (EP02-S29). Needs `inventory.lot.manage`; a switch to `serial` with stock
	 * is `409 serial_requires_empty`.
	 */
	setItemTracking(itemId: string, draft: ItemTrackingDraft): Promise<ItemTracking>;
	/** Lots with their balances, earliest expiry first. */
	listLots(query: {
		storeId?: string;
		skuId?: string;
		state?: LotState;
		expiringBefore?: string;
		limit?: number;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<LotPage>;
	getLot(lotId: string, options?: RequestOptions): Promise<Lot>;
	/** Holds a lot: nothing more of it is reserved or picked, its free units are quarantined. */
	holdLot(lotId: string, reason: string): Promise<Lot>;
	/** Lifts a hold; the quarantined units go back on hand. */
	releaseLot(lotId: string): Promise<Lot>;
	/** Writes off a held or expired lot's quarantined units. */
	disposeLot(lotId: string, note?: string): Promise<LotDisposal>;
	/** Where the lot is, and every order and dispatch that consumed it. */
	traceLot(lotId: string, options?: RequestOptions): Promise<LotTrace>;
	downloadLotTrace(lotId: string, format: "csv" | "xlsx"): Promise<DownloadedFile>;
	/** Serial numbers: one by its number, or a sku's. */
	listSerialNumbers(query: {
		serialNo?: string;
		skuId?: string;
		storeId?: string;
		limit?: number;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<SerialNumberPage>;
	/** Expired, inside the minimum shelf life, inside the alert window, and the disposal queue. */
	getExpiryReport(query: { storeId?: string; signal?: AbortSignal }): Promise<ExpiryReport>;
	/** Stock take (jarde) campaigns, newest first (EP02-S26). */
	listStockTakes(query: {
		status?: StockTakeStatus;
		warehouseId?: string;
		limit?: number;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<StockTakePage>;
	getStockTake(id: string, options?: RequestOptions): Promise<StockTakeDetail>;
	/** Opens a campaign. `422 empty_scope` names the filters that matched nothing. */
	createStockTake(draft: StockTakeDraft): Promise<StockTake>;
	/** One site's storage units a stock take in progress covers (ADJ-1016-8). */
	listStockTakeActiveUnits(
		warehouseId: string,
		options?: RequestOptions,
	): Promise<StockTakeActiveUnits>;
	/** How many storage units a scope resolves to, by zone and row. Never refuses an empty scope. */
	previewStockTake(
		body: { warehouseId: string; scope?: StockTakeScope },
		options?: RequestOptions,
	): Promise<StockTakePreview>;
	/** Splits a campaign into tasks; the first one starts counting (and a freeze). */
	generateStockTakeTasks(
		id: string,
		tasks: StockTakeTaskDraft[],
	): Promise<{ tasks: StockTakeTask[] }>;
	/** Reassigns a task, or moves its deadline. */
	assignStockTakeTask(
		id: string,
		body: { assigneeEmployeeId: string; dueAt?: string },
	): Promise<StockTakeTask>;
	/** The caller's own stock take tasks, soonest due first (EP02-S27). */
	listMyStockTakeTasks(options?: RequestOptions): Promise<{ tasks: StockTakeTask[] }>;
	/** A task's units in walking order; a blind counter gets no expected quantities. */
	getStockTakeWalk(taskId: string, options?: RequestOptions): Promise<StockTakeWalk>;
	/** Saves a pending unit's lines; `markDone` closes it with them. */
	countStockTakeUnit(
		unitId: string,
		body: { lines: StockTakeCountEntry[]; markDone?: boolean },
		idempotencyKey: string,
	): Promise<StockTakeUnit>;
	/** Closes a unit as counted; without `lines` the saved ones count. */
	markStockTakeUnitDone(
		unitId: string,
		lines: StockTakeCountEntry[] | undefined,
		idempotencyKey: string,
	): Promise<StockTakeUnit>;
	/** Closes a unit as counted and empty. */
	markStockTakeUnitEmpty(unitId: string, idempotencyKey: string): Promise<StockTakeUnit>;
	reopenStockTakeUnit(
		unitId: string,
		reason: string,
		idempotencyKey: string,
	): Promise<StockTakeUnit>;
	/** Hands a task over for review; every unit must be closed. */
	submitStockTakeTask(taskId: string, idempotencyKey: string): Promise<StockTakeTask>;
	getStockTakeProgress(id: string, options?: RequestOptions): Promise<StockTakeProgress>;
	/** When each storage unit holding a sku was last counted. */
	getSkuVerification(skuId: string, options?: RequestOptions): Promise<SkuVerification>;
	/** A campaign's variance lines for review (EP02-S28). */
	listStockTakeVariances(id: string, options?: RequestOptions): Promise<StockTakeVarianceList>;
	/** Accepts (one count correction each) or rejects variance lines. */
	approveStockTakeVariances(
		id: string,
		body: StockTakeApproveRequest,
	): Promise<StockTakeApproveResult>;
	/** Closes a reviewed campaign and lifts its freeze. */
	closeStockTake(id: string): Promise<StockTake>;
	/** Cancels a campaign: no correction is written. */
	cancelStockTake(id: string, reason: string): Promise<StockTake>;
	/** A campaign's verification log, oldest first. */
	getStockTakeLog(
		id: string,
		filter: StockTakeLogFilter,
		options?: RequestOptions,
	): Promise<StockTakeLog>;
	/** The same rows as a file. */
	downloadStockTakeLog(
		id: string,
		filter: StockTakeLogFilter,
		format: "csv" | "xlsx" | "pdf",
	): Promise<DownloadedFile>;
	/** Skus never counted, or not for a while, by zone and store. */
	getVerificationAgeing(query: {
		warehouseId: string;
		storeId?: string;
		olderThanDays?: number;
		signal?: AbortSignal;
	}): Promise<VerificationAgeingReport>;
	/** One store's effective policy: its row, or the defaults with `configured: false`. */
	getAllocationPolicy(storeId: string, options?: RequestOptions): Promise<AllocationPolicy>;
	/** Sets one store's policy whole. Needs `inventory.reservation.manage`. */
	putAllocationPolicy(storeId: string, draft: AllocationPolicyDraft): Promise<AllocationPolicy>;
	/**
	 * One store's stock valuation (EP02-S14): now, or as of a past instant.
	 * Needs `inventory.valuation.read`.
	 */
	getValuation(query: { storeId: string; asOf?: string; signal?: AbortSignal }): Promise<Valuation>;
	/** Schedules a store's change of method for the next period. */
	putValuationPolicy(draft: ValuationPolicyDraft): Promise<ValuationPolicy>;
	/** One store's frozen periods, newest first, without lines. */
	listValuationSnapshots(query: {
		storeId: string;
		limit?: number;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<ValuationSnapshotPage>;
	/**
	 * Freezes a closed period. A second call for the same store and period
	 * returns the original unchanged, so a retry is harmless.
	 */
	createValuationSnapshot(draft: ValuationSnapshotDraft): Promise<ValuationSnapshot>;
	/** Two snapshots side by side, with the per-SKU difference (B minus A). */
	compareValuationSnapshots(query: {
		storeId: string;
		periodA: string;
		periodB: string;
		signal?: AbortSignal;
	}): Promise<ValuationComparison>;
	/**
	 * Everything the stock-edit dialog needs to open.
	 *
	 * One call rather than five: the dialog is useless until it has all of it,
	 * and each half degrades on its own — `servicesKnown: false` means nothing
	 * could say what this site performs, which is a different sentence from
	 * "this site performs nothing".
	 */
	getStockEditContext(query: {
		skuId?: string;
		boxId?: string;
		warehouseId: string;
		storeId?: string;
		signal?: AbortSignal;
	}): Promise<StockEditContext>;
	/**
	 * Adds or deducts a quantity, split across storage units, with a reason.
	 *
	 * `idempotencyKey` is required by the server and required here for the same
	 * reason: each split row derives its own movement key from it as
	 * `<key>#<n>`, so a caller that times out halfway retries the whole
	 * submission and the rows that landed replay rather than posting twice.
	 */
	adjustStock(draft: StockAdjustDraft, idempotencyKey: string): Promise<StockAdjustResult>;
	/**
	 * Clear inventory (ADJ-1017-5): writes the items' stock off under the
	 * reason `cleared`, leaving what orders hold and what is still on its way
	 * in. Each item answers on its own. At most 200; `idempotencyKey` required.
	 */
	clearStock(skuIds: string[], idempotencyKey: string): Promise<StockClearResult>;
	/** Moves existing stock between units without changing the total. */
	allocateStock(draft: StockAllocateDraft, idempotencyKey: string): Promise<StockAllocateResult>;
	/** Marks a quantity damaged. A note and at least one photo are mandatory. */
	markStockDamaged(draft: StockDamageDraft, idempotencyKey: string): Promise<StockAdjustResult>;
	/** Damaged and quarantined stock with its age (EP02-S13), oldest first. */
	listStockExceptions(query: {
		state?: ExceptionState;
		storeId?: string;
		warehouseId?: string;
		signal?: AbortSignal;
	}): Promise<StockExceptionReport>;
	/** Repairs, scraps, returns, releases or expires exception stock. */
	resolveStockException(
		draft: StockResolveDraft,
		idempotencyKey: string,
	): Promise<StockAdjustResult>;
	/** EP02-S17: every row a bulk action would write, valid and blocked. Writes nothing. */
	previewBulkStock(draft: BulkStockDraft): Promise<BulkStockPreview>;
	/** One add or deduct, one reason, every valid row. Needs `inventory.stock.bulk`. */
	bulkAdjustStock(draft: BulkStockDraft, idempotencyKey: string): Promise<StockEditBatchDetail>;
	/** Re-places every object of a selection by a strategy. Needs `inventory.stock.bulk`. */
	bulkAllocateStock(draft: BulkStockDraft, idempotencyKey: string): Promise<StockEditBatchDetail>;
	/** The batch queue, newest first. `pending` is the approval queue. */
	listStockEditBatches(query: {
		status?: StockEditBatchStatus;
		limit?: number;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<StockEditBatchPage>;
	/** One batch and its rows. */
	getStockEditBatch(
		batchId: string,
		options?: { signal?: AbortSignal },
	): Promise<StockEditBatchDetail>;
	/** Approves or rejects a pending batch as a unit. Needs `inventory.stock.approve`. */
	decideStockEditBatch(
		batchId: string,
		decision: "approve" | "reject",
	): Promise<StockEditBatchDetail>;
	/** Undoes an applied batch with compensating movements. Needs `inventory.stock.approve`. */
	reverseStockEditBatch(batchId: string): Promise<StockEditBatchDetail>;
	/** The inbound board (EP02-S15): every ASN and blind receipt, newest first. */
	listReceivingOrders(query: {
		warehouseId?: string;
		storeId?: string;
		status?: ReceivingStatus;
		limit?: number;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<ReceivingOrderPage>;
	/** Announces an inbound, or opens a blind receipt at the dock. */
	announceReceivingOrder(draft: ReceivingOrderDraft): Promise<ReceivingOrder>;
	/** One inbound with its lines and every receipt recorded against it. */
	getReceivingOrder(
		receivingOrderId: string,
		options?: RequestOptions,
	): Promise<ReceivingOrderDetail>;
	/** Moves the inbound along its state machine, or edits its header. `If-Match` is required. */
	updateReceivingOrder(
		receivingOrderId: string,
		patch: ReceivingOrderPatch,
		version: number,
	): Promise<ReceivingOrder>;
	/**
	 * Records what arrived against one or more lines.
	 *
	 * `idempotencyKey` is required: each row derives its own key from it, so a
	 * caller that times out halfway retries the whole submission and the rows
	 * that landed replay rather than posting twice.
	 */
	recordReceipt(
		receivingOrderId: string,
		draft: ReceiptDraft,
		idempotencyKey: string,
	): Promise<ReceiptResult>;
	/** Accepts or rejects the units held on one line. Needs `inventory.stock.approve`. */
	decideOverReceipt(
		receivingOrderId: string,
		decision: OverReceiptDecision,
		idempotencyKey: string,
	): Promise<OverReceiptResult>;
	/** Ranked storage units for putting one sku away at one site. */
	suggestPutaway(query: {
		skuId: string;
		warehouseId: string;
		qty?: number;
		signal?: AbortSignal;
	}): Promise<PutawaySuggestions>;
	/** Moves units from the site's transit into a storage unit. */
	putawayStock(draft: PutawayDraft, idempotencyKey: string): Promise<MovementResult>;
	/** Moves units between storage units, or between sites through transit. */
	transferStock(draft: TransferDraft, idempotencyKey: string): Promise<TransferResult>;
	/** `POST /stock/adjust` with one split row; parks above the threshold. */
	adjustMovement(draft: MovementAdjustDraft, idempotencyKey: string): Promise<StockAdjustResult>;
	/** One sku by id, deleted or not, for naming it (ADJ-M03-5). */
	getSku(skuId: string, options?: RequestOptions): Promise<Sku>;
	/** The chosen skus' barcodes on A4 sticker sheets, each `copies` times. */
	printSkuLabels(skuIds: string[], copies: number): Promise<DownloadedFile>;
	/** What a sku has on its way: its lines on the store's open purchase orders. */
	listSkuInbound(skuId: string, storeId: string, options?: RequestOptions): Promise<SkuInboundList>;
	/** One supplier by id, for naming it. */
	getSupplier(supplierId: string, options?: RequestOptions): Promise<Supplier>;
	/** Suppliers purchase orders are raised against (EP02-S21), by name. */
	listSuppliers(query: {
		active?: boolean;
		storeId?: string;
		limit?: number;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<SupplierPage>;
	createSupplier(draft: SupplierDraft): Promise<Supplier>;
	/** Edits a supplier, or disables it. `If-Match` is required. */
	updateSupplier(supplierId: string, patch: SupplierPatch, version: number): Promise<Supplier>;
	/** The purchase-order board, newest first. */
	listPurchaseOrders(query: {
		warehouseId?: string;
		status?: PurchaseOrderStatus;
		storeId?: string;
		supplierId?: string;
		limit?: number;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<PurchaseOrderPage>;
	/** Raises a purchase order. The key makes a double submit one order. */
	createPurchaseOrder(draft: PurchaseOrderDraft, idempotencyKey: string): Promise<PurchaseOrder>;
	getPurchaseOrder(purchaseOrderId: string, options?: RequestOptions): Promise<PurchaseOrder>;
	/** Edits lines, dates (with a reason) or costs before receipt. `If-Match` is required. */
	updatePurchaseOrder(
		purchaseOrderId: string,
		patch: PurchaseOrderPatch,
		version: number,
	): Promise<PurchaseOrder>;
	confirmPurchaseOrder(purchaseOrderId: string): Promise<PurchaseOrder>;
	markPurchaseOrderShipped(purchaseOrderId: string, shippedAt?: string): Promise<PurchaseOrder>;
	/** Confirms arrival. Needs `inventory.purchase_order.receive`; the key is required. */
	receivePurchaseOrder(
		purchaseOrderId: string,
		draft: PurchaseOrderReceiptDraft,
		idempotencyKey: string,
	): Promise<PurchaseOrder>;
	cancelPurchaseOrder(purchaseOrderId: string, reason: string): Promise<PurchaseOrder>;
	/** The order's append-only log, oldest first. */
	listPurchaseOrderLog(
		purchaseOrderId: string,
		query?: { limit?: number; cursor?: string; signal?: AbortSignal },
	): Promise<PurchaseOrderEventPage>;
	/** The whole log as a file. */
	downloadPurchaseOrderLog(
		purchaseOrderId: string,
		format: "csv" | "xlsx" | "pdf",
	): Promise<DownloadedFile>;
	/** A bundle sku's recipe (EP02-S25); 404 for a sku that is not a bundle. */
	getSkuBundle(skuId: string, options?: RequestOptions): Promise<SkuBundle>;
	/** Every bundle with a recipe, for Catalog → Bundles. */
	listBundles(options?: RequestOptions): Promise<SkuBundleList>;
	/** Makes a sku a bundle or replaces its recipe; `version` is 0 for a new one. */
	putSkuBundle(skuId: string, draft: SkuBundleDraft, version: number): Promise<SkuBundle>;
	/** A bundle's derived availability and the component that limits it. */
	getSkuBundleAvailability(skuId: string, options?: RequestOptions): Promise<SkuBundleAvailability>;
	/** The order with its freight, duty and other costs split over the lines (EP02-S23). */
	getPurchaseOrderCostPreview(
		purchaseOrderId: string,
		options?: RequestOptions,
	): Promise<PurchaseOrder>;
	/**
	 * Closes a sorted order: landed cost, the GRN and its email (EP02-S23). The
	 * key is required; a closed order answers a second close with itself.
	 */
	closePurchaseOrder(
		purchaseOrderId: string,
		extraRecipients: string[],
		idempotencyKey: string,
	): Promise<PurchaseOrder>;
	/** The closed order's GRN as a file. */
	downloadPurchaseOrderGrn(
		purchaseOrderId: string,
		format: "pdf" | "xlsx" | "csv",
	): Promise<DownloadedFile>;
	/** Emails the GRN again, to its recipients and any added. */
	resendPurchaseOrderGrn(
		purchaseOrderId: string,
		extraRecipients: string[],
	): Promise<PurchaseOrder>;
	/**
	 * Opens the order's sorting session, or answers the one already open
	 * (EP02-S22). The first open moves a received order to `sorting`.
	 */
	openSortingSession(
		purchaseOrderId: string,
		draft?: SortingSessionOpenDraft,
	): Promise<SortingSession>;
	/** The inbound services the order's site offers its store (ADJ-1017-2). */
	listPurchaseOrderInboundServices(
		purchaseOrderId: string,
		options?: RequestOptions,
	): Promise<ServiceDefinition[]>;
	getSortingSession(sortingSessionId: string, options?: RequestOptions): Promise<SortingSession>;
	pauseSortingSession(sortingSessionId: string): Promise<SortingSession>;
	resumeSortingSession(sortingSessionId: string): Promise<SortingSession>;
	/** Who sorted what, where — oldest first. */
	listSortingEntries(
		sortingSessionId: string,
		query?: { limit?: number; cursor?: string; signal?: AbortSignal },
	): Promise<SortingEntryPage>;
	/**
	 * Sorts part of one line. The key is required and the caller keeps it
	 * until the line lands, so a scan retried after a timeout is the same line.
	 */
	recordSortingLine(
		sortingSessionId: string,
		draft: SortLineDraft,
		idempotencyKey: string,
	): Promise<SortLineResult>;
	submitSortingSession(sortingSessionId: string): Promise<SortingSession>;
	/** The second person's decision on pending variances. The key is required. */
	approvePurchaseOrderVariances(
		purchaseOrderId: string,
		draft: VarianceDecisionsDraft,
		idempotencyKey: string,
	): Promise<SortingSession>;
	getZone(zoneId: string, options?: RequestOptions): Promise<Zone>;
	/** The version is the node's - see the contract's `Zone.version`. */
	updateZone(zoneId: string, patch: ZonePatch, version: number): Promise<Zone>;
	/**
	 * EP02-S05's Zone Designer read. `zoneId` may be a zone id or the id of the
	 * depth-1 node a zone is, for a zone provisioning seeded with no design.
	 */
	getZoneDesign(zoneId: string, options?: RequestOptions): Promise<ZoneDesign>;
	/** Adds an area, or - with `zoneAreaId` and its version - updates one. */
	saveZoneArea(zoneId: string, draft: ZoneAreaDraft, version?: number): Promise<ZoneArea>;
	/** Adds rows to an area, or updates the ones whose codes it holds. */
	saveZoneRows(zoneAreaId: string, rows: ZoneRowDraft[]): Promise<ZoneRowList>;
	/** Materialises a row's storage units. Idempotent. */
	generateZoneRow(zoneRowId: string): Promise<ZoneRowGenerated>;
	/** The advisory estimate, per zone, area, row and unit. */
	getZoneCapacity(zoneId: string, skuId?: string, options?: RequestOptions): Promise<ZoneCapacity>;
	/** The base currency and the others the tenant accepts, each with its latest rate (call note 1). */
	listCurrencies(options?: RequestOptions): Promise<CurrencyList>;
	setCurrencies(currencies: string[]): Promise<CurrencyList>;
	listCurrencyRates(currency: string, options?: RequestOptions): Promise<CurrencyRateList>;
	/** One day's rate: units of `currency` one base unit buys, × 1,000,000. */
	publishCurrencyRate(currency: string, date: string, rateMicro: number): Promise<CurrencyRate>;
	/** Which items must carry dimensions and weight, by where they came from (owner note 16). */
	getDimensionPolicy(options?: RequestOptions): Promise<DimensionPolicy>;
	putDimensionPolicy(policy: DimensionPolicy): Promise<DimensionPolicy>;
	/** One store's override of the dimension rule: `default`, `required` or `optional`. */
	getStoreDimensionRule(storeId: string, options?: RequestOptions): Promise<StoreDimensionRule>;
	putStoreDimensionRule(storeId: string, rule: StoreDimensionRule): Promise<StoreDimensionRule>;
	/** The four built-in unit kinds, then the tenant's own kinds of bin (owner note 14). */
	listUnitKinds(options?: RequestOptions): Promise<UnitKindList>;
	/** Adds a kind of bin of the tenant's own, or renames one (or a built-in bin) by key. */
	saveUnitKind(name: string, unitKind?: string): Promise<UnitKindDef>;
	/** Stops offering a tenant's own kind; what is already of it keeps it. */
	deleteUnitKind(unitKind: string): Promise<void>;
	/** The five built-in handling equipment, then the tenant's own (owner note 13). */
	listHandlingEquipment(options?: RequestOptions): Promise<HandlingEquipmentList>;
	/** Adds the tenant's own handling equipment, or replaces one when `equipmentId` is given. */
	saveHandlingEquipment(
		draft: HandlingEquipmentDraft,
		equipmentId?: string,
	): Promise<AisleSuggestion>;
	/** Deletes the tenant's own handling equipment; refused while an area uses it. */
	deleteHandlingEquipment(equipmentId: string): Promise<void>;
	/** The five standard storage-unit templates, then the tenant's own. */
	listStorageUnitTemplates(options?: RequestOptions): Promise<StorageUnitTemplateList>;
	/** Creates a template, or clones one with some fields changed. */
	createStorageUnitTemplate(draft: StorageUnitTemplateDraft): Promise<StorageUnitTemplate>;
	/** Takes one of the tenant's own templates out of the library; standard ones are refused. */
	deleteStorageUnitTemplate(templateId: string): Promise<void>;
	/** ADJ-1016-7: a tenant template's SKU-type rule, and optionally its existing units'. */
	setStorageUnitTemplateSkuRule(
		templateId: string,
		rule: StorageUnitTemplateSkuRule,
	): Promise<StorageUnitTemplateSkuRuleResult>;
	/** A warehouse's service prices and the stores they reach (bug list, Stores). */
	getWarehouseServicePrices(
		warehouseId: string,
		options?: RequestOptions,
	): Promise<WarehouseServicePrices>;
	/** Sets a warehouse's price; `keepStoreIds` stay on the old one. */
	scheduleWarehouseServicePrice(
		warehouseId: string,
		rate: StoreServiceRateDraft,
		keepStoreIds: string[],
	): Promise<StoreServiceRate>;
	setWarehouseStorageFee(
		warehouseId: string,
		fee: StorageFeeDraft,
		keepStoreIds: string[],
	): Promise<StorageFee>;
	/** What a store not yet created would pay these carriers for the area it serves. */
	previewDeliveryRates(
		companyIds: string[],
		provinceIds: string[],
		cityIds: string[],
		options?: RequestOptions,
	): Promise<StoreDeliveryRateList>;
	/** Replaces the store's volume-discount tiers (bug list, Stores). */
	setStoreDiscountTiers(storeId: string, tiers: StoreDiscountTier[]): Promise<Store>;
	/** Attaches the store's signed agreement, uploaded first (bug list, Stores). */
	setStoreAgreement(
		storeId: string,
		draft: { attachmentId: string; filename?: string },
	): Promise<Store>;
	removeStoreAgreement(storeId: string): Promise<Store>;
	/** A store's service switches (bug list, Stores). */
	getStoreServiceSwitches(storeId: string, options?: RequestOptions): Promise<StoreServiceSwitches>;
	/** What the store's extra sub-accounts and SKUs would cost if its fees period closed now. */
	getStoreAccountCharges(storeId: string, options?: RequestOptions): Promise<StoreAccountCharges>;
	/**
	 * Sets the codes a store has switched off; `DELIVERY` for no delivery. A
	 * default service mode, when given, is what the store's new orders take
	 * (ADJ-1022-3).
	 */
	setStoreServiceSwitches(
		storeId: string,
		disabledServices: string[],
		defaultServiceMode?: OrderServiceMode,
	): Promise<StoreServiceSwitches>;
	/** The caller's own store's switches, from the Store Portal. */
	getPortalServiceSwitches(options?: RequestOptions): Promise<StoreServiceSwitches>;
	/** The store's packaging: its options, default and own types (bug list, Packaging). */
	getPortalPackaging(options?: RequestOptions): Promise<PackagingOptions>;
	setPortalPackagingDefault(packageTypeId: string): Promise<PackagingOptions>;
	createPortalPackageType(draft: StorePackageTypeDraft): Promise<PackagingOptions>;
	updatePortalPackageType(
		packageTypeId: string,
		patch: StorePackageTypePatch,
	): Promise<PackagingOptions>;
	archivePortalPackageType(packageTypeId: string): Promise<PackagingOptions>;
	receivePortalPackagingStock(packageTypeId: string, quantity: number): Promise<PackagingOptions>;
	setPortalServiceSwitches(disabledServices: string[]): Promise<StoreServiceSwitches>;
	/** Deletes a node with everything under it; refused while a unit holds stock. */
	deleteLocation(locationId: string): Promise<void>;
	/** Deletes a zone with its areas, rows, folders and units. */
	deleteZone(zoneId: string): Promise<void>;
	/** Deletes an area with its rows and units; the others keep their codes. */
	deleteZoneArea(zoneId: string, zoneAreaId: string): Promise<void>;
	/** Deletes a row of a zone's design with its units; refused while one holds stock. */
	deleteZoneRow(zoneRowId: string): Promise<void>;
	/**
	 * Deletes level `level` (1 from the floor) of an area with its rows and
	 * their units; the levels above move down a number.
	 */
	deleteZoneAreaLevel(zoneAreaId: string, level: number): Promise<void>;
	/** EP02-S06's gallery: the five standard zone templates, then the tenant's own. */
	listZoneTemplates(usage?: ZoneUsage, options?: RequestOptions): Promise<ZoneTemplateList>;
	/** Saves a zone's current design as a zone template of the tenant's own. */
	saveZoneTemplate(draft: ZoneTemplateDraft): Promise<ZoneTemplate>;
	/**
	 * Adds a template's areas and rows to a zone, never touching what it has.
	 * `idempotencyKey` is required: a retry replays rather than adding twice.
	 */
	applyZoneTemplate(
		zoneId: string,
		body: ZoneTemplateApply,
		idempotencyKey: string,
	): Promise<ZoneTemplateApplied>;
	/** The layout map's model. `zoneId` may be the zone's node id. */
	getZoneLayout(zoneId: string, options?: RequestOptions): Promise<ZoneLayout>;
	/** The map rendered by the server, for download. */
	downloadZoneLayout(
		zoneId: string,
		format: "svg" | "png" | "pdf",
		query: { legend: ZoneMapLegend; stockTakeId?: string; level?: number; layer?: number },
	): Promise<DownloadedFile>;
	/**
	 * Deletes every active city at once, without removing any of them.
	 *
	 * `confirm` is the literal string `DELETE` and `expectedCount` is the
	 * number the person was shown. Both are guards rather than parameters: the
	 * first is about intent, the second about staleness, and a mismatch on the
	 * second is `409 city_count_changed` with nothing written.
	 */
	deleteAllCities(request: CityDeleteAllRequest): Promise<CityDeleteAllResult>;

	/** The packaging materials catalog, ordered by code (EP06-S01). */
	listPackagingMaterials(query?: ListPackagingMaterialsQuery): Promise<PackagingMaterialPage>;
	getPackagingMaterial(materialId: string, options?: RequestOptions): Promise<PackagingMaterial>;
	createPackagingMaterial(draft: PackagingMaterialDraft): Promise<PackagingMaterial>;
	/** `version` is the one the form was rendered from; it travels as `If-Match`. */
	updatePackagingMaterial(
		materialId: string,
		patch: PackagingMaterialPatch,
		version: number,
	): Promise<PackagingMaterial>;
	/** `409 referenced_by_active_package_types` names the types in `blocking`. */
	archivePackagingMaterial(materialId: string): Promise<PackagingMaterialArchiveResult>;
	getPackagingMaterialCostHistory(
		materialId: string,
		options?: RequestOptions,
	): Promise<PackagingCostHistory>;

	/** Package types, ordered by code; the first read seeds the Bag (EP06-S02). */
	listPackageTypes(query?: ListPackageTypesQuery): Promise<PackageTypePage>;
	getPackageType(packageTypeId: string, options?: RequestOptions): Promise<PackageType>;
	createPackageType(draft: PackageTypeDraft): Promise<PackageType>;
	/** `version` is the one the form was rendered from; it travels as `If-Match`. */
	updatePackageType(
		packageTypeId: string,
		patch: PackageTypePatch,
		version: number,
	): Promise<PackageType>;
	/** `422 default_must_be_free` when the type has a price per item. */
	setDefaultPackageType(packageTypeId: string): Promise<PackageType>;
	/** `409 is_default` for the default; `409 referenced_by_active_rules` names the rules in `blocking`. */
	archivePackageType(packageTypeId: string): Promise<PackageType>;
	/** The empty state's "Create the Bag": idempotent, answers the default. */
	seedDefaultPackageType(): Promise<PackageType>;

	/** The stores offered a package type, with overrides and default flags (EP06-S03). */
	listPackageTypeStores(
		packageTypeId: string,
		options?: RequestOptions,
	): Promise<PackageTypeStoreList>;
	/**
	 * Offer a type to a store or change its terms (versions the row). `version`
	 * is the store's packaging-settings version, sent as `If-Match` (`0` before
	 * its first change).
	 */
	putPackageTypeStore(
		packageTypeId: string,
		storeId: string,
		body: PackageTypeStorePut,
		version: number,
	): Promise<PackagingOptions>;
	/** Stop offering a type to a store; `409 is_store_default` for its default. */
	deletePackageTypeStore(
		packageTypeId: string,
		storeId: string,
		version: number,
	): Promise<PackagingOptions>;
	/** A store's resolved packaging options — EP-07 intake and the Store Portal read this. */
	getStorePackagingOptions(storeId: string, options?: RequestOptions): Promise<PackagingOptions>;
	/** Set the store's default type; `422 type_not_offered` when it is not offered. */
	putStorePackagingDefault(
		storeId: string,
		packageTypeId: string,
		version: number,
	): Promise<PackagingOptions>;
	/** The store's bag choice: the client's own bags, or Khazzin bags at a price. */
	putStorePackagingBag(
		storeId: string,
		body: StoreBagSupplyPut,
		version: number,
	): Promise<PackagingOptions>;

	/**
	 * The selection rules, store-scoped first then by ascending priority
	 * (EP06-S04). Not paged: the resolver evaluates the whole set on every
	 * question, and a second, paged code path could disagree with it.
	 */
	listPackagingRules(options?: RequestOptions): Promise<PackagingRuleList>;
	/** `409 priority_taken`; `422 package_type_not_active` or `band_inverted`. */
	createPackagingRule(draft: PackagingRuleDraft): Promise<PackagingRule>;
	/** Every field is replaced. `version` is the one the drawer read, sent as `If-Match`. */
	updatePackagingRule(
		ruleId: string,
		draft: PackagingRuleDraft,
		version: number,
	): Promise<PackagingRule>;
	/**
	 * Renumber one scope's rules as 10, 20, 30… in the order given — what the
	 * table's drag handle commits. The ids must name **every** rule of the
	 * scope, or the ones left out keep priorities from the old numbering.
	 */
	reorderPackagingRules(body: PackagingRuleReorder): Promise<PackagingRuleList>;
	/**
	 * Resolve the package type for a content. **Advisory** (`07/04` §11): v1
	 * does not capture a package's dimensions, so a deviation is visible
	 * rather than prevented. A POST because the content's volume, weight and
	 * category belong in a body; it writes nothing.
	 */
	selectPackageType(
		body: PackageSelectRequest,
		options?: RequestOptions,
	): Promise<PackageSelection>;

	/** Packaging stock with policy, alert, velocity and days of cover (EP06-S08). */
	listPackagingStock(query?: { alert?: string; signal?: AbortSignal }): Promise<PackagingStockPage>;
	/** A material's reorder policy; `version` is the row's `policyVersion` (`0` before the first). */
	putPackagingStockPolicy(
		materialId: string,
		body: PackagingStockPolicyPut,
		version: number,
	): Promise<PackagingStockRow>;
	/**
	 * A receipt, adjustment, write-off or transfer. `idempotencyKey` is
	 * required by the server; a repeated `sourceRef` replays the first.
	 */
	appendPackagingStockMovement(
		draft: PackagingStockMovementDraft,
		idempotencyKey: string,
	): Promise<PackagingStockMovementResult>;
	/** The movement ledger, newest first: every material's, or one's with `materialId`. */
	listPackagingStockMovements(
		query?: ListPackagingStockMovementsQuery,
	): Promise<PackagingStockMovementPage>;
	/** The replenishment queue (EP06-S09); `state` defaults to `active` (open and ordered). */
	listPackagingReplenishments(query?: {
		state?: string;
		overdue?: boolean;
		signal?: AbortSignal;
	}): Promise<PackagingReplenishmentPage>;
	/** Mark an open replenishment ordered with its purchase order. */
	orderPackagingReplenishment(
		replenishmentId: string,
		body: PackagingReplenishmentOrder,
	): Promise<PackagingReplenishment>;
	/** Dismiss an open or ordered replenishment; the reason is required. */
	dismissPackagingReplenishment(
		replenishmentId: string,
		reason: string,
	): Promise<PackagingReplenishment>;

	/**
	 * The packaging consumption log, newest first (EP06-S05). Recording one is
	 * EP-07's session finish, in process — the UI never posts a consumption.
	 */
	listPackagingConsumptions(
		query?: ListPackagingConsumptionsQuery,
	): Promise<PackagingConsumptionPage>;
	getPackagingConsumption(
		consumptionId: string,
		options?: RequestOptions,
	): Promise<PackagingConsumption>;

	/**
	 * Packaging billing (EP06-S07). Charges are posted, voided and waived by the
	 * server's consumers; a person sets a store's price and rerates a charge
	 * nobody could price.
	 */
	getStorePackagingPrice(
		storeId: string,
		options?: RequestOptions,
	): Promise<StorePackagingPriceList>;
	/** Open a new pricing row; the open one closes where it starts. Answers the store's rows. */
	putStorePackagingPrice(
		storeId: string,
		draft: StorePackagingPriceDraft,
	): Promise<StorePackagingPriceList>;
	listPackagingCharges(query?: ListPackagingChargesQuery): Promise<PackagingChargePage>;
	reratePackagingCharge(chargeId: string): Promise<PackagingChargeRerate>;
	getPackagingMarginReport(query: PackagingMarginReportQuery): Promise<PackagingMarginReport>;
	/** The Consumption tab's KPIs and utilization by type (EP06-S10). */
	getPackagingOverview(query: PackagingOverviewQuery): Promise<PackagingOverview>;
	/** One metric's daily rows over a range, scoped to the caller (EP13-S01). */
	getAnalyticsMetric(query: MetricQuery): Promise<MetricSeries>;
	/** A live metric's intraday counters for today (EP13-S01). */
	getAnalyticsLiveMetric(query: LiveMetricQuery): Promise<MetricSeries>;
	/** One Sales & Revenue block with its previous period, scoped to the caller (EP13-S10). */
	getAnalyticsSales(block: SalesBlock, query: SalesQuery): Promise<SalesBreakdown>;
	/** One Customer & Returns block, scoped to the caller (EP13-S16). */
	getAnalyticsCustomers(block: CustomersBlock, query: CustomersQuery): Promise<CustomersBreakdown>;
	/** The returns and inspections strip (EP13-S16). */
	getAnalyticsReturnsInspections(query: CustomersQuery): Promise<ReturnsInspections>;
	/** Every store's Store Performance row, ranked by revenue; operators only (EP13-S11). */
	listStorePerformance(query: StorePerformanceQuery): Promise<StorePerformanceList>;
	/** One store's scorecard; a store user's own only, portal-safe (EP13-S11). */
	getStoreScorecard(storeId: string, query: StorePerformanceQuery): Promise<StoreScorecard>;
	/** One store's orders and fulfillment rate per day (EP13-S11). */
	getStoreTrend(storeId: string, query: StorePerformanceQuery): Promise<StoreTrend>;
	/** One store's scorecard as a file, for an account review (EP13-S11). */
	downloadStoreScorecard(
		storeId: string,
		query: { from: string; to: string },
		format?: "csv" | "xlsx",
	): Promise<DownloadedFile>;
	/** One Delivery KPIs read, scoped to the caller: a store sees no driver, a driver itself (EP13-S08). */
	getDeliveryKpi<R extends DeliveryKpiRead>(
		read: R,
		query: DeliveryKpiQuery,
	): Promise<DeliveryKpiResults[R]>;
	/** One Fulfillment & Warehouse Ops read (EP13-S07); a store reads `sla` for its own stores only. */
	getFulfillment<R extends FulfillmentRead>(
		read: R,
		query: FulfillmentQuery,
	): Promise<FulfillmentResults[R]>;
	/** One employee performance read (EP13-S06); operators with `analytics.employee_performance.read` only. */
	getWorkforce<R extends WorkforceRead>(
		read: R,
		query: WorkforceQuery,
	): Promise<WorkforceResults[R]>;
	/** Finance & Cashflow (EP13-S12, admin-only): revenue, cost and margin per currency over a range. */
	getFinanceSummary(query: FinanceRangeQuery): Promise<FinanceSummary>;
	/** The same figures per economic day. */
	getFinanceTrend(query: FinanceRangeQuery): Promise<FinanceTrend>;
	/** Where COD sits, one panel per currency. */
	getFinanceCodWaterfall(query: FinanceRangeQuery): Promise<FinanceCodWaterfall>;
	/** Every store's, carrier's and driver's balance now. */
	listFinanceBalances(query?: FinancePartyQuery): Promise<FinanceBalances>;
	/** The next settlement per party kind; never binding. */
	getFinanceForecast(query?: FinancePartyQuery): Promise<FinanceForecast>;
	/** Issued store statements meeting the range (EP13-S13); a store user reads its own. */
	getFinanceStatementReport(query: FinanceReportQuery): Promise<FinanceStatementReport>;
	/** Delivery margin grouped by company, store, province or city (`analytics.margin.read`). */
	getFinanceMarginReport(query: FinanceMarginQuery): Promise<FinanceMarginReport>;
	/** Each party's COD over the range. */
	getFinanceCodPosition(query: FinanceReportQuery): Promise<FinanceCodPositionReport>;
	/** The payout runs cut off in the range, with each party's gross, deductions and net. */
	getFinancePayoutRunReport(query: FinanceReportQuery): Promise<FinancePayoutRunReport>;
	/** A report row's entries: `drillQuery` is the row's own query string, passed as is. */
	listFinanceReportEntries(
		drillQuery: string,
		options?: RequestOptions,
	): Promise<FinanceReportEntries>;
	/** The Executive Overview of a month or a quarter (EP13-S17, operator-only). */
	getAnalyticsExecutive(query: ExecutiveQuery): Promise<ExecutiveOverview>;
	/** The targets a period's tiles use: its own and, for a month, its quarter's. */
	listKpiTargets(period: string, options?: RequestOptions): Promise<KpiTargetList>;
	/** Set a north-star KPI's target; `version` travels as `If-Match` (0 for a new one), stale is 409. */
	putKpiTarget(
		metricKey: ExecutiveKpiKey,
		body: KpiTargetInput,
		version: number,
	): Promise<KpiTarget>;
	/** Export a block, tab or exporter: `ready` at up to 1,000 rows, else `queued` (EP13-S18). */
	createAnalyticsExport(body: AnalyticsExportRequest): Promise<AnalyticsExport>;
	/** The caller's newest exports and the scheduled files sent to them. */
	listAnalyticsExports(options?: RequestOptions): Promise<AnalyticsExportList>;
	getAnalyticsExport(exportId: string, options?: RequestOptions): Promise<AnalyticsExport>;
	/** A 15-minute signed link to a ready export's file (audited). */
	getAnalyticsExportDownloadUrl(exportId: string): Promise<AnalyticsExportDownload>;
	/** The caller's scheduled reports and metric alerts (EP13-S18). */
	listAnalyticsSchedules(options?: RequestOptions): Promise<AnalyticsScheduleList>;
	createAnalyticsSchedule(body: AnalyticsScheduleInput): Promise<AnalyticsSchedule>;
	/** Replace a schedule's settings; `version` travels as `If-Match`, stale is 409. */
	updateAnalyticsSchedule(
		scheduleId: string,
		body: AnalyticsScheduleInput,
		version: number,
	): Promise<AnalyticsSchedule>;
	deleteAnalyticsSchedule(scheduleId: string): Promise<void>;
	/** Send a report schedule's last complete period now. */
	runAnalyticsSchedule(scheduleId: string): Promise<AnalyticsSchedule>;
	/** The 50 newest read-model rebuild runs (EP13-S02). */
	listAnalyticsRebuilds(options?: RequestOptions): Promise<AggregateRebuildList>;
	/** Queue a backfill of closed days; `409 rebuild_in_progress` while another runs (EP13-S02). */
	requestAnalyticsRebuild(body: RequestAnalyticsRebuild): Promise<AggregateRebuild>;
	/** Each metric's latest drift finding (EP13-S02). */
	getAnalyticsReconciliation(options?: RequestOptions): Promise<AnalyticsReconciliation>;
	/** The dashboard catalog for the caller's interface (EP13-S03). */
	listAnalyticsDashboards(options?: RequestOptions): Promise<AnalyticsDashboardList>;
	/** The metric dictionary for the caller's visibility, by key (EP13-S03). */
	listAnalyticsMetricDefinitions(options?: RequestOptions): Promise<MetricDefinitionList>;
	/** One metric definition; `404` for a key the caller may not see (EP13-S03). */
	getAnalyticsMetricDefinition(key: string, options?: RequestOptions): Promise<MetricDefinition>;
	/** The projects the caller can see, by name; archived ones only when asked (EP15-S01). */
	listProjects(query?: { includeArchived?: boolean; signal?: AbortSignal }): Promise<ProjectList>;
	getProject(projectId: string, options?: RequestOptions): Promise<Project>;
	/** `409 prefix_taken` lands on `keyPrefix`. */
	createProject(draft: ProjectDraft): Promise<Project>;
	/** `version` travels as `If-Match`; `409 prefix_frozen` or `project_archived`. */
	updateProject(projectId: string, patch: ProjectPatch, version: number): Promise<Project>;
	/** The create dialog's live key-prefix hint. */
	getProjectKeyPrefixAvailability(
		prefix: string,
		options?: RequestOptions,
	): Promise<ProjectKeyPrefixAvailability>;
	/** The Inventory Health tiles; occupancy is null for a store user (EP13-S14). */
	getInventoryHealthSummary(query?: InventoryHealthQuery): Promise<InventoryHealthSummary>;
	/** One node's occupancy per unit kind, its children and its 90-day trend; operators only (EP13-S14). */
	getInventoryOccupancy(query?: InventoryOccupancyQuery): Promise<InventoryOccupancy>;
	/** Held units and value by age bucket (EP13-S14). */
	getInventoryAging(query?: InventoryHealthQuery): Promise<InventoryAging>;
	/** Dead and slow skus (EP13-S14). */
	listInventoryDeadStock(query?: InventoryDeadStockQuery): Promise<InventoryDeadStock>;
	/** Turnover's integer components over 90 days, in all and per store (EP13-S14). */
	getInventoryTurnover(query?: InventoryHealthQuery): Promise<InventoryTurnoverReport>;
	/** A project's members, active first (EP15-S02); any project role may read. */
	listProjectMembers(projectId: string, options?: RequestOptions): Promise<ProjectMemberList>;
	/** `201` added, `200` already a member (the row as it is); `422 member_not_employee`. */
	addProjectMember(projectId: string, draft: ProjectMemberDraft): Promise<ProjectMember>;
	/** `409 last_admin` when it would leave the project with no admin. */
	changeProjectMemberRole(
		projectId: string,
		employeeId: string,
		role: ProjectRole,
	): Promise<ProjectMember>;
	/** The row is kept inactive; `409 last_admin` for the last admin. */
	removeProjectMember(projectId: string, employeeId: string): Promise<void>;
	/** A project's tasks, newest key first, with the caller's role (EP15-S03). */
	listProjectTasks(projectId: string, query?: ProjectTasksQuery): Promise<TaskList>;
	/** Files a task; the key is issued in the same transaction (EP15-S03). */
	createTask(projectId: string, draft: TaskDraft): Promise<Task>;
	/** By key or a former key; `movedTo` names the current key after a move. */
	getTask(key: string, options?: RequestOptions): Promise<Task>;
	/** `version` travels as `If-Match`; a `status` is a transition with its 422 guards. */
	updateTask(key: string, patch: TaskPatch, version: number): Promise<Task>;
	/** Soft delete; project admins only. */
	deleteTask(key: string): Promise<void>;
	/** To another project under a new key; the old one keeps resolving. */
	moveTask(key: string, projectId: string): Promise<Task>;
	/** The task's trail, newest first. */
	listTaskActivity(key: string, options?: RequestOptions): Promise<TaskActivityList>;
	/** The org pool, plus a project's own labels when one is named. */
	listTaskLabels(query?: { projectId?: string; signal?: AbortSignal }): Promise<TaskLabelList>;
	createTaskLabel(draft: TaskLabelDraft): Promise<TaskLabel>;
	/** The org default workflow, in order. */
	getTaskWorkflow(options?: RequestOptions): Promise<TaskWorkflow>;
	/** Replaces the ordered checklist at `version` (EP15-S04); ticks are stamped by the server. */
	replaceTaskChecklist(key: string, write: TaskChecklistWrite, version: number): Promise<Task>;
	/** Links a record by its id or number; `422 link_target_not_found` when the org has none. */
	addTaskLink(key: string, draft: TaskLinkDraft): Promise<Task>;
	removeTaskLink(key: string, linkId: string): Promise<void>;
	/** `201` new, `200` already there; `422 dependency_cycle` carries the path in `blocking`. */
	addTaskDependency(key: string, draft: TaskDependencyDraft): Promise<TaskDependency>;
	removeTaskDependency(key: string, dependencyId: string): Promise<void>;
	/** Names a file uploaded as `task_attachment` (owner: the task) on the task's trail. */
	attachTaskFile(key: string, attachmentId: string): Promise<Attachment>;
	removeTaskFile(key: string, attachmentId: string): Promise<void>;
	/** A project's milestones with progress, by due date (EP15-S14). */
	listMilestones(projectId: string, options?: RequestOptions): Promise<MilestoneList>;
	createMilestone(projectId: string, draft: MilestoneDraft): Promise<Milestone>;
	/** One milestone with its linked tasks. */
	getMilestone(milestoneId: string, options?: RequestOptions): Promise<Milestone>;
	/** `422 milestone_open_tasks` unless `confirmOpenTasks`; `invalid_transition`. */
	updateMilestone(milestoneId: string, patch: MilestonePatch): Promise<Milestone>;
	/** A project's releases with progress, soonest target first (EP15-S14). */
	listReleases(projectId: string, options?: RequestOptions): Promise<ReleaseList>;
	/** `409 version_taken` for a version the project already has. */
	createRelease(projectId: string, draft: ReleaseDraft): Promise<Release>;
	getRelease(releaseId: string, options?: RequestOptions): Promise<Release>;
	/** Start, cancel or edit; a shipped release takes note corrections only. */
	updateRelease(releaseId: string, patch: ReleasePatch): Promise<Release>;
	/** `422 ship_decision_required` names the undecided tasks in `blocking`. */
	shipRelease(releaseId: string, ship: ReleaseShip): Promise<Release>;
	/** One lane per visible project; `projectIds` narrows it. */
	getRoadmap(query?: { projectIds?: string[]; signal?: AbortSignal }): Promise<Roadmap>;
	/** A project's ideas, best RICE first (EP15-S15). */
	listIdeas(projectId: string, options?: RequestOptions): Promise<IdeaList>;
	/** Any role in the project, or anybody when its intake is open. */
	submitIdea(projectId: string, draft: IdeaDraft): Promise<Idea>;
	/** Also for its submitter outside the project. */
	getIdea(ideaId: string, options?: RequestOptions): Promise<Idea>;
	/** Triage: RICE inputs, review, decline (with a reason), merge. */
	updateIdea(ideaId: string, patch: IdeaPatch): Promise<Idea>;
	/** Casts the caller's vote, or retracts it. */
	voteIdea(ideaId: string): Promise<Idea>;
	/** `422 promote_task_required` without `taskKey` or `createTask`. */
	promoteIdea(ideaId: string, promotion: IdeaPromotion): Promise<Idea>;
	listIdeaComments(ideaId: string, options?: RequestOptions): Promise<IdeaCommentList>;
	addIdeaComment(ideaId: string, bodyMd: string): Promise<IdeaComment>;
	/** The projects the caller may submit an idea to. */
	listIdeaIntake(options?: RequestOptions): Promise<IdeaIntakeList>;
	/** A project's task templates (EP15-S13); archived ones only when asked for. */
	listTaskTemplates(
		projectId: string,
		query?: { includeArchived?: boolean; signal?: AbortSignal },
	): Promise<TaskTemplateList>;
	/** Project admins only; at most 100 live per project. */
	createTaskTemplate(projectId: string, draft: TaskTemplateDraft): Promise<TaskTemplate>;
	getTaskTemplate(templateId: string, options?: RequestOptions): Promise<TaskTemplate>;
	/** Edit, archive or restore; project admins only. */
	updateTaskTemplate(templateId: string, patch: TaskTemplatePatch): Promise<TaskTemplate>;
	/** The task, its checklist and subtasks in one go; answers with the parent. */
	instantiateTaskTemplate(templateId: string, instance: TaskTemplateInstance): Promise<Task>;
	/** A project's recurring rules; project admins only. */
	listRecurringRules(projectId: string, options?: RequestOptions): Promise<RecurringRuleList>;
	createRecurringRule(projectId: string, draft: RecurringRuleDraft): Promise<RecurringRule>;
	/** Edit, pause (`enabled: false`) or resume. */
	updateRecurringRule(ruleId: string, patch: RecurringRulePatch): Promise<RecurringRule>;
	/** Tasks due in a window and the unscheduled tray (EP15-S09); a drag is `updateTask`. */
	getTaskCalendar(projectId: string, query: TaskWindowQuery): Promise<TaskCalendar>;
	/** The Gantt in a window: bars, `blocks` edges, milestones (EP15-S09). */
	getTaskTimeline(projectId: string, query: TaskWindowQuery): Promise<TaskTimeline>;
	/** A project's boards, oldest first, with the caller's role (EP15-S07). */
	listProjectBoards(projectId: string, options?: RequestOptions): Promise<BoardList>;
	/** A board with the default columns; project admins only. The first becomes the default. */
	createBoard(projectId: string, name: string): Promise<Board>;
	/** Name, filter, swimlane, WIP mode, or `isDefault: true`. */
	updateBoard(boardId: string, patch: BoardPatch): Promise<Board>;
	/** The lens only; no task is touched. */
	deleteBoard(boardId: string): Promise<void>;
	/** The whole column set; `422 unmapped_statuses` lists orphans in `blocking`. */
	replaceBoardColumns(boardId: string, columns: BoardColumnInput[]): Promise<Board>;
	/** Cards by column in rank order, each with its swimlane. */
	listBoardCards(
		boardId: string,
		options?: RequestOptions & { filterId?: string; sprintId?: string },
	): Promise<BoardCards>;
	/** A structured query across the projects the caller can see; grouped rollups and a cursor (EP15-S08). */
	searchTasks(search: TaskSearch, options?: RequestOptions): Promise<TaskSearchPage>;
	/** One change to many tasks, each through its own patch; partial success (EP15-S08). */
	bulkEditTasks(edit: TaskBulkEdit): Promise<TaskBulkResult>;
	/** The caller's personal filters and the shared ones of the projects they can see. */
	listTaskFilters(query?: { projectId?: string; signal?: AbortSignal }): Promise<TaskFilterList>;
	createTaskFilter(draft: TaskFilterDraft): Promise<TaskFilter>;
	updateTaskFilter(filterId: string, patch: TaskFilterPatch): Promise<TaskFilter>;
	deleteTaskFilter(filterId: string): Promise<void>;
	/** Rename, recolour or soft-disable a label (EP15-S08). */
	updateTaskLabel(labelId: string, patch: TaskLabelPatch): Promise<TaskLabel>;
	/** A drop: rank only within a column, a transition across; `409 wip_limit_exceeded` / `version_conflict`. */
	moveBoardCard(boardId: string, move: BoardMove): Promise<BoardMoveResult>;
	/** A project's sprints in date order, with the caller's role (EP15-S11). */
	listProjectSprints(projectId: string, options?: RequestOptions): Promise<SprintList>;
	/** A planned sprint; `422 sprint_dates_invalid` when the end is not after the start. */
	createSprint(projectId: string, draft: SprintDraft): Promise<Sprint>;
	/** Name, goal, dates, capacity; a finished sprint takes its retro notes only. */
	updateSprint(sprintId: string, patch: SprintPatch): Promise<Sprint>;
	/** Snapshots the commitment; `409 sprint_already_active`. */
	startSprint(sprintId: string): Promise<Sprint>;
	/** `422 rollover_decision_required` names the undecided tasks in `blocking`. */
	completeSprint(sprintId: string, completion: SprintCompletion): Promise<SprintCompleted>;
	/** Its tasks return to the top of the backlog. */
	cancelSprint(sprintId: string): Promise<Sprint>;
	/** The ranked backlog, the open sprints with their tasks, the rolling velocity. */
	getProjectBacklog(projectId: string, options?: RequestOptions): Promise<ProjectBacklog>;
	/** Writes the moved task's rank only. */
	reorderBacklog(projectId: string, move: BacklogReorder): Promise<BacklogReorderResult>;
	/** Into a sprint, or `""` back to the backlog; `422 estimate_required` / `sprint_closed`. */
	setTaskSprint(key: string, sprintId: string, expectedVersion?: number): Promise<Task>;
	/** The latest completed sprints and the rolling velocity. */
	getProjectVelocity(projectId: string, options?: RequestOptions): Promise<ProjectVelocity>;
	/** A project's automation rules, oldest first; project_admin (EP15-S12). */
	listProjectAutomations(projectId: string, options?: RequestOptions): Promise<AutomationList>;
	/** `422 automation_invalid` names the offending entry in `field`; `409 automation_quota`. */
	createAutomation(projectId: string, draft: AutomationDraft): Promise<Automation>;
	/** Edit, enable or disable a rule. */
	updateAutomation(automationId: string, patch: AutomationPatch): Promise<Automation>;
	deleteAutomation(automationId: string): Promise<void>;
	/** The latest runs, newest first; `result` narrows to one. */
	listAutomationRuns(
		automationId: string,
		options?: RequestOptions & { result?: AutomationRunResult },
	): Promise<AutomationRunList>;
	/** A saved rule against the current tasks, writing nothing. */
	testAutomation(automationId: string): Promise<AutomationDryRun>;
	/** A rule the builder has not saved, against the current tasks. */
	previewAutomation(projectId: string, draft: AutomationDraft): Promise<AutomationDryRun>;
	/** A sprint's burndown; no `sprintId` is the active sprint (EP15-S16). */
	getProjectBurndown(
		projectId: string,
		sprintId?: string,
		options?: RequestOptions,
	): Promise<Burndown>;
	/** Tasks done per week, each once, in the week of its final done. */
	getProjectThroughput(
		projectId: string,
		weeks?: number,
		options?: RequestOptions,
	): Promise<Throughput>;
	/** Median and p85 cycle and lead time, by label; under 5 samples `insufficientData`. */
	getProjectCycleTime(
		projectId: string,
		weeks?: number,
		options?: RequestOptions,
	): Promise<CycleTime>;
	/** Open and overdue tasks by age, live. */
	getProjectOverdue(projectId: string, options?: RequestOptions): Promise<OverdueSummary>;
	/** The default board's columns against their WIP limits, live. */
	getProjectWip(projectId: string, options?: RequestOptions): Promise<WipSummary>;
	/** Re-rolls past days' snapshots; `422 metrics_range_invalid`. Admins only. */
	recomputeProjectMetrics(projectId: string, from: string, to: string): Promise<MetricsRecomputed>;
	/** The active sprint by assignee with yesterday's and today's activity, blockers pinned. */
	getProjectStandup(
		projectId: string,
		sprintId?: string,
		options?: RequestOptions,
	): Promise<Standup>;
	/** Burndown, committed vs completed, scope added and carry-over. */
	getSprintReport(sprintId: string, options?: RequestOptions): Promise<SprintReport>;
	/** Sets or clears the assignee (EP15-S06); `""` clears; `422 assignee_not_member`. */
	assignTask(key: string, assigneeEmployeeId: string): Promise<Task>;
	/** Starts or stops watching; no `employeeId` is the caller (EP15-S06). */
	watchTask(key: string, watching: boolean, employeeId?: string): Promise<Task>;
	/** The comment thread, oldest first; a deleted comment is a stub (EP15-S06). */
	listTaskComments(key: string, options?: RequestOptions): Promise<TaskCommentList>;
	/** `422 mention_not_member` names the first mentioned non-member. */
	addTaskComment(key: string, draft: TaskCommentDraft): Promise<TaskComment>;
	/** The author only (`403 comment_author_only`). */
	editTaskComment(commentId: string, edit: TaskCommentEdit): Promise<TaskComment>;
	/** Soft delete: the author or a project admin. */
	deleteTaskComment(commentId: string): Promise<void>;
	/** The caller's work across projects; `recent` are keys they opened lately (EP15-S10). */
	getMyWork(query?: { recent?: string[]; signal?: AbortSignal }): Promise<MyWork>;
	/** Logs the caller's minutes; `422 timelog_task_closed` on a task closed too long ago. */
	logTaskTime(key: string, draft: TimeLogDraft): Promise<TimeLog>;
	/** By task, or by project or person over a window of at most 93 days. */
	listTimeLogs(query: TimeLogsQuery): Promise<TimeLogList>;
	/** The author or a project admin (`403 timelog_owner_only`). */
	updateTimeLog(timeLogId: string, patch: TimeLogPatch): Promise<TimeLog>;
	deleteTimeLog(timeLogId: string): Promise<void>;
	/** Load against capacity; named rows for admins, anonymous bars for the rest. */
	getWorkload(query: WorkloadQuery): Promise<Workload>;
	/** Live stock on hand, reserved and available (EP13-S15). */
	getInventoryReportSoh(query?: InventorySohQuery): Promise<InventorySohPage>;
	/** Units per sku by age bucket, from the snapshot (EP13-S15). */
	getInventoryReportAging(query?: InventorySnapshotReportQuery): Promise<InventoryAgingReport>;
	/** Declared value per sku and totals per currency (EP13-S15). */
	getInventoryReportValuation(
		query?: InventorySnapshotReportQuery,
	): Promise<InventoryValuationReport>;
	/** The movement ledger; over 93 days is `400 range_too_large` (EP13-S15). */
	getInventoryReportMovements(
		query?: InventoryMovementsReportQuery,
	): Promise<InventoryMovementReport>;
	/** An order's consumptions and totals over the recorded ones; `version` is the bag adjustment's `If-Match`. */
	getOrderPackaging(orderId: string, options?: RequestOptions): Promise<OrderPackaging>;
	/** Set the order's extra bag revenue; `version` is the order packaging version (`0` before the first). */
	putOrderBagAdjustment(
		orderId: string,
		body: OrderBagAdjustmentPut,
		version: number,
	): Promise<OrderPackaging>;
	/** Remove the order's extra bag revenue. */
	deleteOrderBagAdjustment(orderId: string, version: number): Promise<OrderPackaging>;
	/** Return cases, newest first (EP08-S01). A page may be short: some filters are re-checked on the rows. */
	listReturnCases(query?: ListReturnCasesQuery): Promise<ReturnCasePage>;
	/** The five stage counts, always in pipeline order. */
	getReturnsPipeline(query?: { storeId?: string; signal?: AbortSignal }): Promise<ReturnPipeline>;
	/**
	 * The board (EP08-S02): five columns, each with the stage's whole count and
	 * its newest few cases. No row filters - those belong to the table view.
	 */
	getReturnsBoard(query?: {
		storeId?: string;
		limit?: number;
		signal?: AbortSignal;
	}): Promise<ReturnBoard>;
	/** One case with its lines. */
	getReturnCase(returnId: string, options?: RequestOptions): Promise<ReturnCaseDetail>;
	/** Raise a case against lines of an order. `idempotencyKey` is required by the server. */
	createReturnCase(draft: ReturnCaseDraft, idempotencyKey: string): Promise<ReturnCaseDetail>;
	/**
	 * Resolve a scanned order label or item barcode (EP08-S03).
	 *
	 * A code that resolves to nothing answers `200` with `kind: "unknown"` —
	 * **not** a `404` — so the caller reads `match.kind` rather than catching.
	 * A location or licence-plate barcode is the one refusal: `422
	 * wrong_barcode_kind`.
	 */
	resolveReturnScan(body: ReturnScanRequest, options?: RequestOptions): Promise<ReturnScanMatch>;
	/** Edit notes, weight, channel number or (before inspection) reason; `version` is sent as `If-Match`. */
	updateReturnCase(
		returnId: string,
		patch: ReturnCasePatch,
		version: number,
	): Promise<ReturnCaseDetail>;
	/** Cancel a case that has not been received. */
	cancelReturnCase(returnId: string, reason?: string): Promise<ReturnCaseDetail>;
	/** The parcel is here (EP08-S05): To Receive becomes To Inspect; a second is `409 already_received`. */
	receiveReturnCase(returnId: string, idempotencyKey: string): Promise<ReturnCaseDetail>;
	/** Mark received, per case: what could not be is listed with its reason. */
	bulkReceiveReturnCases(returnIds: string[]): Promise<ReturnBulkReceiveResult>;
	/** A parcel with no case: a flagged case at To Inspect with no order. */
	receiveUnexpectedParcel(
		draft: ReturnUnexpectedDraft,
		idempotencyKey: string,
	): Promise<ReturnCaseDetail>;
	/** Set or clear a case's assignees (a manager's); `null` clears a slot, absent leaves it. */
	assignReturnCase(
		returnId: string,
		body: ReturnAssign,
		version: number,
	): Promise<ReturnCaseDetail>;
	/** One employee (or nobody) in one slot of a selection. */
	bulkAssignReturnCases(body: ReturnBulkAssign): Promise<ReturnBulkAssignResult>;
	/** Count and grade lines of a received case (EP08-S06). */
	inspectReturnCase(
		returnId: string,
		body: ReturnInspect,
		idempotencyKey: string,
	): Promise<ReturnCaseDetail>;
	/** A manager's answer to a flagged line. */
	resolveReturnDiscrepancy(
		returnId: string,
		body: ReturnResolveDiscrepancy,
	): Promise<ReturnCaseDetail>;
	/** Bind an unexpected parcel to an order and give it lines. */
	reconcileReturnCase(returnId: string, body: ReturnReconcile): Promise<ReturnCaseDetail>;
	listReturnInspections(returnId: string, options?: RequestOptions): Promise<ReturnInspectionList>;
	/** Restock, hold, dispose of or send back inspected lines (EP08-S07). */
	disposeReturnLines(
		returnId: string,
		body: ReturnDispose,
		idempotencyKey: string,
	): Promise<ReturnCaseDetail>;
	listReturnDispositions(
		returnId: string,
		options?: RequestOptions,
	): Promise<ReturnDispositionList>;
	getStoreReturnPolicy(storeId: string, options?: RequestOptions): Promise<ReturnPolicy>;
	setStoreReturnPolicy(storeId: string, policy: ReturnPolicy): Promise<ReturnPolicy>;
	/** Record a refund or store credit against a RETURN case (EP08-S11). */
	recordReturnRefund(returnId: string, body: RefundDraft, idempotencyKey: string): Promise<Refund>;
	/** Void a pending or posted refund, with a reason. */
	voidRefund(refundId: string, reason: string): Promise<Refund>;
	/** An order's refunds, newest first, voided ones included. */
	listOrderRefunds(orderId: string, options?: RequestOptions): Promise<RefundList>;
	/** Create the replacement order of an inspected EXCHANGE case (EP08-S12). */
	createReturnExchange(
		returnId: string,
		body: ReturnExchangeDraft,
		idempotencyKey: string,
	): Promise<ReturnExchange>;
	/** A case's values, net difference, fees, refunds and their postings. */
	getReturnFinance(returnId: string, options?: RequestOptions): Promise<ReturnCaseFinance>;
	/** An order's return cases, oldest first, cancelled ones included (EP08-S13). */
	listOrderReturns(orderId: string, options?: RequestOptions): Promise<ReturnCasePage>;
	/** One row per SKU and store of the selected cases' restockable units (EP08-S08). */
	previewReturnRestock(body: ReturnRestockPreviewRequest): Promise<ReturnRestockPreview>;
	/** Restock the selected cases where the allocations say. */
	commitReturnRestock(
		body: ReturnRestockBatch,
		idempotencyKey: string,
	): Promise<ReturnRestockBatchResult>;
	/**
	 * Return sessions (EP08-S10): the caller's own, or — with
	 * `sessions.read_all` and `scope: "all"` — every session of a status.
	 */
	listReturnSessions(query?: {
		scope?: "mine" | "all";
		status?: ReturnSessionStatus;
		signal?: AbortSignal;
	}): Promise<ReturnSessionList>;
	/** The Active Sessions panel: every open session for a manager, one's own otherwise. */
	listActiveReturnSessions(options?: RequestOptions): Promise<ReturnSessionList>;
	getReturnSession(sessionId: string, options?: RequestOptions): Promise<ReturnSessionDetail>;
	/** Open the caller's session, on their work session. */
	openReturnSession(): Promise<ReturnSessionDetail>;
	/** Pull received cases into a session: all of them, or none. */
	addReturnSessionCases(sessionId: string, returnIds: string[]): Promise<ReturnSessionDetail>;
	releaseReturnSessionCase(sessionId: string, returnId: string): Promise<ReturnSessionDetail>;
	/** `force` is a manager's, and stamps the duration to the last activity. */
	closeReturnSession(sessionId: string, force?: boolean): Promise<ReturnSessionDetail>;
	takeOverReturnSession(sessionId: string): Promise<ReturnSessionDetail>;
	/**
	 * The Orders page (EP07-S04): a page of rows, the two tab counts, the
	 * footer's total and the Selected Total. A page can be shorter than
	 * `limit` — some filters are re-checked on the rows — and still carry a
	 * `nextCursor`.
	 */
	listOrders(query?: ListOrdersQuery): Promise<OrderListPage>;
	/** Resolve a scanned order label to its order; an unknown code is a 404. */
	resolveOrderScan(code: string, options?: RequestOptions): Promise<OrderScanMatch>;
	/** The caller's open orders on track, at risk and breached, per store (EP07-S22). */
	getOrderPromiseSummary(options?: RequestOptions): Promise<OrderPromiseSummary>;

	/**
	 * The end recipients, most recently ordered first (EP07-S02). The phone is
	 * masked unless the caller holds `pii.view_unmasked`; `phoneMasked` says
	 * which was returned.
	 */
	listCustomers(query?: ListCustomersQuery): Promise<CustomerPage>;
	/** One customer with phones, addresses, consent and recent orders. A merged id answers with the survivor. */
	getCustomer(customerId: string, options?: RequestOptions): Promise<CustomerDetail>;
	/** Edit a customer; `addresses` replaces the saved set and `version` travels as `If-Match`. */
	updateCustomer(
		customerId: string,
		patch: CustomerPatch,
		version: number,
	): Promise<CustomerDetail>;
	/** Pin or override the COD risk level, blocklist included. A reason is required. */
	setCustomerRisk(
		customerId: string,
		body: CustomerRiskUpdate,
		version: number,
	): Promise<CustomerDetail>;
	/** Fold two records into one; the merged id then redirects to the survivor. */
	mergeCustomers(body: CustomerMerge): Promise<CustomerMergeResult>;
	/** The risk and blocklist history, newest first. */
	listCustomerRiskEvents(
		customerId: string,
		query?: { cursor?: string; limit?: number; signal?: AbortSignal },
	): Promise<CustomerRiskEventPage>;
	/**
	 * Create an order through the one intake contract (EP07-S03).
	 *
	 * `idempotencyKey` is required by the server. A repeat under the same
	 * channel reference answers `duplicate: true` with the order it already
	 * created rather than a conflict, so the caller reads `result.duplicate`
	 * instead of catching an error.
	 */
	createOrder(draft: OrderDraft, idempotencyKey: string): Promise<OrderIntakeResult>;
	/** The New Order form's SKU picker for one store: live availability and the pre-filled price. */
	searchStoreCatalogSkus(
		storeId: string,
		query?: { q?: string; limit?: number; signal?: AbortSignal },
	): Promise<OrderCatalogSkuPage>;
	/** One order with its lines and the moves it can take now (EP07-S01). */
	getOrder(orderId: string, options?: RequestOptions): Promise<Order>;
	/** Move an order along the transition table; `version` travels as `If-Match`. */
	transitionOrder(orderId: string, body: OrderTransition, version: number): Promise<Order>;
	/** The org owner sets an order to any status (ADJ-1016-2); `version` travels as `If-Match`. */
	overrideOrderStatus(orderId: string, body: OrderStatusOverride, version: number): Promise<Order>;
	/**
	 * Cancel a set of an order's items (EP08-S04).
	 *
	 * What it does depends on where the goods are — the answer's `consequence`
	 * says which of the four happened, and `returnId` names the case when one
	 * was opened. `version` travels as `If-Match`; `idempotencyKey` is
	 * required by the server.
	 */
	cancelOrderLines(
		orderId: string,
		body: OrderCancelLines,
		version: number,
		idempotencyKey: string,
	): Promise<OrderCancelLinesResult>;
	/**
	 * One of an order's five logs, newest first (EP07-S07).
	 *
	 * `edits` is operator-only and needs `orders.logs.edits`; without
	 * `pii.view_unmasked` its personal values are masked and the field names
	 * stay.
	 */
	getOrderLog(
		orderId: string,
		log: OrderLogName,
		query?: { cursor?: string; limit?: number; signal?: AbortSignal },
	): Promise<OrderLogPage>;
	/** The five tab badges, in one read. */
	getOrderLogCounts(orderId: string, options?: RequestOptions): Promise<OrderLogCounts>;

	/**
	 * Change an order's fields, under `07/01` §3.6's guard table (EP07-S14).
	 *
	 * `version` travels as `If-Match`. One blocked field refuses the whole
	 * patch; the refusal names every one of them.
	 */
	editOrder(orderId: string, patch: OrderPatch, version: number): Promise<Order>;
	/**
	 * The A6 label PDF for a selection of orders (EP07-S11).
	 *
	 * Answers the bytes rather than a link: somebody pressing Print Labels
	 * wants a print dialog, not a download that opens a page offering one.
	 */
	printOrderLabels(orderIds: string[], locale?: LabelLocale): Promise<DownloadedFile>;
	/**
	 * Apply one action to a selection (EP07-S17).
	 *
	 * Answers `200` with its refusals in the body: seven orders moved and
	 * three did not is a successful call whose result has three rows in it.
	 * Each rejection carries the refusal the single-order endpoint would
	 * have given, because it is the same refusal from the same code.
	 */
	bulkUpdateOrderStatus(body: OrderBulkStatus): Promise<OrderBulkResult>;
	/**
	 * The org owner's Update status over a selection (ADJ-1017-3): every
	 * order to one status, `unchanged` listing the ones already there.
	 * Anybody else is `403 owner_only`. `idempotencyKey` is required.
	 */
	bulkOverrideOrderStatus(
		body: OrderBulkStatusOverride,
		idempotencyKey: string,
	): Promise<OrderBulkResult>;
	/** Record the same contact attempt across a selection. */
	bulkSetOrderContact(body: OrderBulkContact): Promise<OrderBulkResult>;
	/** Give a selection a new delivery date. */
	bulkRescheduleOrders(body: OrderBulkReschedule): Promise<OrderBulkResult>;
	/** Lock a selection to one employee (CR-014). */
	bulkAssignOrders(body: OrderBulkAssign): Promise<OrderBulkResult>;
	/** Give one driver to each selected order's open shipment (ADJ-M03-3). */
	bulkAssignOrderDrivers(body: OrderBulkAssignDriver): Promise<OrderBulkResult>;
	/** Take a selection of closed orders off the list, or put them back. */
	bulkArchiveOrders(body: OrderBulkArchive): Promise<OrderBulkResult>;
	/** Stop a selection, or release it. A reason holds; none releases. */
	bulkHoldOrders(body: OrderBulkHold): Promise<OrderBulkResult>;
	/** Show a selection in the public API, or hide it (ADJ-B02-3). */
	bulkSetOrderApiVisibility(body: OrderBulkApiVisibility): Promise<OrderBulkResult>;
	/**
	 * The External Import queue — channel orders waiting for approval, and
	 * the exception queue when `hasErrors` is true (EP07-S25).
	 *
	 * The store and the status are what an index serves; the source and the
	 * error filter are re-checked over that page, so a page may come back
	 * shorter than `limit` with a cursor still set.
	 */
	listExternalImports(query: {
		storeId?: string;
		channel?: OrderChannel;
		status?: ExternalImportStatus;
		hasErrors?: boolean;
		from?: string;
		to?: string;
		limit?: number;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<ExternalImportPage>;
	/** Approve staged rows into real orders. Per row, like every batch here. */
	importExternalOrders(ids: string[]): Promise<ExternalImportReport>;
	/** Throw staged rows away. Soft: the row keeps its payload. */
	deleteExternalImports(ids: string[]): Promise<ExternalImportReport>;
	/** Correct a staged row and revalidate it — the exception queue's drawer. */
	fixExternalImport(importId: string, fix: ExternalImportFix): Promise<ExternalImportRow>;
	/** Take back an import while its order is still `pending`. */
	revertExternalImport(importId: string): Promise<ExternalImportRow>;
	/** The channel's own submission, as it arrived. Operator only. */
	getExternalImportPayload(importId: string): Promise<unknown>;
	/** The intake log: one row per dedupe key, whatever became of it. */
	listIntakeRecords(query: {
		storeId?: string;
		channel?: OrderChannel;
		limit?: number;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<IntakeRecordPage>;
	/**
	 * Cancel a whole order (EP07-S15).
	 *
	 * The stage is derived from where the goods are, never sent. A store
	 * principal is refused past `pending`; `khazzinMistake` needs
	 * `orders.mistake.write` and a reason.
	 */
	cancelOrder(orderId: string, body: OrderCancel, version: number): Promise<OrderCancelLinesResult>;
	/** Take a closed order out of the default list. A view, not a deletion. */
	archiveOrder(orderId: string): Promise<Order>;
	/** Put an archived order back on the list. */
	unarchiveOrder(orderId: string): Promise<Order>;
	/**
	 * Start a handover for one delivery company (EP07-S13).
	 *
	 * Nothing is pre-selected silently: the client proposes the company from
	 * the auto-assignment of the orders it is about to scan.
	 */
	openHandover(body: HandoverOpen): Promise<Handover>;
	/** Every handover still being scanned into, newest first. */
	listOpenHandovers(options?: RequestOptions): Promise<{ items: Handover[] }>;
	/** One handover, its manifest, and what is still on the bench. */
	getHandover(handoverId: string, options?: RequestOptions): Promise<HandoverDetail>;
	/**
	 * Put one parcel on the manifest.
	 *
	 * A wrong-company scan answers `409 wrong_company` with `canOverride`; a
	 * manager re-sends it with `overrideReason`.
	 */
	scanOrderOntoHandover(handoverId: string, body: HandoverScan): Promise<HandoverOrder>;
	/**
	 * Hand the parcels over: price every lane, move every order, freeze the
	 * two delivery amounts. One unpriced lane refuses the whole close.
	 */
	closeHandover(handoverId: string, body: HandoverClose): Promise<HandoverDetail>;
	/** Abandon a handover before anybody signed. Nothing moved, so nothing moves back. */
	cancelHandover(handoverId: string, reason: string): Promise<Handover>;
	/**
	 * Record an attempt to reach the customer (EP07-S16).
	 *
	 * `version` travels as `If-Match`. Attempts count manual values only, and
	 * a `rescheduleTo` on a failed or rescheduled order moves the order too.
	 */
	contactOrder(orderId: string, body: OrderContact, version: number): Promise<Order>;
	/** A contact note that touches neither the chip nor the count. */
	addOrderContactNote(orderId: string, body: OrderContactNote): Promise<void>;
	/** EP12-S09's stamp for a message that went out by itself. */
	stampAutomaticContact(orderId: string, body: OrderAutoContactStamp): Promise<Order>;
	/** Put an order on hold. A flag, never a status. */
	/** An order's P&L, operator-only (EP07-S19). */
	getOrderCosting(orderId: string, options?: RequestOptions): Promise<OrderCosting>;
	/** Rebuild an estimated snapshot at today's rates. */
	recomputeOrderCosting(orderId: string): Promise<OrderCosting>;
	/** What the store is billed for an order: revenue lines only. */
	getOrderCharges(orderId: string, options?: RequestOptions): Promise<OrderCharges>;
	/** Link a correction to a snapshot; above the threshold it waits for a second person. */
	createCostingAdjustment(
		body: CostAdjustmentDraft,
		idempotencyKey: string,
	): Promise<CostAdjustment>;
	/** The second person posts a pending adjustment. */
	approveCostingAdjustment(adjustmentId: string): Promise<CostAdjustment>;
	/** Profitability of the orders placed in a period. */
	getCostingSummary(query: CostingSummaryQuery): Promise<CostingSummary>;
	holdOrder(orderId: string, body: OrderHold): Promise<Order>;
	/** Lift an order's hold. */
	releaseOrder(orderId: string): Promise<Order>;
	/** Show an order in the public API (ADJ-B02-3). */
	showOrderInApi(orderId: string): Promise<Order>;
	/** Take an order out of the public API. */
	hideOrderFromApi(orderId: string): Promise<Order>;
	/** Take a pending order back out of the warehouse. */
	withdrawOrder(orderId: string): Promise<Order>;
	/** The order's status trail, oldest first. */
	listOrderStatusEvents(
		orderId: string,
		query?: { cursor?: string; limit?: number; signal?: AbortSignal },
	): Promise<OrderStatusEventPage>;
	/**
	 * Run or re-run allocation for one order (EP07-S08). Idempotent: the
	 * reservation key is derived from the order, so a re-run replays the lines
	 * that landed and re-attempts the ones that did not.
	 */
	allocateOrder(orderId: string): Promise<OrderAllocationResult>;

	/** Every reservation an order's lines hold, with their shelves (EP07-S06). */
	orderAllocations(orderId: string, options?: RequestOptions): Promise<OrderAllocationPanel>;

	/**
	 * Open a fulfillment session over a set of pending orders (EP07-S09).
	 *
	 * One transaction: the stock leaves its shelves, every order moves to
	 * `fulfilling`, and the session is written. An order that cannot join
	 * refuses the whole open with `409 orders_not_ready`, whose body carries a
	 * reason per order — read it off `ApiError.body`.
	 */
	openFulfillmentSession(
		body: FulfillmentSessionOpen,
		idempotencyKey: string,
	): Promise<FulfillmentSessionDetail>;
	/** What an open of these orders would do. Nothing is picked and nothing moves. */
	checkFulfillmentReadiness(
		body: FulfillmentSessionOpen,
		options?: RequestOptions,
	): Promise<FulfillmentReadiness>;
	/** One session with its pick rows and its orders, for its owner or a manager. */
	getFulfillmentSession(
		sessionId: string,
		options?: RequestOptions,
	): Promise<FulfillmentSessionDetail>;
	/** The zone and area of every shelf on a session's walk (owner note 7). */
	getFulfillmentSessionPlaces(sessionId: string, options?: RequestOptions): Promise<PickPlaceList>;
	/** The sessions still being worked: own for an employee, all for a manager. */
	listFulfillmentSessions(options?: RequestOptions): Promise<FulfillmentSessionPage>;
	/**
	 * End a session and put every unit back (EP07-S12).
	 *
	 * The session's owner or a warehouse manager. One already closed is
	 * refused with `409 session_closed` rather than replayed: its stock is
	 * back, and doing it again would invent units.
	 */
	cancelFulfillmentSession(
		sessionId: string,
		body: FulfillmentSessionCancel,
	): Promise<FulfillmentSession>;
	/** Take one order back out of a live session. A manager's alone. */
	removeOrderFromFulfillmentSession(
		sessionId: string,
		orderId: string,
	): Promise<FulfillmentSession>;
	/**
	 * Hand a live session to another employee (review-01 D10). A manager's
	 * alone; what was picked so far stays credited to whoever picked it.
	 */
	reassignFulfillmentSession(
		sessionId: string,
		body: FulfillmentSessionReassign,
	): Promise<FulfillmentSession>;

	/**
	 * Count one scanned unit against a session's pick list (EP07-S10).
	 *
	 * Idempotent by `clientScanId`, so an offline queue replaying itself
	 * counts once — the second delivery answers `replay: true`.
	 */
	scanFulfillmentItem(sessionId: string, body: FulfillmentScan): Promise<FulfillmentScanResult>;
	/**
	 * Move a session one step on: picking to labels (every row full but for
	 * orders marked can't-complete), labels to packing.
	 */
	advanceFulfillmentSession(sessionId: string): Promise<FulfillmentSessionDetail>;
	/** Move a session one step back: labels to picking, packing to labels. */
	backFulfillmentSession(sessionId: string): Promise<FulfillmentSessionDetail>;
	/** Mark one order of a session as one that cannot be completed, with why. */
	markFulfillmentOrderCantComplete(
		sessionId: string,
		orderId: string,
		reason: string,
	): Promise<FulfillmentSessionDetail>;
	/** Take a can't-complete mark off an order. */
	resumeFulfillmentOrder(sessionId: string, orderId: string): Promise<FulfillmentSessionDetail>;
	/** Confirm a cancelled order's units are back on their shelves (ADJ-1022-2). */
	confirmFulfillmentPutBack(sessionId: string, orderId: string): Promise<FulfillmentSessionDetail>;
	/**
	 * A session By cart's box scan (ADJ-1022-5): counts the unit in hand into
	 * its order's box; another box is `422 wrong_box`.
	 */
	placeFulfillmentItem(
		sessionId: string,
		body: FulfillmentPlaceItem,
	): Promise<FulfillmentScanResult>;
	/** Gives an order that does not fit its box the cart's lowest free box. */
	addFulfillmentOrderBox(sessionId: string, orderId: string): Promise<FulfillmentSessionDetail>;
	/** Warehouses → Carts: the tenant's carts, and the code a new one is offered. */
	listFulfillmentCarts(options?: RequestOptions): Promise<FulfillmentCartList>;
	/** Defines a cart, or changes one when `cartId` is given (its code stays). */
	saveFulfillmentCart(draft: FulfillmentCartDraft, cartId?: string): Promise<FulfillmentCart>;
	/** The cart's label and one per box, as a PDF. */
	getFulfillmentCartLabels(cartId: string): Promise<DownloadedFile>;
	/** Adjust stock: a shelf holds fewer units than the session expects (ADJ-1022-2). */
	shortPickFulfillmentRow(
		sessionId: string,
		body: FulfillmentShortPick,
	): Promise<FulfillmentShortPickResult>;

	/**
	 * Scan an order label to select it for packing (EP07-S11).
	 *
	 * Exactly one order of a session is selected at a time; a label from
	 * another session is refused naming that session.
	 */
	selectFulfillmentOrder(
		sessionId: string,
		body: FulfillmentOrderScan,
	): Promise<FulfillmentSessionDetail>;
	/** Scan one item into the order being packed. Only into the selection. */
	packFulfillmentItem(
		sessionId: string,
		orderId: string,
		body: FulfillmentScan,
	): Promise<FulfillmentPackResult>;
	/** Mark one order packed and verified. Every item must be scanned in. */
	completeFulfillmentOrder(sessionId: string, orderId: string): Promise<FulfillmentSessionDetail>;
	/**
	 * Weigh a parcel against what it should weigh (EP07-S21). Outside
	 * tolerance it answers 409 `weight_mismatch` carrying the expected,
	 * measured and tolerance grams; a warehouse manager resends with an
	 * `overrideReason`.
	 */
	weighFulfillmentOrder(
		sessionId: string,
		orderId: string,
		body: FulfillmentWeigh,
	): Promise<FulfillmentWeighResult>;
	/** Photograph a parcel before sealing: one JPEG or PNG of at most 5 MB. */
	uploadFulfillmentPackPhoto(
		sessionId: string,
		orderId: string,
		file: Blob,
		filename?: string,
	): Promise<FulfillmentPackPhotoResult>;
	/** The order's newest pack photo, with a link signed for five minutes. */
	getOrderPackPhoto(orderId: string, options?: RequestOptions): Promise<PackPhoto>;
	/**
	 * End a session with its orders fulfilled (EP07-S12).
	 *
	 * Every live order must be `completed`; the refusal names the ones that
	 * are not. The orders stage straight on to `ready_for_pickup`.
	 */
	finishFulfillmentSession(sessionId: string): Promise<FulfillmentFinishResult>;
	/** The shelves a reservation is bound to and the ones it could move to. */
	listAllocationAlternatives(
		reservationId: string,
		options?: RequestOptions,
	): Promise<AllocationAlternatives>;
	/** Move an allocated reservation to another Location, in one transaction. */
	resourceAllocation(reservationId: string, body: AllocationResource): Promise<Reservation>;
	/** The active store's orders waiting on stock, the one that has waited longest first (EP10-S04). */
	listMissingStockOrders(query?: {
		limit?: number;
		cursor?: string;
		signal?: AbortSignal;
	}): Promise<MissingStockPage>;
	/**
	 * Reverse a recorded consumption for a repack or a cancellation (EP06-S06).
	 * `idempotencyKey` is required by the server; a second reversal of the same
	 * record answers the reversal it already has.
	 */
	reversePackagingConsumption(
		consumptionId: string,
		body: PackagingConsumptionReverse,
		idempotencyKey: string,
	): Promise<PackagingConsumptionReversal>;
	/** The Driver App's day: a snapshot without a cursor, the rows changed since one with it (EP10-S15). */
	syncPull(body: SyncPullRequest, options?: RequestOptions): Promise<SyncPullResult>;
	/** Up to 50 queued commands, applied in order; one result each. */
	syncPush(deviceId: string, mutations: SyncMutationInput[]): Promise<SyncPushResult>;
	/** What to collect for a partial delivery of these lines; records nothing (EP10-S17). */
	quoteShipmentCollectible(
		shipmentId: string,
		acceptedLines: AcceptedLine[],
	): Promise<CollectibleQuote>;
	/** Texts the recipient a code for this delivery; never answers the code (EP03-S17, EP10-S18). */
	sendShipmentOtp(shipmentId: string): Promise<OtpStatus>;
	/** Matches the recipient's code server-side; the fifth wrong one locks it. */
	verifyShipmentOtp(shipmentId: string, code: string): Promise<OtpStatus>;
	/** Register or update this install and its push token. */
	registerDevice(body: DeviceRegistrationDraft): Promise<DeviceRegistration>;
	/** Unregister this install, on sign-out. */
	unregisterDevice(deviceId: string): Promise<void>;
	/**
	 * Driver App commands waiting for a dispatcher (`status` defaults to
	 * `conflict`); `resolved` is every decided one, newest decision first.
	 */
	listSyncConflicts(query?: {
		status?: SyncConflict["status"] | "resolved";
		signal?: AbortSignal;
	}): Promise<SyncConflictList>;
	/** Apply, discard or re-target a conflicted command. */
	resolveSyncConflict(key: string, body: SyncConflictResolve): Promise<SyncConflict>;
	/** Carrier pushes for unknown orders (EP03-S23); `open` by default. */
	listCarrierDeadLetters(query?: {
		status?: CarrierDeadLetter["status"];
		signal?: AbortSignal;
	}): Promise<CarrierDeadLetterList>;
	/** Sends a parked push again, as the key that sent it. */
	replayCarrierDeadLetter(id: string): Promise<CarrierDeadLetter>;
	/** Closes a parked push nobody will replay. */
	dismissCarrierDeadLetter(id: string, body: { note?: string }): Promise<CarrierDeadLetter>;
	/** Opens the live stream (EP10-S22) until the returned function is called. */
	streamEvents(handlers: StreamHandlers): () => void;
	/** The caller is here, on this interface. */
	presenceHeartbeat(body: PresenceHeartbeat): Promise<void>;
	/** Who is online, most recently seen first. */
	listPresence(query?: {
		interface?: Presence["interface"];
		signal?: AbortSignal;
	}): Promise<PresenceList>;
	/** The calling driver's alerts still waiting for their acknowledgment (EP12-S15). */
	listMyAlerts(options?: RequestOptions): Promise<AlertAckList>;
	/** The escalation board (EP12-S15): open alerts by default, earliest deadline first. */
	listPendingAcks(query?: {
		status?: AlertAck["status"];
		driverId?: string;
		signal?: AbortSignal;
	}): Promise<AlertAckBoard>;
	/** A dispatcher closes an unacknowledged alert (EP12-S15). */
	resolveAlert(notificationId: string): Promise<AlertAck>;
}

export function createClient({
	baseUrl = "/api",
	accessToken,
	locale,
	interface: caller = "admin",
	storeId,
	appVersion,
	onUpgradeRequired,
}: ClientOptions): Client {
	/** Every call below goes through here, so a 426 anywhere reaches `onUpgradeRequired`. */
	async function fetch(input: string, init?: RequestInit): Promise<Response> {
		const response = await globalThis.fetch(input, init);
		if (response.status === 426) {
			onUpgradeRequired?.();
		}
		return response;
	}

	/** The headers every request carries, for the one call that bypasses `request`. */
	async function authHeaders(): Promise<Headers> {
		const headers = new Headers({ Accept: "application/json" });
		headers.set("X-Khazzin-Interface", caller);
		if (appVersion !== undefined) {
			headers.set("X-App-Version", appVersion);
		}
		const store = storeId?.() ?? null;
		if (store !== null) {
			headers.set("X-Store-Id", store);
		}
		const language = locale?.() ?? null;
		if (language !== null) {
			headers.set("Accept-Language", language);
		}
		const token = await accessToken();
		if (token !== null) {
			headers.set("Authorization", `Bearer ${token}`);
		}
		return headers;
	}

	async function request<T>(
		path: string,
		init: RequestInit = {},
		options: RequestOptions = {},
	): Promise<T> {
		const headers = new Headers(init.headers);
		headers.set("Accept", "application/json");

		// What language to answer in. The server's validation messages and its
		// PDF rendering both read it, so a person working in Arabic gets an
		// Arabic "this SKU already exists" rather than an English one beside a
		// mirrored form.
		const language = locale?.() ?? null;
		if (language !== null) {
			headers.set("Accept-Language", language);
		}

		if (options.idempotencyKey !== undefined) {
			headers.set("Idempotency-Key", options.idempotencyKey);
		}
		// Which client made the request, recorded on every audit row this
		// request produces. The Store Portal and the Driver App send "store"
		// and "driver"; a value the server does not recognise is recorded as
		// unknown rather than believed, because the header is a claim a client
		// makes about itself.
		headers.set("X-Khazzin-Interface", caller);
		if (appVersion !== undefined) {
			headers.set("X-App-Version", appVersion);
		}
		const store = storeId?.() ?? null;
		if (store !== null) {
			headers.set("X-Store-Id", store);
		}

		const token = await accessToken();
		if (token !== null) {
			headers.set("Authorization", `Bearer ${token}`);
		}

		const response = await fetch(`${baseUrl}${path}`, {
			...init,
			headers,
			signal: options.signal ?? init.signal ?? null,
		});

		if (!response.ok) {
			throw new ApiError(response.status, await errorBody(response));
		}
		// A 204 has no body to parse: reading one threw after the server had
		// already deleted, so a delete that worked showed its error toast.
		if (response.status === 204) {
			return undefined as T;
		}
		return (await response.json()) as T;
	}

	/**
	 * A mutation that answers 204.
	 *
	 * `request` always parses a body, which a 204 does not have. This is the
	 * same call without that step — and *with* the status check, which the
	 * hand-rolled fetch it replaces did not have: a revoke that failed looked
	 * like one that succeeded, so the caller's error toast could never fire.
	 */
	async function send(path: string, method: string): Promise<void> {
		const response = await fetch(`${baseUrl}${path}`, {
			method,
			headers: await authHeaders(),
		});
		if (!response.ok) {
			throw new ApiError(response.status, await errorBody(response));
		}
	}

	/** A JSON POST, for the calls whose body is small and whose shape is fixed. */
	function post<T>(path: string, body: unknown, options: RequestOptions = {}): Promise<T> {
		return request<T>(
			path,
			body === undefined
				? { method: "POST" }
				: {
						method: "POST",
						headers: { "Content-Type": "application/json" },
						body: JSON.stringify(body),
					},
			options,
		);
	}

	/**
	 * A download, fetched rather than linked to.
	 *
	 * An `<a href>` carries no Authorization header, so a plain link to an
	 * export is a 401 the person sees as a broken button. Fetching it means the
	 * bytes arrive in memory and are handed to the browser as a blob — which
	 * also lets a failure be an error message rather than a downloaded file
	 * containing a JSON error.
	 */
	async function file(path: string): Promise<DownloadedFile> {
		const response = await fetch(`${baseUrl}${path}`, { headers: await authHeaders() });
		if (!response.ok) {
			throw new ApiError(response.status, await errorBody(response));
		}
		return {
			blob: await response.blob(),
			filename: filenameFrom(response.headers.get("Content-Disposition")),
		};
	}

	/**
	 * The same, for a document whose request needs a body.
	 *
	 * A selection of two hundred order ids does not fit in a query string, so
	 * the label batch is a POST that answers with a PDF — which is a read
	 * wearing a verb, and the contract says so with `x-audit-action: none`.
	 */
	async function filePost(path: string, body: unknown): Promise<DownloadedFile> {
		// Set on the Headers, never spread: a Headers object has no own
		// properties, so `{ ...headers }` is `{}` and the request went out
		// without its token — a 401 that read "your session has ended".
		const headers = await authHeaders();
		headers.set("Content-Type", "application/json");
		const response = await fetch(`${baseUrl}${path}`, {
			method: "POST",
			headers,
			body: JSON.stringify(body),
		});
		if (!response.ok) {
			throw new ApiError(response.status, await errorBody(response));
		}
		return {
			blob: await response.blob(),
			filename: filenameFrom(response.headers.get("Content-Disposition")),
		};
	}

	/** One read of EP13-S12's Finance & Cashflow dashboard. */
	function financeRead<T>(
		block: string,
		query: { signal?: AbortSignal | undefined } & object,
	): Promise<T> {
		return request<T>(
			`/analytics/finance/${block}${searchOf(query)}`,
			{},
			query.signal === undefined ? {} : { signal: query.signal },
		);
	}

	/** One tab of EP13-S13's financial report hub. */
	function financeReport<T>(
		tab: string,
		query: { signal?: AbortSignal | undefined } & object,
	): Promise<T> {
		return request<T>(
			`/analytics/reports/finance/${tab}${searchOf(query)}`,
			{},
			query.signal === undefined ? {} : { signal: query.signal },
		);
	}

	return {
		listWarehouses(query = {}) {
			const params = new URLSearchParams();
			for (const [key, value] of Object.entries(query)) {
				// `signal` is a request option rather than a query parameter, and
				// an empty string is a filter nobody set.
				if (key === "signal" || value === undefined || value === "") {
					continue;
				}
				params.set(key, String(value));
			}
			const search = params.size > 0 ? `?${params}` : "";
			return request<WarehousePage>(
				`/warehouses${search}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getWarehouse(warehouseId, options) {
			return request<Warehouse>(`/warehouses/${encodeURIComponent(warehouseId)}`, {}, options);
		},

		createWarehouse(draft) {
			return post<Warehouse>("/warehouses", draft);
		},

		updateWarehouse(warehouseId, patch, version) {
			return request<Warehouse>(`/warehouses/${encodeURIComponent(warehouseId)}`, {
				method: "PATCH",
				headers: {
					"Content-Type": "application/json",
					// Quoted, because that is what an entity tag is (RFC 9110).
					"If-Match": `"${version}"`,
				},
				body: JSON.stringify(patch),
			});
		},

		listWarehouseServices(warehouseId, options) {
			return request<WarehouseServiceList>(
				`/warehouses/${encodeURIComponent(warehouseId)}/services`,
				{},
				options,
			);
		},

		getStoreRestockSettings(storeId, options) {
			return request<StoreRestockSettings>(
				`/stores/${encodeURIComponent(storeId)}/restock-settings`,
				{},
				options,
			);
		},

		putStoreRestockSettings(storeId, settings) {
			return request<StoreRestockSettings>(
				`/stores/${encodeURIComponent(storeId)}/restock-settings`,
				{
					method: "PUT",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(settings),
				},
			);
		},

		listWarehouseRoles(options) {
			return request<WarehouseRoleServicesList>("/warehouse-roles", {}, options);
		},

		setWarehouseRole(name, serviceCodes) {
			return request<WarehouseRoleServices>("/warehouse-roles", {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ name, serviceCodes }),
			});
		},

		async deleteWarehouseRole(name) {
			await request<void>(`/warehouse-roles/${encodeURIComponent(name)}`, { method: "DELETE" });
		},

		listWarehouseServiceStates(warehouseId, options) {
			return request<WarehouseServiceStateList>(
				`/warehouses/${encodeURIComponent(warehouseId)}/services/states`,
				{},
				options,
			);
		},

		listAvailableWarehouseServices(warehouseId, scope = {}, options) {
			const params = new URLSearchParams();
			// An empty string is a scope nobody set, and sending it would narrow
			// the answer to the links that name a store called "".
			if (scope.storeId !== undefined && scope.storeId !== "") {
				params.set("storeId", scope.storeId);
			}
			if (scope.skuId !== undefined && scope.skuId !== "") {
				params.set("skuId", scope.skuId);
			}
			const search = params.size > 0 ? `?${params}` : "";
			return request<WarehouseServiceList>(
				`/warehouses/${encodeURIComponent(warehouseId)}/services/available${search}`,
				{},
				options,
			);
		},

		offerWarehouseService(warehouseId, draft) {
			return post<WarehouseService>(
				`/warehouses/${encodeURIComponent(warehouseId)}/services`,
				draft,
			);
		},

		withdrawWarehouseService(warehouseId, warehouseServiceId) {
			return send(
				`/warehouses/${encodeURIComponent(warehouseId)}/services/${encodeURIComponent(
					warehouseServiceId,
				)}`,
				"DELETE",
			);
		},

		listOperatingCompanies(options) {
			return request<OperatingCompanyList>("/operating-companies", {}, options);
		},

		createOperatingCompany(draft) {
			return post<OperatingCompany>("/operating-companies", draft);
		},

		updateOperatingCompany(companyId, patch, version) {
			return request<OperatingCompany>(`/operating-companies/${encodeURIComponent(companyId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(patch),
			});
		},

		listStores(query = {}) {
			const params = new URLSearchParams();
			for (const [key, value] of Object.entries(query)) {
				// `signal` is a request option rather than a query parameter, and
				// an empty string is a filter nobody set.
				if (key === "signal" || value === undefined || value === "") {
					continue;
				}
				params.set(key, String(value));
			}
			const search = params.size > 0 ? `?${params}` : "";
			return request<StorePage>(
				`/stores${search}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getStore(storeId, options) {
			return request<Store>(`/stores/${encodeURIComponent(storeId)}`, {}, options);
		},

		createStore(draft) {
			return post<StoreOnboarding>("/stores", draft);
		},

		patchStore(storeId, patch, version) {
			return request<StoreUpdate>(`/stores/${encodeURIComponent(storeId)}`, {
				method: "PATCH",
				headers: {
					"Content-Type": "application/json",
					// Sent only when the caller read a version. The server accepts
					// the request without it and audits the change either way; a
					// header carrying `undefined` would be a string reading
					// "undefined", which the server would refuse.
					...(version === undefined ? {} : { "If-Match": `"${version}"` }),
				},
				body: JSON.stringify(patch),
			});
		},

		async listStoreContacts(storeId, options) {
			const body = await request<{ items: StoreContact[] }>(
				`/stores/${encodeURIComponent(storeId)}/contacts`,
				{},
				options,
			);
			return body.items;
		},

		async listStoreKycDocuments(storeId, options) {
			const body = await request<{ items: StoreKycDocument[] }>(
				`/stores/${encodeURIComponent(storeId)}/kyc-documents`,
				{},
				options,
			);
			return body.items;
		},

		decideStoreKycDocument(storeId, documentId, decision) {
			return post<StoreKycReview>(
				`/stores/${encodeURIComponent(storeId)}/kyc-documents/${encodeURIComponent(documentId)}/decision`,
				decision,
			);
		},

		getStorePortalSettings(storeId, options) {
			return request<StorePortalSetting>(
				`/stores/${encodeURIComponent(storeId)}/portal-settings`,
				{},
				options,
			);
		},

		putStorePortalSettings(storeId, draft) {
			return request<StorePortalSetting>(`/stores/${encodeURIComponent(storeId)}/portal-settings`, {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(draft),
			});
		},

		listWarehouseLinks(warehouseId, options) {
			return request<WarehouseLinkList>(
				`/warehouses/${encodeURIComponent(warehouseId)}/links`,
				{},
				options,
			);
		},

		linkWarehouses(warehouseId, otherWarehouseId, relation) {
			return request<WarehouseLink>(
				`/warehouses/${encodeURIComponent(warehouseId)}/links/${encodeURIComponent(otherWarehouseId)}`,
				{ method: "PUT", body: JSON.stringify({ relation }) },
			);
		},

		listTransfers(query, options) {
			return request<TransferList>(`/transfers${searchOf(query)}`, {}, options);
		},

		createTransfer(draft) {
			return request<Transfer>("/transfers", { method: "POST", body: JSON.stringify(draft) });
		},

		getTransfer(transferId, options) {
			return request<Transfer>(`/transfers/${encodeURIComponent(transferId)}`, {}, options);
		},

		shipTransfer(transferId, version) {
			return request<Transfer>(`/transfers/${encodeURIComponent(transferId)}/ship`, {
				method: "POST",
				headers: { "If-Match": `"${version}"` },
			});
		},

		receiveTransfer(transferId, receipt, version) {
			return request<Transfer>(`/transfers/${encodeURIComponent(transferId)}/receive`, {
				method: "POST",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(receipt),
			});
		},

		cancelTransfer(transferId, version) {
			return request<Transfer>(`/transfers/${encodeURIComponent(transferId)}/cancel`, {
				method: "POST",
				headers: { "If-Match": `"${version}"` },
			});
		},

		getRestockPlan(warehouseId, options) {
			return request<RestockPlan>(
				`/warehouses/${encodeURIComponent(warehouseId)}/restock`,
				{},
				options,
			);
		},

		setRestockLevel(warehouseId, skuId, min, max) {
			return request<RestockLevel>(
				`/warehouses/${encodeURIComponent(warehouseId)}/restock/${encodeURIComponent(skuId)}`,
				{ method: "PUT", body: JSON.stringify({ min, max }) },
			);
		},

		async removeRestockLevel(warehouseId, skuId) {
			await request<void>(
				`/warehouses/${encodeURIComponent(warehouseId)}/restock/${encodeURIComponent(skuId)}`,
				{ method: "DELETE" },
			);
		},

		draftRestockTransfer(warehouseId, skuIds) {
			return request<Transfer>(`/warehouses/${encodeURIComponent(warehouseId)}/restock/transfer`, {
				method: "POST",
				body: JSON.stringify(skuIds ? { skuIds } : {}),
			});
		},

		async unlinkWarehouses(warehouseId, otherWarehouseId) {
			await request<void>(
				`/warehouses/${encodeURIComponent(warehouseId)}/links/${encodeURIComponent(otherWarehouseId)}`,
				{ method: "DELETE" },
			);
		},

		async deleteWarehouse(warehouseId) {
			await request<void>(`/warehouses/${encodeURIComponent(warehouseId)}`, { method: "DELETE" });
		},

		async deleteStore(storeId) {
			await request<void>(`/stores/${encodeURIComponent(storeId)}`, { method: "DELETE" });
		},

		changeStoreStatus(storeId, change, idempotencyKey) {
			return request<StoreTransition>(`/stores/${encodeURIComponent(storeId)}/status`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"Idempotency-Key": idempotencyKey,
				},
				body: JSON.stringify(change),
			});
		},

		getStoreTransitions(storeId, options) {
			return request<StoreTransitionOptions>(
				`/stores/${encodeURIComponent(storeId)}/transitions`,
				{},
				options,
			);
		},

		getStoreIntakeGate(storeId, options) {
			return request<StoreIntakeGate>(
				`/stores/${encodeURIComponent(storeId)}/intake-gate`,
				{},
				options,
			);
		},

		defineService(draft) {
			return post<ServiceDefinition>("/stores/service-definitions", draft);
		},

		async deleteServiceDefinition(code) {
			await request<void>(`/service-definitions/${encodeURIComponent(code)}`, {
				method: "DELETE",
			});
		},

		getGlobalServicePrices(options) {
			return request<WarehouseServicePrices>("/service-prices", {}, options);
		},

		scheduleGlobalServicePrice(draft) {
			return post<StoreServiceRate>("/service-prices", draft);
		},

		setGlobalStorageFee(fee) {
			return request<StorageFee>("/service-prices/storage-fee", {
				method: "PUT",
				body: JSON.stringify(fee),
			});
		},

		async listGlobalServicePriceVersions(code, options) {
			const body = await request<{ items: StoreServiceRate[] }>(
				`/service-prices/${encodeURIComponent(code)}/versions`,
				{},
				options,
			);
			return body.items;
		},

		async listWarehouseServicePriceVersions(warehouseId, code, costs, options) {
			const body = await request<{ items: StoreServiceRate[] }>(
				`/warehouses/${encodeURIComponent(warehouseId)}/service-prices/${encodeURIComponent(code)}/versions${costs ? "?costs=true" : ""}`,
				{},
				options,
			);
			return body.items;
		},

		scheduleWarehouseServiceCost(warehouseId, draft) {
			return post<StoreServiceRate>(
				`/warehouses/${encodeURIComponent(warehouseId)}/service-costs`,
				draft,
			);
		},

		async listServiceDefinitions(options) {
			const body = await request<{ items: ServiceDefinition[] }>(
				"/stores/service-definitions",
				{},
				options,
			);
			return body.items;
		},

		async listStoreServiceRates(storeId, at, options) {
			const search = at === undefined ? "" : `?at=${encodeURIComponent(at)}`;
			const body = await request<{ items: StoreRateCard[] }>(
				`/stores/${encodeURIComponent(storeId)}/service-rates${search}`,
				{},
				options,
			);
			return body.items;
		},

		async listStoreServiceRateVersions(storeId, code, options) {
			const body = await request<{ items: StoreServiceRate[] }>(
				`/stores/${encodeURIComponent(storeId)}/service-rates/${encodeURIComponent(code)}/versions`,
				{},
				options,
			);
			return body.items;
		},

		scheduleStoreServiceRate(storeId, draft) {
			return post<StoreServiceRate>(`/stores/${encodeURIComponent(storeId)}/service-rates`, draft);
		},

		endStoreServiceRate(storeId, code, effectiveFrom) {
			return post<void>(
				`/stores/${encodeURIComponent(storeId)}/service-rates/${encodeURIComponent(code)}/end`,
				effectiveFrom === undefined ? {} : { effectiveFrom },
			);
		},

		listStorageFees(query = {}, options) {
			const search = new URLSearchParams();
			if (query.q !== undefined && query.q !== "") {
				search.set("q", query.q);
			}
			if (query.cursor !== undefined && query.cursor !== "") {
				search.set("cursor", query.cursor);
			}
			if (query.limit !== undefined) {
				search.set("limit", String(query.limit));
			}
			const suffix = search.size === 0 ? "" : `?${search}`;
			return request<StorageFeeList>(`/stores/storage-fees${suffix}`, {}, options);
		},

		getStorageFee(storeId, options) {
			return request<StorageFeeDetail>(
				`/stores/${encodeURIComponent(storeId)}/storage-fee`,
				{},
				options,
			);
		},

		setStorageFee(storeId, draft) {
			return request<StorageFeeResult>(`/stores/${encodeURIComponent(storeId)}/storage-fee`, {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(draft),
			});
		},

		getStorageOccupancy(storeId, options) {
			return request<StorageOccupancy>(
				`/stores/${encodeURIComponent(storeId)}/storage-occupancy`,
				{},
				options,
			);
		},

		listStorageBills(month, options) {
			return request<StorageBillList>(
				`/stores/storage-bills?month=${encodeURIComponent(month)}`,
				{},
				options,
			);
		},

		listStoreStorageBills(storeId, options) {
			return request<StorageBillList>(
				`/stores/${encodeURIComponent(storeId)}/storage-bills`,
				{},
				options,
			);
		},

		generateStorageBills(body) {
			return post<StorageBillGenerateResult>("/stores/storage-bills/generate", body);
		},

		downloadStorageBill(billId, format) {
			return file(`/storage-bills/${encodeURIComponent(billId)}/document?format=${format}`);
		},

		listFinanceStorageBills({ signal, ...query }) {
			return request<FinanceStorageBillList>(
				`/finance/storage-bills${searchOf(query)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		creditStorageBill(billId, body, idempotencyKey) {
			return post<CreditNote>(`/storage-bills/${encodeURIComponent(billId)}/credit`, body, {
				idempotencyKey,
			});
		},

		decideStorageBillUnallocated(billId, body, idempotencyKey) {
			return post<StorageBill>(`/storage-bills/${encodeURIComponent(billId)}/unallocated`, body, {
				idempotencyKey,
			});
		},

		listStoreCharges(storeId, query = {}, options) {
			const search = new URLSearchParams();
			if (query.month !== undefined && query.month !== "") {
				search.set("month", query.month);
			}
			if (query.service !== undefined && query.service !== "") {
				search.set("service", query.service);
			}
			const suffix = search.size === 0 ? "" : `?${search}`;
			return request<ServiceChargePeriod>(
				`/stores/${encodeURIComponent(storeId)}/charges${suffix}`,
				{},
				options,
			);
		},

		getStoreServicePlan(storeId, pendingAt, options) {
			const search = pendingAt === undefined ? "" : `?pendingAt=${encodeURIComponent(pendingAt)}`;
			return request<StoreServicePlan>(
				`/stores/${encodeURIComponent(storeId)}/service-plan${search}`,
				{},
				options,
			);
		},

		putStoreServicePlan(storeId, draft, version) {
			return request<StoreServicePlan>(`/stores/${encodeURIComponent(storeId)}/service-plan`, {
				method: "PUT",
				headers: {
					"Content-Type": "application/json",
					// Always sent, and `"0"` when there is no plan yet. The server
					// answers 428 without it, deliberately: a precondition that is
					// optional in practice is one the first client to forget it
					// silently loses.
					"If-Match": `"${version}"`,
				},
				body: JSON.stringify(draft),
			});
		},

		async listStorePayoutAccounts(storeId, options) {
			const body = await request<{ items: StorePayoutAccount[] }>(
				`/stores/${encodeURIComponent(storeId)}/payout-accounts`,
				{},
				options,
			);
			return body.items;
		},

		proposeStorePayoutAccount(storeId, draft, idempotencyKey) {
			return request<StorePayoutAccount>(`/stores/${encodeURIComponent(storeId)}/payout-accounts`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"Idempotency-Key": idempotencyKey,
				},
				body: JSON.stringify(draft),
			});
		},

		approveStorePayoutAccount(accountId) {
			return post<StorePayoutAccount>(
				`/payout-accounts/${encodeURIComponent(accountId)}/approve`,
				undefined,
			);
		},

		disableStorePayoutAccount(accountId) {
			return post<StorePayoutAccount>(
				`/payout-accounts/${encodeURIComponent(accountId)}/disable`,
				undefined,
			);
		},

		getStoreBillingBalance(storeId, options) {
			return request<StoreBillingBalance>(
				`/stores/${encodeURIComponent(storeId)}/balance`,
				{},
				options,
			);
		},

		async listStoreStatements(storeId, options) {
			const body = await request<{ items: StoreStatement[] }>(
				`/stores/${encodeURIComponent(storeId)}/statements`,
				{},
				options,
			);
			return body.items;
		},

		getStoreStatement(statementId, options) {
			return request<StoreStatementDetail>(
				`/statements/${encodeURIComponent(statementId)}`,
				{},
				options,
			);
		},

		getStoreStatementDocument(statementId) {
			return request<{ url: string }>(`/statements/${encodeURIComponent(statementId)}/document`);
		},

		async listStorePayouts(storeId, options) {
			const body = await request<{ items: StorePayout[] }>(
				`/stores/${encodeURIComponent(storeId)}/payouts`,
				{},
				options,
			);
			return body.items;
		},

		disputeStatementLine(entryId, note) {
			return post<StatementLine>(`/ledger-entries/${encodeURIComponent(entryId)}/dispute`, {
				note,
			});
		},

		listCashoutQueue(query = {}) {
			return request<CashoutQueue>(
				`/cashout-requests${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		listStoreCashoutRequests(storeId, query = {}) {
			return request<CashoutRequestList>(
				`/stores/${encodeURIComponent(storeId)}/cashout-requests${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getStoreCashoutAvailability(storeId, options) {
			return request<CashoutAvailability>(
				`/stores/${encodeURIComponent(storeId)}/cashout-availability`,
				{},
				options,
			);
		},

		createCashoutRequest(storeId, draft, idempotencyKey) {
			return post<CashoutRequest>(
				`/stores/${encodeURIComponent(storeId)}/cashout-requests`,
				draft,
				{ idempotencyKey },
			);
		},

		decideCashoutRequest(requestId, decision, reason, idempotencyKey) {
			return post<CashoutRequest>(
				`/cashout-requests/${encodeURIComponent(requestId)}/decision`,
				reason === undefined ? { decision } : { decision, reason },
				{ idempotencyKey },
			);
		},

		cancelCashoutRequest(requestId, reason) {
			return post<CashoutRequest>(
				`/cashout-requests/${encodeURIComponent(requestId)}/cancel`,
				reason === undefined ? {} : { reason },
			);
		},

		releaseCashoutRequests() {
			return post<CashoutRelease>("/cashout-requests/release", undefined);
		},

		listStoreCatalog(storeId, query = {}) {
			return request<StoreCatalogPage>(
				`/stores/${encodeURIComponent(storeId)}/items${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		listStoreStock(storeId, query = {}) {
			return request<StoreStockList>(
				`/stores/${encodeURIComponent(storeId)}/stock${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		listStoreRemovalOrders(storeId, query = {}) {
			return request<RemovalOrderList>(
				`/stores/${encodeURIComponent(storeId)}/removal-orders${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		quoteStoreRemovalFee(storeId, units) {
			return request<RemovalFeeQuote>(
				`/stores/${encodeURIComponent(storeId)}/removal-fee${searchOf({ units })}`,
			);
		},

		createStoreRemovalOrder(storeId, draft) {
			return post<RemovalOrder>(`/stores/${encodeURIComponent(storeId)}/removal-orders`, draft);
		},

		confirmRemovalOrder(removalId) {
			return post<RemovalOrder>(
				`/removal-orders/${encodeURIComponent(removalId)}/confirm`,
				undefined,
			);
		},

		cancelRemovalOrder(removalId) {
			return post<RemovalOrder>(
				`/removal-orders/${encodeURIComponent(removalId)}/cancel`,
				undefined,
			);
		},

		async listStoreUsers(storeId, options) {
			const body = await request<{ items: StoreUser[] }>(
				`/stores/${encodeURIComponent(storeId)}/users`,
				{},
				options,
			);
			return body.items;
		},

		changeStoreUserEmail(storeId, storeUserId, change) {
			return post<StoreUser>(
				`/stores/${encodeURIComponent(storeId)}/users/${encodeURIComponent(storeUserId)}/change-email`,
				change,
			);
		},

		createStoreOwner(storeId, draft) {
			return request<StoreUser>(`/stores/${encodeURIComponent(storeId)}/users/owner`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(draft),
			});
		},

		getStoreUserAccess(storeId, storeUserId, options) {
			return request<StoreUserAccess>(
				`/stores/${encodeURIComponent(storeId)}/users/${encodeURIComponent(storeUserId)}/access`,
				{},
				options,
			);
		},

		getStoreSectionMetadata(options) {
			return request<StoreSectionMetadata>("/meta/store-sections", {}, options);
		},

		createStoreSubAccount(storeId, draft) {
			return post<StoreUser>(`/stores/${encodeURIComponent(storeId)}/users`, draft);
		},

		replaceStoreUserAccess(storeId, storeUserId, access, version) {
			return request<StoreUser>(
				`/stores/${encodeURIComponent(storeId)}/users/${encodeURIComponent(storeUserId)}/access`,
				{
					method: "PUT",
					headers: {
						"Content-Type": "application/json",
						...(version === undefined ? {} : { "If-Match": `"${version}"` }),
					},
					body: JSON.stringify({ access }),
				},
			);
		},

		getStoreTeam(storeId, options) {
			return request<StoreUserList>(`/stores/${encodeURIComponent(storeId)}/users`, {}, options);
		},

		updateStoreUser(storeId, storeUserId, patch) {
			return request<StoreUser>(
				`/stores/${encodeURIComponent(storeId)}/users/${encodeURIComponent(storeUserId)}`,
				{
					method: "PATCH",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(patch),
				},
			);
		},

		storeUserLifecycle(storeId, storeUserId, action) {
			const path = `/stores/${encodeURIComponent(storeId)}/users/${encodeURIComponent(storeUserId)}`;
			return action === "revoke"
				? request<StoreUser>(path, { method: "DELETE" })
				: post<StoreUser>(`${path}/${action}`, undefined);
		},

		endStoreUserSessions(storeId, storeUserId) {
			return post<StoreUserSessionsEnded>(
				`/stores/${encodeURIComponent(storeId)}/users/${encodeURIComponent(storeUserId)}/end-sessions`,
				undefined,
			);
		},

		resetStoreUserPassword(storeId, storeUserId) {
			return post<StoreUserPasswordReset>(
				`/stores/${encodeURIComponent(storeId)}/users/${encodeURIComponent(storeUserId)}/reset-password`,
				undefined,
			);
		},

		transferStoreOwnership(storeId, storeUserId, reason) {
			return post<StoreUser>(
				`/stores/${encodeURIComponent(storeId)}/users/${encodeURIComponent(storeUserId)}/transfer-ownership`,
				reason === undefined ? {} : { reason },
			);
		},

		getStoreUserActivity(storeId, storeUserId) {
			return request<StoreUserActivity>(
				`/stores/${encodeURIComponent(storeId)}/users/${encodeURIComponent(storeUserId)}/activity`,
			);
		},

		async listStoreInvitations(storeId, options) {
			const body = await request<{ items: StoreInvitation[] }>(
				`/stores/${encodeURIComponent(storeId)}/invitations`,
				{},
				options,
			);
			return body.items;
		},

		inviteStoreUser(storeId, draft) {
			return post<StoreInvitationIssued>(
				`/stores/${encodeURIComponent(storeId)}/invitations`,
				draft,
			);
		},

		resendStoreInvitation(storeId, invitationId) {
			return post<StoreInvitationIssued>(
				`/stores/${encodeURIComponent(storeId)}/invitations/${encodeURIComponent(invitationId)}/resend`,
				undefined,
			);
		},

		revokeStoreInvitation(storeId, invitationId) {
			return post<StoreUser>(
				`/stores/${encodeURIComponent(storeId)}/invitations/${encodeURIComponent(invitationId)}/revoke`,
				undefined,
			);
		},

		acceptStoreInvitation(token) {
			return post<StoreInvitationAccepted>("/invitations:accept", { token });
		},

		getStoresSummary(options) {
			return request<StoresSummary>("/stores/summary", {}, options);
		},

		listLedgerAccounts(query = {}) {
			return request<LedgerAccountPage>(
				`/finance/accounts${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getLedgerAccount(accountId, options) {
			return request<LedgerAccountDetail>(
				`/finance/accounts/${encodeURIComponent(accountId)}`,
				{},
				options,
			);
		},

		listLedgerAccountEntries(accountId, query = {}) {
			return request<LedgerEntryPage>(
				`/finance/accounts/${encodeURIComponent(accountId)}/entries${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		listLedgerBalances(query = {}) {
			return request<LedgerPositionList>(
				`/finance/balances${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		listProducts(query = {}) {
			const params = new URLSearchParams();
			for (const [key, value] of Object.entries(query)) {
				// `signal` is a request option rather than a query parameter, and
				// an empty string is a filter nobody set — sending `q=` would ask
				// the server to prefix-match nothing.
				if (key === "signal" || value === undefined || value === "") {
					continue;
				}
				params.set(key, String(value));
			}
			const search = params.size > 0 ? `?${params}` : "";
			return request<ProductPage>(
				`/products${search}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getProduct(id, options) {
			return request<Product>(`/products/${encodeURIComponent(id)}`, {}, options);
		},

		createProduct(draft, options) {
			return request<Product>(
				"/products",
				{
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(draft),
				},
				options,
			);
		},

		patchProduct(id, patch, version) {
			return request<Product>(`/products/${encodeURIComponent(id)}`, {
				method: "PATCH",
				headers: {
					"Content-Type": "application/json",
					// Quoted, because that is what an entity tag is (RFC 9110).
					"If-Match": `"${version}"`,
				},
				body: JSON.stringify(patch),
			});
		},

		archiveProduct(id) {
			return request<Product>(`/products/${encodeURIComponent(id)}/archive`, { method: "POST" });
		},

		unarchiveProduct(id) {
			return request<Product>(`/products/${encodeURIComponent(id)}/unarchive`, { method: "POST" });
		},

		getCurrentOrganization() {
			return request<CurrentOrganization>("/orgs/current");
		},

		patchOrgSettings(patch, version, options) {
			return request<CurrentOrganization>(
				"/orgs/current/settings",
				{
					method: "PATCH",
					headers: {
						"Content-Type": "application/json",
						// Quoted, because that is what an entity tag is (RFC 9110).
						// The server accepts it bare too; sending the correct form
						// means a proxy that normalises the header cannot break it.
						"If-Match": `"${version}"`,
					},
					body: JSON.stringify(patch),
				},
				options,
			);
		},

		getSecurityOverview(options) {
			return request<SecurityOverview>("/orgs/current/security", {}, options);
		},

		confirmStepUp(sessionId, code) {
			return post<StepUpResult>("/auth/step-up", { sessionId, code });
		},

		revokeAllOrgSessions() {
			return post<{ revoked: number }>("/orgs/current/sessions/revoke-all", {});
		},

		resetOrgData(confirm) {
			return post<OrgDataResetResult>("/orgs/current/data-reset", { confirm });
		},

		getMeContext(options) {
			return request<MeContext>("/me/context", {}, options);
		},

		getAdminDashboard(options) {
			return request<AdminDashboard>("/admin/dashboard", {}, options);
		},

		putDashboardLayout(layout) {
			return request<DashboardLayout>("/admin/dashboard/layout", {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(layout),
			});
		},

		listUsers(query = {}) {
			const params = new URLSearchParams();
			for (const [key, value] of Object.entries(query)) {
				// `signal` is a request option rather than a query parameter, and
				// an empty string is a filter nobody set.
				if (key === "signal" || value === undefined || value === null || value === "") {
					continue;
				}
				params.set(key, String(value));
			}
			const search = params.size > 0 ? `?${params}` : "";
			return request<{ items: UserRecord[]; counts: UserCounts; nextCursor?: string }>(
				`/users${search}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getUser(id) {
			return request<UserRecord>(`/users/${encodeURIComponent(id)}`);
		},

		grantMembership(grant) {
			return post<Membership>("/memberships", grant);
		},

		listInvitations() {
			return request<{ items: Invitation[] }>("/invitations");
		},

		createInvitation(invitation) {
			return post<Invitation>("/invitations", invitation);
		},

		resendInvitation(id) {
			return post<Invitation>(`/invitations/${encodeURIComponent(id)}/resend`, {});
		},

		revokeInvitation(id) {
			return post<Invitation>(`/invitations/${encodeURIComponent(id)}/revoke`, {});
		},

		listSessions(userId) {
			return request<{ items: Session[] }>(`/users/${encodeURIComponent(userId)}/sessions`);
		},

		revokeSession(sessionId) {
			return send(`/sessions/${encodeURIComponent(sessionId)}/revoke`, "POST");
		},

		revokeAllSessions(userId) {
			return send(`/users/${encodeURIComponent(userId)}/sessions/revoke-all`, "POST");
		},

		logout() {
			return send("/auth/logout", "POST");
		},

		suspendUser(userId) {
			return post<UserStatusChange>(`/users/${encodeURIComponent(userId)}/suspend`, {});
		},

		reactivateUser(userId) {
			return post<UserStatusChange>(`/users/${encodeURIComponent(userId)}/reactivate`, {});
		},

		listRoles(status) {
			const search = status === undefined || status === "" ? "" : `?status=${status}`;
			return request<{ items: Role[]; catalogVersion: number }>(`/roles${search}`);
		},

		listPermissions() {
			return request<PermissionCatalog>("/permissions");
		},

		createRole(role) {
			return post<Role>("/roles", role);
		},

		async updateRole(roleKey, patch, force = false) {
			const search = force ? "?force=true" : "";
			return request<Role>(`/roles/${encodeURIComponent(roleKey)}${search}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(patch),
			});
		},

		listAuditEvents(query) {
			const params = new URLSearchParams();
			for (const [key, value] of Object.entries(query)) {
				if (value !== "") {
					params.set(key, value);
				}
			}
			const search = params.size > 0 ? `?${params}` : "";
			return request<{ items: AuditEvent[]; nextCursor?: string }>(`/audit-events${search}`);
		},

		getAuditEvent(id) {
			return request<AuditEvent>(`/audit-events/${encodeURIComponent(id)}`);
		},

		async exportAuditEvents(filter, format) {
			// Fetched rather than linked to, like every other download here: an
			// `<a href>` carries no Authorization header, so a plain link would
			// be a 401 the person sees as a broken button.
			const headers = await authHeaders();
			headers.set("Content-Type", "application/json");
			const response = await fetch(`${baseUrl}/audit-exports`, {
				method: "POST",
				headers,
				body: JSON.stringify({ filter, format }),
			});
			if (!response.ok) {
				throw new ApiError(response.status, await errorBody(response));
			}
			return {
				blob: await response.blob(),
				filename: filenameFrom(response.headers.get("Content-Disposition")),
			};
		},

		listTeams(status) {
			const search = status === undefined || status === "" ? "" : `?status=${status}`;
			return request<{ items: Team[] }>(`/teams${search}`);
		},

		createTeam(name) {
			return post<Team>("/teams", { name });
		},

		updateTeam(teamId, patch) {
			return request<Team>(`/teams/${encodeURIComponent(teamId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(patch),
			});
		},

		listImpersonations() {
			return request<{ items: Impersonation[] }>("/impersonations");
		},

		startImpersonation(body) {
			return post<Impersonation>("/impersonations", body);
		},

		endImpersonation(id) {
			return send(`/impersonations/${encodeURIComponent(id)}/end`, "POST");
		},

		listStoreImpersonations(storeId) {
			return request<{ items: Impersonation[] }>(
				`/stores/${encodeURIComponent(storeId)}/impersonation-sessions`,
			);
		},

		startStoreImpersonation(storeId, body) {
			return post<Impersonation>(
				`/stores/${encodeURIComponent(storeId)}/impersonation-sessions`,
				body,
			);
		},

		endStoreImpersonation(storeId, id) {
			return send(
				`/stores/${encodeURIComponent(storeId)}/impersonation-sessions/${encodeURIComponent(id)}/end`,
				"POST",
			);
		},

		revokeMembership(id) {
			return send(`/memberships/${encodeURIComponent(id)}`, "DELETE");
		},

		async listApiKeys(query = {}) {
			const params = new URLSearchParams();
			for (const [key, value] of Object.entries(query)) {
				if (key !== "signal" && value !== undefined && value !== "") {
					params.set(key, String(value));
				}
			}
			const suffix = params.size === 0 ? "" : `?${params.toString()}`;
			const body = await request<ApiKeyList>(
				`/developer/api-keys${suffix}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
			return body.items;
		},

		issueApiKey(draft) {
			return post<IssuedApiKey>("/developer/api-keys", draft);
		},

		updateApiKey(keyId, patch) {
			return request<ApiKey>(`/developer/api-keys/${encodeURIComponent(keyId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(patch),
			});
		},

		revokeApiKey(keyId) {
			return post<ApiKey>(`/developer/api-keys/${encodeURIComponent(keyId)}/revoke`, undefined);
		},

		listRequestLogs(query = {}) {
			return request<ApiRequestLogList>(
				`/developer/request-logs${requestLogParams(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getRequestLog(requestId, options) {
			return request<ApiRequestLog>(
				`/developer/request-logs/${encodeURIComponent(requestId)}`,
				{},
				options,
			);
		},

		exportRequestLogs(query = {}) {
			return file(`/developer/request-logs${requestLogParams({ ...query, format: "xlsx" })}`);
		},

		getDeveloperOverview(options) {
			return request<DeveloperOverview>("/developer/overview", {}, options);
		},

		async listDocsPages(options) {
			const body = await request<{ items: DocsPage[] }>("/developer/docs", {}, options);
			return body.items;
		},

		createDocsPage(draft) {
			return post<DocsPage>("/developer/docs", draft);
		},

		updateDocsPage(slug, patch) {
			return request<DocsPage>(`/developer/docs/${encodeURIComponent(slug)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(patch),
			});
		},

		getPublicApiSpec(options) {
			// The public mount serves this one document without a key; the
			// console's token rides along and is ignored.
			return request<unknown>("/v1/openapi.json", {}, options);
		},

		sendSandboxRequest(req) {
			return post<SandboxResponse>("/developer/sandbox/requests", req);
		},

		getSandboxFixtures(keyId, options) {
			return request<SandboxFixtures>(
				`/developer/sandbox/fixtures?keyId=${encodeURIComponent(keyId)}`,
				{},
				options,
			);
		},

		getEndpointPolicies(options) {
			return request<EndpointPolicyMatrix>("/developer/endpoint-policies", {}, options);
		},

		saveEndpointPolicies(update) {
			return request<EndpointPolicyMatrix>("/developer/endpoint-policies", {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(update),
			});
		},

		getOrderCreationStatuses(scope, options) {
			return request<OrderCreationStatusSet>(
				`/developer/order-statuses?scope=${encodeURIComponent(scope)}`,
				{},
				options,
			);
		},

		saveOrderCreationStatuses(update) {
			return request<OrderCreationStatusSet>("/developer/order-statuses", {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(update),
			});
		},

		getDeliveryEditableFields(subject, options) {
			return request<DeliveryFieldSet>(
				`/developer/delivery-fields?subject=${encodeURIComponent(subject)}`,
				{},
				options,
			);
		},

		saveDeliveryEditableFields(update) {
			return request<DeliveryFieldSet>("/developer/delivery-fields", {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(update),
			});
		},

		async listWebhookSubscriptions(options) {
			const body = await request<{ items: WebhookSubscription[] }>(
				"/webhooks/subscriptions",
				{},
				options,
			);
			return body.items;
		},

		createWebhookSubscription(draft) {
			return post<CreatedWebhookSubscription>("/webhooks/subscriptions", draft);
		},

		updateWebhookSubscription(id, patch) {
			return request<UpdatedWebhookSubscription>(
				`/webhooks/subscriptions/${encodeURIComponent(id)}`,
				{
					method: "PATCH",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(patch),
				},
			);
		},

		deleteWebhookSubscription(id) {
			return send(`/webhooks/subscriptions/${encodeURIComponent(id)}`, "DELETE");
		},

		testWebhookSubscription(id) {
			return post<WebhookDelivery>(
				`/webhooks/subscriptions/${encodeURIComponent(id)}/test`,
				undefined,
			);
		},

		listWebhookDeliveries(query = {}) {
			const params = new URLSearchParams();
			for (const [key, value] of Object.entries(query)) {
				if (key !== "signal" && value !== undefined && value !== "") {
					params.set(key, String(value));
				}
			}
			const suffix = params.size === 0 ? "" : `?${params.toString()}`;
			return request<WebhookDeliveryList>(
				`/webhooks/deliveries${suffix}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getWebhookDelivery(id, options) {
			return request<WebhookDeliveryDetail>(
				`/webhooks/deliveries/${encodeURIComponent(id)}`,
				{},
				options,
			);
		},

		replayWebhookDelivery(id) {
			return post<WebhookDelivery>(
				`/webhooks/deliveries/${encodeURIComponent(id)}/replay`,
				undefined,
			);
		},

		replayDeadWebhookDeliveries(body) {
			return post<WebhookReplayJob>("/webhooks/deliveries:replay", body);
		},

		getWebhookReplayJob(jobId, options) {
			return request<WebhookReplayProgress>(
				`/webhooks/replays/${encodeURIComponent(jobId)}`,
				{},
				options,
			);
		},

		async listChannelConnections(query = {}) {
			const params = new URLSearchParams();
			for (const [key, value] of Object.entries(query)) {
				if (key !== "signal" && value !== undefined && value !== "") {
					params.set(key, String(value));
				}
			}
			const suffix = params.size === 0 ? "" : `?${params.toString()}`;
			const body = await request<{ items: ChannelConnection[] }>(
				`/integrations/connections${suffix}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
			return body.items;
		},

		getChannelConnection(id, options) {
			return request<ChannelConnection>(
				`/integrations/connections/${encodeURIComponent(id)}`,
				{},
				options,
			);
		},

		connectShopify(body) {
			return post<ConnectShopifyResponse>("/integrations/shopify/connect", body);
		},

		connectWoo(body) {
			return post<ChannelConnection>("/integrations/connections", body);
		},

		testWooConnection(body) {
			return post<WooHealth>("/integrations/woocommerce/test", body);
		},

		getWooHealth(id, options) {
			return request<WooHealth>(
				`/integrations/woocommerce/${encodeURIComponent(id)}/health`,
				{},
				options,
			);
		},

		updateChannelConnection(id, patch) {
			return request<ChannelConnection>(`/integrations/connections/${encodeURIComponent(id)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(patch),
			});
		},

		revokeChannelConnection(id) {
			return request<ChannelConnection>(`/integrations/connections/${encodeURIComponent(id)}`, {
				method: "DELETE",
			});
		},

		reregisterChannelWebhooks(id) {
			return post<ChannelConnection>(
				`/integrations/connections/${encodeURIComponent(id)}/webhooks`,
				undefined,
			);
		},

		async listChannelLocations(id, options) {
			const body = await request<{ items: ChannelLocation[] }>(
				`/integrations/connections/${encodeURIComponent(id)}/locations`,
				{},
				options,
			);
			return body.items;
		},

		listSyncJobs(connectionId, options) {
			return request<SyncJobList>(
				`/integrations/sync-jobs?connectionId=${encodeURIComponent(connectionId)}`,
				{},
				options,
			);
		},

		startSyncJob(body) {
			return post<SyncJob>("/integrations/sync-jobs", body);
		},

		getSyncJob(id, options) {
			return request<SyncJob>(`/integrations/sync-jobs/${encodeURIComponent(id)}`, {}, options);
		},

		listChannelItemMappings(query = {}) {
			return request<ChannelItemMappingList>(
				`/integrations/mappings${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		resolveChannelItemMapping(id, body) {
			return post<ChannelItemMapping>(
				`/integrations/mappings/${encodeURIComponent(id)}/resolve`,
				body,
			);
		},

		editChannelItemMapping(id, body) {
			return request<ChannelItemMapping>(`/integrations/mappings/${encodeURIComponent(id)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(body),
			});
		},

		approveChannelItemMappingSku(id) {
			return post<ChannelItemMapping>(
				`/integrations/mappings/${encodeURIComponent(id)}/approve-sku`,
				undefined,
			);
		},

		getNextChannelItemMappingSku(id, options) {
			return request<{ sku: string }>(
				`/integrations/mappings/${encodeURIComponent(id)}/next-sku`,
				{},
				options,
			);
		},

		getInventorySync(connectionId, query = {}) {
			const base = `/integrations/connections/${encodeURIComponent(connectionId)}/inventory-sync`;
			return request<InventorySync>(
				query.status === undefined ? base : `${base}?status=${query.status}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		updateInventorySyncPolicy(connectionId, body) {
			return request<InventorySyncPolicy>(
				`/integrations/connections/${encodeURIComponent(connectionId)}/inventory-sync/policy`,
				{
					method: "PATCH",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(body),
				},
			);
		},

		pauseInventorySync(connectionId) {
			return post<InventorySyncPolicy>(
				`/integrations/connections/${encodeURIComponent(connectionId)}/inventory-sync/pause`,
				undefined,
			);
		},

		runInventoryFullSync(connectionId) {
			return post<{ skus: number }>(
				`/integrations/connections/${encodeURIComponent(connectionId)}/inventory-sync/full-sync`,
				undefined,
			);
		},

		setInventorySkuBuffer(connectionId, skuId, buffer) {
			return request<InventorySyncRow>(
				`/integrations/connections/${encodeURIComponent(connectionId)}/inventory-sync/skus/${encodeURIComponent(skuId)}/buffer`,
				{
					method: "PUT",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(buffer === null ? {} : { buffer }),
				},
			);
		},

		listReliabilityDeadLetters(query = {}) {
			return request<DeadLetterPage>(
				`/reliability/dead-letters${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getReliabilityDeadLetter(id, options) {
			return request<DeadLetter>(
				`/reliability/dead-letters/${encodeURIComponent(id)}`,
				{},
				options,
			);
		},

		retryReliabilityDeadLetter(id) {
			return post<DeadLetter>(
				`/reliability/dead-letters/${encodeURIComponent(id)}/retry`,
				undefined,
			);
		},

		discardReliabilityDeadLetter(id, reason) {
			return post<DeadLetter>(`/reliability/dead-letters/${encodeURIComponent(id)}/discard`, {
				reason,
			});
		},

		retryReliabilityDeadLetters(body) {
			return post<DeadLetterBulkRetry>("/reliability/dead-letters/retry", body);
		},

		async listReconciliationRuns(query = {}) {
			const body = await request<{ items: ReconciliationRun[] }>(
				`/reliability/reconciliations${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
			return body.items;
		},

		getReconciliationRun(id, options) {
			return request<ReconciliationRun>(
				`/reliability/reconciliations/${encodeURIComponent(id)}`,
				{},
				options,
			);
		},

		startReconciliationRun(body) {
			return post<ReconciliationRun>("/reliability/reconciliations", body);
		},

		getReliabilitySummary(options) {
			return request<ReliabilitySummary>("/reliability/metrics/summary", {}, options);
		},

		async listJobs(options) {
			const body = await request<{ items: ScheduledJob[] }>("/admin/jobs", {}, options);
			return body.items;
		},

		listJobRuns(name, params = {}) {
			const query = new URLSearchParams();
			if (params.cursor !== undefined) {
				query.set("cursor", params.cursor);
			}
			if (params.limit !== undefined) {
				query.set("limit", String(params.limit));
			}
			const suffix = query.size === 0 ? "" : `?${query.toString()}`;
			return request<{ items: JobRun[]; nextCursor?: string }>(
				`/admin/jobs/${encodeURIComponent(name)}/runs${suffix}`,
			);
		},

		setJobPaused(name, paused, reason, version) {
			return request<ScheduledJob>(`/admin/jobs/${encodeURIComponent(name)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify({ paused, reason }),
			});
		},

		runJobNow(name, idempotencyKey) {
			return post<JobRun>(`/admin/jobs/${encodeURIComponent(name)}/run`, undefined, {
				idempotencyKey,
			});
		},

		listNotifications(query = {}) {
			return request<InboxNotificationList>(
				`/notifications${searchOf({
					severity: query.severity,
					topic: query.topic,
					unread: query.unread,
					cursor: query.cursor,
					limit: query.limit,
				})}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		async getUnreadNotificationCount(options) {
			const body = await request<{ count: number }>("/notifications/unread-count", {}, options);
			return body.count;
		},

		async markNotificationsRead(body) {
			const result = await post<{ marked: number }>("/notifications/mark-read", body);
			return result.marked;
		},

		async listNotificationDefinitions(options) {
			const body = await request<{ items: NotificationDefinition[] }>(
				"/notification-definitions",
				{},
				options,
			);
			return body.items;
		},

		listOrderCustomerMessages(orderId, options) {
			return request<CustomerMessageTimeline>(
				`/orders/${encodeURIComponent(orderId)}/customer-messages`,
				{},
				options,
			);
		},

		getNotificationPreferences(query = {}, options) {
			return request<NotificationPreferences>(
				`/notification-preferences${searchOf({ scopeRef: query.scopeRef, storeId: query.storeId })}`,
				{},
				options,
			);
		},

		putNotificationPreferences(input) {
			return request<NotificationPreferences>("/notification-preferences", {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(input),
			});
		},

		getAlertRules(scopeRef, options) {
			return request<AlertRules>(`/alert-rules${searchOf({ scopeRef })}`, {}, options);
		},

		putAlertRule(ruleKey, scopeRef, valueJson) {
			return request<AlertRules>(`/alert-rules/${encodeURIComponent(ruleKey)}`, {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ scopeRef, valueJson }),
			});
		},

		previewDigest(storeId) {
			return request<DigestPreview>("/digests/preview", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ storeId }),
			});
		},

		getPortalAlertRules(options) {
			return request<AlertRules>("/portal/alert-rules", {}, options);
		},

		putPortalAlertRule(ruleKey, valueJson) {
			return request<AlertRules>(`/portal/alert-rules/${encodeURIComponent(ruleKey)}`, {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ valueJson }),
			});
		},

		previewPortalDigest() {
			return request<DigestPreview>("/portal/digests/preview", { method: "POST" });
		},

		getCustomerNotificationSettings(storeId, options) {
			return request<CustomerNotificationSettings>(
				`/customer-notification-settings${storeId ? `?storeId=${encodeURIComponent(storeId)}` : ""}`,
				{},
				options,
			);
		},

		updateCustomerNotificationSettings(patch) {
			return request<CustomerNotificationSettings>("/customer-notification-settings", {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(patch),
			});
		},

		updateNotificationDefinition(id, patch) {
			return request<NotificationDefinition>(
				`/notification-definitions/${encodeURIComponent(id)}`,
				{
					method: "PATCH",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(patch),
				},
			);
		},

		sendTestNotification(body) {
			return request<NotificationTestResult>("/notifications/test", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(body),
			});
		},

		async listChannelProviders(options) {
			const body = await request<{ items: ChannelProvider[] }>("/channel-providers", {}, options);
			return body.items;
		},

		getChannelSettings(options) {
			return request<ChannelSettings>("/channel-settings", {}, options);
		},

		putChannelSettings(input) {
			return request<ChannelSettings>("/channel-settings", {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(input),
			});
		},

		putChannelProvider(channel, input) {
			return request<ChannelProvider>(`/channel-providers/${encodeURIComponent(channel)}`, {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(input),
			});
		},

		verifyChannelProvider(channel, role, address) {
			return request<ChannelProvider>(`/channel-providers/${encodeURIComponent(channel)}/verify`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(address ? { role, address } : { role }),
			});
		},

		async listWhatsAppTemplates(definitionId, options) {
			const body = await request<{ items: WhatsAppTemplate[] }>(
				`/notification-definitions/${encodeURIComponent(definitionId)}/whatsapp`,
				{},
				options,
			);
			return body.items;
		},

		listNotificationMessages(query, options) {
			const params = new URLSearchParams();
			for (const [key, value] of Object.entries(query)) {
				if (value !== undefined && value !== "") {
					params.set(key, value);
				}
			}
			const search = params.size > 0 ? `?${params}` : "";
			return request<NotificationLogPage>(`/notification-messages${search}`, {}, options);
		},

		getNotificationMessage(id, options) {
			return request<NotificationMessageDetail>(
				`/notification-messages/${encodeURIComponent(id)}`,
				{},
				options,
			);
		},

		resendNotificationMessage(id) {
			return request<NotificationLogEntry>(
				`/notification-messages/${encodeURIComponent(id)}/resend`,
				{ method: "POST" },
			);
		},

		async getChannelHealth(options) {
			const body = await request<{ items: ChannelHealth[] }>("/channel-health", {}, options);
			return body.items;
		},

		async listSuppressions(query, options) {
			const params = new URLSearchParams();
			if (query.channel) {
				params.set("channel", query.channel);
			}
			if (query.q) {
				params.set("q", query.q);
			}
			const search = params.size > 0 ? `?${params}` : "";
			const body = await request<{ items: Suppression[] }>(`/suppressions${search}`, {}, options);
			return body.items;
		},

		removeSuppression(id) {
			return send(`/suppressions/${encodeURIComponent(id)}`, "DELETE");
		},

		revokeTrackingToken(shipmentId) {
			return send(`/tracking-tokens/${encodeURIComponent(shipmentId)}/revoke`, "POST");
		},

		submitWhatsAppTemplate(templateId) {
			return request<WhatsAppTemplate>(
				`/notification-templates/${encodeURIComponent(templateId)}/wa-submit`,
				{ method: "POST" },
			);
		},

		async listNotificationTemplates(definitionId, options) {
			const body = await request<{ items: NotificationTemplate[] }>(
				`/notification-templates?definitionId=${encodeURIComponent(definitionId)}`,
				{},
				options,
			);
			return body.items;
		},

		createNotificationTemplate(input) {
			return post<NotificationTemplate>("/notification-templates", input);
		},

		updateNotificationTemplate(templateId, patch) {
			return request<NotificationTemplate>(
				`/notification-templates/${encodeURIComponent(templateId)}`,
				{
					method: "PATCH",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(patch),
				},
			);
		},

		discardNotificationTemplate(templateId) {
			return send(`/notification-templates/${encodeURIComponent(templateId)}`, "DELETE");
		},

		publishNotificationTemplate(templateId) {
			return post<NotificationTemplate>(
				`/notification-templates/${encodeURIComponent(templateId)}/publish`,
				undefined,
			);
		},

		archiveNotificationTemplate(templateId) {
			return post<NotificationTemplate>(
				`/notification-templates/${encodeURIComponent(templateId)}/archive`,
				undefined,
			);
		},

		previewNotificationTemplate(templateId, body, options) {
			return post<NotificationTemplatePreview>(
				`/notification-templates/${encodeURIComponent(templateId)}/preview`,
				body,
				options,
			);
		},

		async listNotificationTemplateVersions(templateId, options) {
			const body = await request<{ items: NotificationTemplate[] }>(
				`/notification-templates/${encodeURIComponent(templateId)}/versions`,
				{},
				options,
			);
			return body.items;
		},

		async listAdminFlags(options) {
			const body = await request<{ items: AdminFlag[] }>("/admin/flags", {}, options);
			return body.items;
		},

		setFlag(key, enabled, reason, version) {
			return request<components["schemas"]["FeatureFlag"]>(
				`/admin/flags/${encodeURIComponent(key)}`,
				{
					method: "PUT",
					headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
					body: JSON.stringify({ interface: "admin", enabled, reason }),
				},
			);
		},

		beginUpload(request) {
			return post<UploadTicket>("/attachments", request);
		},

		completeUpload(id) {
			return post<Attachment>(`/attachments/${encodeURIComponent(id)}/complete`, undefined);
		},

		renewUpload(id) {
			return post<UploadTicket>(`/attachments/${encodeURIComponent(id)}/upload-form`, undefined);
		},

		getAttachmentDownload(id, options) {
			return request<{ url: string }>(
				`/attachments/${encodeURIComponent(id)}/download`,
				{},
				options,
			);
		},

		async listImportTypes(options) {
			const body = await request<{ items: ImportType[] }>("/imports/types", {}, options);
			return body.items;
		},

		createImport(type, attachmentId, idempotencyKey, options) {
			// Absent rather than `{}` when nothing was chosen, so an importer
			// with no options is sent exactly what it was always sent.
			const body =
				options === undefined || Object.keys(options).length === 0
					? { type, attachmentId }
					: { type, attachmentId, options };
			return post<ImportJob>("/imports", body, { idempotencyKey });
		},

		getImport(id) {
			return request<ImportJob>(`/imports/${encodeURIComponent(id)}`);
		},

		listImportResults(id, params = {}) {
			const query = new URLSearchParams();
			if (params.errorsOnly === true) {
				query.set("errorsOnly", "true");
			}
			if (params.cursor !== undefined) {
				query.set("cursor", params.cursor);
			}
			if (params.limit !== undefined) {
				query.set("limit", String(params.limit));
			}
			const suffix = query.size === 0 ? "" : `?${query.toString()}`;
			return request<ImportResultList>(`/imports/${encodeURIComponent(id)}/results${suffix}`);
		},

		commitImport(id, mode, version) {
			return request<ImportJob>(`/imports/${encodeURIComponent(id)}/commit`, {
				method: "POST",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify({ mode }),
			});
		},

		downloadImportTemplate(type, format = "csv") {
			return file(`/imports/${encodeURIComponent(type)}/template?format=${format}`);
		},

		downloadExport(type, filters = new URLSearchParams(), format = "csv") {
			const query = new URLSearchParams(filters);
			query.set("format", format);
			return file(`/exports/${encodeURIComponent(type)}?${query.toString()}`);
		},

		async resetDashboardLayout() {
			// 204, like the saved-view delete: there is no body, and asking
			// `request` to parse one would fail on the empty response.
			await fetch(`${baseUrl}/admin/dashboard/layout`, {
				method: "DELETE",
				headers: await authHeaders(),
			});
		},

		getPortalScope(options) {
			return request<MeStore>("/portal/scope", {}, options);
		},

		getPortalSummary(options) {
			return request<PortalSummary>("/portal/summary", {}, options);
		},

		getPortalSales(block, { signal, ...query }) {
			return request<SalesBreakdown>(
				`/portal/dashboards/sales_revenue${searchOf({ block, ...query })}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		getPortalScorecard({ signal, ...query }) {
			return request<StoreScorecard>(
				`/portal/scorecard${searchOf(query)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		getPortalScorecardTrend({ signal, ...query }) {
			return request<StoreTrend>(
				`/portal/scorecard/trend${searchOf(query)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		downloadPortalScorecard(query, format = "csv") {
			return file(`/portal/scorecard/export${searchOf({ ...query, format })}`);
		},

		listPortalOrders({ filters, ...query } = {}) {
			return request<PortalOrderListPage>(
				`/portal/orders${searchOf({ ...filters, ...query })}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getPortalOrder(orderId, options) {
			return request<PortalOrder>(`/portal/orders/${encodeURIComponent(orderId)}`, {}, options);
		},

		listPortalOrderCustomerMessages(orderId, options) {
			return request<CustomerMessageTimeline>(
				`/portal/orders/${encodeURIComponent(orderId)}/customer-messages`,
				{},
				options,
			);
		},

		getPortalOrderPackPhoto(orderId, options) {
			return request<PackPhoto>(
				`/portal/orders/${encodeURIComponent(orderId)}/pack-photo`,
				{},
				options,
			);
		},

		getPortalOrderLog(orderId, tab, query = {}) {
			return request<OrderLogPage>(
				`/portal/orders/${encodeURIComponent(orderId)}/logs${searchOf({ ...query, tab })}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		downloadPortalOrders(filters = new URLSearchParams(), format = "csv") {
			const query = new URLSearchParams(filters);
			query.set("format", format);
			return file(`/portal/orders/export?${query.toString()}`);
		},

		listPortalExternalImports(query = {}) {
			return request<ExternalImportPage>(
				`/portal/orders/external-imports${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		importPortalExternalOrders(ids, idempotencyKey) {
			return post<ExternalImportReport>(
				"/portal/orders/external-imports/import",
				{ ids },
				{ idempotencyKey },
			);
		},

		deletePortalExternalImports(ids) {
			return post<ExternalImportReport>("/portal/orders/external-imports/delete", { ids });
		},

		revertPortalExternalImport(importId) {
			return post<ExternalImportRow>(
				`/portal/orders/external-imports/${encodeURIComponent(importId)}/revert`,
				undefined,
			);
		},

		editPortalShortLines(orderId, body, version) {
			return request<PortalShortLinesResult>(
				`/portal/orders/missing-stock/${encodeURIComponent(orderId)}/lines`,
				{
					method: "PATCH",
					headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
					body: JSON.stringify(body),
				},
			);
		},

		createPortalOrder(draft, idempotencyKey) {
			return post<PortalOrderIntakeResult>("/portal/orders", draft, { idempotencyKey });
		},

		editPortalOrder(orderId, patch, version) {
			return request<PortalOrder>(`/portal/orders/${encodeURIComponent(orderId)}`, {
				method: "PUT",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(patch),
			});
		},

		withdrawPortalOrder(orderId) {
			return post<PortalOrder>(`/portal/orders/${encodeURIComponent(orderId)}/withdraw`, undefined);
		},

		resubmitPortalOrder(orderId, draft, idempotencyKey) {
			return post<PortalOrderIntakeResult>(
				`/portal/orders/${encodeURIComponent(orderId)}/resubmit`,
				draft,
				{ idempotencyKey },
			);
		},

		cancelPortalOrder(orderId, body, version) {
			return request<PortalOrder>(`/portal/orders/${encodeURIComponent(orderId)}/cancel`, {
				method: "POST",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(body),
			});
		},

		searchPortalCatalogSkus(query = {}) {
			return request<OrderCatalogSkuPage>(
				`/portal/catalog/skus${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		searchPortalCities(q, options) {
			return request<PortalCityPage>(`/portal/geography/cities${searchOf({ q })}`, {}, options);
		},

		getPortalPackagingTypes(options) {
			return request<PackagingOptions>("/portal/packaging/types", {}, options);
		},

		getPortalOrderOptions(options) {
			return request<PortalOrderOptions>("/portal/order-options", {}, options);
		},

		listPortalStock({ signal, ...query } = {}) {
			return request<PortalStockPage>(
				`/portal/inventory/stock${searchOf(query)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		listPortalLowStock({ signal, ...query } = {}) {
			return request<PortalLowStockPage>(
				`/portal/inventory/low-stock${searchOf(query)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		listPortalReceiving({ signal, ...query } = {}) {
			return request<PortalReceivingPage>(
				`/portal/inventory/receiving${searchOf(query)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		listPortalLots({ signal, ...query } = {}) {
			return request<LotPage>(
				`/portal/inventory/lots${searchOf(query)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		listPortalReorderSuggestions(options) {
			return request<PortalReorderPage>("/portal/inventory/reorder-suggestions", {}, options);
		},

		acceptPortalReorderSuggestion(id, body) {
			return post<PortalReorderDecision>(
				`/portal/inventory/reorder-suggestions/${encodeURIComponent(id)}/accept`,
				body,
			);
		},

		dismissPortalReorderSuggestion(id, reason) {
			return post<PortalReorderDecision>(
				`/portal/inventory/reorder-suggestions/${encodeURIComponent(id)}/dismiss`,
				{ reason },
			);
		},

		putPortalReorderTargetDays(targetDays) {
			return request<{ targetDays: number }>("/portal/settings/reorder-target-days", {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ targetDays }),
			});
		},

		listPortalCatalogItems({ signal, ...query } = {}) {
			return request<PortalCatalogPage>(
				`/portal/catalog/items${searchOf(query)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		createPortalCatalogItem(body) {
			return post<PortalCatalogItem>("/portal/catalog/items", body);
		},

		updatePortalCatalogItem(itemId, body) {
			return request<PortalCatalogItem>(`/portal/catalog/items/${encodeURIComponent(itemId)}`, {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(body),
			});
		},

		approvePortalCatalogSku(skuId) {
			return post<PortalCatalogSku>(
				`/portal/catalog/skus/${encodeURIComponent(skuId)}/approve`,
				{},
			);
		},

		putPortalSkuPackagingDefault(skuId, packageTypeId) {
			return request<PortalCatalogSku>(
				`/portal/catalog/skus/${encodeURIComponent(skuId)}/packaging-default`,
				{
					method: "PUT",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({ packageTypeId }),
				},
			);
		},

		listPortalChannels(options) {
			return request<PortalChannelList>("/portal/integrations/channels", {}, options);
		},

		getPortalSettings(options) {
			return request<PortalSettings>("/portal/settings", {}, options);
		},

		putPortalSettings(body, version) {
			return request<PortalSettings>("/portal/settings", {
				method: "PUT",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(body),
			});
		},

		async listPortalApiKeys(options) {
			return (await request<ApiKeyList>("/portal/api-keys", {}, options)).items;
		},

		createPortalApiKey(label) {
			return post<IssuedApiKey>("/portal/api-keys", { label });
		},

		revokePortalApiKey(keyId) {
			return request<ApiKey>(`/portal/api-keys/${encodeURIComponent(keyId)}`, {
				method: "DELETE",
			});
		},

		getMeStores(options) {
			return request<{ stores: MeStore[] }>("/me/stores", {}, options);
		},

		putPreferences(preferences, options) {
			return request<MePreferences>(
				"/me/preferences",
				{
					method: "PUT",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(preferences),
				},
				options,
			);
		},

		async listSavedViews(screenKey, options) {
			const page = await request<{ items: SavedView[] }>(
				`/admin/views?screenKey=${encodeURIComponent(screenKey)}`,
				{},
				options,
			);
			return page.items;
		},

		createSavedView(draft, options) {
			return request<SavedView>(
				"/admin/views",
				{
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(draft),
				},
				options,
			);
		},

		async deleteSavedView(id) {
			// 204: there is no body, and asking `request` to parse one would
			// fail on the empty response the server correctly sends.
			await fetch(`${baseUrl}/admin/views/${encodeURIComponent(id)}`, {
				method: "DELETE",
				headers: await authHeaders(),
			});
		},

		getFlags(iface, options) {
			const search = iface === undefined ? "" : `?interface=${encodeURIComponent(iface)}`;
			return request<FlagSet>(`/flags${search}`, {}, options);
		},

		listProvinces(query = {}) {
			const params = new URLSearchParams();
			if (query.countryCode !== undefined && query.countryCode !== "") {
				params.set("countryCode", query.countryCode);
			}
			// Only `true` is sent. `isActive=false` is not "the inactive ones"
			// on the server either, so sending it would be asking for something
			// the contract does not offer.
			if (query.activeOnly === true) {
				params.set("isActive", "true");
			}
			const search = params.size > 0 ? `?${params}` : "";
			return request<ProvinceList>(
				`/delivery/provinces${search}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		createProvince(draft) {
			return post<Province>("/delivery/provinces", draft);
		},

		updateProvince(provinceId, patch, version) {
			return request<ProvinceUpdate>(`/delivery/provinces/${encodeURIComponent(provinceId)}`, {
				method: "PATCH",
				headers: {
					"Content-Type": "application/json",
					// Quoted, because that is what an entity tag is (RFC 9110).
					"If-Match": `"${version}"`,
				},
				body: JSON.stringify(patch),
			});
		},

		seedGeography(body) {
			return post<GeographySeedReport>("/delivery/geography:seed", body);
		},

		listMyWorkSessions(options) {
			return request<WorkSessionList>("/work-sessions", {}, options);
		},

		openWorkSession(body) {
			return post<WorkSessionDetail>("/work-sessions", body);
		},

		getWorkSession(sessionId, options) {
			return request<WorkSessionDetail>(
				`/work-sessions/${encodeURIComponent(sessionId)}`,
				{},
				options,
			);
		},

		pauseWorkSession(sessionId) {
			return post<WorkSessionDetail>(
				`/work-sessions/${encodeURIComponent(sessionId)}/pause`,
				undefined,
			);
		},

		resumeWorkSession(sessionId) {
			return post<WorkSessionDetail>(
				`/work-sessions/${encodeURIComponent(sessionId)}/resume`,
				undefined,
			);
		},

		closeWorkSession(sessionId) {
			return post<WorkSessionDetail>(
				`/work-sessions/${encodeURIComponent(sessionId)}/close`,
				undefined,
			);
		},

		recordWorkSessionActivity(sessionId, draft) {
			return post<WorkSessionDetail>(
				`/work-sessions/${encodeURIComponent(sessionId)}/activities`,
				draft,
			);
		},

		listWorkSessions(query = {}) {
			return request<WorkSessionList>(
				`/work-sessions${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		cancelWorkSession(sessionId, body) {
			return post<WorkSessionDetail>(
				`/work-sessions/${encodeURIComponent(sessionId)}/cancel`,
				body,
			);
		},

		continueWorkSession(sessionId) {
			return post<WorkSessionDetail>(
				`/work-sessions/${encodeURIComponent(sessionId)}/continue`,
				undefined,
			);
		},

		listWorkSessionLog(query) {
			return request<WorkSessionLog>(
				`/work-sessions/session-log?${sessionLogSearch(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		exportWorkSessionLog(query) {
			return file(`/work-sessions/session-log/export?${sessionLogSearch(query)}`);
		},

		listDepartments(options) {
			return request<DepartmentList>("/departments", {}, options);
		},

		createDepartment(draft) {
			return post<Department>("/departments", draft);
		},

		updateDepartment(departmentId, patch) {
			return request<Department>(`/departments/${encodeURIComponent(departmentId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(patch),
			});
		},

		listPositions(query = {}) {
			return request<PositionList>(
				`/positions${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		createPosition(draft) {
			return post<Position>("/positions", draft);
		},

		updatePosition(positionId, patch) {
			return request<Position>(`/positions/${encodeURIComponent(positionId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(patch),
			});
		},

		listShifts(options) {
			return request<ShiftList>("/shifts", {}, options);
		},

		createShift(draft) {
			return post<Shift>("/shifts", draft);
		},

		updateShift(shiftId, patch, version) {
			return request<Shift>(`/shifts/${encodeURIComponent(shiftId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(patch),
			});
		},

		listShiftAssignments(query) {
			return request<ShiftSchedule>(
				`/shift-assignments${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		createShiftAssignments(batch) {
			return post<ShiftAssignmentBatchResult>("/shift-assignments", batch);
		},

		updateShiftAssignment(assignmentId, patch, version) {
			return request<ShiftAssignment>(`/shift-assignments/${encodeURIComponent(assignmentId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(patch),
			});
		},

		getAttendanceDay(query) {
			const { signal, ...rest } = query;
			return request<AttendanceDay>(
				`/attendance${searchOf(rest)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		clockIn(body, idempotencyKey) {
			return post<AttendanceRecord>("/attendance/clock-in", body, { idempotencyKey });
		},

		clockOut(body, idempotencyKey) {
			return post<AttendanceRecord>("/attendance/clock-out", body, { idempotencyKey });
		},

		correctAttendance(attendanceId, correction, version) {
			return request<AttendanceRecord>(`/attendance/${encodeURIComponent(attendanceId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(correction),
			});
		},

		listCommissionRules(options) {
			return request<CommissionRuleList>("/commission-rules", {}, options ?? {});
		},

		createCommissionRule(draft) {
			return post<CommissionRule>("/commission-rules", draft);
		},

		updateCommissionRule(ruleId, draft, version) {
			return request<CommissionRule>(`/commission-rules/${encodeURIComponent(ruleId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(draft),
			});
		},

		listCommissionAccruals(query = {}) {
			const { signal, ...rest } = query;
			return request<CommissionAccrualPage>(
				`/commission-accruals${searchOf(rest)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		listPerformance(query, options) {
			const { employeeId = [], ...rest } = query;
			const params = new URLSearchParams(searchOf(rest).slice(1));
			for (const id of employeeId) {
				params.append("employeeId", id);
			}
			return request<PerformanceRecordPage>(`/performance?${params}`, {}, options ?? {});
		},

		getPerformanceLeaderboard(query, options) {
			return request<PerformanceLeaderboard>(
				`/performance/leaderboard${searchOf(query)}`,
				{},
				options ?? {},
			);
		},

		reviewPerformance(performanceId, draft) {
			return post<PerformanceRecord>(
				`/performance/${encodeURIComponent(performanceId)}/review`,
				draft,
			);
		},

		recomputePerformance(body) {
			return post<PerformanceRecomputeResult>("/performance/recompute", body);
		},

		listPayrollRuns(query = {}, options) {
			return request<PayrollRunList>(`/payroll/runs${searchOf(query)}`, {}, options ?? {});
		},

		createPayrollRun(draft) {
			return post<PayrollRunDetail>("/payroll/runs", draft);
		},

		getPayrollRun(runId, options) {
			return request<PayrollRunDetail>(
				`/payroll/runs/${encodeURIComponent(runId)}`,
				{},
				options ?? {},
			);
		},

		recomputePayrollRun(runId) {
			return post<PayrollRunDetail>(
				`/payroll/runs/${encodeURIComponent(runId)}/recompute`,
				undefined,
			);
		},

		addPayrollDeduction(runId, draft) {
			return post<PayrollRunDetail>(`/payroll/runs/${encodeURIComponent(runId)}/deductions`, draft);
		},

		removePayrollDeduction(runId, deductionId) {
			return request<PayrollRunDetail>(
				`/payroll/runs/${encodeURIComponent(runId)}/deductions/${encodeURIComponent(deductionId)}`,
				{ method: "DELETE" },
			);
		},

		submitPayrollRun(runId, version) {
			return request<PayrollRunDetail>(`/payroll/runs/${encodeURIComponent(runId)}/submit`, {
				method: "POST",
				headers: { "If-Match": `"${version}"` },
			});
		},

		approvePayrollRun(runId) {
			return post<PayrollRunDetail>(
				`/payroll/runs/${encodeURIComponent(runId)}/approve`,
				undefined,
			);
		},

		rejectPayrollRun(runId, reason) {
			return post<PayrollRunDetail>(`/payroll/runs/${encodeURIComponent(runId)}/reject`, {
				reason,
			});
		},

		listPayrollItems(query = {}, options) {
			return request<PayrollItemList>(`/payroll/items${searchOf(query)}`, {}, options ?? {});
		},

		listEmployees(query = {}) {
			return request<EmployeeDirectory>(
				`/employees${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		createEmployee(draft, idempotencyKey) {
			return post<Employee>("/employees", draft, { idempotencyKey });
		},

		getEmployee(employeeId, options) {
			return request<Employee>(`/employees/${encodeURIComponent(employeeId)}`, {}, options);
		},

		updateEmployee(employeeId, patch, version) {
			return request<Employee>(`/employees/${encodeURIComponent(employeeId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(patch),
			});
		},

		getEmployeeSalary(employeeId, options) {
			return request<EmployeeSalary>(
				`/employees/${encodeURIComponent(employeeId)}/salary`,
				{},
				options,
			);
		},

		setEmployeeSalary(employeeId, draft, version) {
			return request<Employee>(`/employees/${encodeURIComponent(employeeId)}/salary`, {
				method: "PUT",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(draft),
			});
		},

		changeEmployeeStatus(employeeId, change) {
			return post<Employee>(`/employees/${encodeURIComponent(employeeId)}/status`, change);
		},

		assignEmployee(employeeId, assignment) {
			return post<EmployeeAssignResult>(
				`/employees/${encodeURIComponent(employeeId)}/assign`,
				assignment,
			);
		},

		getEmployeeSectionAccess(employeeId, options) {
			return request<EmployeeSectionAccess>(
				`/employees/${encodeURIComponent(employeeId)}/section-access`,
				{},
				options,
			);
		},

		replaceEmployeeSectionAccess(employeeId, body) {
			return request<EmployeeSectionAccess>(
				`/employees/${encodeURIComponent(employeeId)}/section-access`,
				{
					method: "PUT",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(body),
				},
			);
		},

		listRoleSectionDefaults(options) {
			return request<RoleDefaultGridList>("/roles/section-defaults", {}, options);
		},

		replaceRoleSectionDefaults(roleKey, body) {
			return request<RoleDefaultGridSaved>(
				`/roles/${encodeURIComponent(roleKey)}/section-defaults`,
				{
					method: "PUT",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(body),
				},
			);
		},

		listEmployeeAccountRoles(options) {
			return request<EmployeeAccountRoleList>("/employees/account-roles", {}, options);
		},

		checkEmployeeUsername(username, options) {
			return request<EmployeeUsernameAvailability>(
				`/employees/username-availability?${new URLSearchParams({ username })}`,
				{},
				options,
			);
		},

		createEmployeeAccount(employeeId, draft) {
			return post<Employee>(`/employees/${encodeURIComponent(employeeId)}/account`, draft);
		},

		changeEmployeeAccountRole(employeeId, roleKey) {
			return request<Employee>(`/employees/${encodeURIComponent(employeeId)}/account`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ roleKey }),
			});
		},

		resetEmployeePassword(employeeId) {
			return post<EmployeePasswordReset>(
				`/employees/${encodeURIComponent(employeeId)}/account/reset-password`,
				{},
			);
		},

		suspendEmployeeAccount(employeeId) {
			return post<Employee>(`/employees/${encodeURIComponent(employeeId)}/account/suspend`, {});
		},

		reactivateEmployeeAccount(employeeId) {
			return post<Employee>(`/employees/${encodeURIComponent(employeeId)}/account/reactivate`, {});
		},

		linkEmployeeUser(employeeId, userId) {
			return post<Employee>(`/employees/${encodeURIComponent(employeeId)}/link-user`, { userId });
		},

		listCities(query = {}) {
			const params = new URLSearchParams();
			for (const [key, value] of Object.entries(query)) {
				if (key === "signal" || value === undefined || value === "") {
					continue;
				}
				params.set(key, String(value));
			}
			const search = params.size > 0 ? `?${params}` : "";
			return request<CityList>(
				`/delivery/cities${search}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getCity(cityId, options) {
			return request<City>(`/delivery/cities/${encodeURIComponent(cityId)}`, {}, options);
		},

		listDeliveryCompanies(query = {}) {
			const params = new URLSearchParams();
			for (const [key, value] of Object.entries(query)) {
				if (key === "signal" || value === undefined || value === "") {
					continue;
				}
				params.set(key, String(value));
			}
			const search = params.size > 0 ? `?${params}` : "";
			return request<DeliveryCompanyList>(
				`/delivery/companies${search}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getDeliveryCompany(companyId, options) {
			return request<DeliveryCompany>(
				`/delivery/companies/${encodeURIComponent(companyId)}`,
				{},
				options,
			);
		},

		createDeliveryCompany(draft) {
			return post<DeliveryCompany>("/delivery/companies", draft);
		},

		updateDeliveryCompany(companyId, patch, version) {
			return request<DeliveryCompany>(`/delivery/companies/${encodeURIComponent(companyId)}`, {
				method: "PATCH",
				headers: {
					"Content-Type": "application/json",
					// Quoted, because that is what an entity tag is (RFC 9110).
					"If-Match": `"${version}"`,
				},
				body: JSON.stringify(patch),
			});
		},

		changeDeliveryCompanyStatus(companyId, action, body) {
			return post<DeliveryCompanyTransition>(
				`/delivery/companies/${encodeURIComponent(companyId)}/${action}`,
				body ?? {},
			);
		},

		updateDeliveryCompanyOperatingModel(companyId, patch, version) {
			return request<DeliveryCompany>(
				`/delivery/companies/${encodeURIComponent(companyId)}/operating-model`,
				{
					method: "PATCH",
					headers: {
						"Content-Type": "application/json",
						// Quoted, because that is what an entity tag is (RFC 9110).
						"If-Match": `"${version}"`,
					},
					body: JSON.stringify(patch),
				},
			);
		},

		listDeliveryDrivers(query = {}) {
			const search =
				query.companyId === undefined || query.companyId === ""
					? ""
					: `?companyId=${encodeURIComponent(query.companyId)}`;
			return request<DeliveryDriverList>(
				`/delivery/drivers${search}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getDeliveryDriver(driverId, options) {
			return request<DeliveryDriver>(
				`/delivery/drivers/${encodeURIComponent(driverId)}`,
				{},
				options,
			);
		},

		createDeliveryDriver(draft) {
			return post<DeliveryDriver>("/delivery/drivers", draft);
		},

		updateDeliveryDriver(driverId, patch, version) {
			return request<DeliveryDriver>(`/delivery/drivers/${encodeURIComponent(driverId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(patch),
			});
		},

		changeDeliveryDriverStatus(driverId, action, reason) {
			return post<DeliveryDriver>(
				`/delivery/drivers/${encodeURIComponent(driverId)}/${action}`,
				reason === undefined ? {} : { reason },
			);
		},

		listShipments(query = {}) {
			return request<ShipmentList>(
				`/delivery/shipments${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getShipment(shipmentId, options) {
			return request<ShipmentDetail>(
				`/delivery/shipments/${encodeURIComponent(shipmentId)}`,
				{},
				options,
			);
		},

		getShipmentSummary(options) {
			return request<ShipmentSummary>("/delivery/summary", {}, options);
		},

		transitionShipment(shipmentId, body) {
			return post<Shipment>(
				`/delivery/shipments/${encodeURIComponent(shipmentId)}/transition`,
				body,
			);
		},

		cancelShipment(shipmentId, reason) {
			return post<Shipment>(`/delivery/shipments/${encodeURIComponent(shipmentId)}/cancel`, {
				reason,
			});
		},

		rescheduleShipment(shipmentId, body) {
			return post<Shipment>(
				`/delivery/shipments/${encodeURIComponent(shipmentId)}/reschedule`,
				body,
			);
		},

		assignShipment(shipmentId, body) {
			return post<Shipment>(`/delivery/shipments/${encodeURIComponent(shipmentId)}/assign`, body);
		},

		assignShipmentDriver(shipmentId, body) {
			return post<Shipment>(
				`/delivery/shipments/${encodeURIComponent(shipmentId)}/assign-driver`,
				body,
			);
		},

		sendShipmentBack(shipmentId, body) {
			return post<Shipment>(`/delivery/shipments/${encodeURIComponent(shipmentId)}/rto`, body);
		},

		declareShipmentLost(shipmentId, body) {
			return post<Shipment>(`/delivery/shipments/${encodeURIComponent(shipmentId)}/lost`, body);
		},

		listManifests({ signal, ...query } = {}) {
			return request<ManifestList>(
				`/delivery/manifests${searchOf(query)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		getManifest(manifestId, options) {
			return request<ManifestDetail>(
				`/delivery/manifests/${encodeURIComponent(manifestId)}`,
				{},
				options,
			);
		},

		planManifest(companyId, driverId, options) {
			return request<ManifestPlan>(
				`/delivery/manifests:plan${searchOf({ companyId, driverId })}`,
				{},
				options,
			);
		},

		createManifest(body) {
			return post<Manifest>("/delivery/manifests", body);
		},

		confirmManifest(manifestId) {
			return post<Manifest>(`/delivery/manifests/${encodeURIComponent(manifestId)}/confirm`, {});
		},

		reconcileManifest(manifestId, outcomes) {
			return post<Manifest>(`/delivery/manifests/${encodeURIComponent(manifestId)}/reconcile`, {
				outcomes,
			});
		},

		cancelManifest(manifestId) {
			return post<Manifest>(`/delivery/manifests/${encodeURIComponent(manifestId)}/cancel`, {});
		},

		listPickupRequests({ signal, ...query } = {}) {
			return request<PickupRequestList>(
				`/delivery/pickup-requests${searchOf(query)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		createPickupRequest(body) {
			return post<PickupRequest>("/delivery/pickup-requests", body);
		},

		patchPickupRequest(pickupId, body, version) {
			return request<PickupRequest>(`/delivery/pickup-requests/${encodeURIComponent(pickupId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(body),
			});
		},

		schedulePickupRequest(pickupId, body) {
			return post<PickupRequest>(
				`/delivery/pickup-requests/${encodeURIComponent(pickupId)}/schedule`,
				body,
			);
		},

		assignPickupDriver(pickupId, driverId) {
			return post<PickupRequest>(
				`/delivery/pickup-requests/${encodeURIComponent(pickupId)}/assign-driver`,
				{ driverId },
			);
		},

		cancelPickupRequest(pickupId, reason) {
			return post<PickupRequest>(
				`/delivery/pickup-requests/${encodeURIComponent(pickupId)}/cancel`,
				reason ? { reason } : {},
			);
		},

		receivePickupRequest(pickupId) {
			return post<PickupRequest>(
				`/delivery/pickup-requests/${encodeURIComponent(pickupId)}/receive`,
				{},
			);
		},

		listPortalPickupRequests({ signal, ...query } = {}) {
			return request<PickupRequestList>(
				`/portal/pickup-requests${searchOf(query)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		createPortalPickupRequest(body) {
			return post<PickupRequest>("/portal/pickup-requests", body);
		},

		patchPortalPickupRequest(pickupId, body, version) {
			return request<PickupRequest>(`/portal/pickup-requests/${encodeURIComponent(pickupId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(body),
			});
		},

		cancelPortalPickupRequest(pickupId, reason) {
			return post<PickupRequest>(
				`/portal/pickup-requests/${encodeURIComponent(pickupId)}/cancel`,
				reason ? { reason } : {},
			);
		},

		getPortalPickupFeePreview(date, options) {
			return request<PickupFeePreview>(
				`/portal/pickup-requests/fee-preview${searchOf(date === undefined ? {} : { date })}`,
				{},
				options,
			);
		},

		listPortalReturns({ signal, ...query } = {}) {
			return request<PortalReturnList>(
				`/portal/returns${searchOf(query)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		getPortalReturn(returnId, options) {
			return request<PortalReturnCaseDetail>(
				`/portal/returns/${encodeURIComponent(returnId)}`,
				{},
				options,
			);
		},

		requestPortalReturn(body) {
			return post<PortalReturnRequestResult>("/portal/returns:request", body);
		},

		getPortalOrderCharges(orderId, options) {
			return request<OrderCharges>(
				`/portal/orders/${encodeURIComponent(orderId)}/charges`,
				{},
				options,
			);
		},

		listPortalOrderShipments(orderId, options) {
			return request<PortalShipmentList>(
				`/portal/orders/${encodeURIComponent(orderId)}/shipments`,
				{},
				options,
			);
		},

		getPortalShipmentPod(shipmentId, options) {
			return request<PortalPod>(
				`/portal/shipments/${encodeURIComponent(shipmentId)}/pod`,
				{},
				options,
			);
		},

		listPortalTickets({ signal, ...query } = {}) {
			return request<StoreTicketList>(
				`/portal/tickets${searchOf(query)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		openPortalTicket(body) {
			return post<StoreTicketDetail>("/portal/tickets", body);
		},

		getPortalTicket(ticketId, options) {
			return request<StoreTicketDetail>(
				`/portal/tickets/${encodeURIComponent(ticketId)}`,
				{},
				options,
			);
		},

		replyPortalTicket(ticketId, body) {
			return post<StoreTicketDetail>(
				`/portal/tickets/${encodeURIComponent(ticketId)}/messages`,
				body,
			);
		},

		listStoreTickets({ signal, ...query } = {}) {
			return request<StoreTicketList>(
				`/store-tickets${searchOf(query)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		getStoreTicket(ticketId, options) {
			return request<StoreTicketDetail>(
				`/store-tickets/${encodeURIComponent(ticketId)}`,
				{},
				options,
			);
		},

		replyStoreTicket(ticketId, body) {
			return post<StoreTicketDetail>(
				`/store-tickets/${encodeURIComponent(ticketId)}/messages`,
				body,
			);
		},

		setStoreTicketStatus(ticketId, status) {
			return post<StoreTicketDetail>(`/store-tickets/${encodeURIComponent(ticketId)}/status`, {
				status,
			});
		},

		decideStoreTicketClaim(ticketId, body) {
			return post<StoreTicketDetail>(
				`/store-tickets/${encodeURIComponent(ticketId)}/claim-decision`,
				body,
			);
		},

		printManifest(manifestId) {
			return file(`/delivery/manifests/${encodeURIComponent(manifestId)}/print`);
		},

		printShipmentWaybill(shipmentId) {
			return file(`/delivery/shipments/${encodeURIComponent(shipmentId)}/waybill.pdf`);
		},

		listDispatchOrders({ signal, ...query } = {}) {
			return request<DispatchOrderList>(
				`/dispatch-orders${searchOf(query)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		getDispatchOrder(dispatchId, options) {
			return request<DispatchOrderDetail>(
				`/dispatch-orders/${encodeURIComponent(dispatchId)}`,
				{},
				options,
			);
		},

		createDispatchOrder(body) {
			return post<DispatchOrderDetail>("/dispatch-orders", body);
		},

		updateDispatchOrder(dispatchId, body, version) {
			return request<DispatchOrderDetail>(`/dispatch-orders/${encodeURIComponent(dispatchId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(body),
			});
		},

		moveDispatchOrder(dispatchId, step) {
			return post<DispatchOrderDetail>(
				`/dispatch-orders/${encodeURIComponent(dispatchId)}/${step}`,
				undefined,
			);
		},

		approveDispatchOrder(dispatchId, body) {
			return post<DispatchOrderDetail>(
				`/dispatch-orders/${encodeURIComponent(dispatchId)}/approve`,
				body,
			);
		},

		pickDispatchOrder(dispatchId, picks) {
			return post<DispatchOrderDetail>(`/dispatch-orders/${encodeURIComponent(dispatchId)}/pick`, {
				picks,
			});
		},

		dispatchDispatchOrder(dispatchId, body) {
			return post<DispatchOrderDetail>(
				`/dispatch-orders/${encodeURIComponent(dispatchId)}/dispatch`,
				body,
			);
		},

		cancelDispatchOrder(dispatchId, reason) {
			return post<DispatchOrderDetail>(
				`/dispatch-orders/${encodeURIComponent(dispatchId)}/cancel`,
				reason === undefined ? {} : { reason },
			);
		},

		listDispatchDocuments(dispatchId, options) {
			return request<DispatchDocumentList>(
				`/dispatch-orders/${encodeURIComponent(dispatchId)}/documents`,
				{},
				options,
			);
		},

		printDispatchDocument(dispatchId, kind) {
			return file(
				`/dispatch-orders/${encodeURIComponent(dispatchId)}/documents/${encodeURIComponent(kind)}`,
			);
		},

		getDispatchLog(dispatchId, options) {
			return request<DispatchLog>(
				`/dispatch-orders/${encodeURIComponent(dispatchId)}/log`,
				{},
				options,
			);
		},

		exportDispatchLog(dispatchId) {
			return file(`/dispatch-orders/${encodeURIComponent(dispatchId)}/log?format=csv`);
		},

		listDeliveryExceptions({ signal, ...query }) {
			return request<DeliveryExceptionPage>(
				`/delivery/exceptions${searchOf(query)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		bulkAssignShipments(body, idempotencyKey) {
			return post<ShipmentBulkAssignResult>("/delivery/shipments:bulk-assign", body, {
				idempotencyKey,
			});
		},

		getShipmentProof(shipmentId, options) {
			return request<ShipmentProof>(
				`/delivery/shipments/${encodeURIComponent(shipmentId)}/pod`,
				{},
				options,
			);
		},

		setShipmentPin(shipmentId, body) {
			return post<Shipment>(`/delivery/shipments/${encodeURIComponent(shipmentId)}/geocode`, body);
		},

		setShipmentWindow(shipmentId, body) {
			return request<Shipment>(`/delivery/shipments/${encodeURIComponent(shipmentId)}/window`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(body),
			});
		},

		setShipmentPromisedDate(shipmentId, body) {
			return request<Shipment>(
				`/delivery/shipments/${encodeURIComponent(shipmentId)}/promised-date`,
				{
					method: "PATCH",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(body),
				},
			);
		},

		getTimeToDeliver({ signal, ...query }) {
			return request<DeliveryTimeReport>(
				`/delivery/time-to-deliver${searchOf(query)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		setShipmentInsurance(shipmentId, body) {
			return request<Shipment>(`/delivery/shipments/${encodeURIComponent(shipmentId)}/insurance`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(body),
			});
		},

		shipmentTrackingLink(shipmentId) {
			return post<ShipmentTrackingLink>(
				`/delivery/shipments/${encodeURIComponent(shipmentId)}/tracking-link`,
				{},
			);
		},

		getShipmentCod(shipmentId, options) {
			return request<CodCollection>(
				`/delivery/shipments/${encodeURIComponent(shipmentId)}/cod`,
				{},
				options,
			);
		},

		listMyDriverShipmentHistory(query) {
			return request<DriverShipmentHistory>(
				`/delivery/me/shipments/history${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getMyDriverWallet(options) {
			return request<DriverWallet>("/delivery/me/wallet", {}, options);
		},

		getMyCodTenderOptions(options) {
			return request<CodTenderOptions>("/delivery/me/cod-tender-options", {}, options);
		},

		listMyCodHandovers(options) {
			return request<CodHandoverList>("/delivery/me/handovers", {}, options);
		},

		getMyCodHandover(handoverId, options) {
			return request<CodHandover>(
				`/delivery/me/handovers/${encodeURIComponent(handoverId)}`,
				{},
				options,
			);
		},

		listDeliveryCodCollections(query = {}) {
			return request<CodCollectionList>(
				`/delivery/cod/collections${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		initiateCodBatch(body) {
			return post<CodHandover>("/delivery/cod/handovers", body);
		},

		listDeliveryCodHandovers(query = {}) {
			return request<CodHandoverList>(
				`/delivery/cod/handovers${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		confirmDeliveryCodHandover(handoverId, body, idempotencyKey) {
			return post<CodHandover>(
				`/delivery/cod/handovers/${encodeURIComponent(handoverId)}/confirm`,
				body,
				{ idempotencyKey },
			);
		},

		depositCodHandover(handoverId, body) {
			return post<CodHandover>(
				`/delivery/cod/handovers/${encodeURIComponent(handoverId)}/deposit`,
				body,
			);
		},

		getDeliveryCodAging(options) {
			return request<CodAging>("/delivery/cod/aging", {}, options);
		},

		listDeliveryVehicles(options) {
			return request<DeliveryVehicleList>("/delivery/vehicles", {}, options);
		},

		createDeliveryVehicle(draft) {
			return post<DeliveryVehicle>("/delivery/vehicles", draft);
		},

		updateDeliveryVehicle(vehicleId, patch, version) {
			return request<DeliveryVehicle>(`/delivery/vehicles/${encodeURIComponent(vehicleId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(patch),
			});
		},

		listDeliveryShifts(query) {
			const params = new URLSearchParams({ from: query.from, to: query.to });
			if (query.driverId !== undefined) {
				params.set("driverId", query.driverId);
			}
			return request<DriverShiftList>(
				`/delivery/shifts?${params}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		planDeliveryShift(draft) {
			return post<DriverShift>("/delivery/shifts", draft);
		},

		getDeliveryCompanyCapacity(companyId, query = {}) {
			// The date is left off entirely when absent rather than sent empty:
			// the server's default is the tenant's today, and `?date=` would be
			// a malformed date rather than no date.
			const search = query.date === undefined ? "" : `?date=${encodeURIComponent(query.date)}`;
			return request<DeliveryCompanyCapacity>(
				`/delivery/companies/${encodeURIComponent(companyId)}/capacity${search}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		listDeliveryCompanyStores(companyId, query = {}) {
			const params = new URLSearchParams();
			if (query.limit !== undefined) {
				params.set("limit", String(query.limit));
			}
			if (query.cursor !== undefined && query.cursor !== "") {
				params.set("cursor", query.cursor);
			}
			const search = params.size > 0 ? `?${params}` : "";
			return request<DeliveryCompanyStoreList>(
				`/delivery/companies/${encodeURIComponent(companyId)}/stores${search}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		assignDeliveryCompanyStore(companyId, draft) {
			return post<DeliveryCompanyStore>(
				`/delivery/companies/${encodeURIComponent(companyId)}/stores`,
				draft,
			);
		},

		updateDeliveryCompanyStore(companyId, storeId, patch) {
			return request<DeliveryCompanyStore>(
				`/delivery/companies/${encodeURIComponent(companyId)}/stores/${encodeURIComponent(storeId)}`,
				{
					method: "PATCH",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(patch),
				},
			);
		},

		listStoreDeliveryCompanies(storeId, options) {
			return request<StoreDeliveryCompanyList>(
				`/stores/${encodeURIComponent(storeId)}/delivery-companies`,
				{},
				options,
			);
		},

		getDeliveryAssignmentRules(storeId, options) {
			return request<DeliveryAssignmentRuleSet>(
				`/stores/${encodeURIComponent(storeId)}/delivery-assignment-rules`,
				{},
				options,
			);
		},

		replaceDeliveryAssignmentRules(storeId, draft) {
			return request<DeliveryAssignmentRuleSet>(
				`/stores/${encodeURIComponent(storeId)}/delivery-assignment-rules`,
				{
					method: "PUT",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(draft),
				},
			);
		},

		resolveDeliveryAssignment(body) {
			return post<DeliveryAssignmentResolution>("/delivery/assignment:resolve", body);
		},

		listDeliveryRates(query = {}) {
			return request<DeliveryRateList>(
				`/delivery/delivery-rates${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		createDeliveryRate(draft) {
			return post<DeliveryRateCreated>("/delivery/delivery-rates", draft);
		},

		updateDeliveryRate(rateId, patch) {
			return request<DeliveryRate>(`/delivery/delivery-rates/${encodeURIComponent(rateId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(patch),
			});
		},

		endDeliveryRate(rateId, effectiveTo) {
			// An omitted end means now, which the server decides. Sending
			// `{"effectiveTo": null}` would say the same thing in a second way.
			return post<DeliveryRate>(
				`/delivery/delivery-rates/${encodeURIComponent(rateId)}/end`,
				effectiveTo === undefined ? {} : { effectiveTo },
			);
		},

		quoteDeliveryLane(body) {
			return post<DeliveryQuote>("/delivery/quotes", body);
		},

		listRateCards(options) {
			return request<RateCardList>("/delivery/rate-cards", {}, options);
		},

		getRateCard(cardId, options) {
			return request<RateCard>(`/delivery/rate-cards/${encodeURIComponent(cardId)}`, {}, options);
		},

		createRateCard(body) {
			return post<RateCard>("/delivery/rate-cards", body);
		},

		updateRateCard(cardId, patch) {
			return request<RateCard>(`/delivery/rate-cards/${encodeURIComponent(cardId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(patch),
			});
		},

		publishRateCard(cardId) {
			return post<RateCard>(`/delivery/rate-cards/${encodeURIComponent(cardId)}/publish`, {});
		},

		archiveRateCard(cardId) {
			return post<RateCard>(`/delivery/rate-cards/${encodeURIComponent(cardId)}/archive`, {});
		},

		patchShipment(shipmentId, patch) {
			return request<Shipment>(`/delivery/shipments/${encodeURIComponent(shipmentId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(patch),
			});
		},

		listEffectiveDeliveryRates(storeId, query) {
			return request<EffectiveDeliveryRateList>(
				`/stores/${encodeURIComponent(storeId)}/delivery-rates/effective${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		listStoreDeliveryRates(storeId, query = {}) {
			return request<StoreDeliveryRateList>(
				`/stores/${encodeURIComponent(storeId)}/delivery-rates${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getStoreDeliveryCoverage(storeId, query = {}) {
			return request<StoreDeliveryCoverage>(
				`/stores/${encodeURIComponent(storeId)}/delivery-rates/coverage${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getDeliveryRatesGrid(companyId, query = {}) {
			return request<DeliveryRatesGrid>(
				`/delivery/companies/${encodeURIComponent(companyId)}/rates-grid${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		listStoreDeliveryPrices(query = {}) {
			return request<StoreDeliveryPriceList>(
				`/store/delivery-prices${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		listNegativeMarginDeliveryRates(query = {}) {
			return request<NegativeMarginReport>(
				`/delivery/delivery-rates/negative-margin${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		createCity(provinceId, draft) {
			// The province is in the path rather than the body: a city exists
			// inside exactly one, and a payload that could disagree with the URL
			// would be two answers to a question with one.
			return post<City>(`/delivery/provinces/${encodeURIComponent(provinceId)}/cities`, draft);
		},

		updateCity(cityId, patch, version) {
			return request<City>(`/delivery/cities/${encodeURIComponent(cityId)}`, {
				method: "PATCH",
				headers: {
					"Content-Type": "application/json",
					// Quoted, because that is what an entity tag is (RFC 9110).
					"If-Match": `"${version}"`,
				},
				body: JSON.stringify(patch),
			});
		},

		deleteCity(cityId) {
			return request<City>(`/delivery/cities/${encodeURIComponent(cityId)}`, {
				method: "DELETE",
			});
		},

		listLocationTypes(options) {
			return request<LocationTypeList>("/location-types", {}, options);
		},

		createLocationType(draft) {
			return post<LocationType>("/location-types", draft);
		},

		renameLocationType(typeId, patch, version) {
			return request<LocationType>(`/location-types/${encodeURIComponent(typeId)}`, {
				method: "PATCH",
				headers: {
					"Content-Type": "application/json",
					// Quoted, because that is what an entity tag is (RFC 9110).
					"If-Match": `"${version}"`,
				},
				body: JSON.stringify(patch),
			});
		},

		async deleteLocationType(typeId) {
			await request<void>(`/location-types/${encodeURIComponent(typeId)}`, {
				method: "DELETE",
			});
		},

		getLocationTree(query) {
			return request<LocationTreeResponse>(
				`/locations/tree${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		createLocations(draft) {
			return post<LocationsCreated>("/locations", draft);
		},

		getLocation(ref, options) {
			return request<StorageLocation>(`/locations/${encodeURIComponent(ref)}`, {}, options);
		},

		updateLocation(locationId, patch, version) {
			return request<StorageLocation>(`/locations/${encodeURIComponent(locationId)}`, {
				method: "PATCH",
				headers: {
					"Content-Type": "application/json",
					"If-Match": `"${version}"`,
				},
				body: JSON.stringify(patch),
			});
		},

		moveLocation(locationId, parentId, version) {
			return request<LocationMoveResult>(`/locations/${encodeURIComponent(locationId)}/move`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"If-Match": `"${version}"`,
				},
				body: JSON.stringify({ parentId }),
			});
		},

		getLocationContents(locationId, options) {
			return request<LocationContents>(
				`/locations/${encodeURIComponent(locationId)}/contents`,
				{},
				options,
			);
		},

		getLocationLabel(locationId, options) {
			return request<LocationLabel>(
				`/labels/locations/${encodeURIComponent(locationId)}`,
				{},
				options,
			);
		},

		listEntityPostings(sourceKind, sourceId, options) {
			return request<EntityPostings>(
				`/finance/sources/${encodeURIComponent(sourceKind)}/${encodeURIComponent(sourceId)}/postings`,
				{},
				options,
			);
		},

		listJournalEntries(query = {}) {
			return request<JournalPage>(
				`/finance/journal-entries${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getJournalEntry(journalId, options) {
			return request<JournalDetail>(
				`/finance/journal-entries/${encodeURIComponent(journalId)}`,
				{},
				options,
			);
		},

		postJournalEntry(draft, idempotencyKey) {
			return post<PostedJournal>("/finance/journal-entries", draft, { idempotencyKey });
		},

		approveJournalEntry(journalId, options) {
			return post<Journal>(
				`/finance/journal-entries/${encodeURIComponent(journalId)}/approve`,
				undefined,
				options,
			);
		},

		reverseJournalEntry(journalId, body, options) {
			return post<Journal>(
				`/finance/journal-entries/${encodeURIComponent(journalId)}/reverse`,
				body,
				options,
			);
		},

		listPostingRules(eventType, options) {
			return request<PostingRuleList>(
				`/finance/posting-rules${searchOf({ eventType: eventType ?? "" })}`,
				{},
				options,
			);
		},

		listEconomicEvents(query = {}) {
			return request<EconomicEventPage>(
				`/finance/economic-events${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		repostEconomicEvent(eventId, options) {
			return post<EconomicEvent>(
				`/finance/economic-events/${encodeURIComponent(eventId)}/repost`,
				undefined,
				options,
			);
		},

		listCashoutEligibleOrders(storeId, options) {
			return request<CashoutEligibleOrders>(
				`/cashouts/eligible-orders?storeId=${encodeURIComponent(storeId)}`,
				{},
				options,
			);
		},

		listCashouts(query = {}) {
			return request<CashoutList>(
				`/cashouts${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getCashout(cashoutId, options) {
			return request<Cashout>(`/cashouts/${encodeURIComponent(cashoutId)}`, {}, options);
		},

		generateCashout(body, idempotencyKey) {
			return post<Cashout>("/cashouts", body, { idempotencyKey });
		},

		cancelCashout(cashoutId, reason, idempotencyKey) {
			return post<Cashout>(
				`/cashouts/${encodeURIComponent(cashoutId)}/cancel`,
				{ reason },
				{ idempotencyKey },
			);
		},

		downloadCashoutDocument(cashoutId, format) {
			return file(`/cashouts/${encodeURIComponent(cashoutId)}/document?format=${format}`);
		},

		getRemittanceSettings(storeId, options) {
			return request<RemittanceSettings>(
				`/stores/${encodeURIComponent(storeId)}/remittance-settings`,
				{},
				options,
			);
		},

		putRemittanceSettings(storeId, draft, version) {
			return request<RemittanceSettings>(
				`/stores/${encodeURIComponent(storeId)}/remittance-settings`,
				{
					method: "PUT",
					headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
					body: JSON.stringify(draft),
				},
			);
		},

		getPortalExpressCashoutQuote(options) {
			return request<ExpressCashoutQuote>("/portal/cashouts/express-quote", {}, options);
		},

		createPortalExpressCashout(idempotencyKey) {
			return post<Cashout>("/portal/cashouts/express", {}, { idempotencyKey });
		},

		getPortalFinanceSummary(query, options) {
			return request<PortalFinanceSummary>(
				`/portal/finance/summary${searchOf(query)}`,
				{},
				options,
			);
		},

		getPortalFinanceBalance(options) {
			return request<PortalFinanceBalance>("/portal/finance/balance", {}, options);
		},

		listPortalCashouts(query = {}) {
			return request<CashoutList>(
				`/portal/finance/cashouts${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		downloadPortalCashoutDocument(cashoutId) {
			return file(`/portal/finance/cashouts/${encodeURIComponent(cashoutId)}/document`);
		},

		listPortalStatements(options) {
			return request<PortalStatementList>("/portal/finance/statements", {}, options);
		},

		getPortalFinanceStatement(statementId, options) {
			return request<PortalStatementDetail>(
				`/portal/finance/statements/${encodeURIComponent(statementId)}`,
				{},
				options,
			);
		},

		downloadPortalStatementDocument(statementId) {
			return file(`/portal/finance/statements/${encodeURIComponent(statementId)}/document`);
		},

		getPortalLedgerEntry(entryId, options) {
			return request<PortalLedgerEntry>(
				`/portal/finance/ledger-entries/${encodeURIComponent(entryId)}`,
				{},
				options,
			);
		},

		listPortalPayouts(options) {
			return request<StorePayoutList>("/portal/finance/payouts", {}, options);
		},

		getPortalStorageFee(options) {
			return request<StorageFeeRow>("/portal/finance/storage-fee", {}, options);
		},

		listPortalCashoutRequests(query = {}) {
			return request<PortalCashoutRequestList>(
				`/portal/finance/cashout-requests${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		createPortalCashoutRequest(amountMinor, idempotencyKey) {
			return post<CashoutRequest>(
				"/portal/finance/cashout-requests",
				{ amountMinor },
				{ idempotencyKey },
			);
		},

		cancelPortalCashoutRequest(requestId) {
			return post<CashoutRequest>(
				`/portal/finance/cashout-requests/${encodeURIComponent(requestId)}/cancel`,
				{},
			);
		},

		disputePortalLedgerEntry(entryId, body) {
			return post<PortalLedgerDisputeResult>(
				`/portal/finance/ledger-entries/${encodeURIComponent(entryId)}/dispute`,
				body,
			);
		},

		listPortalDeliveryRates(options) {
			return request<StoreDeliveryPriceList>("/portal/delivery-rates", {}, options);
		},

		listPayoutRuns(query = {}) {
			return request<PayoutRunList>(
				`/payout-runs${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getPayoutRun(runId, options) {
			return request<PayoutRun>(`/payout-runs/${encodeURIComponent(runId)}`, {}, options);
		},

		createPayoutRun(body, idempotencyKey) {
			return post<PayoutRun>("/payout-runs", body, { idempotencyKey });
		},

		transitionPayoutRun(runId, action, idempotencyKey) {
			return post<PayoutRun>(`/payout-runs/${encodeURIComponent(runId)}/${action}`, undefined, {
				idempotencyKey,
			});
		},

		listPayoutRunItems(runId, options) {
			return request<PayoutRunItemList>(
				`/payout-runs/${encodeURIComponent(runId)}/items`,
				{},
				options,
			);
		},

		listPayoutRunItemEntries(runId, itemId, options) {
			return request<PayoutRunItemEntries>(
				`/payout-runs/${encodeURIComponent(runId)}/items/${encodeURIComponent(itemId)}/entries`,
				{},
				options,
			);
		},

		holdPayoutRunItem(runId, itemId, body, idempotencyKey) {
			return post<PayoutRunItem>(
				`/payout-runs/${encodeURIComponent(runId)}/items/${encodeURIComponent(itemId)}/hold`,
				body,
				{ idempotencyKey },
			);
		},

		recordPayoutRunItemResult(runId, itemId, body, idempotencyKey) {
			return post<PayoutRunItem>(
				`/payout-runs/${encodeURIComponent(runId)}/items/${encodeURIComponent(itemId)}/result`,
				body,
				{ idempotencyKey },
			);
		},

		downloadPayoutRunExport(runId) {
			return file(`/payout-runs/${encodeURIComponent(runId)}/export`);
		},

		listSettlementRuns(query = {}) {
			return request<SettlementRunList>(
				`/finance/settlement-runs${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getSettlementRun(runId, options) {
			return request<SettlementRun>(
				`/finance/settlement-runs/${encodeURIComponent(runId)}`,
				{},
				options,
			);
		},

		createSettlementRun(body, idempotencyKey) {
			return post<SettlementRun>("/finance/settlement-runs", body, { idempotencyKey });
		},

		listSettlementLines(runId, options) {
			return request<SettlementLineList>(
				`/finance/settlement-runs/${encodeURIComponent(runId)}/lines`,
				{},
				options,
			);
		},

		listSettlementDisputes(options) {
			return request<SettlementLineList>("/finance/settlement-disputes", {}, options);
		},

		actOnSettlementLine(runId, lineId, body, idempotencyKey) {
			return post<SettlementLineResult>(
				`/finance/settlement-runs/${encodeURIComponent(runId)}/lines/${encodeURIComponent(lineId)}/dispute`,
				body,
				{ idempotencyKey },
			);
		},

		transitionSettlementRun(runId, body, idempotencyKey) {
			return post<SettlementRun>(
				`/finance/settlement-runs/${encodeURIComponent(runId)}/transition`,
				body,
				{ idempotencyKey },
			);
		},

		downloadSettlementStatement(runId, format) {
			return file(
				`/finance/settlement-runs/${encodeURIComponent(runId)}/statement?format=${format}`,
			);
		},

		getPnlReport(query) {
			const { signal, ...rest } = query;
			return request<PnlReport>(
				`/reports/pnl${searchOf(rest)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		getCarrierMarginReport(query) {
			const { signal, ...rest } = query;
			return request<CarrierMarginReport>(
				`/reports/carrier-margin${searchOf(rest)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		getAgingReport(options) {
			return request<AgingReport>("/reports/aging", {}, options);
		},

		listReportEntries(query) {
			const { signal, ...rest } = query;
			return request<ReportEntryList>(
				`/reports/entries${searchOf(rest)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		listReportSnapshots(periodStart, options) {
			return request<ReportSnapshotList>(
				`/report-snapshots${searchOf(periodStart === undefined ? {} : { periodStart })}`,
				{},
				options,
			);
		},

		downloadPartyStatement(kind, partyId, query, format) {
			return file(
				`/statements/party/${encodeURIComponent(kind)}/${encodeURIComponent(partyId)}${searchOf({ ...query, format })}`,
			);
		},

		createExportJob(body) {
			return post<ExportJob>("/export-jobs", body);
		},

		listExportJobs(options) {
			return request<ExportJobList>("/export-jobs", {}, options);
		},

		getExportJob(jobId, options) {
			return request<ExportJob>(`/export-jobs/${encodeURIComponent(jobId)}`, {}, options);
		},

		downloadExportJob(jobId) {
			return file(`/export-jobs/${encodeURIComponent(jobId)}/download`);
		},

		getCarrierBalance(companyId, options) {
			return request<CarrierBalance>(
				`/finance/carriers/${encodeURIComponent(companyId)}/balance`,
				{},
				options,
			);
		},

		listAdjustments(query = {}) {
			return request<AdjustmentList>(
				`/finance/adjustments${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getAdjustment(adjustmentId, options) {
			return request<Adjustment>(
				`/finance/adjustments/${encodeURIComponent(adjustmentId)}`,
				{},
				options,
			);
		},

		previewAdjustment(adjustmentId, options) {
			return request<AdjustmentPreview>(
				`/finance/adjustments/${encodeURIComponent(adjustmentId)}/preview`,
				{},
				options,
			);
		},

		createAdjustment(body, idempotencyKey) {
			return post<Adjustment>("/finance/adjustments", body, { idempotencyKey });
		},

		submitAdjustment(adjustmentId, idempotencyKey) {
			return post<Adjustment>(
				`/finance/adjustments/${encodeURIComponent(adjustmentId)}/submit`,
				{},
				{ idempotencyKey },
			);
		},

		approveAdjustment(adjustmentId, idempotencyKey) {
			return post<Adjustment>(
				`/finance/adjustments/${encodeURIComponent(adjustmentId)}/approve`,
				{},
				{ idempotencyKey },
			);
		},

		rejectAdjustment(adjustmentId, note, idempotencyKey) {
			return post<Adjustment>(
				`/finance/adjustments/${encodeURIComponent(adjustmentId)}/reject`,
				{ note },
				{ idempotencyKey },
			);
		},

		listRecurringCosts(options) {
			return request<RecurringCostList>("/finance/internal/recurring-costs", {}, options);
		},

		createRecurringCost(body, idempotencyKey) {
			return post<RecurringCost>("/finance/internal/recurring-costs", body, { idempotencyKey });
		},

		updateRecurringCost(recurringCostId, patch) {
			return request<RecurringCost>(
				`/finance/internal/recurring-costs/${encodeURIComponent(recurringCostId)}`,
				{
					method: "PATCH",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(patch),
				},
			);
		},

		syncInternalSalaries() {
			return post<SalarySyncResult>("/finance/internal/salaries/sync", undefined);
		},

		listOneTimeCosts(query = {}) {
			return request<OneTimeCostList>(
				`/finance/internal/one-time-costs${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		createOneTimeCost(body, idempotencyKey) {
			return post<OneTimeCost>("/finance/internal/one-time-costs", body, { idempotencyKey });
		},

		updateOneTimeCost(oneTimeCostId, patch) {
			return request<OneTimeCost>(
				`/finance/internal/one-time-costs/${encodeURIComponent(oneTimeCostId)}`,
				{
					method: "PATCH",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(patch),
				},
			);
		},

		getOneTimeCostAttachment(oneTimeCostId) {
			return request<{ url: string }>(
				`/finance/internal/one-time-costs/${encodeURIComponent(oneTimeCostId)}/attachment`,
				{},
			);
		},

		getInternalStatus(query, options) {
			return request<InternalStatus>(`/finance/internal/status${searchOf(query)}`, {}, options);
		},

		getInternalStatusMonthly(year, options) {
			return request<InternalStatus>(`/finance/internal/status/monthly?year=${year}`, {}, options);
		},

		listInternalStatusItems(query, options) {
			return request<InternalStatusItemList>(
				`/finance/internal/status/items${searchOf(query)}`,
				{},
				options,
			);
		},

		listProfitPeriodVersions(periodId, options) {
			return request<ProfitPeriodList>(
				`/finance/internal/periods/${encodeURIComponent(periodId)}`,
				{},
				options,
			);
		},

		closeProfitPeriod(periodId) {
			return post<ProfitPeriodClose>(
				`/finance/internal/periods/${encodeURIComponent(periodId)}/close`,
				undefined,
			);
		},

		exportInternalFinance(query) {
			return file(`/finance/internal/export${searchOf(query)}`);
		},

		listDriverEarnings(query = {}) {
			return request<DriverEarningList>(
				`/finance/driver-earnings${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getDriverEarningsSummary(driverId, options) {
			return request<DriverEarningsSummary>(
				`/finance/drivers/${encodeURIComponent(driverId)}/earnings-summary`,
				{},
				options,
			);
		},

		listDriverShortfalls(query = {}) {
			return request<DriverShortfallList>(
				`/finance/driver-shortfalls${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		writeOffDriverShortfall(shortfallId, reason, idempotencyKey) {
			return post<DriverShortfall>(
				`/finance/driver-shortfalls/${encodeURIComponent(shortfallId)}/write-off`,
				{ reason },
				{ idempotencyKey },
			);
		},

		listStatements(query = {}) {
			return request<BillingStatementList>(
				`/billing/statements${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getStatement(statementId, options) {
			return request<BillingStatement>(
				`/billing/statements/${encodeURIComponent(statementId)}`,
				{},
				options,
			);
		},

		listStatementLines(statementId, options = {}) {
			const { cursor, limit, ...rest } = options;
			return request<BillingStatementLines>(
				`/billing/statements/${encodeURIComponent(statementId)}/lines${searchOf({ cursor, limit })}`,
				{},
				rest,
			);
		},

		generateStatements(body, idempotencyKey) {
			return post<StatementGenerateResult>("/billing/statements/generate", body, {
				idempotencyKey,
			});
		},

		transitionStatement(statementId, action, idempotencyKey) {
			return post<BillingStatement>(
				`/billing/statements/${encodeURIComponent(statementId)}/${action}`,
				undefined,
				{ idempotencyKey },
			);
		},

		downloadStatementCSV(statementId) {
			return file(`/billing/statements/${encodeURIComponent(statementId)}/document`);
		},

		listStatementDisputes(options) {
			return request<BillingStatementLines>("/billing/disputes", {}, options);
		},

		resolveStatementDispute(entryId, note, idempotencyKey) {
			return post<StatementLine>(
				`/billing/disputes/${encodeURIComponent(entryId)}/resolve`,
				{ note },
				{ idempotencyKey },
			);
		},

		listInvoices(query = {}) {
			return request<InvoiceList>(
				`/billing/invoices${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getInvoice(invoiceId, options) {
			return request<Invoice>(`/billing/invoices/${encodeURIComponent(invoiceId)}`, {}, options);
		},

		downloadInvoicePDF(invoiceId) {
			return file(`/billing/invoices/${encodeURIComponent(invoiceId)}/document`);
		},

		issueCreditNote(invoiceId, body, idempotencyKey) {
			return post<CreditNote>(
				`/billing/invoices/${encodeURIComponent(invoiceId)}/credit-notes`,
				body,
				{ idempotencyKey },
			);
		},

		listCreditNotes(options) {
			return request<CreditNoteList>("/billing/credit-notes", {}, options);
		},

		listFeeSchedules(query = {}) {
			return request<FeeScheduleList>(
				`/finance/fee-schedules${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		createFeeSchedule(body, options) {
			return post<FeeSchedule>("/finance/fee-schedules", body, options);
		},

		closeFeeSchedule(scheduleId, body, options) {
			return post<FeeSchedule>(
				`/finance/fee-schedules/${encodeURIComponent(scheduleId)}/close`,
				body,
				options,
			);
		},

		getFeeMatrix(query = {}) {
			return request<FeeMatrix>(
				`/finance/fee-matrix${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		listTaxRules(options) {
			return request<TaxRuleList>("/finance/tax-rules", {}, options);
		},

		createTaxRule(body, options) {
			return post<TaxRule>("/finance/tax-rules", body, options);
		},

		priceBillableEvent(body, options) {
			return post<PriceResult>("/finance/price", body, options);
		},

		getFxRate(date, options) {
			return request<FxRate>(`/finance/fx-rates/${encodeURIComponent(date)}`, {}, options);
		},

		publishFxRate(date, lbpPerUsd) {
			return request<FxRatePublication>(`/finance/fx-rates/${encodeURIComponent(date)}`, {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ lbpPerUsd }),
			});
		},

		listCodCollections(query = {}, options) {
			return request<CodCollectionList>(`/finance/cod/collections${searchOf(query)}`, {}, options);
		},

		getCodCollection(collectionId, options) {
			return request<CodCollection>(
				`/finance/cod/collections/${encodeURIComponent(collectionId)}`,
				{},
				options,
			);
		},

		getCodSummary(options) {
			return request<CodSummary>("/finance/cod/summary", {}, options);
		},

		openCodHandover(driverId, idempotencyKey) {
			return post<CodHandoverOpened>("/finance/cod/handovers", { driverId }, { idempotencyKey });
		},

		getCodHandover(handoverId, options) {
			return request<CodHandoverDetail>(
				`/finance/cod/handovers/${encodeURIComponent(handoverId)}`,
				{},
				options,
			);
		},

		confirmCodHandover(handoverId, body) {
			return post<CodHandover>(
				`/finance/cod/handovers/${encodeURIComponent(handoverId)}/confirm`,
				body,
			);
		},

		countCodHandover(handoverId, body, idempotencyKey) {
			return post<CodHandover>(
				`/finance/cod/handovers/${encodeURIComponent(handoverId)}/count`,
				body,
				{ idempotencyKey },
			);
		},

		listCodDiscrepancies(query = {}, options) {
			return request<CodDiscrepancyList>(
				`/finance/cod/discrepancies${searchOf(query)}`,
				{},
				options,
			);
		},

		resolveCodDiscrepancy(discrepancyId, body) {
			return post<CodDiscrepancy>(
				`/finance/cod/discrepancies/${encodeURIComponent(discrepancyId)}/resolve`,
				body,
			);
		},

		listZones(query) {
			return request<ZoneList>(
				`/zones${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		listCategories(storeId, options) {
			return request<CategoryTree>(
				`/categories?storeId=${encodeURIComponent(storeId)}`,
				{},
				options,
			);
		},

		createCategory(draft) {
			return post<Category>("/categories", draft);
		},

		patchCategory(categoryId, patch) {
			return request<Category>(`/categories/${encodeURIComponent(categoryId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(patch),
			});
		},

		reparentCategory(categoryId, parentId) {
			return post<Category>(`/categories/${encodeURIComponent(categoryId)}/reparent`, { parentId });
		},

		getCategoryRollup(categoryId, options) {
			return request<CategoryRollup>(
				`/categories/${encodeURIComponent(categoryId)}/rollup`,
				{},
				options,
			);
		},

		async listCategoryNiches(options) {
			const body = await request<{ items: CategoryNiche[] }>("/category-library", {}, options);
			return body.items;
		},

		getCategoryNiche(niche, options) {
			return request<CategoryNiche>(`/category-library/${encodeURIComponent(niche)}`, {}, options);
		},

		importCategoryLibrary(body) {
			return post<CategoryLibraryImportResult>("/categories/import-library", body);
		},

		async listCategoryLibraryPaths(options) {
			const body = await request<{ items: CategoryLibraryPath[] }>(
				"/category-library-paths",
				{},
				options,
			);
			return body.items;
		},

		ensureCategoryLibraryPath(body) {
			return post<CategoryLibraryPathResult>("/categories/ensure-library-path", body);
		},

		createItem(draft, options) {
			return post<ItemDetail>("/items", draft, options ?? {});
		},

		getItem(itemId, options) {
			return request<ItemDetail>(`/items/${encodeURIComponent(itemId)}`, {}, options);
		},

		patchItem(itemId, patch) {
			return request<Item>(`/items/${encodeURIComponent(itemId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(patch),
			});
		},

		addSku(itemId, draft) {
			return post<Sku>(`/items/${encodeURIComponent(itemId)}/skus`, draft);
		},

		listSkus(query) {
			return request<SkuPage>(
				`/skus${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		listLowStock(query) {
			return request<LowStockPage>(
				`/items/low-stock${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		putSkuMinStock(skuId, minStockThreshold) {
			return request<LowStockStatus>(`/skus/${encodeURIComponent(skuId)}/min-stock`, {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ minStockThreshold }),
			});
		},

		createSkuSelection(draft) {
			return post<SkuSelection>("/skus/selection", draft);
		},

		listReorderPolicies(query) {
			return request<ReorderPolicyPage>(
				`/reorder-policies${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		putReorderPolicy(skuId, draft) {
			return request<ReorderPolicy>(`/reorder-policies/${encodeURIComponent(skuId)}`, {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(draft),
			});
		},

		listPickFacePolicies(query) {
			return request<PickFaceStatusPage>(
				`/pick-face-policies${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getPickFacePolicy(locationId, options) {
			return request<PickFaceStatus>(
				`/pick-face-policies/${encodeURIComponent(locationId)}`,
				{},
				options ?? {},
			);
		},

		putPickFacePolicy(locationId, draft) {
			return request<PickFaceStatus>(`/pick-face-policies/${encodeURIComponent(locationId)}`, {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(draft),
			});
		},

		listReplenishmentSuggestions(query) {
			return request<ReplenishmentSuggestionPage>(
				`/replenishment-suggestions${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		acceptReplenishmentSuggestion(id, body) {
			return post<ReplenishmentSuggestion>(
				`/replenishment-suggestions/${encodeURIComponent(id)}/accept`,
				body,
			);
		},

		dismissReplenishmentSuggestion(id, reason) {
			return post<ReplenishmentSuggestion>(
				`/replenishment-suggestions/${encodeURIComponent(id)}/dismiss`,
				{ reason },
			);
		},

		getReorderRecommendations(query) {
			return request<ReorderRecommendationPage>(
				`/reorder-recommendations${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getLowStockReport(options) {
			return request<LowStockReport>("/low-stock-report", {}, options ?? {});
		},

		bulkApproveSkus(body) {
			return post<BulkApproveResponse>("/skus/bulk-approve", body);
		},

		listStockLevels(query) {
			return request<StockLevelPage>(
				`/stock-levels${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		listStockSummary(query) {
			return request<SkuStockSummaryPage>(
				`/stock-levels/summary${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		listStockDiscrepancies(query) {
			return request<StockDiscrepancyPage>(
				`/stock-levels/discrepancies${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		listMovements(query) {
			return request<StockMovementPage>(
				`/movements${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		listItemHistory(subject, query) {
			return request<ItemHistoryPage>(
				`${historyPath(subject)}${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		exportItemHistory(subject, query, format) {
			return file(`${historyPath(subject)}/export${searchOf({ ...query, format })}`);
		},

		listMasterBoxes(query) {
			return request<MasterBoxPage>(
				`/master-boxes${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getMasterBox(boxId, options) {
			return request<MasterBoxDetail>(`/master-boxes/${encodeURIComponent(boxId)}`, {}, options);
		},

		createMasterBox(draft) {
			return post<MasterBox>("/master-boxes", draft);
		},

		updateMasterBox(boxId, patch, version) {
			return request<MasterBox>(`/master-boxes/${encodeURIComponent(boxId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(patch),
			});
		},

		replaceMasterBoxContents(boxId, contents, version) {
			return request<MasterBox>(`/master-boxes/${encodeURIComponent(boxId)}/contents`, {
				method: "PUT",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify({ contents }),
			});
		},

		getMasterBoxLabel(boxId) {
			return file(`/master-boxes/${encodeURIComponent(boxId)}/label`);
		},

		listMasterBoxInstances(boxId, options) {
			return request<MasterBoxInstancePage>(
				`/master-boxes/${encodeURIComponent(boxId)}/instances`,
				{},
				options,
			);
		},

		splitMasterBoxes(draft, idempotencyKey) {
			return post<BoxMoveResult>("/movements/box-split", draft, { idempotencyKey });
		},

		packMasterBoxes(draft, idempotencyKey) {
			return post<BoxMoveResult>("/movements/box-pack", draft, { idempotencyKey });
		},

		listStockAdjustmentReasons(query = {}) {
			return request<StockAdjustmentReasonList>(
				`/stock-adjustment-reasons${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		createStockAdjustmentReason(draft) {
			return post<StockAdjustmentReason>("/stock-adjustment-reasons", draft);
		},

		updateStockAdjustmentReason(reasonCode, patch) {
			return request<StockAdjustmentReason>(
				`/stock-adjustment-reasons/${encodeURIComponent(reasonCode)}`,
				{
					method: "PATCH",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(patch),
				},
			);
		},

		getStockEditContext(query) {
			return request<StockEditContext>(
				`/stock/edit-context${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		adjustStock(draft, idempotencyKey) {
			return post<StockAdjustResult>("/stock/adjust", draft, { idempotencyKey });
		},

		clearStock(skuIds, idempotencyKey) {
			return post<StockClearResult>("/stock/clear", { skuIds }, { idempotencyKey });
		},

		allocateStock(draft, idempotencyKey) {
			return post<StockAllocateResult>("/stock/allocate", draft, { idempotencyKey });
		},

		markStockDamaged(draft, idempotencyKey) {
			return post<StockAdjustResult>("/stock/damage", draft, { idempotencyKey });
		},

		listStockExceptions(query) {
			return request<StockExceptionReport>(
				`/stock-levels/exceptions${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		resolveStockException(draft, idempotencyKey) {
			return post<StockAdjustResult>("/stock/resolve", draft, { idempotencyKey });
		},

		previewBulkStock(draft) {
			return post<BulkStockPreview>("/stock/bulk-preview", draft);
		},

		bulkAdjustStock(draft, idempotencyKey) {
			return post<StockEditBatchDetail>("/stock/bulk-adjust", draft, { idempotencyKey });
		},

		bulkAllocateStock(draft, idempotencyKey) {
			return post<StockEditBatchDetail>("/stock/bulk-allocate", draft, { idempotencyKey });
		},

		listStockEditBatches(query) {
			return request<StockEditBatchPage>(
				`/stock-edit-batches${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getStockEditBatch(batchId, options = {}) {
			return request<StockEditBatchDetail>(
				`/stock-edit-batches/${encodeURIComponent(batchId)}`,
				{},
				options.signal === undefined ? {} : { signal: options.signal },
			);
		},

		decideStockEditBatch(batchId, decision) {
			return post<StockEditBatchDetail>(
				`/stock-edit-batches/${encodeURIComponent(batchId)}/approve`,
				{ decision },
			);
		},

		reverseStockEditBatch(batchId) {
			return post<StockEditBatchDetail>(
				`/stock-edit-batches/${encodeURIComponent(batchId)}/reverse`,
				{},
			);
		},
		listReservations(query) {
			return request<ReservationPage>(
				`/reservations${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		releaseReservation(id) {
			return post<Reservation>(`/reservations/${encodeURIComponent(id)}/release`, undefined);
		},

		listBackorders(query) {
			return request<BackorderPage>(
				`/backorders${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		prioritizeBackorder(id) {
			return post<Backorder>(`/backorders/${encodeURIComponent(id)}/prioritize`, undefined);
		},

		listBinTasks(query) {
			return request<BinTaskPage>(
				`/bin-tasks${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getBinTask(id, options) {
			return request<BinTask>(`/bin-tasks/${encodeURIComponent(id)}`, {}, options);
		},

		createBinTask(draft) {
			return post<BinTask>("/bin-tasks", draft);
		},

		claimBinTask(id) {
			return post<BinTask>(`/bin-tasks/${encodeURIComponent(id)}/claim`, undefined);
		},

		scanBinTask(id, scan) {
			return post<ScanResult>(`/bin-tasks/${encodeURIComponent(id)}/scan`, scan);
		},

		shortBinTask(id, body) {
			return post<BinTask>(`/bin-tasks/${encodeURIComponent(id)}/short`, body);
		},

		skipBinTask(id, reason) {
			return post<BinTask>(`/bin-tasks/${encodeURIComponent(id)}/skip`, { reason });
		},

		replayScanEvents(scans) {
			return post<ScanBatchResult>("/scan-events/batch", { scans });
		},

		setItemTracking(itemId, draft) {
			return request<ItemTracking>(`/items/${encodeURIComponent(itemId)}/tracking`, {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(draft),
			});
		},

		listLots(query) {
			return request<LotPage>(
				`/lots${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getLot(lotId, options) {
			return request<Lot>(`/lots/${encodeURIComponent(lotId)}`, {}, options);
		},

		holdLot(lotId, reason) {
			return post<Lot>(`/lots/${encodeURIComponent(lotId)}/hold`, { reason });
		},

		releaseLot(lotId) {
			return post<Lot>(`/lots/${encodeURIComponent(lotId)}/release`, undefined);
		},

		disposeLot(lotId, note) {
			return post<LotDisposal>(
				`/lots/${encodeURIComponent(lotId)}/dispose`,
				note === undefined || note === "" ? undefined : { note },
			);
		},

		traceLot(lotId, options) {
			return request<LotTrace>(`/lots/${encodeURIComponent(lotId)}/trace`, {}, options);
		},

		downloadLotTrace(lotId, format) {
			return file(`/lots/${encodeURIComponent(lotId)}/trace/export${searchOf({ format })}`);
		},

		listSerialNumbers(query) {
			return request<SerialNumberPage>(
				`/serial-numbers${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getExpiryReport(query) {
			return request<ExpiryReport>(
				`/expiry-report${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		listStockTakes(query) {
			return request<StockTakePage>(
				`/stock-takes${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getStockTake(id, options) {
			return request<StockTakeDetail>(`/stock-takes/${encodeURIComponent(id)}`, {}, options);
		},

		createStockTake(draft) {
			return post<StockTake>("/stock-takes", draft);
		},

		previewStockTake(body, options) {
			return post<StockTakePreview>("/stock-takes/preview", body, options);
		},

		listStockTakeActiveUnits(warehouseId, options) {
			return request<StockTakeActiveUnits>(
				`/stock-takes/active-units${searchOf({ warehouseId })}`,
				{},
				options,
			);
		},

		generateStockTakeTasks(id, tasks) {
			return post<{ tasks: StockTakeTask[] }>(
				`/stock-takes/${encodeURIComponent(id)}/generate-tasks`,
				{ tasks },
			);
		},

		assignStockTakeTask(id, body) {
			return post<StockTakeTask>(`/stock-take-tasks/${encodeURIComponent(id)}/assign`, body);
		},

		listMyStockTakeTasks(options) {
			return request<{ tasks: StockTakeTask[] }>("/stock-take-tasks?assignee=me", {}, options);
		},

		getStockTakeWalk(taskId, options) {
			return request<StockTakeWalk>(
				`/stock-take-tasks/${encodeURIComponent(taskId)}/units`,
				{},
				options,
			);
		},

		countStockTakeUnit(unitId, body, idempotencyKey) {
			return post<StockTakeUnit>(`/stock-take-units/${encodeURIComponent(unitId)}/count`, body, {
				idempotencyKey,
			});
		},

		markStockTakeUnitDone(unitId, lines, idempotencyKey) {
			return post<StockTakeUnit>(
				`/stock-take-units/${encodeURIComponent(unitId)}/done`,
				lines === undefined ? {} : { lines },
				{ idempotencyKey },
			);
		},

		markStockTakeUnitEmpty(unitId, idempotencyKey) {
			return post<StockTakeUnit>(
				`/stock-take-units/${encodeURIComponent(unitId)}/empty`,
				{},
				{ idempotencyKey },
			);
		},

		reopenStockTakeUnit(unitId, reason, idempotencyKey) {
			return post<StockTakeUnit>(
				`/stock-take-units/${encodeURIComponent(unitId)}/reopen`,
				{ reason },
				{ idempotencyKey },
			);
		},

		submitStockTakeTask(taskId, idempotencyKey) {
			return post<StockTakeTask>(
				`/stock-take-tasks/${encodeURIComponent(taskId)}/submit`,
				{},
				{ idempotencyKey },
			);
		},

		getStockTakeProgress(id, options) {
			return request<StockTakeProgress>(
				`/stock-takes/${encodeURIComponent(id)}/progress`,
				{},
				options,
			);
		},

		getSkuVerification(skuId, options) {
			return request<SkuVerification>(
				`/skus/${encodeURIComponent(skuId)}/verification`,
				{},
				options,
			);
		},

		listStockTakeVariances(id, options) {
			return request<StockTakeVarianceList>(
				`/stock-takes/${encodeURIComponent(id)}/variances`,
				{},
				options,
			);
		},

		approveStockTakeVariances(id, body) {
			return post<StockTakeApproveResult>(`/stock-takes/${encodeURIComponent(id)}/approve`, body);
		},

		closeStockTake(id) {
			return post<StockTake>(`/stock-takes/${encodeURIComponent(id)}/close`, {});
		},

		cancelStockTake(id, reason) {
			return post<StockTake>(
				`/stock-takes/${encodeURIComponent(id)}/cancel`,
				reason === "" ? {} : { reason },
			);
		},

		getStockTakeLog(id, filter, options) {
			return request<StockTakeLog>(
				`/stock-takes/${encodeURIComponent(id)}/log${searchOf(filter)}`,
				{},
				options,
			);
		},

		downloadStockTakeLog(id, filter, format) {
			return file(
				`/stock-takes/${encodeURIComponent(id)}/export${searchOf({ ...filter, format })}`,
			);
		},

		getVerificationAgeing(query) {
			return request<VerificationAgeingReport>(
				`/reports/verification-ageing${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getAllocationPolicy(storeId, options) {
			return request<AllocationPolicy>(
				`/allocation-policies/${encodeURIComponent(storeId)}`,
				{},
				options,
			);
		},

		putAllocationPolicy(storeId, draft) {
			return request<AllocationPolicy>(`/allocation-policies/${encodeURIComponent(storeId)}`, {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(draft),
			});
		},

		getValuation(query) {
			return request<Valuation>(
				`/valuation${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		putValuationPolicy(draft) {
			return request<ValuationPolicy>("/valuation/policy", {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(draft),
			});
		},

		listValuationSnapshots(query) {
			return request<ValuationSnapshotPage>(
				`/valuation/snapshots${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		createValuationSnapshot(draft) {
			return post<ValuationSnapshot>("/valuation/snapshots", draft);
		},

		compareValuationSnapshots(query) {
			return request<ValuationComparison>(
				`/valuation/snapshots/compare${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		listReceivingOrders(query) {
			return request<ReceivingOrderPage>(
				`/receiving-orders${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		announceReceivingOrder(draft) {
			return post<ReceivingOrder>("/receiving-orders", draft);
		},

		getReceivingOrder(receivingOrderId, options) {
			return request<ReceivingOrderDetail>(
				`/receiving-orders/${encodeURIComponent(receivingOrderId)}`,
				{},
				options,
			);
		},

		updateReceivingOrder(receivingOrderId, patch, version) {
			return request<ReceivingOrder>(`/receiving-orders/${encodeURIComponent(receivingOrderId)}`, {
				method: "PATCH",
				headers: {
					"Content-Type": "application/json",
					"If-Match": `"${version}"`,
				},
				body: JSON.stringify(patch),
			});
		},

		recordReceipt(receivingOrderId, draft, idempotencyKey) {
			return post<ReceiptResult>(
				`/receiving-orders/${encodeURIComponent(receivingOrderId)}/receipts`,
				draft,
				{ idempotencyKey },
			);
		},

		decideOverReceipt(receivingOrderId, decision, idempotencyKey) {
			return post<OverReceiptResult>(
				`/receiving-orders/${encodeURIComponent(receivingOrderId)}/approve-over-receipt`,
				decision,
				{ idempotencyKey },
			);
		},

		suggestPutaway(query) {
			return request<PutawaySuggestions>(
				`/putaway/suggestions${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		putawayStock(draft, idempotencyKey) {
			return post<MovementResult>("/movements/putaway", draft, { idempotencyKey });
		},

		transferStock(draft, idempotencyKey) {
			return post<TransferResult>("/movements/transfer", draft, { idempotencyKey });
		},

		adjustMovement(draft, idempotencyKey) {
			return post<StockAdjustResult>("/movements/adjust", draft, { idempotencyKey });
		},

		listSkuInbound(skuId, storeId, options) {
			return request<SkuInboundList>(
				`/skus/${encodeURIComponent(skuId)}/inbound?storeId=${encodeURIComponent(storeId)}`,
				{},
				options,
			);
		},

		printSkuLabels(skuIds, copies) {
			return filePost("/skus/labels", { skuIds, copies });
		},

		getSku(skuId, options) {
			return request<Sku>(`/skus/${encodeURIComponent(skuId)}`, {}, options);
		},

		getSupplier(supplierId, options) {
			return request<Supplier>(`/suppliers/${encodeURIComponent(supplierId)}`, {}, options);
		},

		listSuppliers(query) {
			return request<SupplierPage>(
				`/suppliers${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		createSupplier(draft) {
			return post<Supplier>("/suppliers", draft);
		},

		updateSupplier(supplierId, patch, version) {
			return request<Supplier>(`/suppliers/${encodeURIComponent(supplierId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(patch),
			});
		},

		listPurchaseOrders(query) {
			return request<PurchaseOrderPage>(
				`/purchase-orders${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		createPurchaseOrder(draft, idempotencyKey) {
			return post<PurchaseOrder>("/purchase-orders", draft, { idempotencyKey });
		},

		getPurchaseOrder(purchaseOrderId, options) {
			return request<PurchaseOrder>(
				`/purchase-orders/${encodeURIComponent(purchaseOrderId)}`,
				{},
				options,
			);
		},

		updatePurchaseOrder(purchaseOrderId, patch, version) {
			return request<PurchaseOrder>(`/purchase-orders/${encodeURIComponent(purchaseOrderId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(patch),
			});
		},

		confirmPurchaseOrder(purchaseOrderId) {
			return post<PurchaseOrder>(
				`/purchase-orders/${encodeURIComponent(purchaseOrderId)}/confirm`,
				undefined,
			);
		},

		markPurchaseOrderShipped(purchaseOrderId, shippedAt) {
			return post<PurchaseOrder>(
				`/purchase-orders/${encodeURIComponent(purchaseOrderId)}/mark-shipped`,
				shippedAt === undefined ? {} : { shippedAt },
			);
		},

		receivePurchaseOrder(purchaseOrderId, draft, idempotencyKey) {
			return post<PurchaseOrder>(
				`/purchase-orders/${encodeURIComponent(purchaseOrderId)}/receive`,
				draft,
				{ idempotencyKey },
			);
		},

		cancelPurchaseOrder(purchaseOrderId, reason) {
			return post<PurchaseOrder>(`/purchase-orders/${encodeURIComponent(purchaseOrderId)}/cancel`, {
				reason,
			});
		},

		listPurchaseOrderLog(purchaseOrderId, query = {}) {
			return request<PurchaseOrderEventPage>(
				`/purchase-orders/${encodeURIComponent(purchaseOrderId)}/log${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		downloadPurchaseOrderLog(purchaseOrderId, format) {
			return file(
				`/purchase-orders/${encodeURIComponent(purchaseOrderId)}/log/export?format=${format}`,
			);
		},

		listBundles(options) {
			return request<SkuBundleList>("/bundles", {}, options);
		},

		getSkuBundle(skuId, options) {
			return request<SkuBundle>(
				`/skus/${encodeURIComponent(skuId)}/bundle-components`,
				{},
				options,
			);
		},

		putSkuBundle(skuId, draft, version) {
			return request<SkuBundle>(`/skus/${encodeURIComponent(skuId)}/bundle-components`, {
				method: "PUT",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(draft),
			});
		},

		getSkuBundleAvailability(skuId, options) {
			return request<SkuBundleAvailability>(
				`/skus/${encodeURIComponent(skuId)}/bundle-availability`,
				{},
				options,
			);
		},

		getPurchaseOrderCostPreview(purchaseOrderId, options) {
			return request<PurchaseOrder>(
				`/purchase-orders/${encodeURIComponent(purchaseOrderId)}?include=cost_preview`,
				{},
				options,
			);
		},

		closePurchaseOrder(purchaseOrderId, extraRecipients, idempotencyKey) {
			return post<PurchaseOrder>(
				`/purchase-orders/${encodeURIComponent(purchaseOrderId)}/close`,
				{ extraRecipients },
				{ idempotencyKey },
			);
		},

		downloadPurchaseOrderGrn(purchaseOrderId, format) {
			return file(`/purchase-orders/${encodeURIComponent(purchaseOrderId)}/grn?format=${format}`);
		},

		resendPurchaseOrderGrn(purchaseOrderId, extraRecipients) {
			return post<PurchaseOrder>(
				`/purchase-orders/${encodeURIComponent(purchaseOrderId)}/grn/resend`,
				{ extraRecipients },
			);
		},

		openSortingSession(purchaseOrderId, draft) {
			return post<SortingSession>(
				`/purchase-orders/${encodeURIComponent(purchaseOrderId)}/sorting-sessions`,
				draft ?? {},
			);
		},

		async listPurchaseOrderInboundServices(purchaseOrderId, options) {
			const body = await request<{ items: ServiceDefinition[] }>(
				`/purchase-orders/${encodeURIComponent(purchaseOrderId)}/inbound-services`,
				{},
				options,
			);
			return body.items;
		},

		getSortingSession(sortingSessionId, options) {
			return request<SortingSession>(
				`/sorting-sessions/${encodeURIComponent(sortingSessionId)}`,
				{},
				options,
			);
		},

		pauseSortingSession(sortingSessionId) {
			return post<SortingSession>(
				`/sorting-sessions/${encodeURIComponent(sortingSessionId)}/pause`,
				undefined,
			);
		},

		resumeSortingSession(sortingSessionId) {
			return post<SortingSession>(
				`/sorting-sessions/${encodeURIComponent(sortingSessionId)}/resume`,
				undefined,
			);
		},

		listSortingEntries(sortingSessionId, query = {}) {
			return request<SortingEntryPage>(
				`/sorting-sessions/${encodeURIComponent(sortingSessionId)}/lines${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		recordSortingLine(sortingSessionId, draft, idempotencyKey) {
			return post<SortLineResult>(
				`/sorting-sessions/${encodeURIComponent(sortingSessionId)}/lines`,
				draft,
				{ idempotencyKey },
			);
		},

		submitSortingSession(sortingSessionId) {
			return post<SortingSession>(
				`/sorting-sessions/${encodeURIComponent(sortingSessionId)}/submit`,
				undefined,
			);
		},

		approvePurchaseOrderVariances(purchaseOrderId, draft, idempotencyKey) {
			return post<SortingSession>(
				`/purchase-orders/${encodeURIComponent(purchaseOrderId)}/approve-variances`,
				draft,
				{ idempotencyKey },
			);
		},

		lookupSku(code, storeId, options) {
			const search = new URLSearchParams({ code });
			if (storeId !== undefined && storeId !== "") {
				search.set("storeId", storeId);
			}
			return request<CodeMatch>(`/skus/lookup?${search.toString()}`, {}, options);
		},

		lookupSkuMatches(code, storeId, options) {
			const search = new URLSearchParams({ code });
			if (storeId !== undefined && storeId !== "") {
				search.set("storeId", storeId);
			}
			return request<CodeMatchList>(`/skus/lookup/matches?${search.toString()}`, {}, options);
		},

		patchSku(skuId, patch) {
			return request<Sku>(`/skus/${encodeURIComponent(skuId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(patch),
			});
		},

		archiveSku(skuId) {
			return post<Sku>(`/skus/${encodeURIComponent(skuId)}/archive`, undefined);
		},

		async deleteSku(skuId) {
			await request<void>(`/skus/${encodeURIComponent(skuId)}`, { method: "DELETE" });
		},

		linkSkuAlias(skuId, draft) {
			return post<SkuAlias>(`/skus/${encodeURIComponent(skuId)}/aliases`, draft);
		},

		approveSku(skuId) {
			return post<Sku>(`/skus/${encodeURIComponent(skuId)}/approve`, undefined);
		},

		previewVariations(body) {
			return post<VariationPreview>("/items/variations/preview", body);
		},

		createVariations(itemId, body) {
			return post<ItemDetail>(`/items/${encodeURIComponent(itemId)}/variations`, body);
		},

		listVariationPresets(storeId, options = {}) {
			return request<VariationPresetList>(
				`/variation-presets${storeId === undefined || storeId === "" ? "" : `?storeId=${encodeURIComponent(storeId)}`}`,
				{},
				options,
			);
		},

		createVariationPreset(draft) {
			return post<VariationPreset>("/variation-presets", draft);
		},

		deleteVariationPreset(presetId) {
			return send(`/variation-presets/${encodeURIComponent(presetId)}`, "DELETE");
		},

		async unlinkSkuAlias(skuId, aliasId) {
			// 204: there is no body, and asking `request` to parse one would
			// fail on the empty response the server correctly sends.
			await fetch(
				`${baseUrl}/skus/${encodeURIComponent(skuId)}/aliases/${encodeURIComponent(aliasId)}`,
				{ method: "DELETE", headers: await authHeaders() },
			);
		},

		createZone(draft) {
			return post<Zone>("/zones", draft);
		},

		getZone(zoneId, options) {
			return request<Zone>(`/zones/${encodeURIComponent(zoneId)}`, {}, options);
		},

		updateZone(zoneId, patch, version) {
			return request<Zone>(`/zones/${encodeURIComponent(zoneId)}`, {
				method: "PATCH",
				headers: {
					"Content-Type": "application/json",
					"If-Match": `"${version}"`,
				},
				body: JSON.stringify(patch),
			});
		},

		getZoneDesign(zoneId, options) {
			return request<ZoneDesign>(`/zones/${encodeURIComponent(zoneId)}/design`, {}, options);
		},

		saveZoneArea(zoneId, draft, version) {
			return request<ZoneArea>(`/zones/${encodeURIComponent(zoneId)}/areas`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					...(version === undefined ? {} : { "If-Match": `"${version}"` }),
				},
				body: JSON.stringify(draft),
			});
		},

		saveZoneRows(zoneAreaId, rows) {
			return post<ZoneRowList>(`/zone-areas/${encodeURIComponent(zoneAreaId)}/rows`, { rows });
		},

		generateZoneRow(zoneRowId) {
			return post<ZoneRowGenerated>(`/zone-rows/${encodeURIComponent(zoneRowId)}/generate`, {});
		},

		getZoneCapacity(zoneId, skuId, options) {
			const query =
				skuId === undefined || skuId === "" ? "" : `?skuId=${encodeURIComponent(skuId)}`;
			return request<ZoneCapacity>(
				`/zones/${encodeURIComponent(zoneId)}/capacity${query}`,
				{},
				options,
			);
		},

		listCurrencies(options) {
			return request<CurrencyList>("/currencies", {}, options);
		},

		setCurrencies(currencies) {
			return request<CurrencyList>("/currencies", {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ currencies }),
			});
		},

		listCurrencyRates(currency, options) {
			return request<CurrencyRateList>(
				`/currencies/${encodeURIComponent(currency)}/rates`,
				{},
				options,
			);
		},

		publishCurrencyRate(currency, date, rateMicro) {
			return request<CurrencyRate>(
				`/currencies/${encodeURIComponent(currency)}/rates/${encodeURIComponent(date)}`,
				{
					method: "PUT",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({ rateMicro }),
				},
			);
		},

		getDimensionPolicy(options) {
			return request<DimensionPolicy>("/item-dimension-policy", {}, options);
		},

		putDimensionPolicy(policy) {
			return request<DimensionPolicy>("/item-dimension-policy", {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(policy),
			});
		},

		getStoreDimensionRule(storeId, options) {
			return request<StoreDimensionRule>(
				`/stores/${encodeURIComponent(storeId)}/item-dimension-rule`,
				{},
				options,
			);
		},

		putStoreDimensionRule(storeId, rule) {
			return request<StoreDimensionRule>(
				`/stores/${encodeURIComponent(storeId)}/item-dimension-rule`,
				{
					method: "PUT",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(rule),
				},
			);
		},

		listUnitKinds(options) {
			return request<UnitKindList>("/unit-kinds", {}, options);
		},

		saveUnitKind(name, unitKind) {
			if (unitKind === undefined) {
				return post<UnitKindDef>("/unit-kinds", { name });
			}
			return request<UnitKindDef>(`/unit-kinds/${encodeURIComponent(unitKind)}`, {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ name }),
			});
		},

		async deleteUnitKind(unitKind) {
			await request<void>(`/unit-kinds/${encodeURIComponent(unitKind)}`, { method: "DELETE" });
		},

		listHandlingEquipment(options) {
			return request<HandlingEquipmentList>("/handling-equipment", {}, options);
		},

		saveHandlingEquipment(draft, equipmentId) {
			if (equipmentId === undefined) {
				return post<AisleSuggestion>("/handling-equipment", draft);
			}
			return request<AisleSuggestion>(`/handling-equipment/${encodeURIComponent(equipmentId)}`, {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(draft),
			});
		},

		async deleteHandlingEquipment(equipmentId) {
			await request<void>(`/handling-equipment/${encodeURIComponent(equipmentId)}`, {
				method: "DELETE",
			});
		},

		listStorageUnitTemplates(options) {
			return request<StorageUnitTemplateList>("/storage-unit-templates", {}, options);
		},

		async deleteLocation(locationId) {
			await request<void>(`/locations/${encodeURIComponent(locationId)}`, { method: "DELETE" });
		},

		async deleteZone(zoneId) {
			await request<void>(`/zones/${encodeURIComponent(zoneId)}`, { method: "DELETE" });
		},

		async deleteZoneArea(zoneId, zoneAreaId) {
			await request<void>(
				`/zones/${encodeURIComponent(zoneId)}/areas/${encodeURIComponent(zoneAreaId)}`,
				{ method: "DELETE" },
			);
		},

		async deleteZoneRow(zoneRowId) {
			await request<void>(`/zone-rows/${encodeURIComponent(zoneRowId)}`, { method: "DELETE" });
		},

		async deleteZoneAreaLevel(zoneAreaId, level) {
			await request<void>(
				`/zone-areas/${encodeURIComponent(zoneAreaId)}/levels/${encodeURIComponent(String(level))}`,
				{ method: "DELETE" },
			);
		},

		getWarehouseServicePrices(warehouseId, options) {
			return request<WarehouseServicePrices>(
				`/warehouses/${encodeURIComponent(warehouseId)}/service-prices`,
				{},
				options,
			);
		},

		scheduleWarehouseServicePrice(warehouseId, rate, keepStoreIds) {
			return request<StoreServiceRate>(
				`/warehouses/${encodeURIComponent(warehouseId)}/service-prices`,
				{
					method: "POST",
					body: JSON.stringify({ rate, keepStoreIds }),
				},
			);
		},

		setWarehouseStorageFee(warehouseId, fee, keepStoreIds) {
			return request<StorageFee>(`/warehouses/${encodeURIComponent(warehouseId)}/storage-fee`, {
				method: "PUT",
				body: JSON.stringify({ fee, keepStoreIds }),
			});
		},

		previewDeliveryRates(companyIds, provinceIds, cityIds, options) {
			const params = new URLSearchParams();
			for (const id of companyIds) params.append("companyId", id);
			for (const id of provinceIds) params.append("provinceId", id);
			for (const id of cityIds) params.append("cityId", id);
			return request<StoreDeliveryRateList>(
				`/delivery/delivery-rates/preview?${params}`,
				{},
				options,
			);
		},

		setStoreDiscountTiers(storeId, tiers) {
			return request<Store>(`/stores/${encodeURIComponent(storeId)}/discounts`, {
				method: "PUT",
				body: JSON.stringify({ tiers }),
			});
		},

		setStoreAgreement(storeId, draft) {
			return request<Store>(`/stores/${encodeURIComponent(storeId)}/agreement`, {
				method: "PUT",
				body: JSON.stringify(draft),
			});
		},

		removeStoreAgreement(storeId) {
			return request<Store>(`/stores/${encodeURIComponent(storeId)}/agreement`, {
				method: "DELETE",
			});
		},

		getStoreServiceSwitches(storeId, options) {
			return request<StoreServiceSwitches>(
				`/stores/${encodeURIComponent(storeId)}/services`,
				{},
				options,
			);
		},

		setStoreServiceSwitches(storeId, disabledServices, defaultServiceMode) {
			return request<StoreServiceSwitches>(`/stores/${encodeURIComponent(storeId)}/services`, {
				method: "PUT",
				body: JSON.stringify(
					defaultServiceMode === undefined
						? { disabledServices }
						: { disabledServices, defaultServiceMode },
				),
			});
		},

		getStoreAccountCharges(storeId, options) {
			return request<StoreAccountCharges>(
				`/stores/${encodeURIComponent(storeId)}/account-charges`,
				{},
				options,
			);
		},

		getPortalServiceSwitches(options) {
			return request<StoreServiceSwitches>("/portal/services", {}, options);
		},

		getPortalPackaging(options) {
			return request<PackagingOptions>("/portal/packaging", {}, options);
		},

		setPortalPackagingDefault(packageTypeId) {
			return request<PackagingOptions>("/portal/packaging/default", {
				method: "PUT",
				body: JSON.stringify({ packageTypeId }),
			});
		},

		createPortalPackageType(draft) {
			return request<PackagingOptions>("/portal/packaging/types", {
				method: "POST",
				body: JSON.stringify(draft),
			});
		},

		updatePortalPackageType(packageTypeId, patch) {
			return request<PackagingOptions>(
				`/portal/packaging/types/${encodeURIComponent(packageTypeId)}`,
				{
					method: "PATCH",
					body: JSON.stringify(patch),
				},
			);
		},

		archivePortalPackageType(packageTypeId) {
			return request<PackagingOptions>(
				`/portal/packaging/types/${encodeURIComponent(packageTypeId)}/archive`,
				{ method: "POST" },
			);
		},

		receivePortalPackagingStock(packageTypeId, quantity) {
			return request<PackagingOptions>(
				`/portal/packaging/types/${encodeURIComponent(packageTypeId)}/stock`,
				{ method: "POST", body: JSON.stringify({ quantity }) },
			);
		},

		setPortalServiceSwitches(disabledServices) {
			return request<StoreServiceSwitches>("/portal/services", {
				method: "PUT",
				body: JSON.stringify({ disabledServices }),
			});
		},

		async deleteStorageUnitTemplate(templateId) {
			await request<void>(`/storage-unit-templates/${encodeURIComponent(templateId)}`, {
				method: "DELETE",
			});
		},

		createStorageUnitTemplate(draft) {
			return post<StorageUnitTemplate>("/storage-unit-templates", draft);
		},

		setStorageUnitTemplateSkuRule(templateId, rule) {
			return request<StorageUnitTemplateSkuRuleResult>(
				`/storage-unit-templates/${encodeURIComponent(templateId)}/sku-rule`,
				{ method: "PUT", body: JSON.stringify(rule) },
			);
		},

		listZoneTemplates(usage, options) {
			return request<ZoneTemplateList>(`/zone-templates${searchOf({ usage })}`, {}, options);
		},

		saveZoneTemplate(draft) {
			return post<ZoneTemplate>("/zone-templates", draft);
		},

		applyZoneTemplate(zoneId, body, idempotencyKey) {
			return post<ZoneTemplateApplied>(
				`/zones/${encodeURIComponent(zoneId)}/apply-template`,
				body,
				{ idempotencyKey },
			);
		},

		getZoneLayout(zoneId, options) {
			return request<ZoneLayout>(`/zones/${encodeURIComponent(zoneId)}/layout`, {}, options);
		},

		downloadZoneLayout(zoneId, format, query) {
			return file(`/zones/${encodeURIComponent(zoneId)}/layout.${format}${searchOf(query)}`);
		},

		deleteAllCities(body) {
			return post<CityDeleteAllResult>("/delivery/cities:delete-all", body);
		},

		listPackagingMaterials(query = {}) {
			return request<PackagingMaterialPage>(
				`/packaging/materials${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getPackagingMaterial(materialId, options) {
			return request<PackagingMaterial>(
				`/packaging/materials/${encodeURIComponent(materialId)}`,
				{},
				options,
			);
		},

		createPackagingMaterial(draft) {
			return post<PackagingMaterial>("/packaging/materials", draft);
		},

		updatePackagingMaterial(materialId, patch, version) {
			return request<PackagingMaterial>(`/packaging/materials/${encodeURIComponent(materialId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(patch),
			});
		},

		archivePackagingMaterial(materialId) {
			return post<PackagingMaterialArchiveResult>(
				`/packaging/materials/${encodeURIComponent(materialId)}/archive`,
				undefined,
			);
		},

		getPackagingMaterialCostHistory(materialId, options) {
			return request<PackagingCostHistory>(
				`/packaging/materials/${encodeURIComponent(materialId)}/cost-history`,
				{},
				options,
			);
		},

		listPackageTypes(query = {}) {
			return request<PackageTypePage>(
				`/packaging/package-types${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getPackageType(packageTypeId, options) {
			return request<PackageType>(
				`/packaging/package-types/${encodeURIComponent(packageTypeId)}`,
				{},
				options,
			);
		},

		createPackageType(draft) {
			return post<PackageType>("/packaging/package-types", draft);
		},

		updatePackageType(packageTypeId, patch, version) {
			return request<PackageType>(`/packaging/package-types/${encodeURIComponent(packageTypeId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(patch),
			});
		},

		setDefaultPackageType(packageTypeId) {
			return post<PackageType>(
				`/packaging/package-types/${encodeURIComponent(packageTypeId)}/set-default`,
				undefined,
			);
		},

		archivePackageType(packageTypeId) {
			return post<PackageType>(
				`/packaging/package-types/${encodeURIComponent(packageTypeId)}/archive`,
				undefined,
			);
		},

		seedDefaultPackageType() {
			return post<PackageType>("/packaging/package-types/seed-default", undefined);
		},

		listPackageTypeStores(packageTypeId, options) {
			return request<PackageTypeStoreList>(
				`/packaging/package-types/${encodeURIComponent(packageTypeId)}/stores`,
				{},
				options,
			);
		},

		putPackageTypeStore(packageTypeId, storeId, body, version) {
			return request<PackagingOptions>(
				`/packaging/package-types/${encodeURIComponent(packageTypeId)}/stores/${encodeURIComponent(storeId)}`,
				{
					method: "PUT",
					headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
					body: JSON.stringify(body),
				},
			);
		},

		deletePackageTypeStore(packageTypeId, storeId, version) {
			return request<PackagingOptions>(
				`/packaging/package-types/${encodeURIComponent(packageTypeId)}/stores/${encodeURIComponent(storeId)}`,
				{ method: "DELETE", headers: { "If-Match": `"${version}"` } },
			);
		},

		getStorePackagingOptions(storeId, options) {
			return request<PackagingOptions>(
				`/stores/${encodeURIComponent(storeId)}/packaging-options`,
				{},
				options,
			);
		},

		putStorePackagingDefault(storeId, packageTypeId, version) {
			return request<PackagingOptions>(`/stores/${encodeURIComponent(storeId)}/packaging-default`, {
				method: "PUT",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify({ packageTypeId }),
			});
		},

		putStorePackagingBag(storeId, body, version) {
			return request<PackagingOptions>(`/stores/${encodeURIComponent(storeId)}/packaging-bag`, {
				method: "PUT",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(body),
			});
		},

		listPackagingRules(options) {
			return request<PackagingRuleList>("/packaging/rules", {}, options);
		},

		createPackagingRule(draft) {
			return post<PackagingRule>("/packaging/rules", draft);
		},

		updatePackagingRule(ruleId, draft, version) {
			return request<PackagingRule>(`/packaging/rules/${encodeURIComponent(ruleId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(draft),
			});
		},

		reorderPackagingRules(body) {
			return post<PackagingRuleList>("/packaging/rules/reorder", body);
		},

		selectPackageType(body, options) {
			return request<PackageSelection>(
				"/packaging/select",
				{
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(body),
				},
				options,
			);
		},

		listPackagingStock(query = {}) {
			return request<PackagingStockPage>(
				`/packaging/stock${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		putPackagingStockPolicy(materialId, body, version) {
			return request<PackagingStockRow>(
				`/packaging/stock/${encodeURIComponent(materialId)}/policy`,
				{
					method: "PUT",
					headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
					body: JSON.stringify(body),
				},
			);
		},

		appendPackagingStockMovement(draft, idempotencyKey) {
			return post<PackagingStockMovementResult>("/packaging/stock/movements", draft, {
				idempotencyKey,
			});
		},

		listPackagingStockMovements(query = {}) {
			return request<PackagingStockMovementPage>(
				`/packaging/stock/movements${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		listPackagingReplenishments(query = {}) {
			return request<PackagingReplenishmentPage>(
				`/packaging/replenishments${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		orderPackagingReplenishment(replenishmentId, body) {
			return post<PackagingReplenishment>(
				`/packaging/replenishments/${encodeURIComponent(replenishmentId)}/order`,
				body,
			);
		},

		dismissPackagingReplenishment(replenishmentId, reason) {
			return post<PackagingReplenishment>(
				`/packaging/replenishments/${encodeURIComponent(replenishmentId)}/dismiss`,
				{ reason },
			);
		},

		listPackagingConsumptions(query = {}) {
			return request<PackagingConsumptionPage>(
				`/packaging/consumptions${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getPackagingConsumption(consumptionId, options) {
			return request<PackagingConsumption>(
				`/packaging/consumptions/${encodeURIComponent(consumptionId)}`,
				{},
				options,
			);
		},

		getStorePackagingPrice(storeId, options) {
			return request<StorePackagingPriceList>(
				`/stores/${encodeURIComponent(storeId)}/packaging-price`,
				{},
				options,
			);
		},

		putStorePackagingPrice(storeId, draft) {
			return request<StorePackagingPriceList>(
				`/stores/${encodeURIComponent(storeId)}/packaging-price`,
				{
					method: "PUT",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(draft),
				},
			);
		},

		listPackagingCharges(query = {}) {
			return request<PackagingChargePage>(
				`/packaging/charges${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		reratePackagingCharge(chargeId) {
			return post<PackagingChargeRerate>(
				`/packaging/charges/${encodeURIComponent(chargeId)}/rerate`,
				{},
			);
		},

		getPackagingMarginReport(query) {
			return request<PackagingMarginReport>(
				`/packaging/margin-report${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getPackagingOverview(query) {
			return request<PackagingOverview>(
				`/packaging/overview${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getAnalyticsMetric(query) {
			return request<MetricSeries>(
				`/analytics/metrics${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getAnalyticsLiveMetric(query) {
			return request<MetricSeries>(
				`/analytics/metrics/live${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getAnalyticsSales(block, query) {
			return request<SalesBreakdown>(
				`/analytics/sales/${block}${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		listStorePerformance({ signal, ...query }) {
			return request<StorePerformanceList>(
				`/analytics/stores${searchOf(query)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		getStoreScorecard(storeId, { signal, ...query }) {
			return request<StoreScorecard>(
				`/analytics/stores/${encodeURIComponent(storeId)}/scorecard${searchOf(query)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		getStoreTrend(storeId, { signal, ...query }) {
			return request<StoreTrend>(
				`/analytics/stores/${encodeURIComponent(storeId)}/trend${searchOf(query)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		downloadStoreScorecard(storeId, query, format = "csv") {
			return file(
				`/analytics/stores/${encodeURIComponent(storeId)}/scorecard/export${searchOf({ ...query, format })}`,
			);
		},

		getAnalyticsCustomers(block, query) {
			return request<CustomersBreakdown>(
				`/analytics/customers/${block}${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getAnalyticsReturnsInspections(query) {
			return request<ReturnsInspections>(
				`/analytics/returns/inspections${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getDeliveryKpi<R extends DeliveryKpiRead>(read: R, query: DeliveryKpiQuery) {
			return request<DeliveryKpiResults[R]>(
				`/analytics/delivery/${read}${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getFulfillment<R extends FulfillmentRead>(read: R, query: FulfillmentQuery) {
			return request<FulfillmentResults[R]>(
				`/analytics/fulfillment/${read}${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getWorkforce<R extends WorkforceRead>(read: R, query: WorkforceQuery) {
			return request<WorkforceResults[R]>(
				`/analytics/workforce/${read}${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getFinanceSummary(query) {
			return financeRead<FinanceSummary>("summary", query);
		},

		getFinanceTrend(query) {
			return financeRead<FinanceTrend>("trend", query);
		},

		getFinanceCodWaterfall(query) {
			return financeRead<FinanceCodWaterfall>("cod-waterfall", query);
		},

		listFinanceBalances(query = {}) {
			return financeRead<FinanceBalances>("balances", query);
		},

		getFinanceForecast(query = {}) {
			return financeRead<FinanceForecast>("forecast", query);
		},

		getFinanceStatementReport(query) {
			return financeReport<FinanceStatementReport>("statements", query);
		},

		getFinanceMarginReport(query) {
			return financeReport<FinanceMarginReport>("margin", query);
		},

		getFinanceCodPosition(query) {
			return financeReport<FinanceCodPositionReport>("cod-position", query);
		},

		getFinancePayoutRunReport(query) {
			return financeReport<FinancePayoutRunReport>("payout-runs", query);
		},

		listFinanceReportEntries(drillQuery, options) {
			// Passed as is: an empty lane key (`cityId=`) is a filter, not an absence.
			return request<FinanceReportEntries>(
				`/analytics/reports/finance/entries?${drillQuery}`,
				{},
				options,
			);
		},

		getAnalyticsExecutive(query) {
			return request<ExecutiveOverview>(
				`/analytics/executive${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		listKpiTargets(period, options) {
			return request<KpiTargetList>(
				`/analytics/targets?period=${encodeURIComponent(period)}`,
				{},
				options,
			);
		},

		putKpiTarget(metricKey, body, version) {
			return request<KpiTarget>(`/analytics/targets/${encodeURIComponent(metricKey)}`, {
				method: "PUT",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(body),
			});
		},

		createAnalyticsExport(body) {
			return post<AnalyticsExport>("/analytics/exports", body);
		},

		listAnalyticsExports(options) {
			return request<AnalyticsExportList>("/analytics/exports", {}, options);
		},

		getAnalyticsExport(exportId, options) {
			return request<AnalyticsExport>(
				`/analytics/exports/${encodeURIComponent(exportId)}`,
				{},
				options,
			);
		},

		getAnalyticsExportDownloadUrl(exportId) {
			return request<AnalyticsExportDownload>(
				`/analytics/exports/${encodeURIComponent(exportId)}/download-url`,
			);
		},

		listAnalyticsSchedules(options) {
			return request<AnalyticsScheduleList>("/analytics/schedules", {}, options);
		},

		createAnalyticsSchedule(body) {
			return post<AnalyticsSchedule>("/analytics/schedules", body);
		},

		updateAnalyticsSchedule(scheduleId, body, version) {
			return request<AnalyticsSchedule>(`/analytics/schedules/${encodeURIComponent(scheduleId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(body),
			});
		},

		async deleteAnalyticsSchedule(scheduleId) {
			await request<void>(`/analytics/schedules/${encodeURIComponent(scheduleId)}`, {
				method: "DELETE",
			});
		},

		runAnalyticsSchedule(scheduleId) {
			return post<AnalyticsSchedule>(
				`/analytics/schedules/${encodeURIComponent(scheduleId)}/run`,
				{},
			);
		},

		listAnalyticsRebuilds(options) {
			return request<AggregateRebuildList>("/analytics/rebuilds", {}, options);
		},

		requestAnalyticsRebuild(body) {
			return post<AggregateRebuild>("/analytics/rebuilds", body);
		},

		getAnalyticsReconciliation(options) {
			return request<AnalyticsReconciliation>("/analytics/reconciliation", {}, options);
		},

		listAnalyticsDashboards(options) {
			return request<AnalyticsDashboardList>("/analytics/catalog/dashboards", {}, options);
		},

		listAnalyticsMetricDefinitions(options) {
			return request<MetricDefinitionList>("/analytics/catalog/metrics", {}, options);
		},

		getAnalyticsMetricDefinition(key, options) {
			return request<MetricDefinition>(
				`/analytics/catalog/metrics/${encodeURIComponent(key)}`,
				{},
				options,
			);
		},

		listProjects(query = {}) {
			return request<ProjectList>(
				`/projects${searchOf({ includeArchived: query.includeArchived === true ? "true" : undefined })}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getProject(projectId, options) {
			return request<Project>(`/projects/${encodeURIComponent(projectId)}`, {}, options);
		},

		createProject(draft) {
			return post<Project>("/projects", draft);
		},

		updateProject(projectId, patch, version) {
			return request<Project>(`/projects/${encodeURIComponent(projectId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(patch),
			});
		},

		getProjectKeyPrefixAvailability(prefix, options) {
			return request<ProjectKeyPrefixAvailability>(
				`/projects/key-prefix-availability${searchOf({ prefix })}`,
				{},
				options,
			);
		},

		getInventoryHealthSummary(query = {}) {
			const { signal, ...params } = query;
			return request<InventoryHealthSummary>(
				`/analytics/inventory/summary${searchOf(params)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		getInventoryOccupancy(query = {}) {
			const { signal, ...params } = query;
			return request<InventoryOccupancy>(
				`/analytics/inventory/occupancy${searchOf(params)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		getInventoryAging(query = {}) {
			const { signal, ...params } = query;
			return request<InventoryAging>(
				`/analytics/inventory/aging${searchOf(params)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		listInventoryDeadStock(query = {}) {
			const { signal, ...params } = query;
			return request<InventoryDeadStock>(
				`/analytics/inventory/dead-stock${searchOf(params)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		getInventoryTurnover(query = {}) {
			const { signal, ...params } = query;
			return request<InventoryTurnoverReport>(
				`/analytics/inventory/turnover${searchOf(params)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		listProjectMembers(projectId, options) {
			return request<ProjectMemberList>(
				`/projects/${encodeURIComponent(projectId)}/members`,
				{},
				options,
			);
		},

		addProjectMember(projectId, draft) {
			return post<ProjectMember>(`/projects/${encodeURIComponent(projectId)}/members`, draft);
		},

		changeProjectMemberRole(projectId, employeeId, role) {
			return request<ProjectMember>(
				`/projects/${encodeURIComponent(projectId)}/members/${encodeURIComponent(employeeId)}`,
				{
					method: "PATCH",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({ role }),
				},
			);
		},

		async removeProjectMember(projectId, employeeId) {
			await request<void>(
				`/projects/${encodeURIComponent(projectId)}/members/${encodeURIComponent(employeeId)}`,
				{ method: "DELETE" },
			);
		},

		listProjectTasks(projectId, query = {}) {
			const { signal, ...params } = query;
			return request<TaskList>(
				`/projects/${encodeURIComponent(projectId)}/tasks${searchOf(params)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		createTask(projectId, draft) {
			return post<Task>(`/projects/${encodeURIComponent(projectId)}/tasks`, draft);
		},

		getTask(key, options) {
			return request<Task>(`/tasks/${encodeURIComponent(key)}`, {}, options);
		},

		updateTask(key, patch, version) {
			return request<Task>(`/tasks/${encodeURIComponent(key)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(patch),
			});
		},

		async deleteTask(key) {
			await request<void>(`/tasks/${encodeURIComponent(key)}`, { method: "DELETE" });
		},

		moveTask(key, projectId) {
			return post<Task>(`/tasks/${encodeURIComponent(key)}/move-project`, { projectId });
		},

		listTaskActivity(key, options) {
			return request<TaskActivityList>(`/tasks/${encodeURIComponent(key)}/activity`, {}, options);
		},

		listTaskLabels(query = {}) {
			return request<TaskLabelList>(
				`/task-labels${searchOf({ projectId: query.projectId })}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		createTaskLabel(draft) {
			return post<TaskLabel>("/task-labels", draft);
		},

		getTaskWorkflow(options) {
			return request<TaskWorkflow>("/task-workflow", {}, options);
		},

		replaceTaskChecklist(key, write, version) {
			return request<Task>(`/tasks/${encodeURIComponent(key)}/checklist`, {
				method: "PUT",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(write),
			});
		},

		addTaskLink(key, draft) {
			return post<Task>(`/tasks/${encodeURIComponent(key)}/links`, draft);
		},

		async removeTaskLink(key, linkId) {
			await request<void>(`/tasks/${encodeURIComponent(key)}/links/${encodeURIComponent(linkId)}`, {
				method: "DELETE",
			});
		},

		addTaskDependency(key, draft) {
			return post<TaskDependency>(`/tasks/${encodeURIComponent(key)}/dependencies`, draft);
		},

		async removeTaskDependency(key, dependencyId) {
			await request<void>(
				`/tasks/${encodeURIComponent(key)}/dependencies/${encodeURIComponent(dependencyId)}`,
				{ method: "DELETE" },
			);
		},

		attachTaskFile(key, attachmentId) {
			return post<Attachment>(`/tasks/${encodeURIComponent(key)}/attachments`, { attachmentId });
		},

		async removeTaskFile(key, attachmentId) {
			await request<void>(
				`/tasks/${encodeURIComponent(key)}/attachments/${encodeURIComponent(attachmentId)}`,
				{ method: "DELETE" },
			);
		},

		listMilestones(projectId, options) {
			return request<MilestoneList>(
				`/projects/${encodeURIComponent(projectId)}/milestones`,
				{},
				options,
			);
		},

		createMilestone(projectId, draft) {
			return post<Milestone>(`/projects/${encodeURIComponent(projectId)}/milestones`, draft);
		},

		getMilestone(milestoneId, options) {
			return request<Milestone>(`/milestones/${encodeURIComponent(milestoneId)}`, {}, options);
		},

		updateMilestone(milestoneId, patch) {
			return request<Milestone>(`/milestones/${encodeURIComponent(milestoneId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(patch),
			});
		},

		listReleases(projectId, options) {
			return request<ReleaseList>(
				`/projects/${encodeURIComponent(projectId)}/releases`,
				{},
				options,
			);
		},

		createRelease(projectId, draft) {
			return post<Release>(`/projects/${encodeURIComponent(projectId)}/releases`, draft);
		},

		getRelease(releaseId, options) {
			return request<Release>(`/releases/${encodeURIComponent(releaseId)}`, {}, options);
		},

		updateRelease(releaseId, patch) {
			return request<Release>(`/releases/${encodeURIComponent(releaseId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(patch),
			});
		},

		shipRelease(releaseId, ship) {
			return post<Release>(`/releases/${encodeURIComponent(releaseId)}/ship`, ship);
		},

		getRoadmap(query = {}) {
			const ids = query.projectIds?.join(",");
			return request<Roadmap>(
				`/roadmap${searchOf({ projectIds: ids === "" ? undefined : ids })}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		listIdeas(projectId, options) {
			return request<IdeaList>(`/projects/${encodeURIComponent(projectId)}/ideas`, {}, options);
		},

		submitIdea(projectId, draft) {
			return post<Idea>(`/projects/${encodeURIComponent(projectId)}/ideas`, draft);
		},

		getIdea(ideaId, options) {
			return request<Idea>(`/ideas/${encodeURIComponent(ideaId)}`, {}, options);
		},

		updateIdea(ideaId, patch) {
			return request<Idea>(`/ideas/${encodeURIComponent(ideaId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(patch),
			});
		},

		voteIdea(ideaId) {
			return post<Idea>(`/ideas/${encodeURIComponent(ideaId)}/vote`, undefined);
		},

		promoteIdea(ideaId, promotion) {
			return post<Idea>(`/ideas/${encodeURIComponent(ideaId)}/promote`, promotion);
		},

		listIdeaComments(ideaId, options) {
			return request<IdeaCommentList>(`/ideas/${encodeURIComponent(ideaId)}/comments`, {}, options);
		},

		addIdeaComment(ideaId, bodyMd) {
			return post<IdeaComment>(`/ideas/${encodeURIComponent(ideaId)}/comments`, { bodyMd });
		},

		listIdeaIntake(options) {
			return request<IdeaIntakeList>("/idea-intake", {}, options);
		},

		listTaskTemplates(projectId, query = {}) {
			return request<TaskTemplateList>(
				`/projects/${encodeURIComponent(projectId)}/templates${searchOf({
					includeArchived: query.includeArchived ? "true" : undefined,
				})}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		createTaskTemplate(projectId, draft) {
			return post<TaskTemplate>(`/projects/${encodeURIComponent(projectId)}/templates`, draft);
		},

		getTaskTemplate(templateId, options) {
			return request<TaskTemplate>(`/templates/${encodeURIComponent(templateId)}`, {}, options);
		},

		updateTaskTemplate(templateId, patch) {
			return request<TaskTemplate>(`/templates/${encodeURIComponent(templateId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(patch),
			});
		},

		instantiateTaskTemplate(templateId, instance) {
			return post<Task>(`/templates/${encodeURIComponent(templateId)}/instantiate`, instance);
		},

		listRecurringRules(projectId, options) {
			return request<RecurringRuleList>(
				`/projects/${encodeURIComponent(projectId)}/recurring`,
				{},
				options,
			);
		},

		createRecurringRule(projectId, draft) {
			return post<RecurringRule>(`/projects/${encodeURIComponent(projectId)}/recurring`, draft);
		},

		updateRecurringRule(ruleId, patch) {
			return request<RecurringRule>(`/recurring/${encodeURIComponent(ruleId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(patch),
			});
		},

		getTaskCalendar(projectId, { signal, ...query }) {
			return request<TaskCalendar>(
				`/projects/${encodeURIComponent(projectId)}/calendar${searchOf(query)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		getTaskTimeline(projectId, { signal, ...query }) {
			return request<TaskTimeline>(
				`/projects/${encodeURIComponent(projectId)}/timeline${searchOf(query)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		listProjectBoards(projectId, options) {
			return request<BoardList>(`/projects/${encodeURIComponent(projectId)}/boards`, {}, options);
		},

		createBoard(projectId, name) {
			return post<Board>(`/projects/${encodeURIComponent(projectId)}/boards`, { name });
		},

		updateBoard(boardId, patch) {
			return request<Board>(`/boards/${encodeURIComponent(boardId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(patch),
			});
		},

		async deleteBoard(boardId) {
			await request<void>(`/boards/${encodeURIComponent(boardId)}`, { method: "DELETE" });
		},

		replaceBoardColumns(boardId, columns) {
			return request<Board>(`/boards/${encodeURIComponent(boardId)}/columns`, {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ columns }),
			});
		},

		listBoardCards(boardId, options = {}) {
			const { filterId, sprintId, ...rest } = options;
			return request<BoardCards>(
				`/boards/${encodeURIComponent(boardId)}/cards${searchOf({ filterId, sprintId })}`,
				{},
				rest,
			);
		},

		searchTasks(search, options) {
			return post<TaskSearchPage>("/tasks/search", search, options);
		},

		bulkEditTasks(edit) {
			return post<TaskBulkResult>("/tasks/bulk", edit);
		},

		listTaskFilters(query = {}) {
			return request<TaskFilterList>(
				`/task-filters${searchOf({ projectId: query.projectId })}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		createTaskFilter(draft) {
			return post<TaskFilter>("/task-filters", draft);
		},

		updateTaskFilter(filterId, patch) {
			return request<TaskFilter>(`/task-filters/${encodeURIComponent(filterId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(patch),
			});
		},

		async deleteTaskFilter(filterId) {
			await send(`/task-filters/${encodeURIComponent(filterId)}`, "DELETE");
		},

		updateTaskLabel(labelId, patch) {
			return request<TaskLabel>(`/task-labels/${encodeURIComponent(labelId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(patch),
			});
		},

		moveBoardCard(boardId, move) {
			return post<BoardMoveResult>(`/boards/${encodeURIComponent(boardId)}/moves`, move);
		},

		listProjectSprints(projectId, options) {
			return request<SprintList>(`/projects/${encodeURIComponent(projectId)}/sprints`, {}, options);
		},

		createSprint(projectId, draft) {
			return post<Sprint>(`/projects/${encodeURIComponent(projectId)}/sprints`, draft);
		},

		updateSprint(sprintId, patch) {
			return request<Sprint>(`/sprints/${encodeURIComponent(sprintId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(patch),
			});
		},

		startSprint(sprintId) {
			return post<Sprint>(`/sprints/${encodeURIComponent(sprintId)}/start`, {});
		},

		completeSprint(sprintId, completion) {
			return post<SprintCompleted>(`/sprints/${encodeURIComponent(sprintId)}/complete`, completion);
		},

		cancelSprint(sprintId) {
			return post<Sprint>(`/sprints/${encodeURIComponent(sprintId)}/cancel`, {});
		},

		getProjectBacklog(projectId, options) {
			return request<ProjectBacklog>(
				`/projects/${encodeURIComponent(projectId)}/backlog`,
				{},
				options,
			);
		},

		reorderBacklog(projectId, move) {
			return post<BacklogReorderResult>(
				`/projects/${encodeURIComponent(projectId)}/backlog/reorder`,
				move,
			);
		},

		setTaskSprint(key, sprintId, expectedVersion) {
			return post<Task>(`/tasks/${encodeURIComponent(key)}/sprint`, {
				sprintId,
				...(expectedVersion === undefined ? {} : { expectedVersion }),
			});
		},

		getProjectVelocity(projectId, options) {
			return request<ProjectVelocity>(
				`/projects/${encodeURIComponent(projectId)}/velocity`,
				{},
				options,
			);
		},

		listProjectAutomations(projectId, options) {
			return request<AutomationList>(
				`/projects/${encodeURIComponent(projectId)}/automations`,
				{},
				options,
			);
		},

		createAutomation(projectId, draft) {
			return post<Automation>(`/projects/${encodeURIComponent(projectId)}/automations`, draft);
		},

		updateAutomation(automationId, patch) {
			return request<Automation>(`/automations/${encodeURIComponent(automationId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(patch),
			});
		},

		async deleteAutomation(automationId) {
			await request<void>(`/automations/${encodeURIComponent(automationId)}`, {
				method: "DELETE",
			});
		},

		listAutomationRuns(automationId, options = {}) {
			const { result, ...rest } = options;
			return request<AutomationRunList>(
				`/automations/${encodeURIComponent(automationId)}/runs${searchOf({ result })}`,
				{},
				rest,
			);
		},

		testAutomation(automationId) {
			return post<AutomationDryRun>(`/automations/${encodeURIComponent(automationId)}/test`, {});
		},

		previewAutomation(projectId, draft) {
			return post<AutomationDryRun>(
				`/projects/${encodeURIComponent(projectId)}/automations/test`,
				draft,
			);
		},

		getProjectBurndown(projectId, sprintId, options) {
			return request<Burndown>(
				`/projects/${encodeURIComponent(projectId)}/metrics/burndown${searchOf({ sprintId })}`,
				{},
				options,
			);
		},

		getProjectThroughput(projectId, weeks, options) {
			return request<Throughput>(
				`/projects/${encodeURIComponent(projectId)}/metrics/throughput${searchOf({ weeks })}`,
				{},
				options,
			);
		},

		getProjectCycleTime(projectId, weeks, options) {
			return request<CycleTime>(
				`/projects/${encodeURIComponent(projectId)}/metrics/cycle-time${searchOf({ weeks })}`,
				{},
				options,
			);
		},

		getProjectOverdue(projectId, options) {
			return request<OverdueSummary>(
				`/projects/${encodeURIComponent(projectId)}/metrics/overdue`,
				{},
				options,
			);
		},

		getProjectWip(projectId, options) {
			return request<WipSummary>(
				`/projects/${encodeURIComponent(projectId)}/metrics/wip`,
				{},
				options,
			);
		},

		recomputeProjectMetrics(projectId, from, to) {
			return post<MetricsRecomputed>(
				`/projects/${encodeURIComponent(projectId)}/metrics/recompute`,
				{ from, to },
			);
		},

		getProjectStandup(projectId, sprintId, options) {
			return request<Standup>(
				`/projects/${encodeURIComponent(projectId)}/standup${searchOf({ sprintId })}`,
				{},
				options,
			);
		},

		getSprintReport(sprintId, options) {
			return request<SprintReport>(`/sprints/${encodeURIComponent(sprintId)}/report`, {}, options);
		},

		assignTask(key, assigneeEmployeeId) {
			return post<Task>(`/tasks/${encodeURIComponent(key)}/assign`, { assigneeEmployeeId });
		},

		watchTask(key, watching, employeeId) {
			return post<Task>(
				`/tasks/${encodeURIComponent(key)}/watchers`,
				employeeId === undefined ? { watching } : { watching, employeeId },
			);
		},

		listTaskComments(key, options) {
			return request<TaskCommentList>(`/tasks/${encodeURIComponent(key)}/comments`, {}, options);
		},

		addTaskComment(key, draft) {
			return post<TaskComment>(`/tasks/${encodeURIComponent(key)}/comments`, draft);
		},

		editTaskComment(commentId, edit) {
			return request<TaskComment>(`/task-comments/${encodeURIComponent(commentId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(edit),
			});
		},

		async deleteTaskComment(commentId) {
			await request<void>(`/task-comments/${encodeURIComponent(commentId)}`, { method: "DELETE" });
		},

		getMyWork(query = {}) {
			const recent = query.recent?.join(",");
			return request<MyWork>(
				`/me/work${searchOf({ recent: recent === "" ? undefined : recent })}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		logTaskTime(key, draft) {
			return post<TimeLog>(`/tasks/${encodeURIComponent(key)}/timelogs`, draft);
		},

		listTimeLogs(query) {
			const { signal, ...params } = query;
			return request<TimeLogList>(
				`/timelogs${searchOf(params)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		updateTimeLog(timeLogId, patch) {
			return request<TimeLog>(`/timelogs/${encodeURIComponent(timeLogId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(patch),
			});
		},

		async deleteTimeLog(timeLogId) {
			await request<void>(`/timelogs/${encodeURIComponent(timeLogId)}`, { method: "DELETE" });
		},

		getWorkload(query) {
			const { signal, ...params } = query;
			return request<Workload>(
				`/workload${searchOf(params)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		getInventoryReportSoh(query = {}) {
			const { signal, ...params } = query;
			return request<InventorySohPage>(
				`/analytics/reports/inventory/soh${searchOf(params)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		getInventoryReportAging(query = {}) {
			const { signal, ...params } = query;
			return request<InventoryAgingReport>(
				`/analytics/reports/inventory/aging${searchOf(params)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		getInventoryReportValuation(query = {}) {
			const { signal, ...params } = query;
			return request<InventoryValuationReport>(
				`/analytics/reports/inventory/valuation${searchOf(params)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		getInventoryReportMovements(query = {}) {
			const { signal, ...params } = query;
			return request<InventoryMovementReport>(
				`/analytics/reports/inventory/movements${searchOf(params)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		getOrderPackaging(orderId, options) {
			return request<OrderPackaging>(
				`/orders/${encodeURIComponent(orderId)}/packaging`,
				{},
				options,
			);
		},

		putOrderBagAdjustment(orderId, body, version) {
			return request<OrderPackaging>(
				`/orders/${encodeURIComponent(orderId)}/packaging/bag-adjustment`,
				{
					method: "PUT",
					headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
					body: JSON.stringify(body),
				},
			);
		},

		deleteOrderBagAdjustment(orderId, version) {
			return request<OrderPackaging>(
				`/orders/${encodeURIComponent(orderId)}/packaging/bag-adjustment`,
				{ method: "DELETE", headers: { "If-Match": `"${version}"` } },
			);
		},

		listReturnCases(query = {}) {
			return request<ReturnCasePage>(
				`/returns${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getReturnsPipeline(query = {}) {
			return request<ReturnPipeline>(
				`/returns/pipeline${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getReturnsBoard(query = {}) {
			return request<ReturnBoard>(
				`/returns/board${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getReturnCase(returnId, options) {
			return request<ReturnCaseDetail>(`/returns/${encodeURIComponent(returnId)}`, {}, options);
		},

		createReturnCase(draft, idempotencyKey) {
			return post<ReturnCaseDetail>("/returns", draft, { idempotencyKey });
		},

		resolveReturnScan(body, options) {
			return post<ReturnScanMatch>("/returns/scan", body, options ?? {});
		},

		updateReturnCase(returnId, patch, version) {
			return request<ReturnCaseDetail>(`/returns/${encodeURIComponent(returnId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(patch),
			});
		},

		cancelReturnCase(returnId, reason) {
			return post<ReturnCaseDetail>(
				`/returns/${encodeURIComponent(returnId)}/cancel`,
				reason === undefined || reason === "" ? {} : { reason },
			);
		},

		receiveReturnCase(returnId, idempotencyKey) {
			return post<ReturnCaseDetail>(`/returns/${encodeURIComponent(returnId)}/receive`, undefined, {
				idempotencyKey,
			});
		},

		bulkReceiveReturnCases(returnIds) {
			return post<ReturnBulkReceiveResult>("/returns/bulk-receive", { returnIds });
		},

		receiveUnexpectedParcel(draft, idempotencyKey) {
			return post<ReturnCaseDetail>("/returns/receive-unexpected", draft, { idempotencyKey });
		},

		assignReturnCase(returnId, body, version) {
			return request<ReturnCaseDetail>(`/returns/${encodeURIComponent(returnId)}/assign`, {
				method: "POST",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(body),
			});
		},

		bulkAssignReturnCases(body) {
			return post<ReturnBulkAssignResult>("/returns/bulk-assign", body);
		},

		inspectReturnCase(returnId, body, idempotencyKey) {
			return post<ReturnCaseDetail>(`/returns/${encodeURIComponent(returnId)}/inspect`, body, {
				idempotencyKey,
			});
		},

		resolveReturnDiscrepancy(returnId, body) {
			return post<ReturnCaseDetail>(
				`/returns/${encodeURIComponent(returnId)}/resolve-discrepancy`,
				body,
			);
		},

		reconcileReturnCase(returnId, body) {
			return post<ReturnCaseDetail>(`/returns/${encodeURIComponent(returnId)}/reconcile`, body);
		},

		disposeReturnLines(returnId, body, idempotencyKey) {
			return post<ReturnCaseDetail>(`/returns/${encodeURIComponent(returnId)}/disposition`, body, {
				idempotencyKey,
			});
		},

		listReturnDispositions(returnId, options) {
			return request<ReturnDispositionList>(
				`/returns/${encodeURIComponent(returnId)}/dispositions`,
				{},
				options,
			);
		},

		previewReturnRestock(body) {
			return post<ReturnRestockPreview>("/returns/restock-preview", body);
		},

		commitReturnRestock(body, idempotencyKey) {
			return post<ReturnRestockBatchResult>("/returns/restock-batch", body, { idempotencyKey });
		},

		listReturnSessions(query = {}) {
			const { signal, ...params } = query;
			return request<ReturnSessionList>(
				`/return-sessions${searchOf(params)}`,
				{},
				signal === undefined ? {} : { signal },
			);
		},

		listActiveReturnSessions(options) {
			return request<ReturnSessionList>("/return-sessions/active", {}, options);
		},

		getReturnSession(sessionId, options) {
			return request<ReturnSessionDetail>(
				`/return-sessions/${encodeURIComponent(sessionId)}`,
				{},
				options,
			);
		},

		openReturnSession() {
			return post<ReturnSessionDetail>("/return-sessions", undefined);
		},

		addReturnSessionCases(sessionId, returnIds) {
			return post<ReturnSessionDetail>(
				`/return-sessions/${encodeURIComponent(sessionId)}/add-cases`,
				{ returnIds },
			);
		},

		releaseReturnSessionCase(sessionId, returnId) {
			return post<ReturnSessionDetail>(
				`/return-sessions/${encodeURIComponent(sessionId)}/release-case`,
				{ returnId },
			);
		},

		closeReturnSession(sessionId, force) {
			return post<ReturnSessionDetail>(
				`/return-sessions/${encodeURIComponent(sessionId)}/close`,
				force === true ? { force: true } : {},
			);
		},

		takeOverReturnSession(sessionId) {
			return post<ReturnSessionDetail>(
				`/return-sessions/${encodeURIComponent(sessionId)}/takeover`,
				undefined,
			);
		},

		getStoreReturnPolicy(storeId, options) {
			return request<ReturnPolicy>(
				`/stores/${encodeURIComponent(storeId)}/return-policy`,
				{},
				options,
			);
		},

		setStoreReturnPolicy(storeId, policy) {
			return request<ReturnPolicy>(`/stores/${encodeURIComponent(storeId)}/return-policy`, {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(policy),
			});
		},

		recordReturnRefund(returnId, body, idempotencyKey) {
			return post<Refund>(`/returns/${encodeURIComponent(returnId)}/refund`, body, {
				idempotencyKey,
			});
		},

		voidRefund(refundId, reason) {
			return post<Refund>(`/refunds/${encodeURIComponent(refundId)}/void`, { reason });
		},

		listOrderRefunds(orderId, options) {
			return request<RefundList>(`/orders/${encodeURIComponent(orderId)}/refunds`, {}, options);
		},

		createReturnExchange(returnId, body, idempotencyKey) {
			return post<ReturnExchange>(`/returns/${encodeURIComponent(returnId)}/exchange`, body, {
				idempotencyKey,
			});
		},

		getReturnFinance(returnId, options) {
			return request<ReturnCaseFinance>(
				`/returns/${encodeURIComponent(returnId)}/finance`,
				{},
				options,
			);
		},

		listOrderReturns(orderId, options) {
			return request<ReturnCasePage>(`/orders/${encodeURIComponent(orderId)}/returns`, {}, options);
		},

		listReturnInspections(returnId, options) {
			return request<ReturnInspectionList>(
				`/returns/${encodeURIComponent(returnId)}/inspections`,
				{},
				options,
			);
		},

		listOrders(query = {}) {
			return request<OrderListPage>(
				`/orders${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		listCustomers(query = {}) {
			return request<CustomerPage>(
				`/customers${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		resolveOrderScan(code, options) {
			return request<OrderScanMatch>(`/orders/resolve-scan${searchOf({ code })}`, {}, options);
		},

		getOrderPromiseSummary(options) {
			return request<OrderPromiseSummary>("/orders/fulfillment-promise/summary", {}, options);
		},

		getCustomer(customerId, options) {
			return request<CustomerDetail>(`/customers/${encodeURIComponent(customerId)}`, {}, options);
		},

		updateCustomer(customerId, patch, version) {
			return request<CustomerDetail>(`/customers/${encodeURIComponent(customerId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(patch),
			});
		},

		setCustomerRisk(customerId, body, version) {
			return request<CustomerDetail>(`/customers/${encodeURIComponent(customerId)}/risk`, {
				method: "POST",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(body),
			});
		},

		mergeCustomers(body) {
			return post<CustomerMergeResult>("/customers/merge", body);
		},

		listCustomerRiskEvents(customerId, query = {}) {
			return request<CustomerRiskEventPage>(
				`/customers/${encodeURIComponent(customerId)}/risk-events${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		createOrder(draft, idempotencyKey) {
			return post<OrderIntakeResult>("/orders", draft, { idempotencyKey });
		},

		searchStoreCatalogSkus(storeId, query = {}) {
			return request<OrderCatalogSkuPage>(
				`/stores/${encodeURIComponent(storeId)}/catalog/skus${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getOrder(orderId, options) {
			return request<Order>(`/orders/${encodeURIComponent(orderId)}`, {}, options);
		},

		transitionOrder(orderId, body, version) {
			return request<Order>(`/orders/${encodeURIComponent(orderId)}/status`, {
				method: "POST",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(body),
			});
		},

		overrideOrderStatus(orderId, body, version) {
			return request<Order>(`/orders/${encodeURIComponent(orderId)}/status-override`, {
				method: "POST",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(body),
			});
		},

		cancelOrderLines(orderId, body, version, idempotencyKey) {
			return request<OrderCancelLinesResult>(
				`/orders/${encodeURIComponent(orderId)}/cancel-lines`,
				{
					method: "POST",
					headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
					body: JSON.stringify(body),
				},
				{ idempotencyKey },
			);
		},

		editOrder(orderId, patch, version) {
			return request<Order>(`/orders/${encodeURIComponent(orderId)}/edit`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(patch),
			});
		},

		printOrderLabels(orderIds, locale) {
			return filePost("/orders/labels", locale === undefined ? { orderIds } : { orderIds, locale });
		},

		bulkUpdateOrderStatus(body) {
			return post<OrderBulkResult>("/orders/bulk-status", body);
		},

		bulkOverrideOrderStatus(body, idempotencyKey) {
			return post<OrderBulkResult>("/orders/bulk-status-override", body, { idempotencyKey });
		},

		bulkSetOrderContact(body) {
			return post<OrderBulkResult>("/orders/bulk-contact", body);
		},

		bulkRescheduleOrders(body) {
			return post<OrderBulkResult>("/orders/bulk-reschedule", body);
		},

		bulkAssignOrders(body) {
			return post<OrderBulkResult>("/orders/bulk-assign", body);
		},

		bulkAssignOrderDrivers(body) {
			return post<OrderBulkResult>("/delivery/shipments:bulk-assign-driver", body);
		},

		bulkArchiveOrders(body) {
			return post<OrderBulkResult>("/orders/bulk-archive", body);
		},

		bulkHoldOrders(body) {
			return post<OrderBulkResult>("/orders/bulk-hold", body);
		},

		bulkSetOrderApiVisibility(body) {
			return post<OrderBulkResult>("/orders/bulk-api-visibility", body);
		},

		listExternalImports(query) {
			return request<ExternalImportPage>(
				`/order-imports${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		importExternalOrders(ids) {
			return post<ExternalImportReport>("/order-imports/import", { ids });
		},

		deleteExternalImports(ids) {
			return post<ExternalImportReport>("/order-imports/delete", { ids });
		},

		fixExternalImport(importId, fix) {
			return request<ExternalImportRow>(`/order-imports/${encodeURIComponent(importId)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(fix),
			});
		},

		revertExternalImport(importId) {
			return post<ExternalImportRow>(
				`/order-imports/${encodeURIComponent(importId)}/revert`,
				undefined,
			);
		},

		getExternalImportPayload(importId) {
			return request<unknown>(`/order-imports/${encodeURIComponent(importId)}/payload`);
		},

		listIntakeRecords(query) {
			return request<IntakeRecordPage>(
				`/intake-records${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		cancelOrder(orderId, body, version) {
			return request<OrderCancelLinesResult>(`/orders/${encodeURIComponent(orderId)}/cancel`, {
				method: "POST",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(body),
			});
		},

		archiveOrder(orderId) {
			return post<Order>(`/orders/${encodeURIComponent(orderId)}/archive`, undefined);
		},

		unarchiveOrder(orderId) {
			return post<Order>(`/orders/${encodeURIComponent(orderId)}/unarchive`, undefined);
		},

		openHandover(body) {
			return post<Handover>("/handovers", body);
		},

		listOpenHandovers(options) {
			return request<{ items: Handover[] }>("/handovers", {}, options);
		},

		getHandover(handoverId, options) {
			return request<HandoverDetail>(`/handovers/${encodeURIComponent(handoverId)}`, {}, options);
		},

		scanOrderOntoHandover(handoverId, body) {
			return post<HandoverOrder>(`/handovers/${encodeURIComponent(handoverId)}/scan-order`, body);
		},

		closeHandover(handoverId, body) {
			return post<HandoverDetail>(`/handovers/${encodeURIComponent(handoverId)}/close`, body);
		},

		cancelHandover(handoverId, reason) {
			return post<Handover>(`/handovers/${encodeURIComponent(handoverId)}/cancel`, { reason });
		},

		contactOrder(orderId, body, version) {
			return request<Order>(`/orders/${encodeURIComponent(orderId)}/contact`, {
				method: "POST",
				headers: { "Content-Type": "application/json", "If-Match": `"${version}"` },
				body: JSON.stringify(body),
			});
		},

		addOrderContactNote(orderId, body) {
			return post<void>(`/orders/${encodeURIComponent(orderId)}/contact-note`, body);
		},

		stampAutomaticContact(orderId, body) {
			return post<Order>(`/orders/${encodeURIComponent(orderId)}/auto-contact-stamp`, body);
		},

		getOrderCosting(orderId, options) {
			return request<OrderCosting>(`/orders/${encodeURIComponent(orderId)}/costing`, {}, options);
		},

		recomputeOrderCosting(orderId) {
			return post<OrderCosting>(
				`/orders/${encodeURIComponent(orderId)}/costing/recompute`,
				undefined,
			);
		},

		getOrderCharges(orderId, options) {
			return request<OrderCharges>(`/orders/${encodeURIComponent(orderId)}/charges`, {}, options);
		},

		createCostingAdjustment(body, idempotencyKey) {
			return post<CostAdjustment>("/costing/adjustments", body, { idempotencyKey });
		},

		approveCostingAdjustment(adjustmentId) {
			return post<CostAdjustment>(
				`/costing/adjustments/${encodeURIComponent(adjustmentId)}/approve`,
				undefined,
			);
		},

		getCostingSummary(query) {
			return request<CostingSummary>(
				`/costing/summary${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		holdOrder(orderId, body) {
			return post<Order>(`/orders/${encodeURIComponent(orderId)}/hold`, body);
		},

		releaseOrder(orderId) {
			return post<Order>(`/orders/${encodeURIComponent(orderId)}/release`, undefined);
		},

		showOrderInApi(orderId) {
			return post<Order>(`/orders/${encodeURIComponent(orderId)}/show-in-api`, undefined);
		},

		hideOrderFromApi(orderId) {
			return post<Order>(`/orders/${encodeURIComponent(orderId)}/hide-from-api`, undefined);
		},

		withdrawOrder(orderId) {
			return post<Order>(`/orders/${encodeURIComponent(orderId)}/withdraw`, undefined);
		},

		getOrderLog(orderId, log, query = {}) {
			return request<OrderLogPage>(
				`/orders/${encodeURIComponent(orderId)}/logs/${encodeURIComponent(log)}${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		getOrderLogCounts(orderId, options) {
			return request<OrderLogCounts>(`/orders/${encodeURIComponent(orderId)}/logs`, {}, options);
		},

		listOrderStatusEvents(orderId, query = {}) {
			return request<OrderStatusEventPage>(
				`/orders/${encodeURIComponent(orderId)}/events${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		allocateOrder(orderId) {
			return post<OrderAllocationResult>(
				`/orders/${encodeURIComponent(orderId)}/allocate`,
				undefined,
			);
		},

		openFulfillmentSession(body, idempotencyKey) {
			return post<FulfillmentSessionDetail>("/fulfillment-sessions", body, { idempotencyKey });
		},

		checkFulfillmentReadiness(body, options) {
			return request<FulfillmentReadiness>(
				"/fulfillment-sessions/readiness",
				{
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(body),
				},
				options,
			);
		},

		scanFulfillmentItem(sessionId, body) {
			return post<FulfillmentScanResult>(
				`/fulfillment-sessions/${encodeURIComponent(sessionId)}/scan-item`,
				body,
			);
		},

		advanceFulfillmentSession(sessionId) {
			return post<FulfillmentSessionDetail>(
				`/fulfillment-sessions/${encodeURIComponent(sessionId)}/advance`,
				undefined,
			);
		},

		backFulfillmentSession(sessionId) {
			return post<FulfillmentSessionDetail>(
				`/fulfillment-sessions/${encodeURIComponent(sessionId)}/back`,
				undefined,
			);
		},

		markFulfillmentOrderCantComplete(sessionId, orderId, reason) {
			return post<FulfillmentSessionDetail>(
				`/fulfillment-sessions/${encodeURIComponent(sessionId)}/orders/${encodeURIComponent(orderId)}/cant-complete`,
				{ reason },
			);
		},

		resumeFulfillmentOrder(sessionId, orderId) {
			return post<FulfillmentSessionDetail>(
				`/fulfillment-sessions/${encodeURIComponent(sessionId)}/orders/${encodeURIComponent(orderId)}/resume`,
				undefined,
			);
		},

		placeFulfillmentItem(sessionId, body) {
			return post<FulfillmentScanResult>(
				`/fulfillment-sessions/${encodeURIComponent(sessionId)}/place-item`,
				body,
			);
		},

		addFulfillmentOrderBox(sessionId, orderId) {
			return post<FulfillmentSessionDetail>(
				`/fulfillment-sessions/${encodeURIComponent(sessionId)}/orders/${encodeURIComponent(orderId)}/add-box`,
				undefined,
			);
		},

		listFulfillmentCarts(options) {
			return request<FulfillmentCartList>("/fulfillment-carts", {}, options);
		},

		saveFulfillmentCart(draft, cartId) {
			if (cartId === undefined) {
				return post<FulfillmentCart>("/fulfillment-carts", draft);
			}
			return request<FulfillmentCart>(`/fulfillment-carts/${encodeURIComponent(cartId)}`, {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(draft),
			});
		},

		getFulfillmentCartLabels(cartId) {
			return file(`/fulfillment-carts/${encodeURIComponent(cartId)}/labels.pdf`);
		},

		confirmFulfillmentPutBack(sessionId, orderId) {
			return post<FulfillmentSessionDetail>(
				`/fulfillment-sessions/${encodeURIComponent(sessionId)}/orders/${encodeURIComponent(orderId)}/put-back`,
				undefined,
			);
		},

		finishFulfillmentSession(sessionId) {
			return post<FulfillmentFinishResult>(
				`/fulfillment-sessions/${encodeURIComponent(sessionId)}/finish`,
				{},
			);
		},

		selectFulfillmentOrder(sessionId, body) {
			return post<FulfillmentSessionDetail>(
				`/fulfillment-sessions/${encodeURIComponent(sessionId)}/scan-order`,
				body,
			);
		},

		packFulfillmentItem(sessionId, orderId, body) {
			return post<FulfillmentPackResult>(
				`/fulfillment-sessions/${encodeURIComponent(sessionId)}/orders/${encodeURIComponent(orderId)}/scan-item`,
				body,
			);
		},

		completeFulfillmentOrder(sessionId, orderId) {
			return post<FulfillmentSessionDetail>(
				`/fulfillment-sessions/${encodeURIComponent(sessionId)}/orders/${encodeURIComponent(orderId)}/complete`,
				undefined,
			);
		},

		weighFulfillmentOrder(sessionId, orderId, body) {
			return post<FulfillmentWeighResult>(
				`/fulfillment-sessions/${encodeURIComponent(sessionId)}/orders/${encodeURIComponent(orderId)}/weigh`,
				body,
			);
		},

		uploadFulfillmentPackPhoto(sessionId, orderId, file, filename = "parcel.jpg") {
			// No Content-Type header: the browser writes the multipart boundary.
			const form = new FormData();
			form.append("file", file, filename);
			return request<FulfillmentPackPhotoResult>(
				`/fulfillment-sessions/${encodeURIComponent(sessionId)}/orders/${encodeURIComponent(orderId)}/pack-photo`,
				{ method: "POST", body: form },
			);
		},

		getOrderPackPhoto(orderId, options) {
			return request<PackPhoto>(`/orders/${encodeURIComponent(orderId)}/pack-photo`, {}, options);
		},

		shortPickFulfillmentRow(sessionId, body) {
			return post<FulfillmentShortPickResult>(
				`/fulfillment-sessions/${encodeURIComponent(sessionId)}/short-pick`,
				body,
			);
		},

		cancelFulfillmentSession(sessionId, body) {
			return post<FulfillmentSession>(
				`/fulfillment-sessions/${encodeURIComponent(sessionId)}/cancel`,
				body,
			);
		},

		removeOrderFromFulfillmentSession(sessionId, orderId) {
			return post<FulfillmentSession>(
				`/fulfillment-sessions/${encodeURIComponent(sessionId)}/orders/${encodeURIComponent(orderId)}/remove`,
				undefined,
			);
		},

		reassignFulfillmentSession(sessionId, body) {
			return post<FulfillmentSession>(
				`/fulfillment-sessions/${encodeURIComponent(sessionId)}/reassign`,
				body,
			);
		},

		getFulfillmentSession(sessionId, options) {
			return request<FulfillmentSessionDetail>(
				`/fulfillment-sessions/${encodeURIComponent(sessionId)}`,
				{},
				options,
			);
		},

		getFulfillmentSessionPlaces(sessionId, options) {
			return request<PickPlaceList>(
				`/fulfillment-sessions/${encodeURIComponent(sessionId)}/places`,
				{},
				options,
			);
		},

		listFulfillmentSessions(options) {
			return request<FulfillmentSessionPage>("/fulfillment-sessions", {}, options);
		},

		orderAllocations(orderId, options) {
			return request<OrderAllocationPanel>(
				`/orders/${encodeURIComponent(orderId)}/allocations`,
				{},
				options,
			);
		},

		listAllocationAlternatives(reservationId, options) {
			return request<AllocationAlternatives>(
				`/allocations/${encodeURIComponent(reservationId)}/alternatives`,
				{},
				options,
			);
		},

		resourceAllocation(reservationId, body) {
			return post<Reservation>(`/allocations/${encodeURIComponent(reservationId)}/resource`, body);
		},

		listMissingStockOrders(query = {}) {
			return request<MissingStockPage>(
				`/portal/orders/missing-stock${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		reversePackagingConsumption(consumptionId, body, idempotencyKey) {
			return post<PackagingConsumptionReversal>(
				`/packaging/consumptions/${encodeURIComponent(consumptionId)}/reverse`,
				body,
				{ idempotencyKey },
			);
		},

		syncPull(body, options) {
			return post<SyncPullResult>("/sync/pull", body, options);
		},

		syncPush(deviceId, mutations) {
			return post<SyncPushResult>("/sync/push", { deviceId, mutations });
		},

		quoteShipmentCollectible(shipmentId, acceptedLines) {
			return post<CollectibleQuote>(
				`/delivery/shipments/${encodeURIComponent(shipmentId)}/collectible`,
				{ acceptedLines },
			);
		},

		sendShipmentOtp(shipmentId) {
			return post<OtpStatus>(
				`/delivery/shipments/${encodeURIComponent(shipmentId)}/otp:send`,
				undefined,
			);
		},

		verifyShipmentOtp(shipmentId, code) {
			return post<OtpStatus>(`/delivery/shipments/${encodeURIComponent(shipmentId)}/otp:verify`, {
				code,
			});
		},

		registerDevice(body) {
			return post<DeviceRegistration>("/devices", body);
		},

		unregisterDevice(deviceId) {
			return send(`/devices/${encodeURIComponent(deviceId)}`, "DELETE");
		},

		listSyncConflicts(query = {}) {
			return request<SyncConflictList>(
				`/sync/conflicts${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		streamEvents(handlers) {
			return connectEventStream(async (lastEventId, signal) => {
				const headers = await authHeaders();
				headers.set("Accept", "text/event-stream");
				if (lastEventId !== null) {
					headers.set("Last-Event-ID", lastEventId);
				}
				return fetch(`${baseUrl}/events/stream`, { headers, signal });
			}, handlers);
		},

		async presenceHeartbeat(body) {
			const headers = await authHeaders();
			headers.set("Content-Type", "application/json");
			const response = await fetch(`${baseUrl}/presence/heartbeat`, {
				method: "POST",
				headers,
				body: JSON.stringify(body),
			});
			if (!response.ok) {
				throw new ApiError(response.status, await errorBody(response));
			}
		},

		listPresence(query = {}) {
			return request<PresenceList>(
				`/presence${searchOf({ interface: query.interface })}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		listMyAlerts(options) {
			return request<AlertAckList>("/alerts/mine", {}, options);
		},

		listPendingAcks(query = {}) {
			return request<AlertAckBoard>(
				`/alerts/pending-acks${searchOf({ status: query.status, driverId: query.driverId })}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		resolveAlert(notificationId) {
			return post<AlertAck>(`/alerts/${encodeURIComponent(notificationId)}/resolve`, {});
		},

		resolveSyncConflict(key, body) {
			return post<SyncConflict>(`/sync/conflicts/${encodeURIComponent(key)}/resolve`, body);
		},

		listCarrierDeadLetters(query = {}) {
			return request<CarrierDeadLetterList>(
				`/delivery/carrier-dead-letters${searchOf(query)}`,
				{},
				query.signal === undefined ? {} : { signal: query.signal },
			);
		},

		replayCarrierDeadLetter(id) {
			return post<CarrierDeadLetter>(
				`/delivery/carrier-dead-letters/${encodeURIComponent(id)}/replay`,
				{},
			);
		},

		dismissCarrierDeadLetter(id, body) {
			return post<CarrierDeadLetter>(
				`/delivery/carrier-dead-letters/${encodeURIComponent(id)}/dismiss`,
				body,
			);
		},
	};
}

/**
 * Turns a query object into a search string, dropping what is not a parameter.
 *
 * `signal` is a request option rather than a filter, and an empty string is a
 * filter nobody set — sending `status=` would make the server parse an empty
 * value and answer differently from the same call with the key absent.
 */
/** Where one object's item history lives: a sku's, or a master box's. */
function historyPath(subject: { kind: "sku" | "box"; id: string }): string {
	const base = subject.kind === "box" ? "/master-boxes" : "/skus";
	return `${base}/${encodeURIComponent(subject.id)}/history`;
}

/**
 * The Session Log's query (EP05-S09). Its employees are a repeated
 * `employeeId`, which [searchOf]'s one-value-per-key cannot say.
 */
export function sessionLogSearch(query: Omit<WorkSessionLogQuery, "signal">): string {
	const params = new URLSearchParams({ from: query.from, to: query.to });
	for (const id of query.employeeIds ?? []) {
		params.append("employeeId", id);
	}
	if (query.type !== undefined) {
		params.set("type", query.type);
	}
	if (query.cursor !== undefined && query.cursor !== "") {
		params.set("cursor", query.cursor);
	}
	if (query.limit !== undefined) {
		params.set("limit", String(query.limit));
	}
	return params.toString();
}

function searchOf(query: object): string {
	const params = new URLSearchParams();
	for (const [key, value] of Object.entries(query)) {
		if (key === "signal" || value === undefined || value === "") {
			continue;
		}
		params.set(key, String(value));
	}
	return params.size > 0 ? `?${params}` : "";
}

/**
 * Reads the error body, tolerating a response that is not the JSON the spec
 * promises — a load balancer returning an HTML 502 does not know about our
 * contract, and the UI should still show something sensible.
 */
async function errorBody(response: Response): Promise<ApiErrorBody> {
	try {
		return (await response.json()) as ApiErrorBody;
	} catch {
		// "internal" rather than a code of its own. From the client's side an
		// HTML 502 from the load balancer and a 500 from the service are the
		// same thing — something broke that is not the user's fault — and
		// inventing a code outside the catalogue means every consumer has to
		// handle one the contract never promised. traceId is empty because
		// there is genuinely none: the response never reached our code.
		return {
			code: "internal",
			message: `request failed with status ${response.status}`,
			traceId: "",
		};
	}
}
